!(function (e) {
    var t = !1;
    if (("function" == typeof define && define.amd && (define(e), (t = !0)), "object" == typeof exports && ((module.exports = e()), (t = !0)), !t)) {
        var i = window.Cookies,
            n = (window.Cookies = e());
        n.noConflict = function () {
            return (window.Cookies = i), n;
        };
    }
})(function () {
    function e() {
        for (var e = 0, t = {}; e < arguments.length; e++) {
            var i = arguments[e];
            for (var n in i) t[n] = i[n];
        }
        return t;
    }
    return (function t(i) {
        function n(t, o, s) {
            var r;
            if ("undefined" != typeof document) {
                if (arguments.length > 1) {
                    if ("number" == typeof (s = e({ path: "/" }, n.defaults, s)).expires) {
                        var c = new Date();
                        c.setMilliseconds(c.getMilliseconds() + 864e5 * s.expires), (s.expires = c);
                    }
                    s.expires = s.expires ? s.expires.toUTCString() : "";
                    try {
                        (r = JSON.stringify(o)), /^[\{\[]/.test(r) && (o = r);
                    } catch (e) {}
                    (o = i.write ? i.write(o, t) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent)),
                        (t = (t = (t = encodeURIComponent(String(t))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape));
                    var a = "";
                    for (var l in s) s[l] && ((a += "; " + l), !0 !== s[l] && (a += "=" + s[l]));
                    return (document.cookie = t + "=" + o + a);
                }
                t || (r = {});
                for (var u = document.cookie ? document.cookie.split("; ") : [], d = /(%[0-9A-Z]{2})+/g, p = 0; p < u.length; p++) {
                    var h = u[p].split("="),
                        f = h.slice(1).join("=");
                    this.json || '"' !== f.charAt(0) || (f = f.slice(1, -1));
                    try {
                        var M = h[0].replace(d, decodeURIComponent);
                        if (((f = i.read ? i.read(f, M) : i(f, M) || f.replace(d, decodeURIComponent)), this.json))
                            try {
                                f = JSON.parse(f);
                            } catch (e) {}
                        if (t === M) {
                            r = f;
                            break;
                        }
                        t || (r[M] = f);
                    } catch (e) {}
                }
                return r;
            }
        }
        return (
            (n.set = n),
            (n.get = function (e) {
                return n.call(n, e);
            }),
            (n.getJSON = function () {
                return n.apply({ json: !0 }, [].slice.call(arguments));
            }),
            (n.defaults = {}),
            (n.remove = function (t, i) {
                n(t, "", e(i, { expires: -1 }));
            }),
            (n.withConverter = t),
            n
        );
    })(function () {});
}),
    (function (e, t) {
        "use strict";
        "object" == typeof module && "object" == typeof module.exports
            ? (module.exports = e.document
                  ? t(e, !0)
                  : function (e) {
                        if (!e.document) throw new Error("jQuery requires a window with a document");
                        return t(e);
                    })
            : t(e);
    })("undefined" != typeof window ? window : this, function (e, t) {
        "use strict";
        var i = [],
            n = e.document,
            o = Object.getPrototypeOf,
            s = i.slice,
            r = i.concat,
            c = i.push,
            a = i.indexOf,
            l = {},
            u = l.toString,
            d = l.hasOwnProperty,
            p = d.toString,
            h = p.call(Object),
            f = {},
            M = function (e) {
                return "function" == typeof e && "number" != typeof e.nodeType;
            },
            b = function (e) {
                return null != e && e === e.window;
            },
            m = { type: !0, src: !0, noModule: !0 };
        function g(e, t, i) {
            var o,
                s = (t = t || n).createElement("script");
            if (((s.text = e), i)) for (o in m) i[o] && (s[o] = i[o]);
            t.head.appendChild(s).parentNode.removeChild(s);
        }
        function A(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? l[u.call(e)] || "object" : typeof e;
        }
        var z = function (e, t) {
                return new z.fn.init(e, t);
            },
            y = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        function v(e) {
            var t = !!e && "length" in e && e.length,
                i = A(e);
            return !M(e) && !b(e) && ("array" === i || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e));
        }
        (z.fn = z.prototype = {
            jquery: "3.3.1",
            constructor: z,
            length: 0,
            toArray: function () {
                return s.call(this);
            },
            get: function (e) {
                return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
            },
            pushStack: function (e) {
                var t = z.merge(this.constructor(), e);
                return (t.prevObject = this), t;
            },
            each: function (e) {
                return z.each(this, e);
            },
            map: function (e) {
                return this.pushStack(
                    z.map(this, function (t, i) {
                        return e.call(t, i, t);
                    })
                );
            },
            slice: function () {
                return this.pushStack(s.apply(this, arguments));
            },
            first: function () {
                return this.eq(0);
            },
            last: function () {
                return this.eq(-1);
            },
            eq: function (e) {
                var t = this.length,
                    i = +e + (e < 0 ? t : 0);
                return this.pushStack(i >= 0 && i < t ? [this[i]] : []);
            },
            end: function () {
                return this.prevObject || this.constructor();
            },
            push: c,
            sort: i.sort,
            splice: i.splice,
        }),
            (z.extend = z.fn.extend = function () {
                var e,
                    t,
                    i,
                    n,
                    o,
                    s,
                    r = arguments[0] || {},
                    c = 1,
                    a = arguments.length,
                    l = !1;
                for ("boolean" == typeof r && ((l = r), (r = arguments[c] || {}), c++), "object" == typeof r || M(r) || (r = {}), c === a && ((r = this), c--); c < a; c++)
                    if (null != (e = arguments[c]))
                        for (t in e)
                            (i = r[t]),
                                r !== (n = e[t]) &&
                                    (l && n && (z.isPlainObject(n) || (o = Array.isArray(n)))
                                        ? (o ? ((o = !1), (s = i && Array.isArray(i) ? i : [])) : (s = i && z.isPlainObject(i) ? i : {}), (r[t] = z.extend(l, s, n)))
                                        : void 0 !== n && (r[t] = n));
                return r;
            }),
            z.extend({
                expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (e) {
                    throw new Error(e);
                },
                noop: function () {},
                isPlainObject: function (e) {
                    var t, i;
                    return !(!e || "[object Object]" !== u.call(e) || ((t = o(e)) && ("function" != typeof (i = d.call(t, "constructor") && t.constructor) || p.call(i) !== h)));
                },
                isEmptyObject: function (e) {
                    var t;
                    for (t in e) return !1;
                    return !0;
                },
                globalEval: function (e) {
                    g(e);
                },
                each: function (e, t) {
                    var i,
                        n = 0;
                    if (v(e)) for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
                    else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
                    return e;
                },
                trim: function (e) {
                    return null == e ? "" : (e + "").replace(y, "");
                },
                makeArray: function (e, t) {
                    var i = t || [];
                    return null != e && (v(Object(e)) ? z.merge(i, "string" == typeof e ? [e] : e) : c.call(i, e)), i;
                },
                inArray: function (e, t, i) {
                    return null == t ? -1 : a.call(t, e, i);
                },
                merge: function (e, t) {
                    for (var i = +t.length, n = 0, o = e.length; n < i; n++) e[o++] = t[n];
                    return (e.length = o), e;
                },
                grep: function (e, t, i) {
                    for (var n = [], o = 0, s = e.length, r = !i; o < s; o++) !t(e[o], o) !== r && n.push(e[o]);
                    return n;
                },
                map: function (e, t, i) {
                    var n,
                        o,
                        s = 0,
                        c = [];
                    if (v(e)) for (n = e.length; s < n; s++) null != (o = t(e[s], s, i)) && c.push(o);
                    else for (s in e) null != (o = t(e[s], s, i)) && c.push(o);
                    return r.apply([], c);
                },
                guid: 1,
                support: f,
            }),
            "function" == typeof Symbol && (z.fn[Symbol.iterator] = i[Symbol.iterator]),
            z.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
                l["[object " + t + "]"] = t.toLowerCase();
            });
        var O = (function (e) {
            var t,
                i,
                n,
                o,
                s,
                r,
                c,
                a,
                l,
                u,
                d,
                p,
                h,
                f,
                M,
                b,
                m,
                g,
                A,
                z = "sizzle" + 1 * new Date(),
                y = e.document,
                v = 0,
                O = 0,
                L = re(),
                T = re(),
                N = re(),
                q = function (e, t) {
                    return e === t && (d = !0), 0;
                },
                w = {}.hasOwnProperty,
                W = [],
                S = W.pop,
                C = W.push,
                k = W.push,
                B = W.slice,
                E = function (e, t) {
                    for (var i = 0, n = e.length; i < n; i++) if (e[i] === t) return i;
                    return -1;
                },
                X = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                x = "[\\x20\\t\\r\\n\\f]",
                _ = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                D = "\\[" + x + "*(" + _ + ")(?:" + x + "*([*^$|!~]?=)" + x + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + _ + "))|)" + x + "*\\]",
                R = ":(" + _ + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + D + ")*)|.*)\\)|)",
                P = new RegExp(x + "+", "g"),
                I = new RegExp("^" + x + "+|((?:^|[^\\\\])(?:\\\\.)*)" + x + "+$", "g"),
                H = new RegExp("^" + x + "*," + x + "*"),
                j = new RegExp("^" + x + "*([>+~]|" + x + ")" + x + "*"),
                $ = new RegExp("=" + x + "*([^\\]'\"]*?)" + x + "*\\]", "g"),
                F = new RegExp(R),
                U = new RegExp("^" + _ + "$"),
                V = {
                    ID: new RegExp("^#(" + _ + ")"),
                    CLASS: new RegExp("^\\.(" + _ + ")"),
                    TAG: new RegExp("^(" + _ + "|[*])"),
                    ATTR: new RegExp("^" + D),
                    PSEUDO: new RegExp("^" + R),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + x + "*(even|odd|(([+-]|)(\\d*)n|)" + x + "*(?:([+-]|)" + x + "*(\\d+)|))" + x + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + X + ")$", "i"),
                    needsContext: new RegExp("^" + x + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + x + "*((?:-\\d)?\\d*)" + x + "*\\)|)(?=[^-]|$)", "i"),
                },
                Y = /^(?:input|select|textarea|button)$/i,
                G = /^h\d$/i,
                K = /^[^{]+\{\s*\[native \w/,
                Q = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                J = /[+~]/,
                Z = new RegExp("\\\\([\\da-f]{1,6}" + x + "?|(" + x + ")|.)", "ig"),
                ee = function (e, t, i) {
                    var n = "0x" + t - 65536;
                    return n != n || i ? t : n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320);
                },
                te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                ie = function (e, t) {
                    return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
                },
                ne = function () {
                    p();
                },
                oe = ge(
                    function (e) {
                        return !0 === e.disabled && ("form" in e || "label" in e);
                    },
                    { dir: "parentNode", next: "legend" }
                );
            try {
                k.apply((W = B.call(y.childNodes)), y.childNodes), W[y.childNodes.length].nodeType;
            } catch (e) {
                k = {
                    apply: W.length
                        ? function (e, t) {
                              C.apply(e, B.call(t));
                          }
                        : function (e, t) {
                              for (var i = e.length, n = 0; (e[i++] = t[n++]); );
                              e.length = i - 1;
                          },
                };
            }
            function se(e, t, n, o) {
                var s,
                    c,
                    l,
                    u,
                    d,
                    f,
                    m,
                    g = t && t.ownerDocument,
                    v = t ? t.nodeType : 9;
                if (((n = n || []), "string" != typeof e || !e || (1 !== v && 9 !== v && 11 !== v))) return n;
                if (!o && ((t ? t.ownerDocument || t : y) !== h && p(t), (t = t || h), M)) {
                    if (11 !== v && (d = Q.exec(e)))
                        if ((s = d[1])) {
                            if (9 === v) {
                                if (!(l = t.getElementById(s))) return n;
                                if (l.id === s) return n.push(l), n;
                            } else if (g && (l = g.getElementById(s)) && A(t, l) && l.id === s) return n.push(l), n;
                        } else {
                            if (d[2]) return k.apply(n, t.getElementsByTagName(e)), n;
                            if ((s = d[3]) && i.getElementsByClassName && t.getElementsByClassName) return k.apply(n, t.getElementsByClassName(s)), n;
                        }
                    if (i.qsa && !N[e + " "] && (!b || !b.test(e))) {
                        if (1 !== v) (g = t), (m = e);
                        else if ("object" !== t.nodeName.toLowerCase()) {
                            for ((u = t.getAttribute("id")) ? (u = u.replace(te, ie)) : t.setAttribute("id", (u = z)), c = (f = r(e)).length; c--; ) f[c] = "#" + u + " " + me(f[c]);
                            (m = f.join(",")), (g = (J.test(e) && Me(t.parentNode)) || t);
                        }
                        if (m)
                            try {
                                return k.apply(n, g.querySelectorAll(m)), n;
                            } catch (e) {
                            } finally {
                                u === z && t.removeAttribute("id");
                            }
                    }
                }
                return a(e.replace(I, "$1"), t, n, o);
            }
            function re() {
                var e = [];
                return function t(i, o) {
                    return e.push(i + " ") > n.cacheLength && delete t[e.shift()], (t[i + " "] = o);
                };
            }
            function ce(e) {
                return (e[z] = !0), e;
            }
            function ae(e) {
                var t = h.createElement("fieldset");
                try {
                    return !!e(t);
                } catch (e) {
                    return !1;
                } finally {
                    t.parentNode && t.parentNode.removeChild(t), (t = null);
                }
            }
            function le(e, t) {
                for (var i = e.split("|"), o = i.length; o--; ) n.attrHandle[i[o]] = t;
            }
            function ue(e, t) {
                var i = t && e,
                    n = i && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
                if (n) return n;
                if (i) for (; (i = i.nextSibling); ) if (i === t) return -1;
                return e ? 1 : -1;
            }
            function de(e) {
                return function (t) {
                    return "input" === t.nodeName.toLowerCase() && t.type === e;
                };
            }
            function pe(e) {
                return function (t) {
                    var i = t.nodeName.toLowerCase();
                    return ("input" === i || "button" === i) && t.type === e;
                };
            }
            function he(e) {
                return function (t) {
                    return "form" in t
                        ? t.parentNode && !1 === t.disabled
                            ? "label" in t
                                ? "label" in t.parentNode
                                    ? t.parentNode.disabled === e
                                    : t.disabled === e
                                : t.isDisabled === e || (t.isDisabled !== !e && oe(t) === e)
                            : t.disabled === e
                        : "label" in t && t.disabled === e;
                };
            }
            function fe(e) {
                return ce(function (t) {
                    return (
                        (t = +t),
                        ce(function (i, n) {
                            for (var o, s = e([], i.length, t), r = s.length; r--; ) i[(o = s[r])] && (i[o] = !(n[o] = i[o]));
                        })
                    );
                });
            }
            function Me(e) {
                return e && void 0 !== e.getElementsByTagName && e;
            }
            for (t in ((i = se.support = {}),
            (s = se.isXML = function (e) {
                var t = e && (e.ownerDocument || e).documentElement;
                return !!t && "HTML" !== t.nodeName;
            }),
            (p = se.setDocument = function (e) {
                var t,
                    o,
                    r = e ? e.ownerDocument || e : y;
                return r !== h && 9 === r.nodeType && r.documentElement
                    ? ((f = (h = r).documentElement),
                      (M = !s(h)),
                      y !== h && (o = h.defaultView) && o.top !== o && (o.addEventListener ? o.addEventListener("unload", ne, !1) : o.attachEvent && o.attachEvent("onunload", ne)),
                      (i.attributes = ae(function (e) {
                          return (e.className = "i"), !e.getAttribute("className");
                      })),
                      (i.getElementsByTagName = ae(function (e) {
                          return e.appendChild(h.createComment("")), !e.getElementsByTagName("*").length;
                      })),
                      (i.getElementsByClassName = K.test(h.getElementsByClassName)),
                      (i.getById = ae(function (e) {
                          return (f.appendChild(e).id = z), !h.getElementsByName || !h.getElementsByName(z).length;
                      })),
                      i.getById
                          ? ((n.filter.ID = function (e) {
                                var t = e.replace(Z, ee);
                                return function (e) {
                                    return e.getAttribute("id") === t;
                                };
                            }),
                            (n.find.ID = function (e, t) {
                                if (void 0 !== t.getElementById && M) {
                                    var i = t.getElementById(e);
                                    return i ? [i] : [];
                                }
                            }))
                          : ((n.filter.ID = function (e) {
                                var t = e.replace(Z, ee);
                                return function (e) {
                                    var i = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                    return i && i.value === t;
                                };
                            }),
                            (n.find.ID = function (e, t) {
                                if (void 0 !== t.getElementById && M) {
                                    var i,
                                        n,
                                        o,
                                        s = t.getElementById(e);
                                    if (s) {
                                        if ((i = s.getAttributeNode("id")) && i.value === e) return [s];
                                        for (o = t.getElementsByName(e), n = 0; (s = o[n++]); ) if ((i = s.getAttributeNode("id")) && i.value === e) return [s];
                                    }
                                    return [];
                                }
                            })),
                      (n.find.TAG = i.getElementsByTagName
                          ? function (e, t) {
                                return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : i.qsa ? t.querySelectorAll(e) : void 0;
                            }
                          : function (e, t) {
                                var i,
                                    n = [],
                                    o = 0,
                                    s = t.getElementsByTagName(e);
                                if ("*" === e) {
                                    for (; (i = s[o++]); ) 1 === i.nodeType && n.push(i);
                                    return n;
                                }
                                return s;
                            }),
                      (n.find.CLASS =
                          i.getElementsByClassName &&
                          function (e, t) {
                              if (void 0 !== t.getElementsByClassName && M) return t.getElementsByClassName(e);
                          }),
                      (m = []),
                      (b = []),
                      (i.qsa = K.test(h.querySelectorAll)) &&
                          (ae(function (e) {
                              (f.appendChild(e).innerHTML = "<a id='" + z + "'></a><select id='" + z + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                  e.querySelectorAll("[msallowcapture^='']").length && b.push("[*^$]=" + x + "*(?:''|\"\")"),
                                  e.querySelectorAll("[selected]").length || b.push("\\[" + x + "*(?:value|" + X + ")"),
                                  e.querySelectorAll("[id~=" + z + "-]").length || b.push("~="),
                                  e.querySelectorAll(":checked").length || b.push(":checked"),
                                  e.querySelectorAll("a#" + z + "+*").length || b.push(".#.+[+~]");
                          }),
                          ae(function (e) {
                              e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                              var t = h.createElement("input");
                              t.setAttribute("type", "hidden"),
                                  e.appendChild(t).setAttribute("name", "D"),
                                  e.querySelectorAll("[name=d]").length && b.push("name" + x + "*[*^$|!~]?="),
                                  2 !== e.querySelectorAll(":enabled").length && b.push(":enabled", ":disabled"),
                                  (f.appendChild(e).disabled = !0),
                                  2 !== e.querySelectorAll(":disabled").length && b.push(":enabled", ":disabled"),
                                  e.querySelectorAll("*,:x"),
                                  b.push(",.*:");
                          })),
                      (i.matchesSelector = K.test((g = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector))) &&
                          ae(function (e) {
                              (i.disconnectedMatch = g.call(e, "*")), g.call(e, "[s!='']:x"), m.push("!=", R);
                          }),
                      (b = b.length && new RegExp(b.join("|"))),
                      (m = m.length && new RegExp(m.join("|"))),
                      (t = K.test(f.compareDocumentPosition)),
                      (A =
                          t || K.test(f.contains)
                              ? function (e, t) {
                                    var i = 9 === e.nodeType ? e.documentElement : e,
                                        n = t && t.parentNode;
                                    return e === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)));
                                }
                              : function (e, t) {
                                    if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                    return !1;
                                }),
                      (q = t
                          ? function (e, t) {
                                if (e === t) return (d = !0), 0;
                                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                return (
                                    n ||
                                    (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!i.sortDetached && t.compareDocumentPosition(e) === n)
                                        ? e === h || (e.ownerDocument === y && A(y, e))
                                            ? -1
                                            : t === h || (t.ownerDocument === y && A(y, t))
                                            ? 1
                                            : u
                                            ? E(u, e) - E(u, t)
                                            : 0
                                        : 4 & n
                                        ? -1
                                        : 1)
                                );
                            }
                          : function (e, t) {
                                if (e === t) return (d = !0), 0;
                                var i,
                                    n = 0,
                                    o = e.parentNode,
                                    s = t.parentNode,
                                    r = [e],
                                    c = [t];
                                if (!o || !s) return e === h ? -1 : t === h ? 1 : o ? -1 : s ? 1 : u ? E(u, e) - E(u, t) : 0;
                                if (o === s) return ue(e, t);
                                for (i = e; (i = i.parentNode); ) r.unshift(i);
                                for (i = t; (i = i.parentNode); ) c.unshift(i);
                                for (; r[n] === c[n]; ) n++;
                                return n ? ue(r[n], c[n]) : r[n] === y ? -1 : c[n] === y ? 1 : 0;
                            }),
                      h)
                    : h;
            }),
            (se.matches = function (e, t) {
                return se(e, null, null, t);
            }),
            (se.matchesSelector = function (e, t) {
                if (((e.ownerDocument || e) !== h && p(e), (t = t.replace($, "='$1']")), i.matchesSelector && M && !N[t + " "] && (!m || !m.test(t)) && (!b || !b.test(t))))
                    try {
                        var n = g.call(e, t);
                        if (n || i.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return n;
                    } catch (e) {}
                return se(t, h, null, [e]).length > 0;
            }),
            (se.contains = function (e, t) {
                return (e.ownerDocument || e) !== h && p(e), A(e, t);
            }),
            (se.attr = function (e, t) {
                (e.ownerDocument || e) !== h && p(e);
                var o = n.attrHandle[t.toLowerCase()],
                    s = o && w.call(n.attrHandle, t.toLowerCase()) ? o(e, t, !M) : void 0;
                return void 0 !== s ? s : i.attributes || !M ? e.getAttribute(t) : (s = e.getAttributeNode(t)) && s.specified ? s.value : null;
            }),
            (se.escape = function (e) {
                return (e + "").replace(te, ie);
            }),
            (se.error = function (e) {
                throw new Error("Syntax error, unrecognized expression: " + e);
            }),
            (se.uniqueSort = function (e) {
                var t,
                    n = [],
                    o = 0,
                    s = 0;
                if (((d = !i.detectDuplicates), (u = !i.sortStable && e.slice(0)), e.sort(q), d)) {
                    for (; (t = e[s++]); ) t === e[s] && (o = n.push(s));
                    for (; o--; ) e.splice(n[o], 1);
                }
                return (u = null), e;
            }),
            (o = se.getText = function (e) {
                var t,
                    i = "",
                    n = 0,
                    s = e.nodeType;
                if (s) {
                    if (1 === s || 9 === s || 11 === s) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) i += o(e);
                    } else if (3 === s || 4 === s) return e.nodeValue;
                } else for (; (t = e[n++]); ) i += o(t);
                return i;
            }),
            ((n = se.selectors = {
                cacheLength: 50,
                createPseudo: ce,
                match: V,
                attrHandle: {},
                find: {},
                relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                preFilter: {
                    ATTR: function (e) {
                        return (e[1] = e[1].replace(Z, ee)), (e[3] = (e[3] || e[4] || e[5] || "").replace(Z, ee)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                    },
                    CHILD: function (e) {
                        return (
                            (e[1] = e[1].toLowerCase()),
                            "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && se.error(e[0]),
                            e
                        );
                    },
                    PSEUDO: function (e) {
                        var t,
                            i = !e[6] && e[2];
                        return V.CHILD.test(e[0])
                            ? null
                            : (e[3] ? (e[2] = e[4] || e[5] || "") : i && F.test(i) && (t = r(i, !0)) && (t = i.indexOf(")", i.length - t) - i.length) && ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))), e.slice(0, 3));
                    },
                },
                filter: {
                    TAG: function (e) {
                        var t = e.replace(Z, ee).toLowerCase();
                        return "*" === e
                            ? function () {
                                  return !0;
                              }
                            : function (e) {
                                  return e.nodeName && e.nodeName.toLowerCase() === t;
                              };
                    },
                    CLASS: function (e) {
                        var t = L[e + " "];
                        return (
                            t ||
                            ((t = new RegExp("(^|" + x + ")" + e + "(" + x + "|$)")) &&
                                L(e, function (e) {
                                    return t.test(("string" == typeof e.className && e.className) || (void 0 !== e.getAttribute && e.getAttribute("class")) || "");
                                }))
                        );
                    },
                    ATTR: function (e, t, i) {
                        return function (n) {
                            var o = se.attr(n, e);
                            return null == o
                                ? "!=" === t
                                : !t ||
                                      ((o += ""),
                                      "=" === t
                                          ? o === i
                                          : "!=" === t
                                          ? o !== i
                                          : "^=" === t
                                          ? i && 0 === o.indexOf(i)
                                          : "*=" === t
                                          ? i && o.indexOf(i) > -1
                                          : "$=" === t
                                          ? i && o.slice(-i.length) === i
                                          : "~=" === t
                                          ? (" " + o.replace(P, " ") + " ").indexOf(i) > -1
                                          : "|=" === t && (o === i || o.slice(0, i.length + 1) === i + "-"));
                        };
                    },
                    CHILD: function (e, t, i, n, o) {
                        var s = "nth" !== e.slice(0, 3),
                            r = "last" !== e.slice(-4),
                            c = "of-type" === t;
                        return 1 === n && 0 === o
                            ? function (e) {
                                  return !!e.parentNode;
                              }
                            : function (t, i, a) {
                                  var l,
                                      u,
                                      d,
                                      p,
                                      h,
                                      f,
                                      M = s !== r ? "nextSibling" : "previousSibling",
                                      b = t.parentNode,
                                      m = c && t.nodeName.toLowerCase(),
                                      g = !a && !c,
                                      A = !1;
                                  if (b) {
                                      if (s) {
                                          for (; M; ) {
                                              for (p = t; (p = p[M]); ) if (c ? p.nodeName.toLowerCase() === m : 1 === p.nodeType) return !1;
                                              f = M = "only" === e && !f && "nextSibling";
                                          }
                                          return !0;
                                      }
                                      if (((f = [r ? b.firstChild : b.lastChild]), r && g)) {
                                          for (
                                              A = (h = (l = (u = (d = (p = b)[z] || (p[z] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === v && l[1]) && l[2], p = h && b.childNodes[h];
                                              (p = (++h && p && p[M]) || (A = h = 0) || f.pop());

                                          )
                                              if (1 === p.nodeType && ++A && p === t) {
                                                  u[e] = [v, h, A];
                                                  break;
                                              }
                                      } else if ((g && (A = h = (l = (u = (d = (p = t)[z] || (p[z] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === v && l[1]), !1 === A))
                                          for (
                                              ;
                                              (p = (++h && p && p[M]) || (A = h = 0) || f.pop()) &&
                                              ((c ? p.nodeName.toLowerCase() !== m : 1 !== p.nodeType) || !++A || (g && ((u = (d = p[z] || (p[z] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] = [v, A]), p !== t));

                                          );
                                      return (A -= o) === n || (A % n == 0 && A / n >= 0);
                                  }
                              };
                    },
                    PSEUDO: function (e, t) {
                        var i,
                            o = n.pseudos[e] || n.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
                        return o[z]
                            ? o(t)
                            : o.length > 1
                            ? ((i = [e, e, "", t]),
                              n.setFilters.hasOwnProperty(e.toLowerCase())
                                  ? ce(function (e, i) {
                                        for (var n, s = o(e, t), r = s.length; r--; ) e[(n = E(e, s[r]))] = !(i[n] = s[r]);
                                    })
                                  : function (e) {
                                        return o(e, 0, i);
                                    })
                            : o;
                    },
                },
                pseudos: {
                    not: ce(function (e) {
                        var t = [],
                            i = [],
                            n = c(e.replace(I, "$1"));
                        return n[z]
                            ? ce(function (e, t, i, o) {
                                  for (var s, r = n(e, null, o, []), c = e.length; c--; ) (s = r[c]) && (e[c] = !(t[c] = s));
                              })
                            : function (e, o, s) {
                                  return (t[0] = e), n(t, null, s, i), (t[0] = null), !i.pop();
                              };
                    }),
                    has: ce(function (e) {
                        return function (t) {
                            return se(e, t).length > 0;
                        };
                    }),
                    contains: ce(function (e) {
                        return (
                            (e = e.replace(Z, ee)),
                            function (t) {
                                return (t.textContent || t.innerText || o(t)).indexOf(e) > -1;
                            }
                        );
                    }),
                    lang: ce(function (e) {
                        return (
                            U.test(e || "") || se.error("unsupported lang: " + e),
                            (e = e.replace(Z, ee).toLowerCase()),
                            function (t) {
                                var i;
                                do {
                                    if ((i = M ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-");
                                } while ((t = t.parentNode) && 1 === t.nodeType);
                                return !1;
                            }
                        );
                    }),
                    target: function (t) {
                        var i = e.location && e.location.hash;
                        return i && i.slice(1) === t.id;
                    },
                    root: function (e) {
                        return e === f;
                    },
                    focus: function (e) {
                        return e === h.activeElement && (!h.hasFocus || h.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                    },
                    enabled: he(!1),
                    disabled: he(!0),
                    checked: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                    },
                    selected: function (e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                    },
                    empty: function (e) {
                        for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                        return !0;
                    },
                    parent: function (e) {
                        return !n.pseudos.empty(e);
                    },
                    header: function (e) {
                        return G.test(e.nodeName);
                    },
                    input: function (e) {
                        return Y.test(e.nodeName);
                    },
                    button: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && "button" === e.type) || "button" === t;
                    },
                    text: function (e) {
                        var t;
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                    },
                    first: fe(function () {
                        return [0];
                    }),
                    last: fe(function (e, t) {
                        return [t - 1];
                    }),
                    eq: fe(function (e, t, i) {
                        return [i < 0 ? i + t : i];
                    }),
                    even: fe(function (e, t) {
                        for (var i = 0; i < t; i += 2) e.push(i);
                        return e;
                    }),
                    odd: fe(function (e, t) {
                        for (var i = 1; i < t; i += 2) e.push(i);
                        return e;
                    }),
                    lt: fe(function (e, t, i) {
                        for (var n = i < 0 ? i + t : i; --n >= 0; ) e.push(n);
                        return e;
                    }),
                    gt: fe(function (e, t, i) {
                        for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
                        return e;
                    }),
                },
            }).pseudos.nth = n.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                n.pseudos[t] = de(t);
            for (t in { submit: !0, reset: !0 }) n.pseudos[t] = pe(t);
            function be() {}
            function me(e) {
                for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
                return n;
            }
            function ge(e, t, i) {
                var n = t.dir,
                    o = t.next,
                    s = o || n,
                    r = i && "parentNode" === s,
                    c = O++;
                return t.first
                    ? function (t, i, o) {
                          for (; (t = t[n]); ) if (1 === t.nodeType || r) return e(t, i, o);
                          return !1;
                      }
                    : function (t, i, a) {
                          var l,
                              u,
                              d,
                              p = [v, c];
                          if (a) {
                              for (; (t = t[n]); ) if ((1 === t.nodeType || r) && e(t, i, a)) return !0;
                          } else
                              for (; (t = t[n]); )
                                  if (1 === t.nodeType || r)
                                      if (((u = (d = t[z] || (t[z] = {}))[t.uniqueID] || (d[t.uniqueID] = {})), o && o === t.nodeName.toLowerCase())) t = t[n] || t;
                                      else {
                                          if ((l = u[s]) && l[0] === v && l[1] === c) return (p[2] = l[2]);
                                          if (((u[s] = p), (p[2] = e(t, i, a)))) return !0;
                                      }
                          return !1;
                      };
            }
            function Ae(e) {
                return e.length > 1
                    ? function (t, i, n) {
                          for (var o = e.length; o--; ) if (!e[o](t, i, n)) return !1;
                          return !0;
                      }
                    : e[0];
            }
            function ze(e, t, i, n, o) {
                for (var s, r = [], c = 0, a = e.length, l = null != t; c < a; c++) (s = e[c]) && ((i && !i(s, n, o)) || (r.push(s), l && t.push(c)));
                return r;
            }
            function ye(e, t, i, n, o, s) {
                return (
                    n && !n[z] && (n = ye(n)),
                    o && !o[z] && (o = ye(o, s)),
                    ce(function (s, r, c, a) {
                        var l,
                            u,
                            d,
                            p = [],
                            h = [],
                            f = r.length,
                            M =
                                s ||
                                (function (e, t, i) {
                                    for (var n = 0, o = t.length; n < o; n++) se(e, t[n], i);
                                    return i;
                                })(t || "*", c.nodeType ? [c] : c, []),
                            b = !e || (!s && t) ? M : ze(M, p, e, c, a),
                            m = i ? (o || (s ? e : f || n) ? [] : r) : b;
                        if ((i && i(b, m, c, a), n)) for (l = ze(m, h), n(l, [], c, a), u = l.length; u--; ) (d = l[u]) && (m[h[u]] = !(b[h[u]] = d));
                        if (s) {
                            if (o || e) {
                                if (o) {
                                    for (l = [], u = m.length; u--; ) (d = m[u]) && l.push((b[u] = d));
                                    o(null, (m = []), l, a);
                                }
                                for (u = m.length; u--; ) (d = m[u]) && (l = o ? E(s, d) : p[u]) > -1 && (s[l] = !(r[l] = d));
                            }
                        } else (m = ze(m === r ? m.splice(f, m.length) : m)), o ? o(null, r, m, a) : k.apply(r, m);
                    })
                );
            }
            function ve(e) {
                for (
                    var t,
                        i,
                        o,
                        s = e.length,
                        r = n.relative[e[0].type],
                        c = r || n.relative[" "],
                        a = r ? 1 : 0,
                        u = ge(
                            function (e) {
                                return e === t;
                            },
                            c,
                            !0
                        ),
                        d = ge(
                            function (e) {
                                return E(t, e) > -1;
                            },
                            c,
                            !0
                        ),
                        p = [
                            function (e, i, n) {
                                var o = (!r && (n || i !== l)) || ((t = i).nodeType ? u(e, i, n) : d(e, i, n));
                                return (t = null), o;
                            },
                        ];
                    a < s;
                    a++
                )
                    if ((i = n.relative[e[a].type])) p = [ge(Ae(p), i)];
                    else {
                        if ((i = n.filter[e[a].type].apply(null, e[a].matches))[z]) {
                            for (o = ++a; o < s && !n.relative[e[o].type]; o++);
                            return ye(a > 1 && Ae(p), a > 1 && me(e.slice(0, a - 1).concat({ value: " " === e[a - 2].type ? "*" : "" })).replace(I, "$1"), i, a < o && ve(e.slice(a, o)), o < s && ve((e = e.slice(o))), o < s && me(e));
                        }
                        p.push(i);
                    }
                return Ae(p);
            }
            function Oe(e, t) {
                var i = t.length > 0,
                    o = e.length > 0,
                    s = function (s, r, c, a, u) {
                        var d,
                            f,
                            b,
                            m = 0,
                            g = "0",
                            A = s && [],
                            z = [],
                            y = l,
                            O = s || (o && n.find.TAG("*", u)),
                            L = (v += null == y ? 1 : Math.random() || 0.1),
                            T = O.length;
                        for (u && (l = r === h || r || u); g !== T && null != (d = O[g]); g++) {
                            if (o && d) {
                                for (f = 0, r || d.ownerDocument === h || (p(d), (c = !M)); (b = e[f++]); )
                                    if (b(d, r || h, c)) {
                                        a.push(d);
                                        break;
                                    }
                                u && (v = L);
                            }
                            i && ((d = !b && d) && m--, s && A.push(d));
                        }
                        if (((m += g), i && g !== m)) {
                            for (f = 0; (b = t[f++]); ) b(A, z, r, c);
                            if (s) {
                                if (m > 0) for (; g--; ) A[g] || z[g] || (z[g] = S.call(a));
                                z = ze(z);
                            }
                            k.apply(a, z), u && !s && z.length > 0 && m + t.length > 1 && se.uniqueSort(a);
                        }
                        return u && ((v = L), (l = y)), A;
                    };
                return i ? ce(s) : s;
            }
            return (
                (be.prototype = n.filters = n.pseudos),
                (n.setFilters = new be()),
                (r = se.tokenize = function (e, t) {
                    var i,
                        o,
                        s,
                        r,
                        c,
                        a,
                        l,
                        u = T[e + " "];
                    if (u) return t ? 0 : u.slice(0);
                    for (c = e, a = [], l = n.preFilter; c; ) {
                        for (r in ((i && !(o = H.exec(c))) || (o && (c = c.slice(o[0].length) || c), a.push((s = []))),
                        (i = !1),
                        (o = j.exec(c)) && ((i = o.shift()), s.push({ value: i, type: o[0].replace(I, " ") }), (c = c.slice(i.length))),
                        n.filter))
                            !(o = V[r].exec(c)) || (l[r] && !(o = l[r](o))) || ((i = o.shift()), s.push({ value: i, type: r, matches: o }), (c = c.slice(i.length)));
                        if (!i) break;
                    }
                    return t ? c.length : c ? se.error(e) : T(e, a).slice(0);
                }),
                (c = se.compile = function (e, t) {
                    var i,
                        n = [],
                        o = [],
                        s = N[e + " "];
                    if (!s) {
                        for (t || (t = r(e)), i = t.length; i--; ) (s = ve(t[i]))[z] ? n.push(s) : o.push(s);
                        (s = N(e, Oe(o, n))).selector = e;
                    }
                    return s;
                }),
                (a = se.select = function (e, t, i, o) {
                    var s,
                        a,
                        l,
                        u,
                        d,
                        p = "function" == typeof e && e,
                        h = !o && r((e = p.selector || e));
                    if (((i = i || []), 1 === h.length)) {
                        if ((a = h[0] = h[0].slice(0)).length > 2 && "ID" === (l = a[0]).type && 9 === t.nodeType && M && n.relative[a[1].type]) {
                            if (!(t = (n.find.ID(l.matches[0].replace(Z, ee), t) || [])[0])) return i;
                            p && (t = t.parentNode), (e = e.slice(a.shift().value.length));
                        }
                        for (s = V.needsContext.test(e) ? 0 : a.length; s-- && ((l = a[s]), !n.relative[(u = l.type)]); )
                            if ((d = n.find[u]) && (o = d(l.matches[0].replace(Z, ee), (J.test(a[0].type) && Me(t.parentNode)) || t))) {
                                if ((a.splice(s, 1), !(e = o.length && me(a)))) return k.apply(i, o), i;
                                break;
                            }
                    }
                    return (p || c(e, h))(o, t, !M, i, !t || (J.test(e) && Me(t.parentNode)) || t), i;
                }),
                (i.sortStable = z.split("").sort(q).join("") === z),
                (i.detectDuplicates = !!d),
                p(),
                (i.sortDetached = ae(function (e) {
                    return 1 & e.compareDocumentPosition(h.createElement("fieldset"));
                })),
                ae(function (e) {
                    return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
                }) ||
                    le("type|href|height|width", function (e, t, i) {
                        if (!i) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                    }),
                (i.attributes &&
                    ae(function (e) {
                        return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                    })) ||
                    le("value", function (e, t, i) {
                        if (!i && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                    }),
                ae(function (e) {
                    return null == e.getAttribute("disabled");
                }) ||
                    le(X, function (e, t, i) {
                        var n;
                        if (!i) return !0 === e[t] ? t.toLowerCase() : (n = e.getAttributeNode(t)) && n.specified ? n.value : null;
                    }),
                se
            );
        })(e);
        (z.find = O), (z.expr = O.selectors), (z.expr[":"] = z.expr.pseudos), (z.uniqueSort = z.unique = O.uniqueSort), (z.text = O.getText), (z.isXMLDoc = O.isXML), (z.contains = O.contains), (z.escapeSelector = O.escape);
        var L = function (e, t, i) {
                for (var n = [], o = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
                    if (1 === e.nodeType) {
                        if (o && z(e).is(i)) break;
                        n.push(e);
                    }
                return n;
            },
            T = function (e, t) {
                for (var i = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && i.push(e);
                return i;
            },
            N = z.expr.match.needsContext;
        function q(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        }
        var w = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        function W(e, t, i) {
            return M(t)
                ? z.grep(e, function (e, n) {
                      return !!t.call(e, n, e) !== i;
                  })
                : t.nodeType
                ? z.grep(e, function (e) {
                      return (e === t) !== i;
                  })
                : "string" != typeof t
                ? z.grep(e, function (e) {
                      return a.call(t, e) > -1 !== i;
                  })
                : z.filter(t, e, i);
        }
        (z.filter = function (e, t, i) {
            var n = t[0];
            return (
                i && (e = ":not(" + e + ")"),
                1 === t.length && 1 === n.nodeType
                    ? z.find.matchesSelector(n, e)
                        ? [n]
                        : []
                    : z.find.matches(
                          e,
                          z.grep(t, function (e) {
                              return 1 === e.nodeType;
                          })
                      )
            );
        }),
            z.fn.extend({
                find: function (e) {
                    var t,
                        i,
                        n = this.length,
                        o = this;
                    if ("string" != typeof e)
                        return this.pushStack(
                            z(e).filter(function () {
                                for (t = 0; t < n; t++) if (z.contains(o[t], this)) return !0;
                            })
                        );
                    for (i = this.pushStack([]), t = 0; t < n; t++) z.find(e, o[t], i);
                    return n > 1 ? z.uniqueSort(i) : i;
                },
                filter: function (e) {
                    return this.pushStack(W(this, e || [], !1));
                },
                not: function (e) {
                    return this.pushStack(W(this, e || [], !0));
                },
                is: function (e) {
                    return !!W(this, "string" == typeof e && N.test(e) ? z(e) : e || [], !1).length;
                },
            });
        var S,
            C = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        ((z.fn.init = function (e, t, i) {
            var o, s;
            if (!e) return this;
            if (((i = i || S), "string" == typeof e)) {
                if (!(o = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : C.exec(e)) || (!o[1] && t)) return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
                if (o[1]) {
                    if (((t = t instanceof z ? t[0] : t), z.merge(this, z.parseHTML(o[1], t && t.nodeType ? t.ownerDocument || t : n, !0)), w.test(o[1]) && z.isPlainObject(t))) for (o in t) M(this[o]) ? this[o](t[o]) : this.attr(o, t[o]);
                    return this;
                }
                return (s = n.getElementById(o[2])) && ((this[0] = s), (this.length = 1)), this;
            }
            return e.nodeType ? ((this[0] = e), (this.length = 1), this) : M(e) ? (void 0 !== i.ready ? i.ready(e) : e(z)) : z.makeArray(e, this);
        }).prototype = z.fn),
            (S = z(n));
        var k = /^(?:parents|prev(?:Until|All))/,
            B = { children: !0, contents: !0, next: !0, prev: !0 };
        function E(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
        }
        z.fn.extend({
            has: function (e) {
                var t = z(e, this),
                    i = t.length;
                return this.filter(function () {
                    for (var e = 0; e < i; e++) if (z.contains(this, t[e])) return !0;
                });
            },
            closest: function (e, t) {
                var i,
                    n = 0,
                    o = this.length,
                    s = [],
                    r = "string" != typeof e && z(e);
                if (!N.test(e))
                    for (; n < o; n++)
                        for (i = this[n]; i && i !== t; i = i.parentNode)
                            if (i.nodeType < 11 && (r ? r.index(i) > -1 : 1 === i.nodeType && z.find.matchesSelector(i, e))) {
                                s.push(i);
                                break;
                            }
                return this.pushStack(s.length > 1 ? z.uniqueSort(s) : s);
            },
            index: function (e) {
                return e ? ("string" == typeof e ? a.call(z(e), this[0]) : a.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function (e, t) {
                return this.pushStack(z.uniqueSort(z.merge(this.get(), z(e, t))));
            },
            addBack: function (e) {
                return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            },
        }),
            z.each(
                {
                    parent: function (e) {
                        var t = e.parentNode;
                        return t && 11 !== t.nodeType ? t : null;
                    },
                    parents: function (e) {
                        return L(e, "parentNode");
                    },
                    parentsUntil: function (e, t, i) {
                        return L(e, "parentNode", i);
                    },
                    next: function (e) {
                        return E(e, "nextSibling");
                    },
                    prev: function (e) {
                        return E(e, "previousSibling");
                    },
                    nextAll: function (e) {
                        return L(e, "nextSibling");
                    },
                    prevAll: function (e) {
                        return L(e, "previousSibling");
                    },
                    nextUntil: function (e, t, i) {
                        return L(e, "nextSibling", i);
                    },
                    prevUntil: function (e, t, i) {
                        return L(e, "previousSibling", i);
                    },
                    siblings: function (e) {
                        return T((e.parentNode || {}).firstChild, e);
                    },
                    children: function (e) {
                        return T(e.firstChild);
                    },
                    contents: function (e) {
                        return q(e, "iframe") ? e.contentDocument : (q(e, "template") && (e = e.content || e), z.merge([], e.childNodes));
                    },
                },
                function (e, t) {
                    z.fn[e] = function (i, n) {
                        var o = z.map(this, t, i);
                        return "Until" !== e.slice(-5) && (n = i), n && "string" == typeof n && (o = z.filter(n, o)), this.length > 1 && (B[e] || z.uniqueSort(o), k.test(e) && o.reverse()), this.pushStack(o);
                    };
                }
            );
        var X = /[^\x20\t\r\n\f]+/g;
        function x(e) {
            return e;
        }
        function _(e) {
            throw e;
        }
        function D(e, t, i, n) {
            var o;
            try {
                e && M((o = e.promise)) ? o.call(e).done(t).fail(i) : e && M((o = e.then)) ? o.call(e, t, i) : t.apply(void 0, [e].slice(n));
            } catch (e) {
                i.apply(void 0, [e]);
            }
        }
        (z.Callbacks = function (e) {
            e =
                "string" == typeof e
                    ? (function (e) {
                          var t = {};
                          return (
                              z.each(e.match(X) || [], function (e, i) {
                                  t[i] = !0;
                              }),
                              t
                          );
                      })(e)
                    : z.extend({}, e);
            var t,
                i,
                n,
                o,
                s = [],
                r = [],
                c = -1,
                a = function () {
                    for (o = o || e.once, n = t = !0; r.length; c = -1) for (i = r.shift(); ++c < s.length; ) !1 === s[c].apply(i[0], i[1]) && e.stopOnFalse && ((c = s.length), (i = !1));
                    e.memory || (i = !1), (t = !1), o && (s = i ? [] : "");
                },
                l = {
                    add: function () {
                        return (
                            s &&
                                (i && !t && ((c = s.length - 1), r.push(i)),
                                (function t(i) {
                                    z.each(i, function (i, n) {
                                        M(n) ? (e.unique && l.has(n)) || s.push(n) : n && n.length && "string" !== A(n) && t(n);
                                    });
                                })(arguments),
                                i && !t && a()),
                            this
                        );
                    },
                    remove: function () {
                        return (
                            z.each(arguments, function (e, t) {
                                for (var i; (i = z.inArray(t, s, i)) > -1; ) s.splice(i, 1), i <= c && c--;
                            }),
                            this
                        );
                    },
                    has: function (e) {
                        return e ? z.inArray(e, s) > -1 : s.length > 0;
                    },
                    empty: function () {
                        return s && (s = []), this;
                    },
                    disable: function () {
                        return (o = r = []), (s = i = ""), this;
                    },
                    disabled: function () {
                        return !s;
                    },
                    lock: function () {
                        return (o = r = []), i || t || (s = i = ""), this;
                    },
                    locked: function () {
                        return !!o;
                    },
                    fireWith: function (e, i) {
                        return o || ((i = [e, (i = i || []).slice ? i.slice() : i]), r.push(i), t || a()), this;
                    },
                    fire: function () {
                        return l.fireWith(this, arguments), this;
                    },
                    fired: function () {
                        return !!n;
                    },
                };
            return l;
        }),
            z.extend({
                Deferred: function (t) {
                    var i = [
                            ["notify", "progress", z.Callbacks("memory"), z.Callbacks("memory"), 2],
                            ["resolve", "done", z.Callbacks("once memory"), z.Callbacks("once memory"), 0, "resolved"],
                            ["reject", "fail", z.Callbacks("once memory"), z.Callbacks("once memory"), 1, "rejected"],
                        ],
                        n = "pending",
                        o = {
                            state: function () {
                                return n;
                            },
                            always: function () {
                                return s.done(arguments).fail(arguments), this;
                            },
                            catch: function (e) {
                                return o.then(null, e);
                            },
                            pipe: function () {
                                var e = arguments;
                                return z
                                    .Deferred(function (t) {
                                        z.each(i, function (i, n) {
                                            var o = M(e[n[4]]) && e[n[4]];
                                            s[n[1]](function () {
                                                var e = o && o.apply(this, arguments);
                                                e && M(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[n[0] + "With"](this, o ? [e] : arguments);
                                            });
                                        }),
                                            (e = null);
                                    })
                                    .promise();
                            },
                            then: function (t, n, o) {
                                var s = 0;
                                function r(t, i, n, o) {
                                    return function () {
                                        var c = this,
                                            a = arguments,
                                            l = function () {
                                                var e, l;
                                                if (!(t < s)) {
                                                    if ((e = n.apply(c, a)) === i.promise()) throw new TypeError("Thenable self-resolution");
                                                    (l = e && ("object" == typeof e || "function" == typeof e) && e.then),
                                                        M(l)
                                                            ? o
                                                                ? l.call(e, r(s, i, x, o), r(s, i, _, o))
                                                                : (s++, l.call(e, r(s, i, x, o), r(s, i, _, o), r(s, i, x, i.notifyWith)))
                                                            : (n !== x && ((c = void 0), (a = [e])), (o || i.resolveWith)(c, a));
                                                }
                                            },
                                            u = o
                                                ? l
                                                : function () {
                                                      try {
                                                          l();
                                                      } catch (e) {
                                                          z.Deferred.exceptionHook && z.Deferred.exceptionHook(e, u.stackTrace), t + 1 >= s && (n !== _ && ((c = void 0), (a = [e])), i.rejectWith(c, a));
                                                      }
                                                  };
                                        t ? u() : (z.Deferred.getStackHook && (u.stackTrace = z.Deferred.getStackHook()), e.setTimeout(u));
                                    };
                                }
                                return z
                                    .Deferred(function (e) {
                                        i[0][3].add(r(0, e, M(o) ? o : x, e.notifyWith)), i[1][3].add(r(0, e, M(t) ? t : x)), i[2][3].add(r(0, e, M(n) ? n : _));
                                    })
                                    .promise();
                            },
                            promise: function (e) {
                                return null != e ? z.extend(e, o) : o;
                            },
                        },
                        s = {};
                    return (
                        z.each(i, function (e, t) {
                            var r = t[2],
                                c = t[5];
                            (o[t[1]] = r.add),
                                c &&
                                    r.add(
                                        function () {
                                            n = c;
                                        },
                                        i[3 - e][2].disable,
                                        i[3 - e][3].disable,
                                        i[0][2].lock,
                                        i[0][3].lock
                                    ),
                                r.add(t[3].fire),
                                (s[t[0]] = function () {
                                    return s[t[0] + "With"](this === s ? void 0 : this, arguments), this;
                                }),
                                (s[t[0] + "With"] = r.fireWith);
                        }),
                        o.promise(s),
                        t && t.call(s, s),
                        s
                    );
                },
                when: function (e) {
                    var t = arguments.length,
                        i = t,
                        n = Array(i),
                        o = s.call(arguments),
                        r = z.Deferred(),
                        c = function (e) {
                            return function (i) {
                                (n[e] = this), (o[e] = arguments.length > 1 ? s.call(arguments) : i), --t || r.resolveWith(n, o);
                            };
                        };
                    if (t <= 1 && (D(e, r.done(c(i)).resolve, r.reject, !t), "pending" === r.state() || M(o[i] && o[i].then))) return r.then();
                    for (; i--; ) D(o[i], c(i), r.reject);
                    return r.promise();
                },
            });
        var R = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        (z.Deferred.exceptionHook = function (t, i) {
            e.console && e.console.warn && t && R.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, i);
        }),
            (z.readyException = function (t) {
                e.setTimeout(function () {
                    throw t;
                });
            });
        var P = z.Deferred();
        function I() {
            n.removeEventListener("DOMContentLoaded", I), e.removeEventListener("load", I), z.ready();
        }
        (z.fn.ready = function (e) {
            return (
                P.then(e).catch(function (e) {
                    z.readyException(e);
                }),
                this
            );
        }),
            z.extend({
                isReady: !1,
                readyWait: 1,
                ready: function (e) {
                    (!0 === e ? --z.readyWait : z.isReady) || ((z.isReady = !0), (!0 !== e && --z.readyWait > 0) || P.resolveWith(n, [z]));
                },
            }),
            (z.ready.then = P.then),
            "complete" === n.readyState || ("loading" !== n.readyState && !n.documentElement.doScroll) ? e.setTimeout(z.ready) : (n.addEventListener("DOMContentLoaded", I), e.addEventListener("load", I));
        var H = function (e, t, i, n, o, s, r) {
                var c = 0,
                    a = e.length,
                    l = null == i;
                if ("object" === A(i)) for (c in ((o = !0), i)) H(e, t, c, i[c], !0, s, r);
                else if (
                    void 0 !== n &&
                    ((o = !0),
                    M(n) || (r = !0),
                    l &&
                        (r
                            ? (t.call(e, n), (t = null))
                            : ((l = t),
                              (t = function (e, t, i) {
                                  return l.call(z(e), i);
                              }))),
                    t)
                )
                    for (; c < a; c++) t(e[c], i, r ? n : n.call(e[c], c, t(e[c], i)));
                return o ? e : l ? t.call(e) : a ? t(e[0], i) : s;
            },
            j = /^-ms-/,
            $ = /-([a-z])/g;
        function F(e, t) {
            return t.toUpperCase();
        }
        function U(e) {
            return e.replace(j, "ms-").replace($, F);
        }
        var V = function (e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
        };
        function Y() {
            this.expando = z.expando + Y.uid++;
        }
        (Y.uid = 1),
            (Y.prototype = {
                cache: function (e) {
                    var t = e[this.expando];
                    return t || ((t = {}), V(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
                },
                set: function (e, t, i) {
                    var n,
                        o = this.cache(e);
                    if ("string" == typeof t) o[U(t)] = i;
                    else for (n in t) o[U(n)] = t[n];
                    return o;
                },
                get: function (e, t) {
                    return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][U(t)];
                },
                access: function (e, t, i) {
                    return void 0 === t || (t && "string" == typeof t && void 0 === i) ? this.get(e, t) : (this.set(e, t, i), void 0 !== i ? i : t);
                },
                remove: function (e, t) {
                    var i,
                        n = e[this.expando];
                    if (void 0 !== n) {
                        if (void 0 !== t) {
                            i = (t = Array.isArray(t) ? t.map(U) : (t = U(t)) in n ? [t] : t.match(X) || []).length;
                            for (; i--; ) delete n[t[i]];
                        }
                        (void 0 === t || z.isEmptyObject(n)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                    }
                },
                hasData: function (e) {
                    var t = e[this.expando];
                    return void 0 !== t && !z.isEmptyObject(t);
                },
            });
        var G = new Y(),
            K = new Y(),
            Q = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            J = /[A-Z]/g;
        function Z(e, t, i) {
            var n;
            if (void 0 === i && 1 === e.nodeType)
                if (((n = "data-" + t.replace(J, "-$&").toLowerCase()), "string" == typeof (i = e.getAttribute(n)))) {
                    try {
                        i = (function (e) {
                            return "true" === e || ("false" !== e && ("null" === e ? null : e === +e + "" ? +e : Q.test(e) ? JSON.parse(e) : e));
                        })(i);
                    } catch (e) {}
                    K.set(e, t, i);
                } else i = void 0;
            return i;
        }
        z.extend({
            hasData: function (e) {
                return K.hasData(e) || G.hasData(e);
            },
            data: function (e, t, i) {
                return K.access(e, t, i);
            },
            removeData: function (e, t) {
                K.remove(e, t);
            },
            _data: function (e, t, i) {
                return G.access(e, t, i);
            },
            _removeData: function (e, t) {
                G.remove(e, t);
            },
        }),
            z.fn.extend({
                data: function (e, t) {
                    var i,
                        n,
                        o,
                        s = this[0],
                        r = s && s.attributes;
                    if (void 0 === e) {
                        if (this.length && ((o = K.get(s)), 1 === s.nodeType && !G.get(s, "hasDataAttrs"))) {
                            for (i = r.length; i--; ) r[i] && 0 === (n = r[i].name).indexOf("data-") && ((n = U(n.slice(5))), Z(s, n, o[n]));
                            G.set(s, "hasDataAttrs", !0);
                        }
                        return o;
                    }
                    return "object" == typeof e
                        ? this.each(function () {
                              K.set(this, e);
                          })
                        : H(
                              this,
                              function (t) {
                                  var i;
                                  if (s && void 0 === t) {
                                      if (void 0 !== (i = K.get(s, e))) return i;
                                      if (void 0 !== (i = Z(s, e))) return i;
                                  } else
                                      this.each(function () {
                                          K.set(this, e, t);
                                      });
                              },
                              null,
                              t,
                              arguments.length > 1,
                              null,
                              !0
                          );
                },
                removeData: function (e) {
                    return this.each(function () {
                        K.remove(this, e);
                    });
                },
            }),
            z.extend({
                queue: function (e, t, i) {
                    var n;
                    if (e) return (t = (t || "fx") + "queue"), (n = G.get(e, t)), i && (!n || Array.isArray(i) ? (n = G.access(e, t, z.makeArray(i))) : n.push(i)), n || [];
                },
                dequeue: function (e, t) {
                    t = t || "fx";
                    var i = z.queue(e, t),
                        n = i.length,
                        o = i.shift(),
                        s = z._queueHooks(e, t);
                    "inprogress" === o && ((o = i.shift()), n--),
                        o &&
                            ("fx" === t && i.unshift("inprogress"),
                            delete s.stop,
                            o.call(
                                e,
                                function () {
                                    z.dequeue(e, t);
                                },
                                s
                            )),
                        !n && s && s.empty.fire();
                },
                _queueHooks: function (e, t) {
                    var i = t + "queueHooks";
                    return (
                        G.get(e, i) ||
                        G.access(e, i, {
                            empty: z.Callbacks("once memory").add(function () {
                                G.remove(e, [t + "queue", i]);
                            }),
                        })
                    );
                },
            }),
            z.fn.extend({
                queue: function (e, t) {
                    var i = 2;
                    return (
                        "string" != typeof e && ((t = e), (e = "fx"), i--),
                        arguments.length < i
                            ? z.queue(this[0], e)
                            : void 0 === t
                            ? this
                            : this.each(function () {
                                  var i = z.queue(this, e, t);
                                  z._queueHooks(this, e), "fx" === e && "inprogress" !== i[0] && z.dequeue(this, e);
                              })
                    );
                },
                dequeue: function (e) {
                    return this.each(function () {
                        z.dequeue(this, e);
                    });
                },
                clearQueue: function (e) {
                    return this.queue(e || "fx", []);
                },
                promise: function (e, t) {
                    var i,
                        n = 1,
                        o = z.Deferred(),
                        s = this,
                        r = this.length,
                        c = function () {
                            --n || o.resolveWith(s, [s]);
                        };
                    for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; r--; ) (i = G.get(s[r], e + "queueHooks")) && i.empty && (n++, i.empty.add(c));
                    return c(), o.promise(t);
                },
            });
        var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
            ie = ["Top", "Right", "Bottom", "Left"],
            ne = function (e, t) {
                return "none" === (e = t || e).style.display || ("" === e.style.display && z.contains(e.ownerDocument, e) && "none" === z.css(e, "display"));
            },
            oe = function (e, t, i, n) {
                var o,
                    s,
                    r = {};
                for (s in t) (r[s] = e.style[s]), (e.style[s] = t[s]);
                for (s in ((o = i.apply(e, n || [])), t)) e.style[s] = r[s];
                return o;
            };
        function se(e, t, i, n) {
            var o,
                s,
                r = 20,
                c = n
                    ? function () {
                          return n.cur();
                      }
                    : function () {
                          return z.css(e, t, "");
                      },
                a = c(),
                l = (i && i[3]) || (z.cssNumber[t] ? "" : "px"),
                u = (z.cssNumber[t] || ("px" !== l && +a)) && te.exec(z.css(e, t));
            if (u && u[3] !== l) {
                for (a /= 2, l = l || u[3], u = +a || 1; r--; ) z.style(e, t, u + l), (1 - s) * (1 - (s = c() / a || 0.5)) <= 0 && (r = 0), (u /= s);
                (u *= 2), z.style(e, t, u + l), (i = i || []);
            }
            return i && ((u = +u || +a || 0), (o = i[1] ? u + (i[1] + 1) * i[2] : +i[2]), n && ((n.unit = l), (n.start = u), (n.end = o))), o;
        }
        var re = {};
        function ce(e) {
            var t,
                i = e.ownerDocument,
                n = e.nodeName,
                o = re[n];
            return o || ((t = i.body.appendChild(i.createElement(n))), (o = z.css(t, "display")), t.parentNode.removeChild(t), "none" === o && (o = "block"), (re[n] = o), o);
        }
        function ae(e, t) {
            for (var i, n, o = [], s = 0, r = e.length; s < r; s++)
                (n = e[s]).style &&
                    ((i = n.style.display),
                    t ? ("none" === i && ((o[s] = G.get(n, "display") || null), o[s] || (n.style.display = "")), "" === n.style.display && ne(n) && (o[s] = ce(n))) : "none" !== i && ((o[s] = "none"), G.set(n, "display", i)));
            for (s = 0; s < r; s++) null != o[s] && (e[s].style.display = o[s]);
            return e;
        }
        z.fn.extend({
            show: function () {
                return ae(this, !0);
            },
            hide: function () {
                return ae(this);
            },
            toggle: function (e) {
                return "boolean" == typeof e
                    ? e
                        ? this.show()
                        : this.hide()
                    : this.each(function () {
                          ne(this) ? z(this).show() : z(this).hide();
                      });
            },
        });
        var le = /^(?:checkbox|radio)$/i,
            ue = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
            de = /^$|^module$|\/(?:java|ecma)script/i,
            pe = {
                option: [1, "<select multiple='multiple'>", "</select>"],
                thead: [1, "<table>", "</table>"],
                col: [2, "<table><colgroup>", "</colgroup></table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: [0, "", ""],
            };
        function he(e, t) {
            var i;
            return (i = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : []), void 0 === t || (t && q(e, t)) ? z.merge([e], i) : i;
        }
        function fe(e, t) {
            for (var i = 0, n = e.length; i < n; i++) G.set(e[i], "globalEval", !t || G.get(t[i], "globalEval"));
        }
        (pe.optgroup = pe.option), (pe.tbody = pe.tfoot = pe.colgroup = pe.caption = pe.thead), (pe.th = pe.td);
        var Me = /<|&#?\w+;/;
        function be(e, t, i, n, o) {
            for (var s, r, c, a, l, u, d = t.createDocumentFragment(), p = [], h = 0, f = e.length; h < f; h++)
                if ((s = e[h]) || 0 === s)
                    if ("object" === A(s)) z.merge(p, s.nodeType ? [s] : s);
                    else if (Me.test(s)) {
                        for (r = r || d.appendChild(t.createElement("div")), c = (ue.exec(s) || ["", ""])[1].toLowerCase(), a = pe[c] || pe._default, r.innerHTML = a[1] + z.htmlPrefilter(s) + a[2], u = a[0]; u--; ) r = r.lastChild;
                        z.merge(p, r.childNodes), ((r = d.firstChild).textContent = "");
                    } else p.push(t.createTextNode(s));
            for (d.textContent = "", h = 0; (s = p[h++]); )
                if (n && z.inArray(s, n) > -1) o && o.push(s);
                else if (((l = z.contains(s.ownerDocument, s)), (r = he(d.appendChild(s), "script")), l && fe(r), i)) for (u = 0; (s = r[u++]); ) de.test(s.type || "") && i.push(s);
            return d;
        }
        !(function () {
            var e = n.createDocumentFragment().appendChild(n.createElement("div")),
                t = n.createElement("input");
            t.setAttribute("type", "radio"),
                t.setAttribute("checked", "checked"),
                t.setAttribute("name", "t"),
                e.appendChild(t),
                (f.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked),
                (e.innerHTML = "<textarea>x</textarea>"),
                (f.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue);
        })();
        var me = n.documentElement,
            ge = /^key/,
            Ae = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            ze = /^([^.]*)(?:\.(.+)|)/;
        function ye() {
            return !0;
        }
        function ve() {
            return !1;
        }
        function Oe() {
            try {
                return n.activeElement;
            } catch (e) {}
        }
        function Le(e, t, i, n, o, s) {
            var r, c;
            if ("object" == typeof t) {
                for (c in ("string" != typeof i && ((n = n || i), (i = void 0)), t)) Le(e, c, i, n, t[c], s);
                return e;
            }
            if ((null == n && null == o ? ((o = i), (n = i = void 0)) : null == o && ("string" == typeof i ? ((o = n), (n = void 0)) : ((o = n), (n = i), (i = void 0))), !1 === o)) o = ve;
            else if (!o) return e;
            return (
                1 === s &&
                    ((r = o),
                    ((o = function (e) {
                        return z().off(e), r.apply(this, arguments);
                    }).guid = r.guid || (r.guid = z.guid++))),
                e.each(function () {
                    z.event.add(this, t, o, n, i);
                })
            );
        }
        (z.event = {
            global: {},
            add: function (e, t, i, n, o) {
                var s,
                    r,
                    c,
                    a,
                    l,
                    u,
                    d,
                    p,
                    h,
                    f,
                    M,
                    b = G.get(e);
                if (b)
                    for (
                        i.handler && ((i = (s = i).handler), (o = s.selector)),
                            o && z.find.matchesSelector(me, o),
                            i.guid || (i.guid = z.guid++),
                            (a = b.events) || (a = b.events = {}),
                            (r = b.handle) ||
                                (r = b.handle = function (t) {
                                    return void 0 !== z && z.event.triggered !== t.type ? z.event.dispatch.apply(e, arguments) : void 0;
                                }),
                            l = (t = (t || "").match(X) || [""]).length;
                        l--;

                    )
                        (h = M = (c = ze.exec(t[l]) || [])[1]),
                            (f = (c[2] || "").split(".").sort()),
                            h &&
                                ((d = z.event.special[h] || {}),
                                (h = (o ? d.delegateType : d.bindType) || h),
                                (d = z.event.special[h] || {}),
                                (u = z.extend({ type: h, origType: M, data: n, handler: i, guid: i.guid, selector: o, needsContext: o && z.expr.match.needsContext.test(o), namespace: f.join(".") }, s)),
                                (p = a[h]) || (((p = a[h] = []).delegateCount = 0), (d.setup && !1 !== d.setup.call(e, n, f, r)) || (e.addEventListener && e.addEventListener(h, r))),
                                d.add && (d.add.call(e, u), u.handler.guid || (u.handler.guid = i.guid)),
                                o ? p.splice(p.delegateCount++, 0, u) : p.push(u),
                                (z.event.global[h] = !0));
            },
            remove: function (e, t, i, n, o) {
                var s,
                    r,
                    c,
                    a,
                    l,
                    u,
                    d,
                    p,
                    h,
                    f,
                    M,
                    b = G.hasData(e) && G.get(e);
                if (b && (a = b.events)) {
                    for (l = (t = (t || "").match(X) || [""]).length; l--; )
                        if (((h = M = (c = ze.exec(t[l]) || [])[1]), (f = (c[2] || "").split(".").sort()), h)) {
                            for (d = z.event.special[h] || {}, p = a[(h = (n ? d.delegateType : d.bindType) || h)] || [], c = c[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = s = p.length; s--; )
                                (u = p[s]),
                                    (!o && M !== u.origType) ||
                                        (i && i.guid !== u.guid) ||
                                        (c && !c.test(u.namespace)) ||
                                        (n && n !== u.selector && ("**" !== n || !u.selector)) ||
                                        (p.splice(s, 1), u.selector && p.delegateCount--, d.remove && d.remove.call(e, u));
                            r && !p.length && ((d.teardown && !1 !== d.teardown.call(e, f, b.handle)) || z.removeEvent(e, h, b.handle), delete a[h]);
                        } else for (h in a) z.event.remove(e, h + t[l], i, n, !0);
                    z.isEmptyObject(a) && G.remove(e, "handle events");
                }
            },
            dispatch: function (e) {
                var t,
                    i,
                    n,
                    o,
                    s,
                    r,
                    c = z.event.fix(e),
                    a = new Array(arguments.length),
                    l = (G.get(this, "events") || {})[c.type] || [],
                    u = z.event.special[c.type] || {};
                for (a[0] = c, t = 1; t < arguments.length; t++) a[t] = arguments[t];
                if (((c.delegateTarget = this), !u.preDispatch || !1 !== u.preDispatch.call(this, c))) {
                    for (r = z.event.handlers.call(this, c, l), t = 0; (o = r[t++]) && !c.isPropagationStopped(); )
                        for (c.currentTarget = o.elem, i = 0; (s = o.handlers[i++]) && !c.isImmediatePropagationStopped(); )
                            (c.rnamespace && !c.rnamespace.test(s.namespace)) ||
                                ((c.handleObj = s), (c.data = s.data), void 0 !== (n = ((z.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, a)) && !1 === (c.result = n) && (c.preventDefault(), c.stopPropagation()));
                    return u.postDispatch && u.postDispatch.call(this, c), c.result;
                }
            },
            handlers: function (e, t) {
                var i,
                    n,
                    o,
                    s,
                    r,
                    c = [],
                    a = t.delegateCount,
                    l = e.target;
                if (a && l.nodeType && !("click" === e.type && e.button >= 1))
                    for (; l !== this; l = l.parentNode || this)
                        if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
                            for (s = [], r = {}, i = 0; i < a; i++) void 0 === r[(o = (n = t[i]).selector + " ")] && (r[o] = n.needsContext ? z(o, this).index(l) > -1 : z.find(o, this, null, [l]).length), r[o] && s.push(n);
                            s.length && c.push({ elem: l, handlers: s });
                        }
                return (l = this), a < t.length && c.push({ elem: l, handlers: t.slice(a) }), c;
            },
            addProp: function (e, t) {
                Object.defineProperty(z.Event.prototype, e, {
                    enumerable: !0,
                    configurable: !0,
                    get: M(t)
                        ? function () {
                              if (this.originalEvent) return t(this.originalEvent);
                          }
                        : function () {
                              if (this.originalEvent) return this.originalEvent[e];
                          },
                    set: function (t) {
                        Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
                    },
                });
            },
            fix: function (e) {
                return e[z.expando] ? e : new z.Event(e);
            },
            special: {
                load: { noBubble: !0 },
                focus: {
                    trigger: function () {
                        if (this !== Oe() && this.focus) return this.focus(), !1;
                    },
                    delegateType: "focusin",
                },
                blur: {
                    trigger: function () {
                        if (this === Oe() && this.blur) return this.blur(), !1;
                    },
                    delegateType: "focusout",
                },
                click: {
                    trigger: function () {
                        if ("checkbox" === this.type && this.click && q(this, "input")) return this.click(), !1;
                    },
                    _default: function (e) {
                        return q(e.target, "a");
                    },
                },
                beforeunload: {
                    postDispatch: function (e) {
                        void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                    },
                },
            },
        }),
            (z.removeEvent = function (e, t, i) {
                e.removeEventListener && e.removeEventListener(t, i);
            }),
            (z.Event = function (e, t) {
                if (!(this instanceof z.Event)) return new z.Event(e, t);
                e && e.type
                    ? ((this.originalEvent = e),
                      (this.type = e.type),
                      (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? ye : ve),
                      (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                      (this.currentTarget = e.currentTarget),
                      (this.relatedTarget = e.relatedTarget))
                    : (this.type = e),
                    t && z.extend(this, t),
                    (this.timeStamp = (e && e.timeStamp) || Date.now()),
                    (this[z.expando] = !0);
            }),
            (z.Event.prototype = {
                constructor: z.Event,
                isDefaultPrevented: ve,
                isPropagationStopped: ve,
                isImmediatePropagationStopped: ve,
                isSimulated: !1,
                preventDefault: function () {
                    var e = this.originalEvent;
                    (this.isDefaultPrevented = ye), e && !this.isSimulated && e.preventDefault();
                },
                stopPropagation: function () {
                    var e = this.originalEvent;
                    (this.isPropagationStopped = ye), e && !this.isSimulated && e.stopPropagation();
                },
                stopImmediatePropagation: function () {
                    var e = this.originalEvent;
                    (this.isImmediatePropagationStopped = ye), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
                },
            }),
            z.each(
                {
                    altKey: !0,
                    bubbles: !0,
                    cancelable: !0,
                    changedTouches: !0,
                    ctrlKey: !0,
                    detail: !0,
                    eventPhase: !0,
                    metaKey: !0,
                    pageX: !0,
                    pageY: !0,
                    shiftKey: !0,
                    view: !0,
                    char: !0,
                    charCode: !0,
                    key: !0,
                    keyCode: !0,
                    button: !0,
                    buttons: !0,
                    clientX: !0,
                    clientY: !0,
                    offsetX: !0,
                    offsetY: !0,
                    pointerId: !0,
                    pointerType: !0,
                    screenX: !0,
                    screenY: !0,
                    targetTouches: !0,
                    toElement: !0,
                    touches: !0,
                    which: function (e) {
                        var t = e.button;
                        return null == e.which && ge.test(e.type) ? (null != e.charCode ? e.charCode : e.keyCode) : !e.which && void 0 !== t && Ae.test(e.type) ? (1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0) : e.which;
                    },
                },
                z.event.addProp
            ),
            z.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
                z.event.special[e] = {
                    delegateType: t,
                    bindType: t,
                    handle: function (e) {
                        var i,
                            n = this,
                            o = e.relatedTarget,
                            s = e.handleObj;
                        return (o && (o === n || z.contains(n, o))) || ((e.type = s.origType), (i = s.handler.apply(this, arguments)), (e.type = t)), i;
                    },
                };
            }),
            z.fn.extend({
                on: function (e, t, i, n) {
                    return Le(this, e, t, i, n);
                },
                one: function (e, t, i, n) {
                    return Le(this, e, t, i, n, 1);
                },
                off: function (e, t, i) {
                    var n, o;
                    if (e && e.preventDefault && e.handleObj) return (n = e.handleObj), z(e.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
                    if ("object" == typeof e) {
                        for (o in e) this.off(o, t, e[o]);
                        return this;
                    }
                    return (
                        (!1 !== t && "function" != typeof t) || ((i = t), (t = void 0)),
                        !1 === i && (i = ve),
                        this.each(function () {
                            z.event.remove(this, e, i, t);
                        })
                    );
                },
            });
        var Te = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
            Ne = /<script|<style|<link/i,
            qe = /checked\s*(?:[^=]|=\s*.checked.)/i,
            we = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        function We(e, t) {
            return (q(e, "table") && q(11 !== t.nodeType ? t : t.firstChild, "tr") && z(e).children("tbody")[0]) || e;
        }
        function Se(e) {
            return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
        }
        function Ce(e) {
            return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
        }
        function ke(e, t) {
            var i, n, o, s, r, c, a, l;
            if (1 === t.nodeType) {
                if (G.hasData(e) && ((s = G.access(e)), (r = G.set(t, s)), (l = s.events))) for (o in (delete r.handle, (r.events = {}), l)) for (i = 0, n = l[o].length; i < n; i++) z.event.add(t, o, l[o][i]);
                K.hasData(e) && ((c = K.access(e)), (a = z.extend({}, c)), K.set(t, a));
            }
        }
        function Be(e, t) {
            var i = t.nodeName.toLowerCase();
            "input" === i && le.test(e.type) ? (t.checked = e.checked) : ("input" !== i && "textarea" !== i) || (t.defaultValue = e.defaultValue);
        }
        function Ee(e, t, i, n) {
            t = r.apply([], t);
            var o,
                s,
                c,
                a,
                l,
                u,
                d = 0,
                p = e.length,
                h = p - 1,
                b = t[0],
                m = M(b);
            if (m || (p > 1 && "string" == typeof b && !f.checkClone && qe.test(b)))
                return e.each(function (o) {
                    var s = e.eq(o);
                    m && (t[0] = b.call(this, o, s.html())), Ee(s, t, i, n);
                });
            if (p && ((s = (o = be(t, e[0].ownerDocument, !1, e, n)).firstChild), 1 === o.childNodes.length && (o = s), s || n)) {
                for (a = (c = z.map(he(o, "script"), Se)).length; d < p; d++) (l = o), d !== h && ((l = z.clone(l, !0, !0)), a && z.merge(c, he(l, "script"))), i.call(e[d], l, d);
                if (a)
                    for (u = c[c.length - 1].ownerDocument, z.map(c, Ce), d = 0; d < a; d++)
                        (l = c[d]), de.test(l.type || "") && !G.access(l, "globalEval") && z.contains(u, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? z._evalUrl && z._evalUrl(l.src) : g(l.textContent.replace(we, ""), u, l));
            }
            return e;
        }
        function Xe(e, t, i) {
            for (var n, o = t ? z.filter(t, e) : e, s = 0; null != (n = o[s]); s++) i || 1 !== n.nodeType || z.cleanData(he(n)), n.parentNode && (i && z.contains(n.ownerDocument, n) && fe(he(n, "script")), n.parentNode.removeChild(n));
            return e;
        }
        z.extend({
            htmlPrefilter: function (e) {
                return e.replace(Te, "<$1></$2>");
            },
            clone: function (e, t, i) {
                var n,
                    o,
                    s,
                    r,
                    c = e.cloneNode(!0),
                    a = z.contains(e.ownerDocument, e);
                if (!(f.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || z.isXMLDoc(e))) for (r = he(c), n = 0, o = (s = he(e)).length; n < o; n++) Be(s[n], r[n]);
                if (t)
                    if (i) for (s = s || he(e), r = r || he(c), n = 0, o = s.length; n < o; n++) ke(s[n], r[n]);
                    else ke(e, c);
                return (r = he(c, "script")).length > 0 && fe(r, !a && he(e, "script")), c;
            },
            cleanData: function (e) {
                for (var t, i, n, o = z.event.special, s = 0; void 0 !== (i = e[s]); s++)
                    if (V(i)) {
                        if ((t = i[G.expando])) {
                            if (t.events) for (n in t.events) o[n] ? z.event.remove(i, n) : z.removeEvent(i, n, t.handle);
                            i[G.expando] = void 0;
                        }
                        i[K.expando] && (i[K.expando] = void 0);
                    }
            },
        }),
            z.fn.extend({
                detach: function (e) {
                    return Xe(this, e, !0);
                },
                remove: function (e) {
                    return Xe(this, e);
                },
                text: function (e) {
                    return H(
                        this,
                        function (e) {
                            return void 0 === e
                                ? z.text(this)
                                : this.empty().each(function () {
                                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                                  });
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                append: function () {
                    return Ee(this, arguments, function (e) {
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || We(this, e).appendChild(e);
                    });
                },
                prepend: function () {
                    return Ee(this, arguments, function (e) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var t = We(this, e);
                            t.insertBefore(e, t.firstChild);
                        }
                    });
                },
                before: function () {
                    return Ee(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this);
                    });
                },
                after: function () {
                    return Ee(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                    });
                },
                empty: function () {
                    for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (z.cleanData(he(e, !1)), (e.textContent = ""));
                    return this;
                },
                clone: function (e, t) {
                    return (
                        (e = null != e && e),
                        (t = null == t ? e : t),
                        this.map(function () {
                            return z.clone(this, e, t);
                        })
                    );
                },
                html: function (e) {
                    return H(
                        this,
                        function (e) {
                            var t = this[0] || {},
                                i = 0,
                                n = this.length;
                            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                            if ("string" == typeof e && !Ne.test(e) && !pe[(ue.exec(e) || ["", ""])[1].toLowerCase()]) {
                                e = z.htmlPrefilter(e);
                                try {
                                    for (; i < n; i++) 1 === (t = this[i] || {}).nodeType && (z.cleanData(he(t, !1)), (t.innerHTML = e));
                                    t = 0;
                                } catch (e) {}
                            }
                            t && this.empty().append(e);
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                replaceWith: function () {
                    var e = [];
                    return Ee(
                        this,
                        arguments,
                        function (t) {
                            var i = this.parentNode;
                            z.inArray(this, e) < 0 && (z.cleanData(he(this)), i && i.replaceChild(t, this));
                        },
                        e
                    );
                },
            }),
            z.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
                z.fn[e] = function (e) {
                    for (var i, n = [], o = z(e), s = o.length - 1, r = 0; r <= s; r++) (i = r === s ? this : this.clone(!0)), z(o[r])[t](i), c.apply(n, i.get());
                    return this.pushStack(n);
                };
            });
        var xe = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
            _e = function (t) {
                var i = t.ownerDocument.defaultView;
                return (i && i.opener) || (i = e), i.getComputedStyle(t);
            },
            De = new RegExp(ie.join("|"), "i");
        function Re(e, t, i) {
            var n,
                o,
                s,
                r,
                c = e.style;
            return (
                (i = i || _e(e)) &&
                    ("" !== (r = i.getPropertyValue(t) || i[t]) || z.contains(e.ownerDocument, e) || (r = z.style(e, t)),
                    !f.pixelBoxStyles() && xe.test(r) && De.test(t) && ((n = c.width), (o = c.minWidth), (s = c.maxWidth), (c.minWidth = c.maxWidth = c.width = r), (r = i.width), (c.width = n), (c.minWidth = o), (c.maxWidth = s))),
                void 0 !== r ? r + "" : r
            );
        }
        function Pe(e, t) {
            return {
                get: function () {
                    if (!e()) return (this.get = t).apply(this, arguments);
                    delete this.get;
                },
            };
        }
        !(function () {
            function t() {
                if (u) {
                    (l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                        (u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                        me.appendChild(l).appendChild(u);
                    var t = e.getComputedStyle(u);
                    (o = "1%" !== t.top),
                        (a = 12 === i(t.marginLeft)),
                        (u.style.right = "60%"),
                        (c = 36 === i(t.right)),
                        (s = 36 === i(t.width)),
                        (u.style.position = "absolute"),
                        (r = 36 === u.offsetWidth || "absolute"),
                        me.removeChild(l),
                        (u = null);
                }
            }
            function i(e) {
                return Math.round(parseFloat(e));
            }
            var o,
                s,
                r,
                c,
                a,
                l = n.createElement("div"),
                u = n.createElement("div");
            u.style &&
                ((u.style.backgroundClip = "content-box"),
                (u.cloneNode(!0).style.backgroundClip = ""),
                (f.clearCloneStyle = "content-box" === u.style.backgroundClip),
                z.extend(f, {
                    boxSizingReliable: function () {
                        return t(), s;
                    },
                    pixelBoxStyles: function () {
                        return t(), c;
                    },
                    pixelPosition: function () {
                        return t(), o;
                    },
                    reliableMarginLeft: function () {
                        return t(), a;
                    },
                    scrollboxSize: function () {
                        return t(), r;
                    },
                }));
        })();
        var Ie = /^(none|table(?!-c[ea]).+)/,
            He = /^--/,
            je = { position: "absolute", visibility: "hidden", display: "block" },
            $e = { letterSpacing: "0", fontWeight: "400" },
            Fe = ["Webkit", "Moz", "ms"],
            Ue = n.createElement("div").style;
        function Ve(e) {
            var t = z.cssProps[e];
            return (
                t ||
                    (t = z.cssProps[e] =
                        (function (e) {
                            if (e in Ue) return e;
                            for (var t = e[0].toUpperCase() + e.slice(1), i = Fe.length; i--; ) if ((e = Fe[i] + t) in Ue) return e;
                        })(e) || e),
                t
            );
        }
        function Ye(e, t, i) {
            var n = te.exec(t);
            return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t;
        }
        function Ge(e, t, i, n, o, s) {
            var r = "width" === t ? 1 : 0,
                c = 0,
                a = 0;
            if (i === (n ? "border" : "content")) return 0;
            for (; r < 4; r += 2)
                "margin" === i && (a += z.css(e, i + ie[r], !0, o)),
                    n
                        ? ("content" === i && (a -= z.css(e, "padding" + ie[r], !0, o)), "margin" !== i && (a -= z.css(e, "border" + ie[r] + "Width", !0, o)))
                        : ((a += z.css(e, "padding" + ie[r], !0, o)), "padding" !== i ? (a += z.css(e, "border" + ie[r] + "Width", !0, o)) : (c += z.css(e, "border" + ie[r] + "Width", !0, o)));
            return !n && s >= 0 && (a += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - s - a - c - 0.5))), a;
        }
        function Ke(e, t, i) {
            var n = _e(e),
                o = Re(e, t, n),
                s = "border-box" === z.css(e, "boxSizing", !1, n),
                r = s;
            if (xe.test(o)) {
                if (!i) return o;
                o = "auto";
            }
            return (
                (r = r && (f.boxSizingReliable() || o === e.style[t])),
                ("auto" === o || (!parseFloat(o) && "inline" === z.css(e, "display", !1, n))) && ((o = e["offset" + t[0].toUpperCase() + t.slice(1)]), (r = !0)),
                (o = parseFloat(o) || 0) + Ge(e, t, i || (s ? "border" : "content"), r, n, o) + "px"
            );
        }
        function Qe(e, t, i, n, o) {
            return new Qe.prototype.init(e, t, i, n, o);
        }
        z.extend({
            cssHooks: {
                opacity: {
                    get: function (e, t) {
                        if (t) {
                            var i = Re(e, "opacity");
                            return "" === i ? "1" : i;
                        }
                    },
                },
            },
            cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 },
            cssProps: {},
            style: function (e, t, i, n) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                    var o,
                        s,
                        r,
                        c = U(t),
                        a = He.test(t),
                        l = e.style;
                    if ((a || (t = Ve(c)), (r = z.cssHooks[t] || z.cssHooks[c]), void 0 === i)) return r && "get" in r && void 0 !== (o = r.get(e, !1, n)) ? o : l[t];
                    "string" == (s = typeof i) && (o = te.exec(i)) && o[1] && ((i = se(e, t, o)), (s = "number")),
                        null != i &&
                            i == i &&
                            ("number" === s && (i += (o && o[3]) || (z.cssNumber[c] ? "" : "px")),
                            f.clearCloneStyle || "" !== i || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                            (r && "set" in r && void 0 === (i = r.set(e, i, n))) || (a ? l.setProperty(t, i) : (l[t] = i)));
                }
            },
            css: function (e, t, i, n) {
                var o,
                    s,
                    r,
                    c = U(t);
                return (
                    He.test(t) || (t = Ve(c)),
                    (r = z.cssHooks[t] || z.cssHooks[c]) && "get" in r && (o = r.get(e, !0, i)),
                    void 0 === o && (o = Re(e, t, n)),
                    "normal" === o && t in $e && (o = $e[t]),
                    "" === i || i ? ((s = parseFloat(o)), !0 === i || isFinite(s) ? s || 0 : o) : o
                );
            },
        }),
            z.each(["height", "width"], function (e, t) {
                z.cssHooks[t] = {
                    get: function (e, i, n) {
                        if (i)
                            return !Ie.test(z.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                                ? Ke(e, t, n)
                                : oe(e, je, function () {
                                      return Ke(e, t, n);
                                  });
                    },
                    set: function (e, i, n) {
                        var o,
                            s = _e(e),
                            r = "border-box" === z.css(e, "boxSizing", !1, s),
                            c = n && Ge(e, t, n, r, s);
                        return (
                            r && f.scrollboxSize() === s.position && (c -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(s[t]) - Ge(e, t, "border", !1, s) - 0.5)),
                            c && (o = te.exec(i)) && "px" !== (o[3] || "px") && ((e.style[t] = i), (i = z.css(e, t))),
                            Ye(0, i, c)
                        );
                    },
                };
            }),
            (z.cssHooks.marginLeft = Pe(f.reliableMarginLeft, function (e, t) {
                if (t)
                    return (
                        (parseFloat(Re(e, "marginLeft")) ||
                            e.getBoundingClientRect().left -
                                oe(e, { marginLeft: 0 }, function () {
                                    return e.getBoundingClientRect().left;
                                })) + "px"
                    );
            })),
            z.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
                (z.cssHooks[e + t] = {
                    expand: function (i) {
                        for (var n = 0, o = {}, s = "string" == typeof i ? i.split(" ") : [i]; n < 4; n++) o[e + ie[n] + t] = s[n] || s[n - 2] || s[0];
                        return o;
                    },
                }),
                    "margin" !== e && (z.cssHooks[e + t].set = Ye);
            }),
            z.fn.extend({
                css: function (e, t) {
                    return H(
                        this,
                        function (e, t, i) {
                            var n,
                                o,
                                s = {},
                                r = 0;
                            if (Array.isArray(t)) {
                                for (n = _e(e), o = t.length; r < o; r++) s[t[r]] = z.css(e, t[r], !1, n);
                                return s;
                            }
                            return void 0 !== i ? z.style(e, t, i) : z.css(e, t);
                        },
                        e,
                        t,
                        arguments.length > 1
                    );
                },
            }),
            (z.Tween = Qe),
            (Qe.prototype = {
                constructor: Qe,
                init: function (e, t, i, n, o, s) {
                    (this.elem = e), (this.prop = i), (this.easing = o || z.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = n), (this.unit = s || (z.cssNumber[i] ? "" : "px"));
                },
                cur: function () {
                    var e = Qe.propHooks[this.prop];
                    return e && e.get ? e.get(this) : Qe.propHooks._default.get(this);
                },
                run: function (e) {
                    var t,
                        i = Qe.propHooks[this.prop];
                    return (
                        this.options.duration ? (this.pos = t = z.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                        (this.now = (this.end - this.start) * t + this.start),
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        i && i.set ? i.set(this) : Qe.propHooks._default.set(this),
                        this
                    );
                },
            }),
            (Qe.prototype.init.prototype = Qe.prototype),
            (Qe.propHooks = {
                _default: {
                    get: function (e) {
                        var t;
                        return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = z.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                    },
                    set: function (e) {
                        z.fx.step[e.prop] ? z.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (null == e.elem.style[z.cssProps[e.prop]] && !z.cssHooks[e.prop]) ? (e.elem[e.prop] = e.now) : z.style(e.elem, e.prop, e.now + e.unit);
                    },
                },
            }),
            (Qe.propHooks.scrollTop = Qe.propHooks.scrollLeft = {
                set: function (e) {
                    e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                },
            }),
            (z.easing = {
                linear: function (e) {
                    return e;
                },
                swing: function (e) {
                    return 0.5 - Math.cos(e * Math.PI) / 2;
                },
                _default: "swing",
            }),
            (z.fx = Qe.prototype.init),
            (z.fx.step = {});
        var Je,
            Ze,
            et = /^(?:toggle|show|hide)$/,
            tt = /queueHooks$/;
        function it() {
            Ze && (!1 === n.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(it) : e.setTimeout(it, z.fx.interval), z.fx.tick());
        }
        function nt() {
            return (
                e.setTimeout(function () {
                    Je = void 0;
                }),
                (Je = Date.now())
            );
        }
        function ot(e, t) {
            var i,
                n = 0,
                o = { height: e };
            for (t = t ? 1 : 0; n < 4; n += 2 - t) o["margin" + (i = ie[n])] = o["padding" + i] = e;
            return t && (o.opacity = o.width = e), o;
        }
        function st(e, t, i) {
            for (var n, o = (rt.tweeners[t] || []).concat(rt.tweeners["*"]), s = 0, r = o.length; s < r; s++) if ((n = o[s].call(i, t, e))) return n;
        }
        function rt(e, t, i) {
            var n,
                o,
                s = 0,
                r = rt.prefilters.length,
                c = z.Deferred().always(function () {
                    delete a.elem;
                }),
                a = function () {
                    if (o) return !1;
                    for (var t = Je || nt(), i = Math.max(0, l.startTime + l.duration - t), n = 1 - (i / l.duration || 0), s = 0, r = l.tweens.length; s < r; s++) l.tweens[s].run(n);
                    return c.notifyWith(e, [l, n, i]), n < 1 && r ? i : (r || c.notifyWith(e, [l, 1, 0]), c.resolveWith(e, [l]), !1);
                },
                l = c.promise({
                    elem: e,
                    props: z.extend({}, t),
                    opts: z.extend(!0, { specialEasing: {}, easing: z.easing._default }, i),
                    originalProperties: t,
                    originalOptions: i,
                    startTime: Je || nt(),
                    duration: i.duration,
                    tweens: [],
                    createTween: function (t, i) {
                        var n = z.Tween(e, l.opts, t, i, l.opts.specialEasing[t] || l.opts.easing);
                        return l.tweens.push(n), n;
                    },
                    stop: function (t) {
                        var i = 0,
                            n = t ? l.tweens.length : 0;
                        if (o) return this;
                        for (o = !0; i < n; i++) l.tweens[i].run(1);
                        return t ? (c.notifyWith(e, [l, 1, 0]), c.resolveWith(e, [l, t])) : c.rejectWith(e, [l, t]), this;
                    },
                }),
                u = l.props;
            for (
                (function (e, t) {
                    var i, n, o, s, r;
                    for (i in e)
                        if (((o = t[(n = U(i))]), (s = e[i]), Array.isArray(s) && ((o = s[1]), (s = e[i] = s[0])), i !== n && ((e[n] = s), delete e[i]), (r = z.cssHooks[n]) && ("expand" in r)))
                            for (i in ((s = r.expand(s)), delete e[n], s)) (i in e) || ((e[i] = s[i]), (t[i] = o));
                        else t[n] = o;
                })(u, l.opts.specialEasing);
                s < r;
                s++
            )
                if ((n = rt.prefilters[s].call(l, e, u, l.opts))) return M(n.stop) && (z._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)), n;
            return (
                z.map(u, st, l),
                M(l.opts.start) && l.opts.start.call(e, l),
                l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always),
                z.fx.timer(z.extend(a, { elem: e, anim: l, queue: l.opts.queue })),
                l
            );
        }
        (z.Animation = z.extend(rt, {
            tweeners: {
                "*": [
                    function (e, t) {
                        var i = this.createTween(e, t);
                        return se(i.elem, e, te.exec(t), i), i;
                    },
                ],
            },
            tweener: function (e, t) {
                M(e) ? ((t = e), (e = ["*"])) : (e = e.match(X));
                for (var i, n = 0, o = e.length; n < o; n++) (i = e[n]), (rt.tweeners[i] = rt.tweeners[i] || []), rt.tweeners[i].unshift(t);
            },
            prefilters: [
                function (e, t, i) {
                    var n,
                        o,
                        s,
                        r,
                        c,
                        a,
                        l,
                        u,
                        d = "width" in t || "height" in t,
                        p = this,
                        h = {},
                        f = e.style,
                        M = e.nodeType && ne(e),
                        b = G.get(e, "fxshow");
                    for (n in (i.queue ||
                        (null == (r = z._queueHooks(e, "fx")).unqueued &&
                            ((r.unqueued = 0),
                            (c = r.empty.fire),
                            (r.empty.fire = function () {
                                r.unqueued || c();
                            })),
                        r.unqueued++,
                        p.always(function () {
                            p.always(function () {
                                r.unqueued--, z.queue(e, "fx").length || r.empty.fire();
                            });
                        })),
                    t))
                        if (((o = t[n]), et.test(o))) {
                            if ((delete t[n], (s = s || "toggle" === o), o === (M ? "hide" : "show"))) {
                                if ("show" !== o || !b || void 0 === b[n]) continue;
                                M = !0;
                            }
                            h[n] = (b && b[n]) || z.style(e, n);
                        }
                    if ((a = !z.isEmptyObject(t)) || !z.isEmptyObject(h))
                        for (n in (d &&
                            1 === e.nodeType &&
                            ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
                            null == (l = b && b.display) && (l = G.get(e, "display")),
                            "none" === (u = z.css(e, "display")) && (l ? (u = l) : (ae([e], !0), (l = e.style.display || l), (u = z.css(e, "display")), ae([e]))),
                            ("inline" === u || ("inline-block" === u && null != l)) &&
                                "none" === z.css(e, "float") &&
                                (a ||
                                    (p.done(function () {
                                        f.display = l;
                                    }),
                                    null == l && ((u = f.display), (l = "none" === u ? "" : u))),
                                (f.display = "inline-block"))),
                        i.overflow &&
                            ((f.overflow = "hidden"),
                            p.always(function () {
                                (f.overflow = i.overflow[0]), (f.overflowX = i.overflow[1]), (f.overflowY = i.overflow[2]);
                            })),
                        (a = !1),
                        h))
                            a ||
                                (b ? "hidden" in b && (M = b.hidden) : (b = G.access(e, "fxshow", { display: l })),
                                s && (b.hidden = !M),
                                M && ae([e], !0),
                                p.done(function () {
                                    for (n in (M || ae([e]), G.remove(e, "fxshow"), h)) z.style(e, n, h[n]);
                                })),
                                (a = st(M ? b[n] : 0, n, p)),
                                n in b || ((b[n] = a.start), M && ((a.end = a.start), (a.start = 0)));
                },
            ],
            prefilter: function (e, t) {
                t ? rt.prefilters.unshift(e) : rt.prefilters.push(e);
            },
        })),
            (z.speed = function (e, t, i) {
                var n = e && "object" == typeof e ? z.extend({}, e) : { complete: i || (!i && t) || (M(e) && e), duration: e, easing: (i && t) || (t && !M(t) && t) };
                return (
                    z.fx.off ? (n.duration = 0) : "number" != typeof n.duration && (n.duration in z.fx.speeds ? (n.duration = z.fx.speeds[n.duration]) : (n.duration = z.fx.speeds._default)),
                    (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
                    (n.old = n.complete),
                    (n.complete = function () {
                        M(n.old) && n.old.call(this), n.queue && z.dequeue(this, n.queue);
                    }),
                    n
                );
            }),
            z.fn.extend({
                fadeTo: function (e, t, i, n) {
                    return this.filter(ne).css("opacity", 0).show().end().animate({ opacity: t }, e, i, n);
                },
                animate: function (e, t, i, n) {
                    var o = z.isEmptyObject(e),
                        s = z.speed(t, i, n),
                        r = function () {
                            var t = rt(this, z.extend({}, e), s);
                            (o || G.get(this, "finish")) && t.stop(!0);
                        };
                    return (r.finish = r), o || !1 === s.queue ? this.each(r) : this.queue(s.queue, r);
                },
                stop: function (e, t, i) {
                    var n = function (e) {
                        var t = e.stop;
                        delete e.stop, t(i);
                    };
                    return (
                        "string" != typeof e && ((i = t), (t = e), (e = void 0)),
                        t && !1 !== e && this.queue(e || "fx", []),
                        this.each(function () {
                            var t = !0,
                                o = null != e && e + "queueHooks",
                                s = z.timers,
                                r = G.get(this);
                            if (o) r[o] && r[o].stop && n(r[o]);
                            else for (o in r) r[o] && r[o].stop && tt.test(o) && n(r[o]);
                            for (o = s.length; o--; ) s[o].elem !== this || (null != e && s[o].queue !== e) || (s[o].anim.stop(i), (t = !1), s.splice(o, 1));
                            (!t && i) || z.dequeue(this, e);
                        })
                    );
                },
                finish: function (e) {
                    return (
                        !1 !== e && (e = e || "fx"),
                        this.each(function () {
                            var t,
                                i = G.get(this),
                                n = i[e + "queue"],
                                o = i[e + "queueHooks"],
                                s = z.timers,
                                r = n ? n.length : 0;
                            for (i.finish = !0, z.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = s.length; t--; ) s[t].elem === this && s[t].queue === e && (s[t].anim.stop(!0), s.splice(t, 1));
                            for (t = 0; t < r; t++) n[t] && n[t].finish && n[t].finish.call(this);
                            delete i.finish;
                        })
                    );
                },
            }),
            z.each(["toggle", "show", "hide"], function (e, t) {
                var i = z.fn[t];
                z.fn[t] = function (e, n, o) {
                    return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(ot(t, !0), e, n, o);
                };
            }),
            z.each({ slideDown: ot("show"), slideUp: ot("hide"), slideToggle: ot("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
                z.fn[e] = function (e, i, n) {
                    return this.animate(t, e, i, n);
                };
            }),
            (z.timers = []),
            (z.fx.tick = function () {
                var e,
                    t = 0,
                    i = z.timers;
                for (Je = Date.now(); t < i.length; t++) (e = i[t])() || i[t] !== e || i.splice(t--, 1);
                i.length || z.fx.stop(), (Je = void 0);
            }),
            (z.fx.timer = function (e) {
                z.timers.push(e), z.fx.start();
            }),
            (z.fx.interval = 13),
            (z.fx.start = function () {
                Ze || ((Ze = !0), it());
            }),
            (z.fx.stop = function () {
                Ze = null;
            }),
            (z.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (z.fn.delay = function (t, i) {
                return (
                    (t = (z.fx && z.fx.speeds[t]) || t),
                    (i = i || "fx"),
                    this.queue(i, function (i, n) {
                        var o = e.setTimeout(i, t);
                        n.stop = function () {
                            e.clearTimeout(o);
                        };
                    })
                );
            }),
            (function () {
                var e = n.createElement("input"),
                    t = n.createElement("select").appendChild(n.createElement("option"));
                (e.type = "checkbox"), (f.checkOn = "" !== e.value), (f.optSelected = t.selected), ((e = n.createElement("input")).value = "t"), (e.type = "radio"), (f.radioValue = "t" === e.value);
            })();
        var ct,
            at = z.expr.attrHandle;
        z.fn.extend({
            attr: function (e, t) {
                return H(this, z.attr, e, t, arguments.length > 1);
            },
            removeAttr: function (e) {
                return this.each(function () {
                    z.removeAttr(this, e);
                });
            },
        }),
            z.extend({
                attr: function (e, t, i) {
                    var n,
                        o,
                        s = e.nodeType;
                    if (3 !== s && 8 !== s && 2 !== s)
                        return void 0 === e.getAttribute
                            ? z.prop(e, t, i)
                            : ((1 === s && z.isXMLDoc(e)) || (o = z.attrHooks[t.toLowerCase()] || (z.expr.match.bool.test(t) ? ct : void 0)),
                              void 0 !== i
                                  ? null === i
                                      ? void z.removeAttr(e, t)
                                      : o && "set" in o && void 0 !== (n = o.set(e, i, t))
                                      ? n
                                      : (e.setAttribute(t, i + ""), i)
                                  : o && "get" in o && null !== (n = o.get(e, t))
                                  ? n
                                  : null == (n = z.find.attr(e, t))
                                  ? void 0
                                  : n);
                },
                attrHooks: {
                    type: {
                        set: function (e, t) {
                            if (!f.radioValue && "radio" === t && q(e, "input")) {
                                var i = e.value;
                                return e.setAttribute("type", t), i && (e.value = i), t;
                            }
                        },
                    },
                },
                removeAttr: function (e, t) {
                    var i,
                        n = 0,
                        o = t && t.match(X);
                    if (o && 1 === e.nodeType) for (; (i = o[n++]); ) e.removeAttribute(i);
                },
            }),
            (ct = {
                set: function (e, t, i) {
                    return !1 === t ? z.removeAttr(e, i) : e.setAttribute(i, i), i;
                },
            }),
            z.each(z.expr.match.bool.source.match(/\w+/g), function (e, t) {
                var i = at[t] || z.find.attr;
                at[t] = function (e, t, n) {
                    var o,
                        s,
                        r = t.toLowerCase();
                    return n || ((s = at[r]), (at[r] = o), (o = null != i(e, t, n) ? r : null), (at[r] = s)), o;
                };
            });
        var lt = /^(?:input|select|textarea|button)$/i,
            ut = /^(?:a|area)$/i;
        function dt(e) {
            return (e.match(X) || []).join(" ");
        }
        function pt(e) {
            return (e.getAttribute && e.getAttribute("class")) || "";
        }
        function ht(e) {
            return Array.isArray(e) ? e : ("string" == typeof e && e.match(X)) || [];
        }
        z.fn.extend({
            prop: function (e, t) {
                return H(this, z.prop, e, t, arguments.length > 1);
            },
            removeProp: function (e) {
                return this.each(function () {
                    delete this[z.propFix[e] || e];
                });
            },
        }),
            z.extend({
                prop: function (e, t, i) {
                    var n,
                        o,
                        s = e.nodeType;
                    if (3 !== s && 8 !== s && 2 !== s)
                        return (
                            (1 === s && z.isXMLDoc(e)) || ((t = z.propFix[t] || t), (o = z.propHooks[t])),
                            void 0 !== i ? (o && "set" in o && void 0 !== (n = o.set(e, i, t)) ? n : (e[t] = i)) : o && "get" in o && null !== (n = o.get(e, t)) ? n : e[t]
                        );
                },
                propHooks: {
                    tabIndex: {
                        get: function (e) {
                            var t = z.find.attr(e, "tabindex");
                            return t ? parseInt(t, 10) : lt.test(e.nodeName) || (ut.test(e.nodeName) && e.href) ? 0 : -1;
                        },
                    },
                },
                propFix: { for: "htmlFor", class: "className" },
            }),
            f.optSelected ||
                (z.propHooks.selected = {
                    get: function (e) {
                        var t = e.parentNode;
                        return t && t.parentNode && t.parentNode.selectedIndex, null;
                    },
                    set: function (e) {
                        var t = e.parentNode;
                        t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                    },
                }),
            z.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                z.propFix[this.toLowerCase()] = this;
            }),
            z.fn.extend({
                addClass: function (e) {
                    var t,
                        i,
                        n,
                        o,
                        s,
                        r,
                        c,
                        a = 0;
                    if (M(e))
                        return this.each(function (t) {
                            z(this).addClass(e.call(this, t, pt(this)));
                        });
                    if ((t = ht(e)).length)
                        for (; (i = this[a++]); )
                            if (((o = pt(i)), (n = 1 === i.nodeType && " " + dt(o) + " "))) {
                                for (r = 0; (s = t[r++]); ) n.indexOf(" " + s + " ") < 0 && (n += s + " ");
                                o !== (c = dt(n)) && i.setAttribute("class", c);
                            }
                    return this;
                },
                removeClass: function (e) {
                    var t,
                        i,
                        n,
                        o,
                        s,
                        r,
                        c,
                        a = 0;
                    if (M(e))
                        return this.each(function (t) {
                            z(this).removeClass(e.call(this, t, pt(this)));
                        });
                    if (!arguments.length) return this.attr("class", "");
                    if ((t = ht(e)).length)
                        for (; (i = this[a++]); )
                            if (((o = pt(i)), (n = 1 === i.nodeType && " " + dt(o) + " "))) {
                                for (r = 0; (s = t[r++]); ) for (; n.indexOf(" " + s + " ") > -1; ) n = n.replace(" " + s + " ", " ");
                                o !== (c = dt(n)) && i.setAttribute("class", c);
                            }
                    return this;
                },
                toggleClass: function (e, t) {
                    var i = typeof e,
                        n = "string" === i || Array.isArray(e);
                    return "boolean" == typeof t && n
                        ? t
                            ? this.addClass(e)
                            : this.removeClass(e)
                        : M(e)
                        ? this.each(function (i) {
                              z(this).toggleClass(e.call(this, i, pt(this), t), t);
                          })
                        : this.each(function () {
                              var t, o, s, r;
                              if (n) for (o = 0, s = z(this), r = ht(e); (t = r[o++]); ) s.hasClass(t) ? s.removeClass(t) : s.addClass(t);
                              else (void 0 !== e && "boolean" !== i) || ((t = pt(this)) && G.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : G.get(this, "__className__") || ""));
                          });
                },
                hasClass: function (e) {
                    var t,
                        i,
                        n = 0;
                    for (t = " " + e + " "; (i = this[n++]); ) if (1 === i.nodeType && (" " + dt(pt(i)) + " ").indexOf(t) > -1) return !0;
                    return !1;
                },
            });
        var ft = /\r/g;
        z.fn.extend({
            val: function (e) {
                var t,
                    i,
                    n,
                    o = this[0];
                return arguments.length
                    ? ((n = M(e)),
                      this.each(function (i) {
                          var o;
                          1 === this.nodeType &&
                              (null == (o = n ? e.call(this, i, z(this).val()) : e)
                                  ? (o = "")
                                  : "number" == typeof o
                                  ? (o += "")
                                  : Array.isArray(o) &&
                                    (o = z.map(o, function (e) {
                                        return null == e ? "" : e + "";
                                    })),
                              ((t = z.valHooks[this.type] || z.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value")) || (this.value = o));
                      }))
                    : o
                    ? (t = z.valHooks[o.type] || z.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (i = t.get(o, "value"))
                        ? i
                        : "string" == typeof (i = o.value)
                        ? i.replace(ft, "")
                        : null == i
                        ? ""
                        : i
                    : void 0;
            },
        }),
            z.extend({
                valHooks: {
                    option: {
                        get: function (e) {
                            var t = z.find.attr(e, "value");
                            return null != t ? t : dt(z.text(e));
                        },
                    },
                    select: {
                        get: function (e) {
                            var t,
                                i,
                                n,
                                o = e.options,
                                s = e.selectedIndex,
                                r = "select-one" === e.type,
                                c = r ? null : [],
                                a = r ? s + 1 : o.length;
                            for (n = s < 0 ? a : r ? s : 0; n < a; n++)
                                if (((i = o[n]).selected || n === s) && !i.disabled && (!i.parentNode.disabled || !q(i.parentNode, "optgroup"))) {
                                    if (((t = z(i).val()), r)) return t;
                                    c.push(t);
                                }
                            return c;
                        },
                        set: function (e, t) {
                            for (var i, n, o = e.options, s = z.makeArray(t), r = o.length; r--; ) ((n = o[r]).selected = z.inArray(z.valHooks.option.get(n), s) > -1) && (i = !0);
                            return i || (e.selectedIndex = -1), s;
                        },
                    },
                },
            }),
            z.each(["radio", "checkbox"], function () {
                (z.valHooks[this] = {
                    set: function (e, t) {
                        if (Array.isArray(t)) return (e.checked = z.inArray(z(e).val(), t) > -1);
                    },
                }),
                    f.checkOn ||
                        (z.valHooks[this].get = function (e) {
                            return null === e.getAttribute("value") ? "on" : e.value;
                        });
            }),
            (f.focusin = "onfocusin" in e);
        var Mt = /^(?:focusinfocus|focusoutblur)$/,
            bt = function (e) {
                e.stopPropagation();
            };
        z.extend(z.event, {
            trigger: function (t, i, o, s) {
                var r,
                    c,
                    a,
                    l,
                    u,
                    p,
                    h,
                    f,
                    m = [o || n],
                    g = d.call(t, "type") ? t.type : t,
                    A = d.call(t, "namespace") ? t.namespace.split(".") : [];
                if (
                    ((c = f = a = o = o || n),
                    3 !== o.nodeType &&
                        8 !== o.nodeType &&
                        !Mt.test(g + z.event.triggered) &&
                        (g.indexOf(".") > -1 && ((g = (A = g.split(".")).shift()), A.sort()),
                        (u = g.indexOf(":") < 0 && "on" + g),
                        ((t = t[z.expando] ? t : new z.Event(g, "object" == typeof t && t)).isTrigger = s ? 2 : 3),
                        (t.namespace = A.join(".")),
                        (t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + A.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                        (t.result = void 0),
                        t.target || (t.target = o),
                        (i = null == i ? [t] : z.makeArray(i, [t])),
                        (h = z.event.special[g] || {}),
                        s || !h.trigger || !1 !== h.trigger.apply(o, i)))
                ) {
                    if (!s && !h.noBubble && !b(o)) {
                        for (l = h.delegateType || g, Mt.test(l + g) || (c = c.parentNode); c; c = c.parentNode) m.push(c), (a = c);
                        a === (o.ownerDocument || n) && m.push(a.defaultView || a.parentWindow || e);
                    }
                    for (r = 0; (c = m[r++]) && !t.isPropagationStopped(); )
                        (f = c),
                            (t.type = r > 1 ? l : h.bindType || g),
                            (p = (G.get(c, "events") || {})[t.type] && G.get(c, "handle")) && p.apply(c, i),
                            (p = u && c[u]) && p.apply && V(c) && ((t.result = p.apply(c, i)), !1 === t.result && t.preventDefault());
                    return (
                        (t.type = g),
                        s ||
                            t.isDefaultPrevented() ||
                            (h._default && !1 !== h._default.apply(m.pop(), i)) ||
                            !V(o) ||
                            (u &&
                                M(o[g]) &&
                                !b(o) &&
                                ((a = o[u]) && (o[u] = null),
                                (z.event.triggered = g),
                                t.isPropagationStopped() && f.addEventListener(g, bt),
                                o[g](),
                                t.isPropagationStopped() && f.removeEventListener(g, bt),
                                (z.event.triggered = void 0),
                                a && (o[u] = a))),
                        t.result
                    );
                }
            },
            simulate: function (e, t, i) {
                var n = z.extend(new z.Event(), i, { type: e, isSimulated: !0 });
                z.event.trigger(n, null, t);
            },
        }),
            z.fn.extend({
                trigger: function (e, t) {
                    return this.each(function () {
                        z.event.trigger(e, t, this);
                    });
                },
                triggerHandler: function (e, t) {
                    var i = this[0];
                    if (i) return z.event.trigger(e, t, i, !0);
                },
            }),
            f.focusin ||
                z.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                    var i = function (e) {
                        z.event.simulate(t, e.target, z.event.fix(e));
                    };
                    z.event.special[t] = {
                        setup: function () {
                            var n = this.ownerDocument || this,
                                o = G.access(n, t);
                            o || n.addEventListener(e, i, !0), G.access(n, t, (o || 0) + 1);
                        },
                        teardown: function () {
                            var n = this.ownerDocument || this,
                                o = G.access(n, t) - 1;
                            o ? G.access(n, t, o) : (n.removeEventListener(e, i, !0), G.remove(n, t));
                        },
                    };
                });
        var mt = e.location,
            gt = Date.now(),
            At = /\?/;
        z.parseXML = function (t) {
            var i;
            if (!t || "string" != typeof t) return null;
            try {
                i = new e.DOMParser().parseFromString(t, "text/xml");
            } catch (e) {
                i = void 0;
            }
            return (i && !i.getElementsByTagName("parsererror").length) || z.error("Invalid XML: " + t), i;
        };
        var zt = /\[\]$/,
            yt = /\r?\n/g,
            vt = /^(?:submit|button|image|reset|file)$/i,
            Ot = /^(?:input|select|textarea|keygen)/i;
        function Lt(e, t, i, n) {
            var o;
            if (Array.isArray(t))
                z.each(t, function (t, o) {
                    i || zt.test(e) ? n(e, o) : Lt(e + "[" + ("object" == typeof o && null != o ? t : "") + "]", o, i, n);
                });
            else if (i || "object" !== A(t)) n(e, t);
            else for (o in t) Lt(e + "[" + o + "]", t[o], i, n);
        }
        (z.param = function (e, t) {
            var i,
                n = [],
                o = function (e, t) {
                    var i = M(t) ? t() : t;
                    n[n.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == i ? "" : i);
                };
            if (Array.isArray(e) || (e.jquery && !z.isPlainObject(e)))
                z.each(e, function () {
                    o(this.name, this.value);
                });
            else for (i in e) Lt(i, e[i], t, o);
            return n.join("&");
        }),
            z.fn.extend({
                serialize: function () {
                    return z.param(this.serializeArray());
                },
                serializeArray: function () {
                    return this.map(function () {
                        var e = z.prop(this, "elements");
                        return e ? z.makeArray(e) : this;
                    })
                        .filter(function () {
                            var e = this.type;
                            return this.name && !z(this).is(":disabled") && Ot.test(this.nodeName) && !vt.test(e) && (this.checked || !le.test(e));
                        })
                        .map(function (e, t) {
                            var i = z(this).val();
                            return null == i
                                ? null
                                : Array.isArray(i)
                                ? z.map(i, function (e) {
                                      return { name: t.name, value: e.replace(yt, "\r\n") };
                                  })
                                : { name: t.name, value: i.replace(yt, "\r\n") };
                        })
                        .get();
                },
            });
        var Tt = /%20/g,
            Nt = /#.*$/,
            qt = /([?&])_=[^&]*/,
            wt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Wt = /^(?:GET|HEAD)$/,
            St = /^\/\//,
            Ct = {},
            kt = {},
            Bt = "*/".concat("*"),
            Et = n.createElement("a");
        function Xt(e) {
            return function (t, i) {
                "string" != typeof t && ((i = t), (t = "*"));
                var n,
                    o = 0,
                    s = t.toLowerCase().match(X) || [];
                if (M(i)) for (; (n = s[o++]); ) "+" === n[0] ? ((n = n.slice(1) || "*"), (e[n] = e[n] || []).unshift(i)) : (e[n] = e[n] || []).push(i);
            };
        }
        function xt(e, t, i, n) {
            var o = {},
                s = e === kt;
            function r(c) {
                var a;
                return (
                    (o[c] = !0),
                    z.each(e[c] || [], function (e, c) {
                        var l = c(t, i, n);
                        return "string" != typeof l || s || o[l] ? (s ? !(a = l) : void 0) : (t.dataTypes.unshift(l), r(l), !1);
                    }),
                    a
                );
            }
            return r(t.dataTypes[0]) || (!o["*"] && r("*"));
        }
        function _t(e, t) {
            var i,
                n,
                o = z.ajaxSettings.flatOptions || {};
            for (i in t) void 0 !== t[i] && ((o[i] ? e : n || (n = {}))[i] = t[i]);
            return n && z.extend(!0, e, n), e;
        }
        (Et.href = mt.href),
            z.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: mt.href,
                    type: "GET",
                    isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(mt.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: { "*": Bt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                    contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                    responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                    converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": z.parseXML },
                    flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (e, t) {
                    return t ? _t(_t(e, z.ajaxSettings), t) : _t(z.ajaxSettings, e);
                },
                ajaxPrefilter: Xt(Ct),
                ajaxTransport: Xt(kt),
                ajax: function (t, i) {
                    "object" == typeof t && ((i = t), (t = void 0)), (i = i || {});
                    var o,
                        s,
                        r,
                        c,
                        a,
                        l,
                        u,
                        d,
                        p,
                        h,
                        f = z.ajaxSetup({}, i),
                        M = f.context || f,
                        b = f.context && (M.nodeType || M.jquery) ? z(M) : z.event,
                        m = z.Deferred(),
                        g = z.Callbacks("once memory"),
                        A = f.statusCode || {},
                        y = {},
                        v = {},
                        O = "canceled",
                        L = {
                            readyState: 0,
                            getResponseHeader: function (e) {
                                var t;
                                if (u) {
                                    if (!c) for (c = {}; (t = wt.exec(r)); ) c[t[1].toLowerCase()] = t[2];
                                    t = c[e.toLowerCase()];
                                }
                                return null == t ? null : t;
                            },
                            getAllResponseHeaders: function () {
                                return u ? r : null;
                            },
                            setRequestHeader: function (e, t) {
                                return null == u && ((e = v[e.toLowerCase()] = v[e.toLowerCase()] || e), (y[e] = t)), this;
                            },
                            overrideMimeType: function (e) {
                                return null == u && (f.mimeType = e), this;
                            },
                            statusCode: function (e) {
                                var t;
                                if (e)
                                    if (u) L.always(e[L.status]);
                                    else for (t in e) A[t] = [A[t], e[t]];
                                return this;
                            },
                            abort: function (e) {
                                var t = e || O;
                                return o && o.abort(t), T(0, t), this;
                            },
                        };
                    if (
                        (m.promise(L),
                        (f.url = ((t || f.url || mt.href) + "").replace(St, mt.protocol + "//")),
                        (f.type = i.method || i.type || f.method || f.type),
                        (f.dataTypes = (f.dataType || "*").toLowerCase().match(X) || [""]),
                        null == f.crossDomain)
                    ) {
                        l = n.createElement("a");
                        try {
                            (l.href = f.url), (l.href = l.href), (f.crossDomain = Et.protocol + "//" + Et.host != l.protocol + "//" + l.host);
                        } catch (e) {
                            f.crossDomain = !0;
                        }
                    }
                    if ((f.data && f.processData && "string" != typeof f.data && (f.data = z.param(f.data, f.traditional)), xt(Ct, f, i, L), u)) return L;
                    for (p in ((d = z.event && f.global) && 0 == z.active++ && z.event.trigger("ajaxStart"),
                    (f.type = f.type.toUpperCase()),
                    (f.hasContent = !Wt.test(f.type)),
                    (s = f.url.replace(Nt, "")),
                    f.hasContent
                        ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(Tt, "+"))
                        : ((h = f.url.slice(s.length)),
                          f.data && (f.processData || "string" == typeof f.data) && ((s += (At.test(s) ? "&" : "?") + f.data), delete f.data),
                          !1 === f.cache && ((s = s.replace(qt, "$1")), (h = (At.test(s) ? "&" : "?") + "_=" + gt++ + h)),
                          (f.url = s + h)),
                    f.ifModified && (z.lastModified[s] && L.setRequestHeader("If-Modified-Since", z.lastModified[s]), z.etag[s] && L.setRequestHeader("If-None-Match", z.etag[s])),
                    ((f.data && f.hasContent && !1 !== f.contentType) || i.contentType) && L.setRequestHeader("Content-Type", f.contentType),
                    L.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Bt + "; q=0.01" : "") : f.accepts["*"]),
                    f.headers))
                        L.setRequestHeader(p, f.headers[p]);
                    if (f.beforeSend && (!1 === f.beforeSend.call(M, L, f) || u)) return L.abort();
                    if (((O = "abort"), g.add(f.complete), L.done(f.success), L.fail(f.error), (o = xt(kt, f, i, L)))) {
                        if (((L.readyState = 1), d && b.trigger("ajaxSend", [L, f]), u)) return L;
                        f.async &&
                            f.timeout > 0 &&
                            (a = e.setTimeout(function () {
                                L.abort("timeout");
                            }, f.timeout));
                        try {
                            (u = !1), o.send(y, T);
                        } catch (e) {
                            if (u) throw e;
                            T(-1, e);
                        }
                    } else T(-1, "No Transport");
                    function T(t, i, n, c) {
                        var l,
                            p,
                            h,
                            y,
                            v,
                            O = i;
                        u ||
                            ((u = !0),
                            a && e.clearTimeout(a),
                            (o = void 0),
                            (r = c || ""),
                            (L.readyState = t > 0 ? 4 : 0),
                            (l = (t >= 200 && t < 300) || 304 === t),
                            n &&
                                (y = (function (e, t, i) {
                                    for (var n, o, s, r, c = e.contents, a = e.dataTypes; "*" === a[0]; ) a.shift(), void 0 === n && (n = e.mimeType || t.getResponseHeader("Content-Type"));
                                    if (n)
                                        for (o in c)
                                            if (c[o] && c[o].test(n)) {
                                                a.unshift(o);
                                                break;
                                            }
                                    if (a[0] in i) s = a[0];
                                    else {
                                        for (o in i) {
                                            if (!a[0] || e.converters[o + " " + a[0]]) {
                                                s = o;
                                                break;
                                            }
                                            r || (r = o);
                                        }
                                        s = s || r;
                                    }
                                    if (s) return s !== a[0] && a.unshift(s), i[s];
                                })(f, L, n)),
                            (y = (function (e, t, i, n) {
                                var o,
                                    s,
                                    r,
                                    c,
                                    a,
                                    l = {},
                                    u = e.dataTypes.slice();
                                if (u[1]) for (r in e.converters) l[r.toLowerCase()] = e.converters[r];
                                for (s = u.shift(); s; )
                                    if ((e.responseFields[s] && (i[e.responseFields[s]] = t), !a && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (a = s), (s = u.shift())))
                                        if ("*" === s) s = a;
                                        else if ("*" !== a && a !== s) {
                                            if (!(r = l[a + " " + s] || l["* " + s]))
                                                for (o in l)
                                                    if ((c = o.split(" "))[1] === s && (r = l[a + " " + c[0]] || l["* " + c[0]])) {
                                                        !0 === r ? (r = l[o]) : !0 !== l[o] && ((s = c[0]), u.unshift(c[1]));
                                                        break;
                                                    }
                                            if (!0 !== r)
                                                if (r && e.throws) t = r(t);
                                                else
                                                    try {
                                                        t = r(t);
                                                    } catch (e) {
                                                        return { state: "parsererror", error: r ? e : "No conversion from " + a + " to " + s };
                                                    }
                                        }
                                return { state: "success", data: t };
                            })(f, y, L, l)),
                            l
                                ? (f.ifModified && ((v = L.getResponseHeader("Last-Modified")) && (z.lastModified[s] = v), (v = L.getResponseHeader("etag")) && (z.etag[s] = v)),
                                  204 === t || "HEAD" === f.type ? (O = "nocontent") : 304 === t ? (O = "notmodified") : ((O = y.state), (p = y.data), (l = !(h = y.error))))
                                : ((h = O), (!t && O) || ((O = "error"), t < 0 && (t = 0))),
                            (L.status = t),
                            (L.statusText = (i || O) + ""),
                            l ? m.resolveWith(M, [p, O, L]) : m.rejectWith(M, [L, O, h]),
                            L.statusCode(A),
                            (A = void 0),
                            d && b.trigger(l ? "ajaxSuccess" : "ajaxError", [L, f, l ? p : h]),
                            g.fireWith(M, [L, O]),
                            d && (b.trigger("ajaxComplete", [L, f]), --z.active || z.event.trigger("ajaxStop")));
                    }
                    return L;
                },
                getJSON: function (e, t, i) {
                    return z.get(e, t, i, "json");
                },
                getScript: function (e, t) {
                    return z.get(e, void 0, t, "script");
                },
            }),
            z.each(["get", "post"], function (e, t) {
                z[t] = function (e, i, n, o) {
                    return M(i) && ((o = o || n), (n = i), (i = void 0)), z.ajax(z.extend({ url: e, type: t, dataType: o, data: i, success: n }, z.isPlainObject(e) && e));
                };
            }),
            (z._evalUrl = function (e) {
                return z.ajax({ url: e, type: "GET", dataType: "script", cache: !0, async: !1, global: !1, throws: !0 });
            }),
            z.fn.extend({
                wrapAll: function (e) {
                    var t;
                    return (
                        this[0] &&
                            (M(e) && (e = e.call(this[0])),
                            (t = z(e, this[0].ownerDocument).eq(0).clone(!0)),
                            this[0].parentNode && t.insertBefore(this[0]),
                            t
                                .map(function () {
                                    for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                    return e;
                                })
                                .append(this)),
                        this
                    );
                },
                wrapInner: function (e) {
                    return M(e)
                        ? this.each(function (t) {
                              z(this).wrapInner(e.call(this, t));
                          })
                        : this.each(function () {
                              var t = z(this),
                                  i = t.contents();
                              i.length ? i.wrapAll(e) : t.append(e);
                          });
                },
                wrap: function (e) {
                    var t = M(e);
                    return this.each(function (i) {
                        z(this).wrapAll(t ? e.call(this, i) : e);
                    });
                },
                unwrap: function (e) {
                    return (
                        this.parent(e)
                            .not("body")
                            .each(function () {
                                z(this).replaceWith(this.childNodes);
                            }),
                        this
                    );
                },
            }),
            (z.expr.pseudos.hidden = function (e) {
                return !z.expr.pseudos.visible(e);
            }),
            (z.expr.pseudos.visible = function (e) {
                return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
            }),
            (z.ajaxSettings.xhr = function () {
                try {
                    return new e.XMLHttpRequest();
                } catch (e) {}
            });
        var Dt = { 0: 200, 1223: 204 },
            Rt = z.ajaxSettings.xhr();
        (f.cors = !!Rt && "withCredentials" in Rt),
            (f.ajax = Rt = !!Rt),
            z.ajaxTransport(function (t) {
                var i, n;
                if (f.cors || (Rt && !t.crossDomain))
                    return {
                        send: function (o, s) {
                            var r,
                                c = t.xhr();
                            if ((c.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)) for (r in t.xhrFields) c[r] = t.xhrFields[r];
                            for (r in (t.mimeType && c.overrideMimeType && c.overrideMimeType(t.mimeType), t.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o)) c.setRequestHeader(r, o[r]);
                            (i = function (e) {
                                return function () {
                                    i &&
                                        ((i = n = c.onload = c.onerror = c.onabort = c.ontimeout = c.onreadystatechange = null),
                                        "abort" === e
                                            ? c.abort()
                                            : "error" === e
                                            ? "number" != typeof c.status
                                                ? s(0, "error")
                                                : s(c.status, c.statusText)
                                            : s(
                                                  Dt[c.status] || c.status,
                                                  c.statusText,
                                                  "text" !== (c.responseType || "text") || "string" != typeof c.responseText ? { binary: c.response } : { text: c.responseText },
                                                  c.getAllResponseHeaders()
                                              ));
                                };
                            }),
                                (c.onload = i()),
                                (n = c.onerror = c.ontimeout = i("error")),
                                void 0 !== c.onabort
                                    ? (c.onabort = n)
                                    : (c.onreadystatechange = function () {
                                          4 === c.readyState &&
                                              e.setTimeout(function () {
                                                  i && n();
                                              });
                                      }),
                                (i = i("abort"));
                            try {
                                c.send((t.hasContent && t.data) || null);
                            } catch (e) {
                                if (i) throw e;
                            }
                        },
                        abort: function () {
                            i && i();
                        },
                    };
            }),
            z.ajaxPrefilter(function (e) {
                e.crossDomain && (e.contents.script = !1);
            }),
            z.ajaxSetup({
                accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                contents: { script: /\b(?:java|ecma)script\b/ },
                converters: {
                    "text script": function (e) {
                        return z.globalEval(e), e;
                    },
                },
            }),
            z.ajaxPrefilter("script", function (e) {
                void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
            }),
            z.ajaxTransport("script", function (e) {
                var t, i;
                if (e.crossDomain)
                    return {
                        send: function (o, s) {
                            (t = z("<script>")
                                .prop({ charset: e.scriptCharset, src: e.url })
                                .on(
                                    "load error",
                                    (i = function (e) {
                                        t.remove(), (i = null), e && s("error" === e.type ? 404 : 200, e.type);
                                    })
                                )),
                                n.head.appendChild(t[0]);
                        },
                        abort: function () {
                            i && i();
                        },
                    };
            });
        var Pt = [],
            It = /(=)\?(?=&|$)|\?\?/;
        z.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var e = Pt.pop() || z.expando + "_" + gt++;
                return (this[e] = !0), e;
            },
        }),
            z.ajaxPrefilter("json jsonp", function (t, i, n) {
                var o,
                    s,
                    r,
                    c = !1 !== t.jsonp && (It.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && It.test(t.data) && "data");
                if (c || "jsonp" === t.dataTypes[0])
                    return (
                        (o = t.jsonpCallback = M(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                        c ? (t[c] = t[c].replace(It, "$1" + o)) : !1 !== t.jsonp && (t.url += (At.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
                        (t.converters["script json"] = function () {
                            return r || z.error(o + " was not called"), r[0];
                        }),
                        (t.dataTypes[0] = "json"),
                        (s = e[o]),
                        (e[o] = function () {
                            r = arguments;
                        }),
                        n.always(function () {
                            void 0 === s ? z(e).removeProp(o) : (e[o] = s), t[o] && ((t.jsonpCallback = i.jsonpCallback), Pt.push(o)), r && M(s) && s(r[0]), (r = s = void 0);
                        }),
                        "script"
                    );
            }),
            (f.createHTMLDocument = (function () {
                var e = n.implementation.createHTMLDocument("").body;
                return (e.innerHTML = "<form></form><form></form>"), 2 === e.childNodes.length;
            })()),
            (z.parseHTML = function (e, t, i) {
                return "string" != typeof e
                    ? []
                    : ("boolean" == typeof t && ((i = t), (t = !1)),
                      t || (f.createHTMLDocument ? (((o = (t = n.implementation.createHTMLDocument("")).createElement("base")).href = n.location.href), t.head.appendChild(o)) : (t = n)),
                      (r = !i && []),
                      (s = w.exec(e)) ? [t.createElement(s[1])] : ((s = be([e], t, r)), r && r.length && z(r).remove(), z.merge([], s.childNodes)));
                var o, s, r;
            }),
            (z.fn.load = function (e, t, i) {
                var n,
                    o,
                    s,
                    r = this,
                    c = e.indexOf(" ");
                return (
                    c > -1 && ((n = dt(e.slice(c))), (e = e.slice(0, c))),
                    M(t) ? ((i = t), (t = void 0)) : t && "object" == typeof t && (o = "POST"),
                    r.length > 0 &&
                        z
                            .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
                            .done(function (e) {
                                (s = arguments), r.html(n ? z("<div>").append(z.parseHTML(e)).find(n) : e);
                            })
                            .always(
                                i &&
                                    function (e, t) {
                                        r.each(function () {
                                            i.apply(this, s || [e.responseText, t, e]);
                                        });
                                    }
                            ),
                    this
                );
            }),
            z.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
                z.fn[t] = function (e) {
                    return this.on(t, e);
                };
            }),
            (z.expr.pseudos.animated = function (e) {
                return z.grep(z.timers, function (t) {
                    return e === t.elem;
                }).length;
            }),
            (z.offset = {
                setOffset: function (e, t, i) {
                    var n,
                        o,
                        s,
                        r,
                        c,
                        a,
                        l = z.css(e, "position"),
                        u = z(e),
                        d = {};
                    "static" === l && (e.style.position = "relative"),
                        (c = u.offset()),
                        (s = z.css(e, "top")),
                        (a = z.css(e, "left")),
                        ("absolute" === l || "fixed" === l) && (s + a).indexOf("auto") > -1 ? ((r = (n = u.position()).top), (o = n.left)) : ((r = parseFloat(s) || 0), (o = parseFloat(a) || 0)),
                        M(t) && (t = t.call(e, i, z.extend({}, c))),
                        null != t.top && (d.top = t.top - c.top + r),
                        null != t.left && (d.left = t.left - c.left + o),
                        "using" in t ? t.using.call(e, d) : u.css(d);
                },
            }),
            z.fn.extend({
                offset: function (e) {
                    if (arguments.length)
                        return void 0 === e
                            ? this
                            : this.each(function (t) {
                                  z.offset.setOffset(this, e, t);
                              });
                    var t,
                        i,
                        n = this[0];
                    return n ? (n.getClientRects().length ? ((t = n.getBoundingClientRect()), (i = n.ownerDocument.defaultView), { top: t.top + i.pageYOffset, left: t.left + i.pageXOffset }) : { top: 0, left: 0 }) : void 0;
                },
                position: function () {
                    if (this[0]) {
                        var e,
                            t,
                            i,
                            n = this[0],
                            o = { top: 0, left: 0 };
                        if ("fixed" === z.css(n, "position")) t = n.getBoundingClientRect();
                        else {
                            for (t = this.offset(), i = n.ownerDocument, e = n.offsetParent || i.documentElement; e && (e === i.body || e === i.documentElement) && "static" === z.css(e, "position"); ) e = e.parentNode;
                            e && e !== n && 1 === e.nodeType && (((o = z(e).offset()).top += z.css(e, "borderTopWidth", !0)), (o.left += z.css(e, "borderLeftWidth", !0)));
                        }
                        return { top: t.top - o.top - z.css(n, "marginTop", !0), left: t.left - o.left - z.css(n, "marginLeft", !0) };
                    }
                },
                offsetParent: function () {
                    return this.map(function () {
                        for (var e = this.offsetParent; e && "static" === z.css(e, "position"); ) e = e.offsetParent;
                        return e || me;
                    });
                },
            }),
            z.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
                var i = "pageYOffset" === t;
                z.fn[e] = function (n) {
                    return H(
                        this,
                        function (e, n, o) {
                            var s;
                            if ((b(e) ? (s = e) : 9 === e.nodeType && (s = e.defaultView), void 0 === o)) return s ? s[t] : e[n];
                            s ? s.scrollTo(i ? s.pageXOffset : o, i ? o : s.pageYOffset) : (e[n] = o);
                        },
                        e,
                        n,
                        arguments.length
                    );
                };
            }),
            z.each(["top", "left"], function (e, t) {
                z.cssHooks[t] = Pe(f.pixelPosition, function (e, i) {
                    if (i) return (i = Re(e, t)), xe.test(i) ? z(e).position()[t] + "px" : i;
                });
            }),
            z.each({ Height: "height", Width: "width" }, function (e, t) {
                z.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (i, n) {
                    z.fn[n] = function (o, s) {
                        var r = arguments.length && (i || "boolean" != typeof o),
                            c = i || (!0 === o || !0 === s ? "margin" : "border");
                        return H(
                            this,
                            function (t, i, o) {
                                var s;
                                return b(t)
                                    ? 0 === n.indexOf("outer")
                                        ? t["inner" + e]
                                        : t.document.documentElement["client" + e]
                                    : 9 === t.nodeType
                                    ? ((s = t.documentElement), Math.max(t.body["scroll" + e], s["scroll" + e], t.body["offset" + e], s["offset" + e], s["client" + e]))
                                    : void 0 === o
                                    ? z.css(t, i, c)
                                    : z.style(t, i, o, c);
                            },
                            t,
                            r ? o : void 0,
                            r
                        );
                    };
                });
            }),
            z.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
                z.fn[t] = function (e, i) {
                    return arguments.length > 0 ? this.on(t, null, e, i) : this.trigger(t);
                };
            }),
            z.fn.extend({
                hover: function (e, t) {
                    return this.mouseenter(e).mouseleave(t || e);
                },
            }),
            z.fn.extend({
                bind: function (e, t, i) {
                    return this.on(e, null, t, i);
                },
                unbind: function (e, t) {
                    return this.off(e, null, t);
                },
                delegate: function (e, t, i, n) {
                    return this.on(t, e, i, n);
                },
                undelegate: function (e, t, i) {
                    return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", i);
                },
            }),
            (z.proxy = function (e, t) {
                var i, n, o;
                if (("string" == typeof t && ((i = e[t]), (t = e), (e = i)), M(e)))
                    return (
                        (n = s.call(arguments, 2)),
                        (o = function () {
                            return e.apply(t || this, n.concat(s.call(arguments)));
                        }),
                        (o.guid = e.guid = e.guid || z.guid++),
                        o
                    );
            }),
            (z.holdReady = function (e) {
                e ? z.readyWait++ : z.ready(!0);
            }),
            (z.isArray = Array.isArray),
            (z.parseJSON = JSON.parse),
            (z.nodeName = q),
            (z.isFunction = M),
            (z.isWindow = b),
            (z.camelCase = U),
            (z.type = A),
            (z.now = Date.now),
            (z.isNumeric = function (e) {
                var t = z.type(e);
                return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
            }),
            "function" == typeof define &&
                define.amd &&
                define("jquery", [], function () {
                    return z;
                });
        var Ht = e.jQuery,
            jt = e.$;
        return (
            (z.noConflict = function (t) {
                return e.$ === z && (e.$ = jt), t && e.jQuery === z && (e.jQuery = Ht), z;
            }),
            t || (e.jQuery = e.$ = z),
            z
        );
    }),
    function () {
        var e,
            t,
            i,
            n,
            o,
            s,
            r = function (e, t) {
                return function () {
                    return e.apply(t, arguments);
                };
            };
        (t = (function () {
            function e() {
                this.update = r(this.update, this);
            }
            return (
                (e.prototype.update = function (e) {
                    var t, i, o;
                    for (i in e) (o = e[i]), "items" !== i && (this[i] = o);
                    return (this.items = (function () {
                        var i, o, s, r;
                        for (r = [], i = 0, o = (s = e.items).length; o > i; i++) (t = s[i]), r.push(new n(t));
                        return r;
                    })());
                }),
                e
            );
        })()),
            (n = (function () {
                function e(e) {
                    (this.propertyArray = r(this.propertyArray, this)), (this.update = r(this.update, this)), this.update(e);
                }
                return (
                    (e.prototype.update = function (e) {
                        var t, n;
                        for (t in e) (n = e[t]), "properties" !== t && (this[t] = n);
                        return (this.properties = i.Utils.extend({}, e.properties));
                    }),
                    (e.prototype.propertyArray = function () {
                        var e, t, i, n;
                        for (e in ((n = []), (i = this.properties))) (t = i[e]), n.push({ name: e, value: t });
                        return n;
                    }),
                    e
                );
            })()),
            ((i = { settings: { debug: !1, dataAPI: !0, requestBodyClass: null, rivetsModels: {}, currency: null, moneyFormat: null, moneyWithCurrencyFormat: null, weightUnit: "g", weightPrecision: 0 }, cart: new t() }).init = function (
                e,
                t
            ) {
                return (
                    null == t && (t = {}),
                    i.configure(t),
                    i.Utils.log("Initialising CartJS."),
                    i.cart.update(e),
                    i.settings.dataAPI && (i.Utils.log('"dataAPI" setting is true, initialising Data API.'), i.Data.init()),
                    i.settings.requestBodyClass &&
                        (i.Utils.log('"requestBodyClass" set, adding event listeners.'),
                        jQuery(document).on("cart.requestStarted", function () {
                            return jQuery("body").addClass(i.settings.requestBodyClass);
                        }),
                        jQuery(document).on("cart.requestComplete", function () {
                            return jQuery("body").removeClass(i.settings.requestBodyClass);
                        })),
                    i.Rivets.init(),
                    jQuery(document).trigger("cart.ready", [i.cart])
                );
            }),
            (i.configure = function (e) {
                return null == e && (e = {}), i.Utils.extend(i.settings, e);
            }),
            null == window.console && ((window.console = {}), (window.console.log = function () {})),
            (i.Utils = {
                log: function () {
                    return i.Utils.console(console.log, arguments);
                },
                error: function () {
                    return i.Utils.console(console.error, arguments);
                },
                console: function (e, t) {
                    return i.settings.debug && "undefined" != typeof console && null !== console ? ((t = Array.prototype.slice.call(t)).unshift("[CartJS]:"), e.apply(console, t)) : void 0;
                },
                wrapKeys: function (e, t, i) {
                    var n, o, s;
                    for (n in (null == t && (t = "properties"), (s = {}), e)) (o = e[n]), (s[t + "[" + n + "]"] = null != i ? i : o);
                    return s;
                },
                unwrapKeys: function (e, t, i) {
                    var n, o, s;
                    for (n in (null == t && (t = "properties"), (o = {}), e)) (s = e[n]), (o[n.replace(t + "[", "").replace("]", "")] = null != i ? i : s);
                    return o;
                },
                extend: function (e, t) {
                    var i, n;
                    for (i in t) (n = t[i]), (e[i] = n);
                    return e;
                },
                clone: function (e) {
                    var t, i;
                    if (null == e || "object" != typeof e) return e;
                    for (t in ((i = new e.constructor()), e)) i[t] = clone(e[t]);
                    return i;
                },
                isArray:
                    Array.isArray ||
                    function (e) {
                        return "[object Array]" === {}.toString.call(e);
                    },
                ensureArray: function (e) {
                    return i.Utils.isArray(e) ? e : null != e ? [e] : [];
                },
                formatMoney: function (e, t, n, o) {
                    var s, r;
                    return (
                        null == o && (o = ""),
                        o || (o = i.settings.currency),
                        null != window.Currency &&
                            o !== i.settings.currency &&
                            ((e = Currency.convert(e, i.settings.currency, o)), null != (null != (s = window.Currency) ? s.moneyFormats : void 0) && o in window.Currency.moneyFormats && (t = window.Currency.moneyFormats[o][n])),
                        null != (null != (r = window.Shopify) ? r.formatMoney : void 0) ? Shopify.formatMoney(e, t) : e
                    );
                },
                getSizedImageUrl: function (e, t) {
                    var i, n;
                    return null != (null != (i = window.Shopify) && null != (n = i.Image) ? n.getSizedImageUrl : void 0)
                        ? e
                            ? Shopify.Image.getSizedImageUrl(e, t)
                            : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", t).replace("-_", "-")
                        : e || "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
                },
            }),
            (s = []),
            (o = !1),
            (i.Queue = {
                add: function (e, t, n) {
                    var r;
                    return (
                        null == n && (n = {}),
                        (r = { url: e, data: t, type: n.type || "POST", dataType: n.dataType || "json", success: i.Utils.ensureArray(n.success), error: i.Utils.ensureArray(n.error), complete: i.Utils.ensureArray(n.complete) }),
                        n.updateCart && r.success.push(i.cart.update),
                        s.push(r),
                        o ? void 0 : (jQuery(document).trigger("cart.requestStarted", [i.cart]), i.Queue.process())
                    );
                },
                process: function () {
                    var e;
                    return s.length ? ((o = !0), ((e = s.shift()).complete = i.Queue.process), jQuery.ajax(e)) : ((o = !1), void jQuery(document).trigger("cart.requestComplete", [i.cart]));
                },
            }),
            (i.Core = {
                getCart: function (e) {
                    return null == e && (e = {}), (e.type = "GET"), (e.updateCart = !0), i.Queue.add("/cart.js", {}, e);
                },
                addItem: function (e, t, n, o) {
                    var s;
                    return null == t && (t = 1), null == n && (n = {}), null == o && (o = {}), ((s = i.Utils.wrapKeys(n)).id = e), (s.quantity = t), i.Queue.add("/cart/add.js", s, o), i.Core.getCart();
                },
                updateItem: function (e, t, n, o) {
                    var s;
                    return null == n && (n = {}), null == o && (o = {}), ((s = i.Utils.wrapKeys(n)).line = e), null != t && (s.quantity = t), (o.updateCart = !0), i.Queue.add("/cart/change.js", s, o);
                },
                removeItem: function (e, t) {
                    return null == t && (t = {}), i.Core.updateItem(e, 0, {}, t);
                },
                updateItemById: function (e, t, n, o) {
                    var s;
                    return null == n && (n = {}), null == o && (o = {}), ((s = i.Utils.wrapKeys(n)).id = e), null != t && (s.quantity = t), (o.updateCart = !0), i.Queue.add("/cart/change.js", s, o);
                },
                updateItemQuantitiesById: function (e, t) {
                    return null == e && (e = {}), null == t && (t = {}), (t.updateCart = !0), i.Queue.add("/cart/update.js", { updates: e }, t);
                },
                removeItemById: function (e, t) {
                    var n;
                    return null == t && (t = {}), (n = { id: e, quantity: 0 }), (t.updateCart = !0), i.Queue.add("/cart/change.js", n, t);
                },
                clear: function (e) {
                    return null == e && (e = {}), (e.updateCart = !0), i.Queue.add("/cart/clear.js", {}, e);
                },
                getAttribute: function (e, t) {
                    return e in i.cart.attributes ? i.cart.attributes[e] : t;
                },
                setAttribute: function (e, t, n) {
                    var o;
                    return null == n && (n = {}), ((o = {})[e] = t), i.Core.setAttributes(o, n);
                },
                getAttributes: function () {
                    return i.cart.attributes;
                },
                setAttributes: function (e, t) {
                    return null == e && (e = {}), null == t && (t = {}), (t.updateCart = !0), i.Queue.add("/cart/update.js", i.Utils.wrapKeys(e, "attributes"), t);
                },
                clearAttributes: function (e) {
                    return null == e && (e = {}), (e.updateCart = !0), i.Queue.add("/cart/update.js", i.Utils.wrapKeys(i.Core.getAttributes(), "attributes", ""), e);
                },
                getNote: function () {
                    return i.cart.note;
                },
                setNote: function (e, t) {
                    return null == t && (t = {}), (t.updateCart = !0), i.Queue.add("/cart/update.js", { note: e }, t);
                },
            }),
            (e = null),
            (i.Data = {
                init: function () {
                    return (e = jQuery(document)), i.Data.setEventListeners("on"), i.Data.render(null, i.cart);
                },
                destroy: function () {
                    return i.Data.setEventListeners("off");
                },
                setEventListeners: function (t) {
                    return (
                        e[t]("click", "[data-cart-add]", i.Data.add),
                        e[t]("click", "[data-cart-remove]", i.Data.remove),
                        e[t]("click", "[data-cart-remove-id]", i.Data.removeById),
                        e[t]("click", "[data-cart-update]", i.Data.update),
                        e[t]("click", "[data-cart-update-id]", i.Data.updateById),
                        e[t]("click", "[data-cart-clear]", i.Data.clear),
                        e[t]("change", "[data-cart-toggle]", i.Data.toggle),
                        e[t]("change", "[data-cart-toggle-attribute]", i.Data.toggleAttribute),
                        e[t]("submit", "[data-cart-submit]", i.Data.submit),
                        e[t]("cart.requestComplete", i.Data.render)
                    );
                },
                add: function (e) {
                    var t;
                    return e.preventDefault(), (t = jQuery(this)), i.Core.addItem(t.attr("data-cart-add"), t.attr("data-cart-quantity"));
                },
                remove: function (e) {
                    var t;
                    return e.preventDefault(), (t = jQuery(this)), i.Core.removeItem(t.attr("data-cart-remove"));
                },
                removeById: function (e) {
                    var t;
                    return e.preventDefault(), (t = jQuery(this)), i.Core.removeItemById(t.attr("data-cart-remove-id"));
                },
                update: function (e) {
                    var t;
                    return e.preventDefault(), (t = jQuery(this)), i.Core.updateItem(t.attr("data-cart-update"), t.attr("data-cart-quantity"));
                },
                updateById: function (e) {
                    var t;
                    return e.preventDefault(), (t = jQuery(this)), i.Core.updateItemById(t.attr("data-cart-update-id"), t.attr("data-cart-quantity"));
                },
                clear: function (e) {
                    return e.preventDefault(), i.Core.clear();
                },
                toggle: function () {
                    var e, t;
                    return (t = (e = jQuery(this)).attr("data-cart-toggle")), e.is(":checked") ? i.Core.addItem(t) : i.Core.removeItemById(t);
                },
                toggleAttribute: function () {
                    var e, t;
                    return (t = (e = jQuery(this)).attr("data-cart-toggle-attribute")), i.Core.setAttribute(t, e.is(":checked") ? "Yes" : "");
                },
                submit: function (e) {
                    var t, n, o, s;
                    return (
                        e.preventDefault(),
                        (t = jQuery(this).serializeArray()),
                        (n = void 0),
                        (s = void 0),
                        (o = {}),
                        jQuery.each(t, function (e, t) {
                            return "id" === t.name ? (n = t.value) : "quantity" === t.name ? (s = t.value) : t.name.match(/^properties\[\w+\]$/) ? (o[t.name] = t.value) : void 0;
                        }),
                        i.Core.addItem(n, s, i.Utils.unwrapKeys(o))
                    );
                },
                render: function (e, t) {
                    var n;
                    return (
                        (n = {
                            item_count: t.item_count,
                            total_price: t.total_price,
                            total_price_money: i.Utils.formatMoney(
                                t.total_price,
                                i.settings.moneyFormat,
                                "money_format",
                                null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0
                            ),
                            total_price_money_with_currency: i.Utils.formatMoney(
                                t.total_price,
                                i.settings.moneyWithCurrencyFormat,
                                "money_with_currency_format",
                                null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0
                            ),
                        }),
                        jQuery("[data-cart-render]").each(function () {
                            var e;
                            return (e = jQuery(this)).html(n[e.attr("data-cart-render")]);
                        })
                    );
                },
            }),
            "rivets" in window
                ? ((i.Rivets = {
                      model: null,
                      boundViews: [],
                      init: function () {
                          return i.Rivets.bindViews();
                      },
                      destroy: function () {
                          return i.Rivets.unbindViews();
                      },
                      bindViews: function () {
                          return (
                              i.Utils.log("Rivets.js is present, binding views."),
                              i.Rivets.unbindViews(),
                              (i.Rivets.model = i.Utils.extend({ cart: i.cart }, i.settings.rivetsModels)),
                              null != window.Currency && (i.Rivets.model.Currency = window.Currency),
                              jQuery("[data-cart-view]").each(function () {
                                  var e;
                                  return (e = rivets.bind(jQuery(this), i.Rivets.model)), i.Rivets.boundViews.push(e);
                              })
                          );
                      },
                      unbindViews: function () {
                          var e, t, n;
                          for (e = 0, t = (n = i.Rivets.boundViews).length; t > e; e++) n[e].unbind();
                          return (i.Rivets.boundViews = []);
                      },
                  }),
                  (rivets.formatters.eq = function (e, t) {
                      return e === t;
                  }),
                  (rivets.formatters.includes = function (e, t) {
                      return e.indexOf(t) >= 0;
                  }),
                  (rivets.formatters.match = function (e, t, i) {
                      return e.match(new RegExp(t, i));
                  }),
                  (rivets.formatters.lt = function (e, t) {
                      return t > e;
                  }),
                  (rivets.formatters.gt = function (e, t) {
                      return e > t;
                  }),
                  (rivets.formatters.not = function (e) {
                      return !e;
                  }),
                  (rivets.formatters.empty = function (e) {
                      return !e.length;
                  }),
                  (rivets.formatters.plus = function (e, t) {
                      return parseInt(e) + parseInt(t);
                  }),
                  (rivets.formatters.minus = function (e, t) {
                      return parseInt(e) - parseInt(t);
                  }),
                  (rivets.formatters.times = function (e, t) {
                      return e * t;
                  }),
                  (rivets.formatters.divided_by = function (e, t) {
                      return e / t;
                  }),
                  (rivets.formatters.modulo = function (e, t) {
                      return e % t;
                  }),
                  (rivets.formatters.prepend = function (e, t) {
                      return t + e;
                  }),
                  (rivets.formatters.append = function (e, t) {
                      return e + t;
                  }),
                  (rivets.formatters.slice = function (e, t, i) {
                      return e.slice(t, i);
                  }),
                  (rivets.formatters.pluralize = function (e, t, n) {
                      return null == n && (n = t + "s"), i.Utils.isArray(e) && (e = e.length), 1 === e ? t : n;
                  }),
                  (rivets.formatters.array_element = function (e, t) {
                      return e[t];
                  }),
                  (rivets.formatters.array_first = function (e) {
                      return e[0];
                  }),
                  (rivets.formatters.array_last = function (e) {
                      return e[e.length - 1];
                  }),
                  (rivets.formatters.money = function (e, t) {
                      return i.Utils.formatMoney(e, i.settings.moneyFormat, "money_format", t);
                  }),
                  (rivets.formatters.money_with_currency = function (e, t) {
                      return i.Utils.formatMoney(e, i.settings.moneyWithCurrencyFormat, "money_with_currency_format", t);
                  }),
                  (rivets.formatters.weight = function (e) {
                      switch (i.settings.weightUnit) {
                          case "kg":
                              return (e / 1e3).toFixed(i.settings.weightPrecision);
                          case "oz":
                              return (0.035274 * e).toFixed(i.settings.weightPrecision);
                          case "lb":
                              return (0.00220462 * e).toFixed(i.settings.weightPrecision);
                          default:
                              return e.toFixed(i.settings.weightPrecision);
                      }
                  }),
                  (rivets.formatters.weight_with_unit = function (e) {
                      return rivets.formatters.weight(e) + i.settings.weightUnit;
                  }),
                  (rivets.formatters.product_image_size = function (e, t) {
                      return i.Utils.getSizedImageUrl(e, t);
                  }),
                  (rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency),
                  (rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit),
                  (rivets.formatters.productImageSize = rivets.formatters.product_image_size))
                : (i.Rivets = { init: function () {}, destroy: function () {} }),
            (i.factory = function (e) {
                return (
                    (e.init = i.init),
                    (e.configure = i.configure),
                    (e.cart = i.cart),
                    (e.settings = i.settings),
                    (e.getCart = i.Core.getCart),
                    (e.addItem = i.Core.addItem),
                    (e.updateItem = i.Core.updateItem),
                    (e.updateItemById = i.Core.updateItemById),
                    (e.updateItemQuantitiesById = i.Core.updateItemQuantitiesById),
                    (e.removeItem = i.Core.removeItem),
                    (e.removeItemById = i.Core.removeItemById),
                    (e.clear = i.Core.clear),
                    (e.getAttribute = i.Core.getAttribute),
                    (e.setAttribute = i.Core.setAttribute),
                    (e.getAttributes = i.Core.getAttributes),
                    (e.setAttributes = i.Core.setAttributes),
                    (e.clearAttributes = i.Core.clearAttributes),
                    (e.getNote = i.Core.getNote),
                    (e.setNote = i.Core.setNote),
                    (e.render = i.Data.render)
                );
            }),
            "object" == typeof exports
                ? i.factory(exports)
                : "function" == typeof define && define.amd
                ? define(["exports"], function (e) {
                      return i.factory((this.CartJS = e)), e;
                  })
                : i.factory((this.CartJS = {}));
    }.call(this),
    (function (e) {
        var t = navigator.userAgent;
        e.HTMLPictureElement &&
            /ecko/.test(t) &&
            t.match(/rv\:(\d+)/) &&
            RegExp.$1 < 45 &&
            addEventListener(
                "resize",
                (function () {
                    var t,
                        i = document.createElement("source"),
                        n = function (e) {
                            var t,
                                n,
                                o = e.parentNode;
                            "PICTURE" === o.nodeName.toUpperCase()
                                ? ((t = i.cloneNode()),
                                  o.insertBefore(t, o.firstElementChild),
                                  setTimeout(function () {
                                      o.removeChild(t);
                                  }))
                                : (!e._pfLastSize || e.offsetWidth > e._pfLastSize) &&
                                  ((e._pfLastSize = e.offsetWidth),
                                  (n = e.sizes),
                                  (e.sizes += ",100vw"),
                                  setTimeout(function () {
                                      e.sizes = n;
                                  }));
                        },
                        o = function () {
                            var e,
                                t = document.querySelectorAll("picture > img, img[srcset][sizes]");
                            for (e = 0; e < t.length; e++) n(t[e]);
                        },
                        s = function () {
                            clearTimeout(t), (t = setTimeout(o, 99));
                        },
                        r = e.matchMedia && matchMedia("(orientation: landscape)"),
                        c = function () {
                            s(), r && r.addListener && r.addListener(s);
                        };
                    return (i.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="), /^[c|i]|d$/.test(document.readyState || "") ? c() : document.addEventListener("DOMContentLoaded", c), s;
                })()
            );
    })(window),
    (function (e, t, i) {
        "use strict";
        function n(e) {
            return " " === e || "\t" === e || "\n" === e || "\f" === e || "\r" === e;
        }
        function o(e, t, i, n) {
            var o, s, r;
            return "saveData" === z.algorithm ? (e > 2.7 ? (r = i + 1) : ((s = (t - i) * (o = Math.pow(e - 0.6, 1.5))), n && (s += 0.1 * o), (r = e + s))) : (r = i > 1 ? Math.sqrt(e * t) : e), r > i;
        }
        function s(e, t) {
            return e.res - t.res;
        }
        function r(e, t, i) {
            var n;
            return !i && t && (i = (i = e[d.ns].sets) && i[i.length - 1]), (n = c(t, i)) && ((t = d.makeUrl(t)), (e[d.ns].curSrc = t), (e[d.ns].curCan = n), n.res || U(n, n.set.sizes)), n;
        }
        function c(e, t) {
            var i, n, o;
            if (e && t)
                for (o = d.parseSet(t), e = d.makeUrl(e), i = 0; i < o.length; i++)
                    if (e === d.makeUrl(o[i].url)) {
                        n = o[i];
                        break;
                    }
            return n;
        }
        t.createElement("picture");
        var a,
            l,
            u,
            d = {},
            p = !1,
            h = function () {},
            f = t.createElement("img"),
            M = f.getAttribute,
            b = f.setAttribute,
            m = f.removeAttribute,
            g = t.documentElement,
            A = {},
            z = { algorithm: "" },
            y = "data-pfsrc",
            v = y + "set",
            O = navigator.userAgent,
            L = /rident/.test(O) || (/ecko/.test(O) && O.match(/rv\:(\d+)/) && RegExp.$1 > 35),
            T = "currentSrc",
            N = /\s+\+?\d+(e\d+)?w/,
            q = /(\([^)]+\))?\s*(.+)/,
            w = e.picturefillCFG,
            W = "font-size:100%!important;",
            S = !0,
            C = {},
            k = {},
            B = e.devicePixelRatio,
            E = { px: 1, in: 96 },
            X = t.createElement("a"),
            x = !1,
            _ = /^[ \t\n\r\u000c]+/,
            D = /^[, \t\n\r\u000c]+/,
            R = /^[^ \t\n\r\u000c]+/,
            P = /[,]+$/,
            I = /^\d+$/,
            H = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,
            j = function (e, t, i, n) {
                e.addEventListener ? e.addEventListener(t, i, n || !1) : e.attachEvent && e.attachEvent("on" + t, i);
            },
            $ = function (e) {
                var t = {};
                return function (i) {
                    return i in t || (t[i] = e(i)), t[i];
                };
            },
            F = (function () {
                var e = /^([\d\.]+)(em|vw|px)$/,
                    t = $(function (e) {
                        return (
                            "return " +
                            (function () {
                                for (var e = arguments, t = 0, i = e[0]; ++t in e; ) i = i.replace(e[t], e[++t]);
                                return i;
                            })(
                                (e || "").toLowerCase(),
                                /\band\b/g,
                                "&&",
                                /,/g,
                                "||",
                                /min-([a-z-\s]+):/g,
                                "e.$1>=",
                                /max-([a-z-\s]+):/g,
                                "e.$1<=",
                                /calc([^)]+)/g,
                                "($1)",
                                /(\d+[\.]*[\d]*)([a-z]+)/g,
                                "($1 * e.$2)",
                                /^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi,
                                ""
                            ) +
                            ";"
                        );
                    });
                return function (i, n) {
                    var o;
                    if (!(i in C))
                        if (((C[i] = !1), n && (o = i.match(e)))) C[i] = o[1] * E[o[2]];
                        else
                            try {
                                C[i] = new Function("e", t(i))(E);
                            } catch (e) {}
                    return C[i];
                };
            })(),
            U = function (e, t) {
                return e.w ? ((e.cWidth = d.calcListLength(t || "100vw")), (e.res = e.w / e.cWidth)) : (e.res = e.d), e;
            },
            V = function (e) {
                if (p) {
                    var i,
                        n,
                        o,
                        s = e || {};
                    if (
                        (s.elements && 1 === s.elements.nodeType && ("IMG" === s.elements.nodeName.toUpperCase() ? (s.elements = [s.elements]) : ((s.context = s.elements), (s.elements = null))),
                        (o = (i = s.elements || d.qsa(s.context || t, s.reevaluate || s.reselect ? d.sel : d.selShort)).length))
                    ) {
                        for (d.setupRun(s), x = !0, n = 0; o > n; n++) d.fillImg(i[n], s);
                        d.teardownRun(s);
                    }
                }
            };
        e.console && console.warn,
            T in f || (T = "src"),
            (A["image/jpeg"] = !0),
            (A["image/gif"] = !0),
            (A["image/png"] = !0),
            (A["image/svg+xml"] = t.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1")),
            (d.ns = ("pf" + new Date().getTime()).substr(0, 9)),
            (d.supSrcset = "srcset" in f),
            (d.supSizes = "sizes" in f),
            (d.supPicture = !!e.HTMLPictureElement),
            d.supSrcset &&
                d.supPicture &&
                !d.supSizes &&
                (function (e) {
                    (f.srcset = "data:,a"), (e.src = "data:,a"), (d.supSrcset = f.complete === e.complete), (d.supPicture = d.supSrcset && d.supPicture);
                })(t.createElement("img")),
            d.supSrcset && !d.supSizes
                ? (function () {
                      var e = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
                          i = t.createElement("img"),
                          n = function () {
                              2 === i.width && (d.supSizes = !0), (l = d.supSrcset && !d.supSizes), (p = !0), setTimeout(V);
                          };
                      (i.onload = n), (i.onerror = n), i.setAttribute("sizes", "9px"), (i.srcset = e + " 1w,data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw== 9w"), (i.src = e);
                  })()
                : (p = !0),
            (d.selShort = "picture>img,img[srcset]"),
            (d.sel = d.selShort),
            (d.cfg = z),
            (d.DPR = B || 1),
            (d.u = E),
            (d.types = A),
            (d.setSize = h),
            (d.makeUrl = $(function (e) {
                return (X.href = e), X.href;
            })),
            (d.qsa = function (e, t) {
                return "querySelector" in e ? e.querySelectorAll(t) : [];
            }),
            (d.matchesMedia = function () {
                return (
                    e.matchMedia && (matchMedia("(min-width: 0.1em)") || {}).matches
                        ? (d.matchesMedia = function (e) {
                              return !e || matchMedia(e).matches;
                          })
                        : (d.matchesMedia = d.mMQ),
                    d.matchesMedia.apply(this, arguments)
                );
            }),
            (d.mMQ = function (e) {
                return !e || F(e);
            }),
            (d.calcLength = function (e) {
                var t = F(e, !0) || !1;
                return 0 > t && (t = !1), t;
            }),
            (d.supportsType = function (e) {
                return !e || A[e];
            }),
            (d.parseSize = $(function (e) {
                var t = (e || "").match(q);
                return { media: t && t[1], length: t && t[2] };
            })),
            (d.parseSet = function (e) {
                return (
                    e.cands ||
                        (e.cands = (function (e, t) {
                            function i(t) {
                                var i,
                                    n = t.exec(e.substring(p));
                                return n ? ((i = n[0]), (p += i.length), i) : void 0;
                            }
                            function o() {
                                var e,
                                    i,
                                    n,
                                    o,
                                    s,
                                    a,
                                    l,
                                    u,
                                    d,
                                    p = !1,
                                    f = {};
                                for (o = 0; o < c.length; o++)
                                    (a = (s = c[o])[s.length - 1]),
                                        (l = s.substring(0, s.length - 1)),
                                        (u = parseInt(l, 10)),
                                        (d = parseFloat(l)),
                                        I.test(l) && "w" === a
                                            ? ((e || i) && (p = !0), 0 === u ? (p = !0) : (e = u))
                                            : H.test(l) && "x" === a
                                            ? ((e || i || n) && (p = !0), 0 > d ? (p = !0) : (i = d))
                                            : I.test(l) && "h" === a
                                            ? ((n || i) && (p = !0), 0 === u ? (p = !0) : (n = u))
                                            : (p = !0);
                                p || ((f.url = r), e && (f.w = e), i && (f.d = i), n && (f.h = n), n || i || e || (f.d = 1), 1 === f.d && (t.has1x = !0), (f.set = t), h.push(f));
                            }
                            function s() {
                                for (i(_), a = "", l = "in descriptor"; ; ) {
                                    if (((u = e.charAt(p)), "in descriptor" === l))
                                        if (n(u)) a && (c.push(a), (a = ""), (l = "after descriptor"));
                                        else {
                                            if ("," === u) return (p += 1), a && c.push(a), void o();
                                            if ("(" === u) (a += u), (l = "in parens");
                                            else {
                                                if ("" === u) return a && c.push(a), void o();
                                                a += u;
                                            }
                                        }
                                    else if ("in parens" === l)
                                        if (")" === u) (a += u), (l = "in descriptor");
                                        else {
                                            if ("" === u) return c.push(a), void o();
                                            a += u;
                                        }
                                    else if ("after descriptor" === l)
                                        if (n(u));
                                        else {
                                            if ("" === u) return void o();
                                            (l = "in descriptor"), (p -= 1);
                                        }
                                    p += 1;
                                }
                            }
                            for (var r, c, a, l, u, d = e.length, p = 0, h = []; ; ) {
                                if ((i(D), p >= d)) return h;
                                (r = i(R)), (c = []), "," === r.slice(-1) ? ((r = r.replace(P, "")), o()) : s();
                            }
                        })(e.srcset, e)),
                    e.cands
                );
            }),
            (d.getEmValue = function () {
                var e;
                if (!a && (e = t.body)) {
                    var i = t.createElement("div"),
                        n = g.style.cssText,
                        o = e.style.cssText;
                    (i.style.cssText = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)"),
                        (g.style.cssText = W),
                        (e.style.cssText = W),
                        e.appendChild(i),
                        (a = i.offsetWidth),
                        e.removeChild(i),
                        (a = parseFloat(a, 10)),
                        (g.style.cssText = n),
                        (e.style.cssText = o);
                }
                return a || 16;
            }),
            (d.calcListLength = function (e) {
                if (!(e in k) || z.uT) {
                    var t = d.calcLength(
                        (function (e) {
                            function t(e) {
                                return !!(l.test(e) && parseFloat(e) >= 0) || !!u.test(e) || "0" === e || "-0" === e || "+0" === e;
                            }
                            var i,
                                o,
                                s,
                                r,
                                c,
                                a,
                                l = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i,
                                u = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;
                            for (
                                o = (function (e) {
                                    function t() {
                                        s && (r.push(s), (s = ""));
                                    }
                                    function i() {
                                        r[0] && (c.push(r), (r = []));
                                    }
                                    for (var o, s = "", r = [], c = [], a = 0, l = 0, u = !1; ; ) {
                                        if ("" === (o = e.charAt(l))) return t(), i(), c;
                                        if (u) {
                                            if ("*" === o && "/" === e[l + 1]) {
                                                (u = !1), (l += 2), t();
                                                continue;
                                            }
                                            l += 1;
                                        } else {
                                            if (n(o)) {
                                                if ((e.charAt(l - 1) && n(e.charAt(l - 1))) || !s) {
                                                    l += 1;
                                                    continue;
                                                }
                                                if (0 === a) {
                                                    t(), (l += 1);
                                                    continue;
                                                }
                                                o = " ";
                                            } else if ("(" === o) a += 1;
                                            else if (")" === o) a -= 1;
                                            else {
                                                if ("," === o) {
                                                    t(), i(), (l += 1);
                                                    continue;
                                                }
                                                if ("/" === o && "*" === e.charAt(l + 1)) {
                                                    (u = !0), (l += 2);
                                                    continue;
                                                }
                                            }
                                            (s += o), (l += 1);
                                        }
                                    }
                                })(e),
                                    s = o.length,
                                    i = 0;
                                s > i;
                                i++
                            )
                                if (t((c = (r = o[i])[r.length - 1]))) {
                                    if (((a = c), r.pop(), 0 === r.length)) return a;
                                    if (((r = r.join(" ")), d.matchesMedia(r))) return a;
                                }
                            return "100vw";
                        })(e)
                    );
                    k[e] = t || E.width;
                }
                return k[e];
            }),
            (d.setRes = function (e) {
                var t;
                if (e) for (var i = 0, n = (t = d.parseSet(e)).length; n > i; i++) U(t[i], e.sizes);
                return t;
            }),
            (d.setRes.res = U),
            (d.applySetCandidate = function (e, t) {
                if (e.length) {
                    var i,
                        n,
                        c,
                        a,
                        l,
                        u,
                        p,
                        h,
                        f,
                        M = t[d.ns],
                        b = d.DPR;
                    if (((u = M.curSrc || t[T]), (p = M.curCan || r(t, u, e[0].set)) && p.set === e[0].set && ((f = L && !t.complete && p.res - 0.1 > b) || ((p.cached = !0), p.res >= b && (l = p))), !l))
                        for (e.sort(s), l = e[(a = e.length) - 1], n = 0; a > n; n++)
                            if ((i = e[n]).res >= b) {
                                l = e[(c = n - 1)] && (f || u !== d.makeUrl(i.url)) && o(e[c].res, i.res, b, e[c].cached) ? e[c] : i;
                                break;
                            }
                    l && ((h = d.makeUrl(l.url)), (M.curSrc = h), (M.curCan = l), h !== u && d.setSrc(t, l), d.setSize(t));
                }
            }),
            (d.setSrc = function (e, t) {
                var i;
                (e.src = t.url), "image/svg+xml" === t.set.type && ((i = e.style.width), (e.style.width = e.offsetWidth + 1 + "px"), e.offsetWidth + 1 && (e.style.width = i));
            }),
            (d.getSet = function (e) {
                var t,
                    i,
                    n,
                    o = !1,
                    s = e[d.ns].sets;
                for (t = 0; t < s.length && !o; t++)
                    if ((i = s[t]).srcset && d.matchesMedia(i.media) && (n = d.supportsType(i.type))) {
                        "pending" === n && (i = n), (o = i);
                        break;
                    }
                return o;
            }),
            (d.parseSets = function (e, t, n) {
                var o,
                    s,
                    r,
                    a,
                    u = t && "PICTURE" === t.nodeName.toUpperCase(),
                    p = e[d.ns];
                (p.src === i || n.src) && ((p.src = M.call(e, "src")), p.src ? b.call(e, y, p.src) : m.call(e, y)),
                    (p.srcset === i || n.srcset || !d.supSrcset || e.srcset) && ((o = M.call(e, "srcset")), (p.srcset = o), (a = !0)),
                    (p.sets = []),
                    u &&
                        ((p.pic = !0),
                        (function (e, t) {
                            var i,
                                n,
                                o,
                                s,
                                r = e.getElementsByTagName("source");
                            for (i = 0, n = r.length; n > i; i++)
                                ((o = r[i])[d.ns] = !0), (s = o.getAttribute("srcset")) && t.push({ srcset: s, media: o.getAttribute("media"), type: o.getAttribute("type"), sizes: o.getAttribute("sizes") });
                        })(t, p.sets)),
                    p.srcset
                        ? ((s = { srcset: p.srcset, sizes: M.call(e, "sizes") }),
                          p.sets.push(s),
                          (r = (l || p.src) && N.test(p.srcset || "")) || !p.src || c(p.src, s) || s.has1x || ((s.srcset += ", " + p.src), s.cands.push({ url: p.src, d: 1, set: s })))
                        : p.src && p.sets.push({ srcset: p.src, sizes: null }),
                    (p.curCan = null),
                    (p.curSrc = i),
                    (p.supported = !(u || (s && !d.supSrcset) || (r && !d.supSizes))),
                    a && d.supSrcset && !p.supported && (o ? (b.call(e, v, o), (e.srcset = "")) : m.call(e, v)),
                    p.supported && !p.srcset && ((!p.src && e.src) || e.src !== d.makeUrl(p.src)) && (null === p.src ? e.removeAttribute("src") : (e.src = p.src)),
                    (p.parsed = !0);
            }),
            (d.fillImg = function (e, t) {
                var i,
                    n = t.reselect || t.reevaluate;
                e[d.ns] || (e[d.ns] = {}),
                    (i = e[d.ns]),
                    (n || i.evaled !== u) &&
                        ((!i.parsed || t.reevaluate) && d.parseSets(e, e.parentNode, t),
                        i.supported
                            ? (i.evaled = u)
                            : (function (e) {
                                  var t,
                                      i = d.getSet(e),
                                      n = !1;
                                  "pending" !== i && ((n = u), i && ((t = d.setRes(i)), d.applySetCandidate(t, e))), (e[d.ns].evaled = n);
                              })(e));
            }),
            (d.setupRun = function () {
                (!x || S || B !== e.devicePixelRatio) &&
                    ((S = !1),
                    (B = e.devicePixelRatio),
                    (C = {}),
                    (k = {}),
                    (d.DPR = B || 1),
                    (E.width = Math.max(e.innerWidth || 0, g.clientWidth)),
                    (E.height = Math.max(e.innerHeight || 0, g.clientHeight)),
                    (E.vw = E.width / 100),
                    (E.vh = E.height / 100),
                    (u = [E.height, E.width, B].join("-")),
                    (E.em = d.getEmValue()),
                    (E.rem = E.em));
            }),
            d.supPicture
                ? ((V = h), (d.fillImg = h))
                : (function () {
                      var i,
                          n = e.attachEvent ? /d$|^c/ : /d$|^c|^i/,
                          o = function () {
                              var e = t.readyState || "";
                              (s = setTimeout(o, "loading" === e ? 200 : 999)), t.body && (d.fillImgs(), (i = i || n.test(e)) && clearTimeout(s));
                          },
                          s = setTimeout(o, t.body ? 9 : 99),
                          r = g.clientHeight;
                      j(
                          e,
                          "resize",
                          (function (e, t) {
                              var i,
                                  n,
                                  o = function () {
                                      var s = new Date() - n;
                                      t > s ? (i = setTimeout(o, t - s)) : ((i = null), e());
                                  };
                              return function () {
                                  (n = new Date()), i || (i = setTimeout(o, t));
                              };
                          })(function () {
                              (S = Math.max(e.innerWidth || 0, g.clientWidth) !== E.width || g.clientHeight !== r), (r = g.clientHeight), S && d.fillImgs();
                          }, 99)
                      ),
                          j(t, "readystatechange", o);
                  })(),
            (d.picturefill = V),
            (d.fillImgs = V),
            (d.teardownRun = h),
            (V._ = d),
            (e.picturefillCFG = {
                pf: d,
                push: function (e) {
                    var t = e.shift();
                    "function" == typeof d[t] ? d[t].apply(d, e) : ((z[t] = e[0]), x && d.fillImgs({ reselect: !0 }));
                },
            });
        for (; w && w.length; ) e.picturefillCFG.push(w.shift());
        (e.picturefill = V),
            "object" == typeof module && "object" == typeof module.exports
                ? (module.exports = V)
                : "function" == typeof define &&
                  define.amd &&
                  define("picturefill", function () {
                      return V;
                  }),
            d.supPicture ||
                (A["image/webp"] = (function (t, i) {
                    var n = new e.Image();
                    return (
                        (n.onerror = function () {
                            (A[t] = !1), V();
                        }),
                        (n.onload = function () {
                            (A[t] = 1 === n.width), V();
                        }),
                        (n.src = i),
                        "pending"
                    );
                })("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="));
    })(window, document),
    (function (e) {
        "function" == typeof define && define.amd ? define(["jquery"], e) : e("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto);
    })(function (e) {
        var t,
            i,
            n,
            o,
            s,
            r,
            c = "Close",
            a = "BeforeClose",
            l = "MarkupParse",
            u = "Open",
            d = "Change",
            p = "mfp",
            h = "." + p,
            f = "mfp-ready",
            M = "mfp-removing",
            b = "mfp-prevent-close",
            m = function () {},
            g = !!window.jQuery,
            A = e(window),
            z = function (e, i) {
                t.ev.on(p + e + h, i);
            },
            y = function (t, i, n, o) {
                var s = document.createElement("div");
                return (s.className = "mfp-" + t), n && (s.innerHTML = n), o ? i && i.appendChild(s) : ((s = e(s)), i && s.appendTo(i)), s;
            },
            v = function (i, n) {
                t.ev.triggerHandler(p + i, n), t.st.callbacks && ((i = i.charAt(0).toLowerCase() + i.slice(1)), t.st.callbacks[i] && t.st.callbacks[i].apply(t, e.isArray(n) ? n : [n]));
            },
            O = function (i) {
                return (i === r && t.currTemplate.closeBtn) || ((t.currTemplate.closeBtn = e(t.st.closeMarkup.replace("%title%", t.st.tClose))), (r = i)), t.currTemplate.closeBtn;
            },
            L = function () {
                e.magnificPopup.instance || ((t = new m()).init(), (e.magnificPopup.instance = t));
            };
        (m.prototype = {
            constructor: m,
            init: function () {
                var i = navigator.appVersion;
                (t.isLowIE = t.isIE8 = document.all && !document.addEventListener),
                    (t.isAndroid = /android/gi.test(i)),
                    (t.isIOS = /iphone|ipad|ipod/gi.test(i)),
                    (t.supportsTransition = (function () {
                        var e = document.createElement("p").style,
                            t = ["ms", "O", "Moz", "Webkit"];
                        if (void 0 !== e.transition) return !0;
                        for (; t.length; ) if (t.pop() + "Transition" in e) return !0;
                        return !1;
                    })()),
                    (t.probablyMobile = t.isAndroid || t.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent)),
                    (n = e(document)),
                    (t.popupsCache = {});
            },
            open: function (i) {
                var o;
                if (!1 === i.isObj) {
                    (t.items = i.items.toArray()), (t.index = 0);
                    var r,
                        c = i.items;
                    for (o = 0; o < c.length; o++)
                        if (((r = c[o]).parsed && (r = r.el[0]), r === i.el[0])) {
                            t.index = o;
                            break;
                        }
                } else (t.items = e.isArray(i.items) ? i.items : [i.items]), (t.index = i.index || 0);
                if (!t.isOpen) {
                    (t.types = []),
                        (s = ""),
                        i.mainEl && i.mainEl.length ? (t.ev = i.mainEl.eq(0)) : (t.ev = n),
                        i.key ? (t.popupsCache[i.key] || (t.popupsCache[i.key] = {}), (t.currTemplate = t.popupsCache[i.key])) : (t.currTemplate = {}),
                        (t.st = e.extend(!0, {}, e.magnificPopup.defaults, i)),
                        (t.fixedContentPos = "auto" === t.st.fixedContentPos ? !t.probablyMobile : t.st.fixedContentPos),
                        t.st.modal && ((t.st.closeOnContentClick = !1), (t.st.closeOnBgClick = !1), (t.st.showCloseBtn = !1), (t.st.enableEscapeKey = !1)),
                        t.bgOverlay ||
                            ((t.bgOverlay = y("bg").on("click" + h, function () {
                                t.close();
                            })),
                            (t.wrap = y("wrap")
                                .attr("tabindex", -1)
                                .on("click" + h, function (e) {
                                    t._checkIfClose(e.target) && t.close();
                                })),
                            (t.container = y("container", t.wrap))),
                        (t.contentContainer = y("content")),
                        t.st.preloader && (t.preloader = y("preloader", t.container, t.st.tLoading));
                    var a = e.magnificPopup.modules;
                    for (o = 0; o < a.length; o++) {
                        var d = a[o];
                        (d = d.charAt(0).toUpperCase() + d.slice(1)), t["init" + d].call(t);
                    }
                    v("BeforeOpen"),
                        t.st.showCloseBtn &&
                            (t.st.closeBtnInside
                                ? (z(l, function (e, t, i, n) {
                                      i.close_replaceWith = O(n.type);
                                  }),
                                  (s += " mfp-close-btn-in"))
                                : t.wrap.append(O())),
                        t.st.alignTop && (s += " mfp-align-top"),
                        t.fixedContentPos ? t.wrap.css({ overflow: t.st.overflowY, overflowX: "hidden", overflowY: t.st.overflowY }) : t.wrap.css({ top: A.scrollTop(), position: "absolute" }),
                        (!1 === t.st.fixedBgPos || ("auto" === t.st.fixedBgPos && !t.fixedContentPos)) && t.bgOverlay.css({ height: n.height(), position: "absolute" }),
                        t.st.enableEscapeKey &&
                            n.on("keyup" + h, function (e) {
                                27 === e.keyCode && t.close();
                            }),
                        A.on("resize" + h, function () {
                            t.updateSize();
                        }),
                        t.st.closeOnContentClick || (s += " mfp-auto-cursor"),
                        s && t.wrap.addClass(s);
                    var p = (t.wH = A.height()),
                        M = {};
                    if (t.fixedContentPos && t._hasScrollBar(p)) {
                        var b = t._getScrollbarSize();
                        b && (M.marginRight = b);
                    }
                    t.fixedContentPos && (t.isIE7 ? e("body, html").css("overflow", "hidden") : (M.overflow = "hidden"));
                    var m = t.st.mainClass;
                    return (
                        t.isIE7 && (m += " mfp-ie7"),
                        m && t._addClassToMFP(m),
                        t.updateItemHTML(),
                        v("BuildControls"),
                        e("html").css(M),
                        t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo || e(document.body)),
                        (t._lastFocusedEl = document.activeElement),
                        setTimeout(function () {
                            t.content ? (t._addClassToMFP(f), t._setFocus()) : t.bgOverlay.addClass(f), n.on("focusin" + h, t._onFocusIn);
                        }, 16),
                        (t.isOpen = !0),
                        t.updateSize(p),
                        v(u),
                        i
                    );
                }
                t.updateItemHTML();
            },
            close: function () {
                t.isOpen &&
                    (v(a),
                    (t.isOpen = !1),
                    t.st.removalDelay && !t.isLowIE && t.supportsTransition
                        ? (t._addClassToMFP(M),
                          setTimeout(function () {
                              t._close();
                          }, t.st.removalDelay))
                        : t._close());
            },
            _close: function () {
                v(c);
                var i = M + " " + f + " ";
                if ((t.bgOverlay.detach(), t.wrap.detach(), t.container.empty(), t.st.mainClass && (i += t.st.mainClass + " "), t._removeClassFromMFP(i), t.fixedContentPos)) {
                    var o = { marginRight: "" };
                    t.isIE7 ? e("body, html").css("overflow", "") : (o.overflow = ""), e("html").css(o);
                }
                n.off("keyup.mfp focusin" + h),
                    t.ev.off(h),
                    t.wrap.attr("class", "mfp-wrap").removeAttr("style"),
                    t.bgOverlay.attr("class", "mfp-bg"),
                    t.container.attr("class", "mfp-container"),
                    !t.st.showCloseBtn || (t.st.closeBtnInside && !0 !== t.currTemplate[t.currItem.type]) || (t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach()),
                    t.st.autoFocusLast && t._lastFocusedEl && e(t._lastFocusedEl).focus(),
                    (t.currItem = null),
                    (t.content = null),
                    (t.currTemplate = null),
                    (t.prevHeight = 0),
                    v("AfterClose");
            },
            updateSize: function (e) {
                if (t.isIOS) {
                    var i = document.documentElement.clientWidth / window.innerWidth,
                        n = window.innerHeight * i;
                    t.wrap.css("height", n), (t.wH = n);
                } else t.wH = e || A.height();
                t.fixedContentPos || t.wrap.css("height", t.wH), v("Resize");
            },
            updateItemHTML: function () {
                var i = t.items[t.index];
                t.contentContainer.detach(), t.content && t.content.detach(), i.parsed || (i = t.parseEl(t.index));
                var n = i.type;
                if ((v("BeforeChange", [t.currItem ? t.currItem.type : "", n]), (t.currItem = i), !t.currTemplate[n])) {
                    var s = !!t.st[n] && t.st[n].markup;
                    v("FirstMarkupParse", s), (t.currTemplate[n] = !s || e(s));
                }
                o && o !== i.type && t.container.removeClass("mfp-" + o + "-holder");
                var r = t["get" + n.charAt(0).toUpperCase() + n.slice(1)](i, t.currTemplate[n]);
                t.appendContent(r, n), (i.preloaded = !0), v(d, i), (o = i.type), t.container.prepend(t.contentContainer), v("AfterChange");
            },
            appendContent: function (e, i) {
                (t.content = e),
                    e ? (t.st.showCloseBtn && t.st.closeBtnInside && !0 === t.currTemplate[i] ? t.content.find(".mfp-close").length || t.content.append(O()) : (t.content = e)) : (t.content = ""),
                    v("BeforeAppend"),
                    t.container.addClass("mfp-" + i + "-holder"),
                    t.contentContainer.append(t.content);
            },
            parseEl: function (i) {
                var n,
                    o = t.items[i];
                if ((o.tagName ? (o = { el: e(o) }) : ((n = o.type), (o = { data: o, src: o.src })), o.el)) {
                    for (var s = t.types, r = 0; r < s.length; r++)
                        if (o.el.hasClass("mfp-" + s[r])) {
                            n = s[r];
                            break;
                        }
                    (o.src = o.el.attr("data-mfp-src")), o.src || (o.src = o.el.attr("href"));
                }
                return (o.type = n || t.st.type || "inline"), (o.index = i), (o.parsed = !0), (t.items[i] = o), v("ElementParse", o), t.items[i];
            },
            addGroup: function (e, i) {
                var n = function (n) {
                    (n.mfpEl = this), t._openClick(n, e, i);
                };
                i || (i = {});
                var o = "click.magnificPopup";
                (i.mainEl = e), i.items ? ((i.isObj = !0), e.off(o).on(o, n)) : ((i.isObj = !1), i.delegate ? e.off(o).on(o, i.delegate, n) : ((i.items = e), e.off(o).on(o, n)));
            },
            _openClick: function (i, n, o) {
                if ((void 0 !== o.midClick ? o.midClick : e.magnificPopup.defaults.midClick) || !(2 === i.which || i.ctrlKey || i.metaKey || i.altKey || i.shiftKey)) {
                    var s = void 0 !== o.disableOn ? o.disableOn : e.magnificPopup.defaults.disableOn;
                    if (s)
                        if (e.isFunction(s)) {
                            if (!s.call(t)) return !0;
                        } else if (A.width() < s) return !0;
                    i.type && (i.preventDefault(), t.isOpen && i.stopPropagation()), (o.el = e(i.mfpEl)), o.delegate && (o.items = n.find(o.delegate)), t.open(o);
                }
            },
            updateStatus: function (e, n) {
                if (t.preloader) {
                    i !== e && t.container.removeClass("mfp-s-" + i), n || "loading" !== e || (n = t.st.tLoading);
                    var o = { status: e, text: n };
                    v("UpdateStatus", o),
                        (e = o.status),
                        (n = o.text),
                        t.preloader.html(n),
                        t.preloader.find("a").on("click", function (e) {
                            e.stopImmediatePropagation();
                        }),
                        t.container.addClass("mfp-s-" + e),
                        (i = e);
                }
            },
            _checkIfClose: function (i) {
                if (!e(i).hasClass(b)) {
                    var n = t.st.closeOnContentClick,
                        o = t.st.closeOnBgClick;
                    if (n && o) return !0;
                    if (!t.content || e(i).hasClass("mfp-close") || (t.preloader && i === t.preloader[0])) return !0;
                    if (i === t.content[0] || e.contains(t.content[0], i)) {
                        if (n) return !0;
                    } else if (o && e.contains(document, i)) return !0;
                    return !1;
                }
            },
            _addClassToMFP: function (e) {
                t.bgOverlay.addClass(e), t.wrap.addClass(e);
            },
            _removeClassFromMFP: function (e) {
                this.bgOverlay.removeClass(e), t.wrap.removeClass(e);
            },
            _hasScrollBar: function (e) {
                return (t.isIE7 ? n.height() : document.body.scrollHeight) > (e || A.height());
            },
            _setFocus: function () {
                (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus();
            },
            _onFocusIn: function (i) {
                return i.target === t.wrap[0] || e.contains(t.wrap[0], i.target) ? void 0 : (t._setFocus(), !1);
            },
            _parseMarkup: function (t, i, n) {
                var o;
                n.data && (i = e.extend(n.data, i)),
                    v(l, [t, i, n]),
                    e.each(i, function (i, n) {
                        if (void 0 === n || !1 === n) return !0;
                        if ((o = i.split("_")).length > 1) {
                            var s = t.find(h + "-" + o[0]);
                            if (s.length > 0) {
                                var r = o[1];
                                "replaceWith" === r ? s[0] !== n[0] && s.replaceWith(n) : "img" === r ? (s.is("img") ? s.attr("src", n) : s.replaceWith(e("<img>").attr("src", n).attr("class", s.attr("class")))) : s.attr(o[1], n);
                            }
                        } else t.find(h + "-" + i).html(n);
                    });
            },
            _getScrollbarSize: function () {
                if (void 0 === t.scrollbarSize) {
                    var e = document.createElement("div");
                    (e.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"), document.body.appendChild(e), (t.scrollbarSize = e.offsetWidth - e.clientWidth), document.body.removeChild(e);
                }
                return t.scrollbarSize;
            },
        }),
            (e.magnificPopup = {
                instance: null,
                proto: m.prototype,
                modules: [],
                open: function (t, i) {
                    return L(), ((t = t ? e.extend(!0, {}, t) : {}).isObj = !0), (t.index = i || 0), this.instance.open(t);
                },
                close: function () {
                    return e.magnificPopup.instance && e.magnificPopup.instance.close();
                },
                registerModule: function (t, i) {
                    i.options && (e.magnificPopup.defaults[t] = i.options), e.extend(this.proto, i.proto), this.modules.push(t);
                },
                defaults: {
                    disableOn: 0,
                    key: null,
                    midClick: !1,
                    mainClass: "",
                    preloader: !0,
                    focus: "",
                    closeOnContentClick: !1,
                    closeOnBgClick: !0,
                    closeBtnInside: !0,
                    showCloseBtn: !0,
                    enableEscapeKey: !0,
                    modal: !1,
                    alignTop: !1,
                    removalDelay: 0,
                    prependTo: null,
                    fixedContentPos: "auto",
                    fixedBgPos: "auto",
                    overflowY: "auto",
                    closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
                    tClose: "Close (Esc)",
                    tLoading: "Loading...",
                    autoFocusLast: !0,
                },
            }),
            (e.fn.magnificPopup = function (i) {
                L();
                var n = e(this);
                if ("string" == typeof i)
                    if ("open" === i) {
                        var o,
                            s = g ? n.data("magnificPopup") : n[0].magnificPopup,
                            r = parseInt(arguments[1], 10) || 0;
                        s.items ? (o = s.items[r]) : ((o = n), s.delegate && (o = o.find(s.delegate)), (o = o.eq(r))), t._openClick({ mfpEl: o }, n, s);
                    } else t.isOpen && t[i].apply(t, Array.prototype.slice.call(arguments, 1));
                else (i = e.extend(!0, {}, i)), g ? n.data("magnificPopup", i) : (n[0].magnificPopup = i), t.addGroup(n, i);
                return n;
            });
        var T,
            N,
            q,
            w = "inline",
            W = function () {
                q && (N.after(q.addClass(T)).detach(), (q = null));
            };
        e.magnificPopup.registerModule(w, {
            options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" },
            proto: {
                initInline: function () {
                    t.types.push(w),
                        z(c + "." + w, function () {
                            W();
                        });
                },
                getInline: function (i, n) {
                    if ((W(), i.src)) {
                        var o = t.st.inline,
                            s = e(i.src);
                        if (s.length) {
                            var r = s[0].parentNode;
                            r && r.tagName && (N || ((T = o.hiddenClass), (N = y(T)), (T = "mfp-" + T)), (q = s.after(N).detach().removeClass(T))), t.updateStatus("ready");
                        } else t.updateStatus("error", o.tNotFound), (s = e("<div>"));
                        return (i.inlineElement = s), s;
                    }
                    return t.updateStatus("ready"), t._parseMarkup(n, {}, i), n;
                },
            },
        });
        var S,
            C = "ajax",
            k = function () {
                S && e(document.body).removeClass(S);
            },
            B = function () {
                k(), t.req && t.req.abort();
            };
        e.magnificPopup.registerModule(C, {
            options: { settings: null, cursor: "mfp-ajax-cur", tError: '<a href="%url%">The content</a> could not be loaded.' },
            proto: {
                initAjax: function () {
                    t.types.push(C), (S = t.st.ajax.cursor), z(c + "." + C, B), z("BeforeChange." + C, B);
                },
                getAjax: function (i) {
                    S && e(document.body).addClass(S), t.updateStatus("loading");
                    var n = e.extend(
                        {
                            url: i.src,
                            success: function (n, o, s) {
                                var r = { data: n, xhr: s };
                                v("ParseAjax", r),
                                    t.appendContent(e(r.data), C),
                                    (i.finished = !0),
                                    k(),
                                    t._setFocus(),
                                    setTimeout(function () {
                                        t.wrap.addClass(f);
                                    }, 16),
                                    t.updateStatus("ready"),
                                    v("AjaxContentAdded");
                            },
                            error: function () {
                                k(), (i.finished = i.loadError = !0), t.updateStatus("error", t.st.ajax.tError.replace("%url%", i.src));
                            },
                        },
                        t.st.ajax.settings
                    );
                    return (t.req = e.ajax(n)), "";
                },
            },
        });
        var E,
            X = function (i) {
                if (i.data && void 0 !== i.data.title) return i.data.title;
                var n = t.st.image.titleSrc;
                if (n) {
                    if (e.isFunction(n)) return n.call(t, i);
                    if (i.el) return i.el.attr(n) || "";
                }
                return "";
            };
        e.magnificPopup.registerModule("image", {
            options: {
                markup:
                    '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
                cursor: "mfp-zoom-out-cur",
                titleSrc: "title",
                verticalFit: !0,
                tError: '<a href="%url%">The image</a> could not be loaded.',
            },
            proto: {
                initImage: function () {
                    var i = t.st.image,
                        n = ".image";
                    t.types.push("image"),
                        z(u + n, function () {
                            "image" === t.currItem.type && i.cursor && e(document.body).addClass(i.cursor);
                        }),
                        z(c + n, function () {
                            i.cursor && e(document.body).removeClass(i.cursor), A.off("resize" + h);
                        }),
                        z("Resize" + n, t.resizeImage),
                        t.isLowIE && z("AfterChange", t.resizeImage);
                },
                resizeImage: function () {
                    var e = t.currItem;
                    if (e && e.img && t.st.image.verticalFit) {
                        var i = 0;
                        t.isLowIE && (i = parseInt(e.img.css("padding-top"), 10) + parseInt(e.img.css("padding-bottom"), 10)), e.img.css("max-height", t.wH - i);
                    }
                },
                _onImageHasSize: function (e) {
                    e.img && ((e.hasSize = !0), E && clearInterval(E), (e.isCheckingImgSize = !1), v("ImageHasSize", e), e.imgHidden && (t.content && t.content.removeClass("mfp-loading"), (e.imgHidden = !1)));
                },
                findImageSize: function (e) {
                    var i = 0,
                        n = e.img[0],
                        o = function (s) {
                            E && clearInterval(E),
                                (E = setInterval(function () {
                                    return n.naturalWidth > 0 ? void t._onImageHasSize(e) : (i > 200 && clearInterval(E), void (3 === ++i ? o(10) : 40 === i ? o(50) : 100 === i && o(500)));
                                }, s));
                        };
                    o(1);
                },
                getImage: function (i, n) {
                    var o = 0,
                        s = function () {
                            i &&
                                (i.img[0].complete
                                    ? (i.img.off(".mfploader"), i === t.currItem && (t._onImageHasSize(i), t.updateStatus("ready")), (i.hasSize = !0), (i.loaded = !0), v("ImageLoadComplete"))
                                    : 200 > ++o
                                    ? setTimeout(s, 100)
                                    : r());
                        },
                        r = function () {
                            i && (i.img.off(".mfploader"), i === t.currItem && (t._onImageHasSize(i), t.updateStatus("error", c.tError.replace("%url%", i.src))), (i.hasSize = !0), (i.loaded = !0), (i.loadError = !0));
                        },
                        c = t.st.image,
                        a = n.find(".mfp-img");
                    if (a.length) {
                        var l = document.createElement("img");
                        (l.className = "mfp-img"),
                            i.el && i.el.find("img").length && (l.alt = i.el.find("img").attr("alt")),
                            (i.img = e(l).on("load.mfploader", s).on("error.mfploader", r)),
                            (l.src = i.src),
                            a.is("img") && (i.img = i.img.clone()),
                            (l = i.img[0]).naturalWidth > 0 ? (i.hasSize = !0) : l.width || (i.hasSize = !1);
                    }
                    return (
                        t._parseMarkup(n, { title: X(i), img_replaceWith: i.img }, i),
                        t.resizeImage(),
                        i.hasSize
                            ? (E && clearInterval(E), i.loadError ? (n.addClass("mfp-loading"), t.updateStatus("error", c.tError.replace("%url%", i.src))) : (n.removeClass("mfp-loading"), t.updateStatus("ready")), n)
                            : (t.updateStatus("loading"), (i.loading = !0), i.hasSize || ((i.imgHidden = !0), n.addClass("mfp-loading"), t.findImageSize(i)), n)
                    );
                },
            },
        });
        var x;
        e.magnificPopup.registerModule("zoom", {
            options: {
                enabled: !1,
                easing: "ease-in-out",
                duration: 300,
                opener: function (e) {
                    return e.is("img") ? e : e.find("img");
                },
            },
            proto: {
                initZoom: function () {
                    var e,
                        i = t.st.zoom,
                        n = ".zoom";
                    if (i.enabled && t.supportsTransition) {
                        var o,
                            s,
                            r = i.duration,
                            l = function (e) {
                                var t = e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                    n = "all " + i.duration / 1e3 + "s " + i.easing,
                                    o = { position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden" },
                                    s = "transition";
                                return (o["-webkit-" + s] = o["-moz-" + s] = o["-o-" + s] = o[s] = n), t.css(o), t;
                            },
                            u = function () {
                                t.content.css("visibility", "visible");
                            };
                        z("BuildControls" + n, function () {
                            if (t._allowZoom()) {
                                if ((clearTimeout(o), t.content.css("visibility", "hidden"), !(e = t._getItemToZoom()))) return void u();
                                (s = l(e)).css(t._getOffset()),
                                    t.wrap.append(s),
                                    (o = setTimeout(function () {
                                        s.css(t._getOffset(!0)),
                                            (o = setTimeout(function () {
                                                u(),
                                                    setTimeout(function () {
                                                        s.remove(), (e = s = null), v("ZoomAnimationEnded");
                                                    }, 16);
                                            }, r));
                                    }, 16));
                            }
                        }),
                            z(a + n, function () {
                                if (t._allowZoom()) {
                                    if ((clearTimeout(o), (t.st.removalDelay = r), !e)) {
                                        if (!(e = t._getItemToZoom())) return;
                                        s = l(e);
                                    }
                                    s.css(t._getOffset(!0)),
                                        t.wrap.append(s),
                                        t.content.css("visibility", "hidden"),
                                        setTimeout(function () {
                                            s.css(t._getOffset());
                                        }, 16);
                                }
                            }),
                            z(c + n, function () {
                                t._allowZoom() && (u(), s && s.remove(), (e = null));
                            });
                    }
                },
                _allowZoom: function () {
                    return "image" === t.currItem.type;
                },
                _getItemToZoom: function () {
                    return !!t.currItem.hasSize && t.currItem.img;
                },
                _getOffset: function (i) {
                    var n,
                        o = (n = i ? t.currItem.img : t.st.zoom.opener(t.currItem.el || t.currItem)).offset(),
                        s = parseInt(n.css("padding-top"), 10),
                        r = parseInt(n.css("padding-bottom"), 10);
                    o.top -= e(window).scrollTop() - s;
                    var c = { width: n.width(), height: (g ? n.innerHeight() : n[0].offsetHeight) - r - s };
                    return void 0 === x && (x = void 0 !== document.createElement("p").style.MozTransform), x ? (c["-moz-transform"] = c.transform = "translate(" + o.left + "px," + o.top + "px)") : ((c.left = o.left), (c.top = o.top)), c;
                },
            },
        });
        var _ = "iframe",
            D = function (e) {
                if (t.currTemplate[_]) {
                    var i = t.currTemplate[_].find("iframe");
                    i.length && (e || (i[0].src = "//about:blank"), t.isIE8 && i.css("display", e ? "block" : "none"));
                }
            };
        e.magnificPopup.registerModule(_, {
            options: {
                markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                srcAction: "iframe_src",
                patterns: {
                    youtube: { index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1" },
                    vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" },
                    gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
                },
            },
            proto: {
                initIframe: function () {
                    t.types.push(_),
                        z("BeforeChange", function (e, t, i) {
                            t !== i && (t === _ ? D() : i === _ && D(!0));
                        }),
                        z(c + "." + _, function () {
                            D();
                        });
                },
                getIframe: function (i, n) {
                    var o = i.src,
                        s = t.st.iframe;
                    e.each(s.patterns, function () {
                        return o.indexOf(this.index) > -1 ? (this.id && (o = "string" == typeof this.id ? o.substr(o.lastIndexOf(this.id) + this.id.length, o.length) : this.id.call(this, o)), (o = this.src.replace("%id%", o)), !1) : void 0;
                    });
                    var r = {};
                    return s.srcAction && (r[s.srcAction] = o), t._parseMarkup(n, r, i), t.updateStatus("ready"), n;
                },
            },
        });
        var R = function (e) {
                var i = t.items.length;
                return e > i - 1 ? e - i : 0 > e ? i + e : e;
            },
            P = function (e, t, i) {
                return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, i);
            };
        e.magnificPopup.registerModule("gallery", {
            options: {
                enabled: !1,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                preload: [0, 2],
                navigateByImgClick: !0,
                arrows: !0,
                tPrev: "Previous (Left arrow key)",
                tNext: "Next (Right arrow key)",
                tCounter: "%curr% of %total%",
            },
            proto: {
                initGallery: function () {
                    var i = t.st.gallery,
                        o = ".mfp-gallery";
                    return (
                        (t.direction = !0),
                        !(!i || !i.enabled) &&
                            ((s += " mfp-gallery"),
                            z(u + o, function () {
                                i.navigateByImgClick &&
                                    t.wrap.on("click" + o, ".mfp-img", function () {
                                        return t.items.length > 1 ? (t.next(), !1) : void 0;
                                    }),
                                    n.on("keydown" + o, function (e) {
                                        37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next();
                                    });
                            }),
                            z("UpdateStatus" + o, function (e, i) {
                                i.text && (i.text = P(i.text, t.currItem.index, t.items.length));
                            }),
                            z(l + o, function (e, n, o, s) {
                                var r = t.items.length;
                                o.counter = r > 1 ? P(i.tCounter, s.index, r) : "";
                            }),
                            z("BuildControls" + o, function () {
                                if (t.items.length > 1 && i.arrows && !t.arrowLeft) {
                                    var n = i.arrowMarkup,
                                        o = (t.arrowLeft = e(n.replace(/%title%/gi, i.tPrev).replace(/%dir%/gi, "left")).addClass(b)),
                                        s = (t.arrowRight = e(n.replace(/%title%/gi, i.tNext).replace(/%dir%/gi, "right")).addClass(b));
                                    o.click(function () {
                                        t.prev();
                                    }),
                                        s.click(function () {
                                            t.next();
                                        }),
                                        t.container.append(o.add(s));
                                }
                            }),
                            z(d + o, function () {
                                t._preloadTimeout && clearTimeout(t._preloadTimeout),
                                    (t._preloadTimeout = setTimeout(function () {
                                        t.preloadNearbyImages(), (t._preloadTimeout = null);
                                    }, 16));
                            }),
                            void z(c + o, function () {
                                n.off(o), t.wrap.off("click" + o), (t.arrowRight = t.arrowLeft = null);
                            }))
                    );
                },
                next: function () {
                    (t.direction = !0), (t.index = R(t.index + 1)), t.updateItemHTML();
                },
                prev: function () {
                    (t.direction = !1), (t.index = R(t.index - 1)), t.updateItemHTML();
                },
                goTo: function (e) {
                    (t.direction = e >= t.index), (t.index = e), t.updateItemHTML();
                },
                preloadNearbyImages: function () {
                    var e,
                        i = t.st.gallery.preload,
                        n = Math.min(i[0], t.items.length),
                        o = Math.min(i[1], t.items.length);
                    for (e = 1; e <= (t.direction ? o : n); e++) t._preloadItem(t.index + e);
                    for (e = 1; e <= (t.direction ? n : o); e++) t._preloadItem(t.index - e);
                },
                _preloadItem: function (i) {
                    if (((i = R(i)), !t.items[i].preloaded)) {
                        var n = t.items[i];
                        n.parsed || (n = t.parseEl(i)),
                            v("LazyLoad", n),
                            "image" === n.type &&
                                (n.img = e('<img class="mfp-img" />')
                                    .on("load.mfploader", function () {
                                        n.hasSize = !0;
                                    })
                                    .on("error.mfploader", function () {
                                        (n.hasSize = !0), (n.loadError = !0), v("LazyLoadError", n);
                                    })
                                    .attr("src", n.src)),
                            (n.preloaded = !0);
                    }
                },
            },
        });
        var I = "retina";
        e.magnificPopup.registerModule(I, {
            options: {
                replaceSrc: function (e) {
                    return e.src.replace(/\.\w+$/, function (e) {
                        return "@2x" + e;
                    });
                },
                ratio: 1,
            },
            proto: {
                initRetina: function () {
                    if (window.devicePixelRatio > 1) {
                        var e = t.st.retina,
                            i = e.ratio;
                        (i = isNaN(i) ? i() : i) > 1 &&
                            (z("ImageHasSize." + I, function (e, t) {
                                t.img.css({ "max-width": t.img[0].naturalWidth / i, width: "100%" });
                            }),
                            z("ElementParse." + I, function (t, n) {
                                n.src = e.replaceSrc(n, i);
                            }));
                    }
                },
            },
        }),
            L();
    }),
    (function (e) {
        var t = (function (e, t, i) {
            "use strict";
            var n, o;
            if (
                ((function () {
                    var t,
                        i = {
                            lazyClass: "lazyload",
                            loadedClass: "lazyloaded",
                            loadingClass: "lazyloading",
                            preloadClass: "lazypreload",
                            errorClass: "lazyerror",
                            autosizesClass: "lazyautosizes",
                            fastLoadedClass: "ls-is-cached",
                            iframeLoadMode: 0,
                            srcAttr: "data-src",
                            srcsetAttr: "data-srcset",
                            sizesAttr: "data-sizes",
                            minSize: 40,
                            customMedia: {},
                            init: !0,
                            expFactor: 1.5,
                            hFac: 0.8,
                            loadMode: 2,
                            loadHidden: !0,
                            ricTimeout: 0,
                            throttleDelay: 125,
                        };
                    for (t in ((o = e.lazySizesConfig || e.lazysizesConfig || {}), i)) t in o || (o[t] = i[t]);
                })(),
                !t || !t.getElementsByClassName)
            )
                return { init: function () {}, cfg: o, noSupport: !0 };
            var s = t.documentElement,
                r = e.HTMLPictureElement,
                c = "addEventListener",
                a = "getAttribute",
                l = e[c].bind(e),
                u = e.setTimeout,
                d = e.requestAnimationFrame || u,
                p = e.requestIdleCallback,
                h = /^picture$/i,
                f = ["load", "error", "lazyincluded", "_lazyloaded"],
                M = {},
                b = Array.prototype.forEach,
                m = function (e, t) {
                    return M[t] || (M[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), M[t].test(e[a]("class") || "") && M[t];
                },
                g = function (e, t) {
                    m(e, t) || e.setAttribute("class", (e[a]("class") || "").trim() + " " + t);
                },
                A = function (e, t) {
                    var i;
                    (i = m(e, t)) && e.setAttribute("class", (e[a]("class") || "").replace(i, " "));
                },
                z = function (e, t, i) {
                    var n = i ? c : "removeEventListener";
                    i && z(e, t),
                        f.forEach(function (i) {
                            e[n](i, t);
                        });
                },
                y = function (e, i, o, s, r) {
                    var c = t.createEvent("Event");
                    return o || (o = {}), (o.instance = n), c.initEvent(i, !s, !r), (c.detail = o), e.dispatchEvent(c), c;
                },
                v = function (t, i) {
                    var n;
                    !r && (n = e.picturefill || o.pf) ? (i && i.src && !t[a]("srcset") && t.setAttribute("srcset", i.src), n({ reevaluate: !0, elements: [t] })) : i && i.src && (t.src = i.src);
                },
                O = function (e, t) {
                    return (getComputedStyle(e, null) || {})[t];
                },
                L = function (e, t, i) {
                    for (i = i || e.offsetWidth; i < o.minSize && t && !e._lazysizesWidth; ) (i = t.offsetWidth), (t = t.parentNode);
                    return i;
                },
                T = (function () {
                    var e,
                        i,
                        n = [],
                        o = [],
                        s = n,
                        r = function () {
                            var t = s;
                            for (s = n.length ? o : n, e = !0, i = !1; t.length; ) t.shift()();
                            e = !1;
                        },
                        c = function (n, o) {
                            e && !o ? n.apply(this, arguments) : (s.push(n), i || ((i = !0), (t.hidden ? u : d)(r)));
                        };
                    return (c._lsFlush = r), c;
                })(),
                N = function (e, t) {
                    return t
                        ? function () {
                              T(e);
                          }
                        : function () {
                              var t = this,
                                  i = arguments;
                              T(function () {
                                  e.apply(t, i);
                              });
                          };
                },
                q = function (e) {
                    var t,
                        n = 0,
                        s = o.throttleDelay,
                        r = o.ricTimeout,
                        c = function () {
                            (t = !1), (n = i.now()), e();
                        },
                        a =
                            p && r > 49
                                ? function () {
                                      p(c, { timeout: r }), r !== o.ricTimeout && (r = o.ricTimeout);
                                  }
                                : N(function () {
                                      u(c);
                                  }, !0);
                    return function (e) {
                        var o;
                        (e = !0 === e) && (r = 33), t || ((t = !0), (o = s - (i.now() - n)) < 0 && (o = 0), e || o < 9 ? a() : u(a, o));
                    };
                },
                w = function (e) {
                    var t,
                        n,
                        o = function () {
                            (t = null), e();
                        },
                        s = function () {
                            var e = i.now() - n;
                            e < 99 ? u(s, 99 - e) : (p || o)(o);
                        };
                    return function () {
                        (n = i.now()), t || (t = u(s, 99));
                    };
                },
                W = (function () {
                    var r,
                        p,
                        f,
                        M,
                        L,
                        W,
                        C,
                        k,
                        B,
                        E,
                        X,
                        x,
                        _ = /^img$/i,
                        D = /^iframe$/i,
                        R = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent),
                        P = 0,
                        I = 0,
                        H = -1,
                        j = function (e) {
                            I--, (!e || I < 0 || !e.target) && (I = 0);
                        },
                        $ = function (e) {
                            return null == x && (x = "hidden" == O(t.body, "visibility")), x || !("hidden" == O(e.parentNode, "visibility") && "hidden" == O(e, "visibility"));
                        },
                        F = function (e, i) {
                            var n,
                                o = e,
                                r = $(e);
                            for (k -= i, X += i, B -= i, E += i; r && (o = o.offsetParent) && o != t.body && o != s; )
                                (r = (O(o, "opacity") || 1) > 0) && "visible" != O(o, "overflow") && ((n = o.getBoundingClientRect()), (r = E > n.left && B < n.right && X > n.top - 1 && k < n.bottom + 1));
                            return r;
                        },
                        U = function () {
                            var e,
                                i,
                                c,
                                l,
                                u,
                                d,
                                h,
                                f,
                                b,
                                m,
                                g,
                                A,
                                z = n.elements;
                            if ((M = o.loadMode) && I < 8 && (e = z.length)) {
                                for (i = 0, H++; i < e; i++)
                                    if (z[i] && !z[i]._lazyRace)
                                        if (!R || (n.prematureUnveil && n.prematureUnveil(z[i]))) Z(z[i]);
                                        else if (
                                            (((f = z[i][a]("data-expand")) && (d = 1 * f)) || (d = P),
                                            m ||
                                                ((m = !o.expand || o.expand < 1 ? (s.clientHeight > 500 && s.clientWidth > 500 ? 500 : 370) : o.expand),
                                                (n._defEx = m),
                                                (g = m * o.expFactor),
                                                (A = o.hFac),
                                                (x = null),
                                                P < g && I < 1 && H > 2 && M > 2 && !t.hidden ? ((P = g), (H = 0)) : (P = M > 1 && H > 1 && I < 6 ? m : 0)),
                                            b !== d && ((W = innerWidth + d * A), (C = innerHeight + d), (h = -1 * d), (b = d)),
                                            (c = z[i].getBoundingClientRect()),
                                            (X = c.bottom) >= h && (k = c.top) <= C && (E = c.right) >= h * A && (B = c.left) <= W && (X || E || B || k) && (o.loadHidden || $(z[i])) && ((p && I < 3 && !f && (M < 3 || H < 4)) || F(z[i], d)))
                                        ) {
                                            if ((Z(z[i]), (u = !0), I > 9)) break;
                                        } else !u && p && !l && I < 4 && H < 4 && M > 2 && (r[0] || o.preloadAfterLoad) && (r[0] || (!f && (X || E || B || k || "auto" != z[i][a](o.sizesAttr)))) && (l = r[0] || z[i]);
                                l && !u && Z(l);
                            }
                        },
                        V = q(U),
                        Y = function (e) {
                            var t = e.target;
                            t._lazyCache ? delete t._lazyCache : (j(e), g(t, o.loadedClass), A(t, o.loadingClass), z(t, K), y(t, "lazyloaded"));
                        },
                        G = N(Y),
                        K = function (e) {
                            G({ target: e.target });
                        },
                        Q = function (e) {
                            var t,
                                i = e[a](o.srcsetAttr);
                            (t = o.customMedia[e[a]("data-media") || e[a]("media")]) && e.setAttribute("media", t), i && e.setAttribute("srcset", i);
                        },
                        J = N(function (e, t, i, n, s) {
                            var r, c, l, d, p, M;
                            (p = y(e, "lazybeforeunveil", t)).defaultPrevented ||
                                (n && (i ? g(e, o.autosizesClass) : e.setAttribute("sizes", n)),
                                (c = e[a](o.srcsetAttr)),
                                (r = e[a](o.srcAttr)),
                                s && (d = (l = e.parentNode) && h.test(l.nodeName || "")),
                                (M = t.firesLoad || ("src" in e && (c || r || d))),
                                (p = { target: e }),
                                g(e, o.loadingClass),
                                M && (clearTimeout(f), (f = u(j, 2500)), z(e, K, !0)),
                                d && b.call(l.getElementsByTagName("source"), Q),
                                c
                                    ? e.setAttribute("srcset", c)
                                    : r &&
                                      !d &&
                                      (D.test(e.nodeName)
                                          ? (function (e, t) {
                                                var i = e.getAttribute("data-load-mode") || o.iframeLoadMode;
                                                0 == i ? e.contentWindow.location.replace(t) : 1 == i && (e.src = t);
                                            })(e, r)
                                          : (e.src = r)),
                                s && (c || d) && v(e, { src: r })),
                                e._lazyRace && delete e._lazyRace,
                                A(e, o.lazyClass),
                                T(function () {
                                    var t = e.complete && e.naturalWidth > 1;
                                    (M && !t) ||
                                        (t && g(e, o.fastLoadedClass),
                                        Y(p),
                                        (e._lazyCache = !0),
                                        u(function () {
                                            "_lazyCache" in e && delete e._lazyCache;
                                        }, 9)),
                                        "lazy" == e.loading && I--;
                                }, !0);
                        }),
                        Z = function (e) {
                            if (!e._lazyRace) {
                                var t,
                                    i = _.test(e.nodeName),
                                    n = i && (e[a](o.sizesAttr) || e[a]("sizes")),
                                    s = "auto" == n;
                                ((!s && p) || !i || (!e[a]("src") && !e.srcset) || e.complete || m(e, o.errorClass) || !m(e, o.lazyClass)) &&
                                    ((t = y(e, "lazyunveilread").detail), s && S.updateElem(e, !0, e.offsetWidth), (e._lazyRace = !0), I++, J(e, t, s, n, i));
                            }
                        },
                        ee = w(function () {
                            (o.loadMode = 3), V();
                        }),
                        te = function () {
                            3 == o.loadMode && (o.loadMode = 2), ee();
                        },
                        ie = function () {
                            p || (i.now() - L < 999 ? u(ie, 999) : ((p = !0), (o.loadMode = 3), V(), l("scroll", te, !0)));
                        };
                    return {
                        _: function () {
                            (L = i.now()),
                                (n.elements = t.getElementsByClassName(o.lazyClass)),
                                (r = t.getElementsByClassName(o.lazyClass + " " + o.preloadClass)),
                                l("scroll", V, !0),
                                l("resize", V, !0),
                                l("pageshow", function (e) {
                                    if (e.persisted) {
                                        var i = t.querySelectorAll("." + o.loadingClass);
                                        i.length &&
                                            i.forEach &&
                                            d(function () {
                                                i.forEach(function (e) {
                                                    e.complete && Z(e);
                                                });
                                            });
                                    }
                                }),
                                e.MutationObserver ? new MutationObserver(V).observe(s, { childList: !0, subtree: !0, attributes: !0 }) : (s[c]("DOMNodeInserted", V, !0), s[c]("DOMAttrModified", V, !0), setInterval(V, 999)),
                                l("hashchange", V, !0),
                                ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function (e) {
                                    t[c](e, V, !0);
                                }),
                                /d$|^c/.test(t.readyState) ? ie() : (l("load", ie), t[c]("DOMContentLoaded", V), u(ie, 2e4)),
                                n.elements.length ? (U(), T._lsFlush()) : V();
                        },
                        checkElems: V,
                        unveil: Z,
                        _aLSL: te,
                    };
                })(),
                S = (function () {
                    var e,
                        i = N(function (e, t, i, n) {
                            var o, s, r;
                            if (((e._lazysizesWidth = n), (n += "px"), e.setAttribute("sizes", n), h.test(t.nodeName || ""))) for (s = 0, r = (o = t.getElementsByTagName("source")).length; s < r; s++) o[s].setAttribute("sizes", n);
                            i.detail.dataAttr || v(e, i.detail);
                        }),
                        n = function (e, t, n) {
                            var o,
                                s = e.parentNode;
                            s && ((n = L(e, s, n)), (o = y(e, "lazybeforesizes", { width: n, dataAttr: !!t })).defaultPrevented || ((n = o.detail.width) && n !== e._lazysizesWidth && i(e, s, o, n)));
                        },
                        s = w(function () {
                            var t,
                                i = e.length;
                            if (i) for (t = 0; t < i; t++) n(e[t]);
                        });
                    return {
                        _: function () {
                            (e = t.getElementsByClassName(o.autosizesClass)), l("resize", s);
                        },
                        checkElems: s,
                        updateElem: n,
                    };
                })(),
                C = function () {
                    !C.i && t.getElementsByClassName && ((C.i = !0), S._(), W._());
                };
            return (
                u(function () {
                    o.init && C();
                }),
                (n = { cfg: o, autoSizer: S, loader: W, init: C, uP: v, aC: g, rC: A, hC: m, fire: y, gW: L, rAF: T })
            );
        })(e, e.document, Date);
        (e.lazySizes = t), "object" == typeof module && module.exports && (module.exports = t);
    })("undefined" != typeof window ? window : {}),
    (function (e) {
        var t = -1,
            i = -1,
            n = function (e) {
                return parseFloat(e) || 0;
            },
            o = function (t) {
                var i = { byRow: !0, remove: !1, property: "height" };
                return "object" == typeof t ? e.extend(i, t) : ("boolean" == typeof t ? (i.byRow = t) : "remove" === t && (i.remove = !0), i);
            },
            s = (e.fn.matchHeight = function (t) {
                if ((t = o(t)).remove) {
                    var i = this;
                    return (
                        this.css(t.property, ""),
                        e.each(s._groups, function (e, t) {
                            t.elements = t.elements.not(i);
                        }),
                        this
                    );
                }
                return 1 >= this.length || (s._groups.push({ elements: this, options: t }), s._apply(this, t)), this;
            });
        (s._groups = []),
            (s._throttle = 80),
            (s._maintainScroll = !1),
            (s._beforeUpdate = null),
            (s._afterUpdate = null),
            (s._apply = function (t, i) {
                var r = o(i),
                    c = e(t),
                    a = [c],
                    l = e(window).scrollTop(),
                    u = e("html").outerHeight(!0),
                    d = c.parents().filter(":hidden");
                return (
                    d.each(function () {
                        var t = e(this);
                        t.data("style-cache", t.attr("style"));
                    }),
                    d.css("display", "block"),
                    r.byRow &&
                        (c.each(function () {
                            var t = e(this),
                                i = "inline-block" === t.css("display") ? "inline-block" : "block";
                            t.data("style-cache", t.attr("style")),
                                t.css({ display: i, "padding-top": "0", "padding-bottom": "0", "margin-top": "0", "margin-bottom": "0", "border-top-width": "0", "border-bottom-width": "0", height: "100px" });
                        }),
                        (a = (function (t) {
                            var i = null,
                                o = [];
                            return (
                                e(t).each(function () {
                                    var t = e(this),
                                        s = t.offset().top - n(t.css("margin-top")),
                                        r = 0 < o.length ? o[o.length - 1] : null;
                                    null === r ? o.push(t) : 1 >= Math.floor(Math.abs(i - s)) ? (o[o.length - 1] = r.add(t)) : o.push(t), (i = s);
                                }),
                                o
                            );
                        })(c)),
                        c.each(function () {
                            var t = e(this);
                            t.attr("style", t.data("style-cache") || "");
                        })),
                    e.each(a, function (t, i) {
                        var o = e(i),
                            s = 0;
                        r.byRow && 1 >= o.length
                            ? o.css(r.property, "")
                            : (o.each(function () {
                                  var t = e(this),
                                      i = { display: "inline-block" === t.css("display") ? "inline-block" : "block" };
                                  (i[r.property] = ""), t.css(i), t.outerHeight(!1) > s && (s = t.outerHeight(!1)), t.css("display", "");
                              }),
                              o.each(function () {
                                  var t = e(this),
                                      i = 0;
                                  "border-box" !== t.css("box-sizing") && ((i += n(t.css("border-top-width")) + n(t.css("border-bottom-width"))), (i += n(t.css("padding-top")) + n(t.css("padding-bottom")))), t.css(r.property, s - i);
                              }));
                    }),
                    d.each(function () {
                        var t = e(this);
                        t.attr("style", t.data("style-cache") || null);
                    }),
                    s._maintainScroll && e(window).scrollTop((l / u) * e("html").outerHeight(!0)),
                    this
                );
            }),
            (s._applyDataApi = function () {
                var t = {};
                e("[data-match-height], [data-mh]").each(function () {
                    var i = e(this),
                        n = i.attr("data-match-height") || i.attr("data-mh");
                    t[n] = n in t ? t[n].add(i) : i;
                }),
                    e.each(t, function () {
                        this.matchHeight(!0);
                    });
            });
        var r = function (t) {
            s._beforeUpdate && s._beforeUpdate(t, s._groups),
                e.each(s._groups, function () {
                    s._apply(this.elements, this.options);
                }),
                s._afterUpdate && s._afterUpdate(t, s._groups);
        };
        (s._update = function (n, o) {
            if (o && "resize" === o.type) {
                var c = e(window).width();
                if (c === t) return;
                t = c;
            }
            n
                ? -1 === i &&
                  (i = setTimeout(function () {
                      r(o), (i = -1);
                  }, s._throttle))
                : r(o);
        }),
            e(s._applyDataApi),
            e(window).bind("load", function (e) {
                s._update(!1, e);
            }),
            e(window).bind("resize orientationchange", function (e) {
                s._update(!0, e);
            });
    })(jQuery),
    (function (e, t) {
        "object" == typeof exports && "undefined" != typeof module ? (module.exports = t()) : "function" == typeof define && define.amd ? define(t) : ((e = e || self).SimpleBar = t());
    })(this, function () {
        "use strict";
        var e = function (e) {
                if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
                return e;
            },
            t = function (e) {
                try {
                    return !!e();
                } catch (e) {
                    return !0;
                }
            },
            i = {}.toString,
            n = function (e) {
                return i.call(e).slice(8, -1);
            },
            o = "".split,
            s = t(function () {
                return !Object("z").propertyIsEnumerable(0);
            })
                ? function (e) {
                      return "String" == n(e) ? o.call(e, "") : Object(e);
                  }
                : Object,
            r = function (e) {
                if (null == e) throw TypeError("Can't call method on " + e);
                return e;
            },
            c = function (e) {
                return Object(r(e));
            },
            a = Math.ceil,
            l = Math.floor,
            u = function (e) {
                return isNaN((e = +e)) ? 0 : (e > 0 ? l : a)(e);
            },
            d = Math.min,
            p = function (e) {
                return e > 0 ? d(u(e), 9007199254740991) : 0;
            },
            h = function (e) {
                return "object" == typeof e ? null !== e : "function" == typeof e;
            },
            f =
                Array.isArray ||
                function (e) {
                    return "Array" == n(e);
                },
            M = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
        function b(e, t) {
            return e((t = { exports: {} }), t.exports), t.exports;
        }
        var m,
            g,
            A,
            z,
            y = "object" == typeof window && window && window.Math == Math ? window : "object" == typeof self && self && self.Math == Math ? self : Function("return this")(),
            v = !t(function () {
                return (
                    7 !=
                    Object.defineProperty({}, "a", {
                        get: function () {
                            return 7;
                        },
                    }).a
                );
            }),
            O = y.document,
            L = h(O) && h(O.createElement),
            T =
                !v &&
                !t(function () {
                    return (
                        7 !=
                        Object.defineProperty(("div", L ? O.createElement("div") : {}), "a", {
                            get: function () {
                                return 7;
                            },
                        }).a
                    );
                }),
            N = function (e) {
                if (!h(e)) throw TypeError(String(e) + " is not an object");
                return e;
            },
            q = function (e, t) {
                if (!h(e)) return e;
                var i, n;
                if (t && "function" == typeof (i = e.toString) && !h((n = i.call(e)))) return n;
                if ("function" == typeof (i = e.valueOf) && !h((n = i.call(e)))) return n;
                if (!t && "function" == typeof (i = e.toString) && !h((n = i.call(e)))) return n;
                throw TypeError("Can't convert object to primitive value");
            },
            w = Object.defineProperty,
            W = {
                f: v
                    ? w
                    : function (e, t, i) {
                          if ((N(e), (t = q(t, !0)), N(i), T))
                              try {
                                  return w(e, t, i);
                              } catch (e) {}
                          if ("get" in i || "set" in i) throw TypeError("Accessors not supported");
                          return "value" in i && (e[t] = i.value), e;
                      },
            },
            S = function (e, t) {
                return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t };
            },
            C = v
                ? function (e, t, i) {
                      return W.f(e, t, S(1, i));
                  }
                : function (e, t, i) {
                      return (e[t] = i), e;
                  },
            k = function (e, t) {
                try {
                    C(y, e, t);
                } catch (i) {
                    y[e] = t;
                }
                return t;
            },
            B = b(function (e) {
                var t = y["__core-js_shared__"] || k("__core-js_shared__", {});
                (e.exports = function (e, i) {
                    return t[e] || (t[e] = void 0 !== i ? i : {});
                })("versions", []).push({ version: "3.0.1", mode: "global", copyright: "© 2019 Denis Pushkarev (zloirock.ru)" });
            }),
            E = 0,
            X = Math.random(),
            x = function (e) {
                return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++E + X).toString(36));
            },
            _ = !t(function () {
                return !String(Symbol());
            }),
            D = B("wks"),
            R = y.Symbol,
            P = function (e) {
                return D[e] || (D[e] = (_ && R[e]) || (_ ? R : x)("Symbol." + e));
            },
            I = P("species"),
            H = function (e, t) {
                var i;
                return f(e) && ("function" != typeof (i = e.constructor) || (i !== Array && !f(i.prototype)) ? h(i) && null === (i = i[I]) && (i = void 0) : (i = void 0)), new (void 0 === i ? Array : i)(0 === t ? 0 : t);
            },
            j = function (t, i) {
                var n = 1 == t,
                    o = 2 == t,
                    r = 3 == t,
                    a = 4 == t,
                    l = 6 == t,
                    u = 5 == t || l,
                    d = i || H;
                return function (i, h, f) {
                    for (
                        var M,
                            b,
                            m = c(i),
                            g = s(m),
                            A = (function (t, i, n) {
                                return (
                                    e(t),
                                    void 0 === i
                                        ? t
                                        : function (e, n, o) {
                                              return t.call(i, e, n, o);
                                          }
                                );
                            })(h, f),
                            z = p(g.length),
                            y = 0,
                            v = n ? d(i, z) : o ? d(i, 0) : void 0;
                        z > y;
                        y++
                    )
                        if ((u || y in g) && ((b = A((M = g[y]), y, m)), t))
                            if (n) v[y] = b;
                            else if (b)
                                switch (t) {
                                    case 3:
                                        return !0;
                                    case 5:
                                        return M;
                                    case 6:
                                        return y;
                                    case 2:
                                        v.push(M);
                                }
                            else if (a) return !1;
                    return l ? -1 : r || a ? a : v;
                };
            },
            $ = P("species"),
            F = {}.propertyIsEnumerable,
            U = Object.getOwnPropertyDescriptor,
            V = {
                f:
                    U && !F.call({ 1: 2 }, 1)
                        ? function (e) {
                              var t = U(this, e);
                              return !!t && t.enumerable;
                          }
                        : F,
            },
            Y = function (e) {
                return s(r(e));
            },
            G = {}.hasOwnProperty,
            K = function (e, t) {
                return G.call(e, t);
            },
            Q = Object.getOwnPropertyDescriptor,
            J = {
                f: v
                    ? Q
                    : function (e, t) {
                          if (((e = Y(e)), (t = q(t, !0)), T))
                              try {
                                  return Q(e, t);
                              } catch (e) {}
                          if (K(e, t)) return S(!V.f.call(e, t), e[t]);
                      },
            },
            Z = B("native-function-to-string", Function.toString),
            ee = y.WeakMap,
            te = "function" == typeof ee && /native code/.test(Z.call(ee)),
            ie = B("keys"),
            ne = {},
            oe = y.WeakMap;
        if (te) {
            var se = new oe(),
                re = se.get,
                ce = se.has,
                ae = se.set;
            (m = function (e, t) {
                return ae.call(se, e, t), t;
            }),
                (g = function (e) {
                    return re.call(se, e) || {};
                }),
                (A = function (e) {
                    return ce.call(se, e);
                });
        } else {
            var le = ie[(z = "state")] || (ie[z] = x(z));
            (ne[le] = !0),
                (m = function (e, t) {
                    return C(e, le, t), t;
                }),
                (g = function (e) {
                    return K(e, le) ? e[le] : {};
                }),
                (A = function (e) {
                    return K(e, le);
                });
        }
        var ue,
            de = {
                set: m,
                get: g,
                has: A,
                enforce: function (e) {
                    return A(e) ? g(e) : m(e, {});
                },
                getterFor: function (e) {
                    return function (t) {
                        var i;
                        if (!h(t) || (i = g(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
                        return i;
                    };
                },
            },
            pe = b(function (e) {
                var t = de.get,
                    i = de.enforce,
                    n = String(Z).split("toString");
                B("inspectSource", function (e) {
                    return Z.call(e);
                }),
                    (e.exports = function (e, t, o, s) {
                        var r = !!s && !!s.unsafe,
                            c = !!s && !!s.enumerable,
                            a = !!s && !!s.noTargetGet;
                        "function" == typeof o && ("string" != typeof t || K(o, "name") || C(o, "name", t), (i(o).source = n.join("string" == typeof t ? t : ""))),
                            e !== y ? (r ? !a && e[t] && (c = !0) : delete e[t], c ? (e[t] = o) : C(e, t, o)) : c ? (e[t] = o) : k(t, o);
                    })(Function.prototype, "toString", function () {
                        return ("function" == typeof this && t(this).source) || Z.call(this);
                    });
            }),
            he = Math.max,
            fe = Math.min,
            Me =
                ((ue = !1),
                function (e, t, i) {
                    var n = Y(e),
                        o = p(n.length),
                        s = (function (e, t) {
                            var i = u(e);
                            return i < 0 ? he(i + t, 0) : fe(i, t);
                        })(i, o);
                    for (ue; o > s; s++) if (s in n && n[s] === t) return s || 0;
                    return -1;
                }),
            be = function (e, t) {
                var i,
                    n = Y(e),
                    o = 0,
                    s = [];
                for (i in n) !K(ne, i) && K(n, i) && s.push(i);
                for (; t.length > o; ) K(n, (i = t[o++])) && (~Me(s, i) || s.push(i));
                return s;
            },
            me = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
            ge = me.concat("length", "prototype"),
            Ae = {
                f:
                    Object.getOwnPropertyNames ||
                    function (e) {
                        return be(e, ge);
                    },
            },
            ze = { f: Object.getOwnPropertySymbols },
            ye = y.Reflect,
            ve =
                (ye && ye.ownKeys) ||
                function (e) {
                    var t = Ae.f(N(e)),
                        i = ze.f;
                    return i ? t.concat(i(e)) : t;
                },
            Oe = function (e, t) {
                for (var i = ve(t), n = W.f, o = J.f, s = 0; s < i.length; s++) {
                    var r = i[s];
                    K(e, r) || n(e, r, o(t, r));
                }
            },
            Le = /#|\.prototype\./,
            Te = function (e, i) {
                var n = qe[Ne(e)];
                return n == We || (n != we && ("function" == typeof i ? t(i) : !!i));
            },
            Ne = (Te.normalize = function (e) {
                return String(e).replace(Le, ".").toLowerCase();
            }),
            qe = (Te.data = {}),
            we = (Te.NATIVE = "N"),
            We = (Te.POLYFILL = "P"),
            Se = Te,
            Ce = J.f,
            ke = function (e, t) {
                var i,
                    n,
                    o,
                    s,
                    r,
                    c = e.target,
                    a = e.global,
                    l = e.stat;
                if ((i = a ? y : l ? y[c] || k(c, {}) : (y[c] || {}).prototype))
                    for (n in t) {
                        if (((s = t[n]), (o = e.noTargetGet ? (r = Ce(i, n)) && r.value : i[n]), !Se(a ? n : c + (l ? "." : "#") + n, e.forced) && void 0 !== o)) {
                            if (typeof s == typeof o) continue;
                            Oe(s, o);
                        }
                        (e.sham || (o && o.sham)) && C(s, "sham", !0), pe(i, n, s, e);
                    }
            },
            Be = j(2);
        ke(
            {
                target: "Array",
                proto: !0,
                forced:
                    ("filter",
                    !!t(function () {
                        var e = [];
                        return (
                            ((e.constructor = {})[$] = function () {
                                return { foo: 1 };
                            }),
                            1 !== e.filter(Boolean).foo
                        );
                    })),
            },
            {
                filter: function (e) {
                    return Be(this, e, arguments[1]);
                },
            }
        );
        var Ee = function (e, i) {
                var n = [][e];
                return (
                    !n ||
                    !t(function () {
                        n.call(
                            null,
                            i ||
                                function () {
                                    throw 1;
                                },
                            1
                        );
                    })
                );
            },
            Xe = [].forEach,
            xe = j(0),
            _e = Ee("forEach")
                ? function (e) {
                      return xe(this, e, arguments[1]);
                  }
                : Xe;
        ke({ target: "Array", proto: !0, forced: [].forEach != _e }, { forEach: _e }),
            ke(
                { target: "Array", proto: !0, forced: Ee("reduce") },
                {
                    reduce: function (t) {
                        return (function (t, i, n, o, r) {
                            e(i);
                            var a = c(t),
                                l = s(a),
                                u = p(a.length),
                                d = 0;
                            if (n < 2)
                                for (;;) {
                                    if (d in l) {
                                        (o = l[d]), (d += 1);
                                        break;
                                    }
                                    if (u <= (d += 1)) throw TypeError("Reduce of empty array with no initial value");
                                }
                            for (; u > d; d += 1) d in l && (o = i(o, l[d], d, a));
                            return o;
                        })(this, t, arguments.length, arguments[1]);
                    },
                }
            );
        var De = W.f,
            Re = Function.prototype,
            Pe = Re.toString,
            Ie = /^\s*function ([^ (]*)/;
        !v ||
            "name" in Re ||
            De(Re, "name", {
                configurable: !0,
                get: function () {
                    try {
                        return Pe.call(this).match(Ie)[1];
                    } catch (e) {
                        return "";
                    }
                },
            });
        var He =
                Object.keys ||
                function (e) {
                    return be(e, me);
                },
            je = Object.assign,
            $e =
                !je ||
                t(function () {
                    var e = {},
                        t = {},
                        i = Symbol();
                    return (
                        (e[i] = 7),
                        "abcdefghijklmnopqrst".split("").forEach(function (e) {
                            t[e] = e;
                        }),
                        7 != je({}, e)[i] || "abcdefghijklmnopqrst" != He(je({}, t)).join("")
                    );
                })
                    ? function (e, t) {
                          for (var i = c(e), n = arguments.length, o = 1, r = ze.f, a = V.f; n > o; )
                              for (var l, u = s(arguments[o++]), d = r ? He(u).concat(r(u)) : He(u), p = d.length, h = 0; p > h; ) a.call(u, (l = d[h++])) && (i[l] = u[l]);
                          return i;
                      }
                    : je;
        ke({ target: "Object", stat: !0, forced: Object.assign !== $e }, { assign: $e });
        var Fe = "\t\n\v\f\r                　\u2028\u2029\ufeff",
            Ue = "[" + Fe + "]",
            Ve = RegExp("^" + Ue + Ue + "*"),
            Ye = RegExp(Ue + Ue + "*$"),
            Ge = y.parseInt,
            Ke = /^[-+]?0[xX]/,
            Qe =
                8 !== Ge(Fe + "08") || 22 !== Ge(Fe + "0x16")
                    ? function (e, t) {
                          var i = (function (e, t) {
                              return (e = (e = (e = String(r(e))).replace(Ve, "")).replace(Ye, ""));
                          })(String(e));
                          return Ge(i, t >>> 0 || (Ke.test(i) ? 16 : 10));
                      }
                    : Ge;
        ke({ global: !0, forced: parseInt != Qe }, { parseInt: Qe });
        var Je,
            Ze,
            et = RegExp.prototype.exec,
            tt = String.prototype.replace,
            it = et,
            nt = ((Je = /a/), (Ze = /b*/g), et.call(Je, "a"), et.call(Ze, "a"), 0 !== Je.lastIndex || 0 !== Ze.lastIndex),
            ot = void 0 !== /()??/.exec("")[1];
        (nt || ot) &&
            (it = function (e) {
                var t,
                    i,
                    n,
                    o,
                    s = this;
                return (
                    ot &&
                        (i = new RegExp(
                            "^" + s.source + "$(?!\\s)",
                            function () {
                                var e = N(this),
                                    t = "";
                                return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
                            }.call(s)
                        )),
                    nt && (t = s.lastIndex),
                    (n = et.call(s, e)),
                    nt && n && (s.lastIndex = s.global ? n.index + n[0].length : t),
                    ot &&
                        n &&
                        n.length > 1 &&
                        tt.call(n[0], i, function () {
                            for (o = 1; o < arguments.length - 2; o++) void 0 === arguments[o] && (n[o] = void 0);
                        }),
                    n
                );
            });
        var st = it;
        ke({ target: "RegExp", proto: !0, forced: /./.exec !== st }, { exec: st });
        var rt = function (e, t, i) {
                return (
                    t +
                    (i
                        ? (function (e, t, i) {
                              var n,
                                  o,
                                  s = String(r(e)),
                                  c = u(t),
                                  a = s.length;
                              return c < 0 || c >= a ? "" : (n = s.charCodeAt(c)) < 55296 || n > 56319 || c + 1 === a || (o = s.charCodeAt(c + 1)) < 56320 || o > 57343 ? s.charAt(c) : s.slice(c, c + 2);
                          })(e, t).length
                        : 1)
                );
            },
            ct = function (e, t) {
                var i = e.exec;
                if ("function" == typeof i) {
                    var o = i.call(e, t);
                    if ("object" != typeof o) throw TypeError("RegExp exec method returned something other than an Object or null");
                    return o;
                }
                if ("RegExp" !== n(e)) throw TypeError("RegExp#exec called on incompatible receiver");
                return st.call(e, t);
            },
            at = P("species"),
            lt = !t(function () {
                var e = /./;
                return (
                    (e.exec = function () {
                        var e = [];
                        return (e.groups = { a: "7" }), e;
                    }),
                    "7" !== "".replace(e, "$<a>")
                );
            }),
            ut = !t(function () {
                var e = /(?:)/,
                    t = e.exec;
                e.exec = function () {
                    return t.apply(this, arguments);
                };
                var i = "ab".split(e);
                return 2 !== i.length || "a" !== i[0] || "b" !== i[1];
            }),
            dt = function (e, i, n, o) {
                var s = P(e),
                    r = !t(function () {
                        var t = {};
                        return (
                            (t[s] = function () {
                                return 7;
                            }),
                            7 != ""[e](t)
                        );
                    }),
                    c =
                        r &&
                        !t(function () {
                            var t = !1,
                                i = /a/;
                            return (
                                (i.exec = function () {
                                    return (t = !0), null;
                                }),
                                "split" === e &&
                                    ((i.constructor = {}),
                                    (i.constructor[at] = function () {
                                        return i;
                                    })),
                                i[s](""),
                                !t
                            );
                        });
                if (!r || !c || ("replace" === e && !lt) || ("split" === e && !ut)) {
                    var a = /./[s],
                        l = n(s, ""[e], function (e, t, i, n, o) {
                            return t.exec === st ? (r && !o ? { done: !0, value: a.call(t, i, n) } : { done: !0, value: e.call(i, t, n) }) : { done: !1 };
                        }),
                        u = l[0],
                        d = l[1];
                    pe(String.prototype, e, u),
                        pe(
                            RegExp.prototype,
                            s,
                            2 == i
                                ? function (e, t) {
                                      return d.call(e, this, t);
                                  }
                                : function (e) {
                                      return d.call(e, this);
                                  }
                        ),
                        o && C(RegExp.prototype[s], "sham", !0);
                }
            };
        dt("match", 1, function (e, t, i) {
            return [
                function (t) {
                    var i = r(this),
                        n = null == t ? void 0 : t[e];
                    return void 0 !== n ? n.call(t, i) : new RegExp(t)[e](String(i));
                },
                function (e) {
                    var n = i(t, e, this);
                    if (n.done) return n.value;
                    var o = N(e),
                        s = String(this);
                    if (!o.global) return ct(o, s);
                    var r = o.unicode;
                    o.lastIndex = 0;
                    for (var c, a = [], l = 0; null !== (c = ct(o, s)); ) {
                        var u = String(c[0]);
                        (a[l] = u), "" === u && (o.lastIndex = rt(s, p(o.lastIndex), r)), l++;
                    }
                    return 0 === l ? null : a;
                },
            ];
        });
        var pt = Math.max,
            ht = Math.min,
            ft = Math.floor,
            Mt = /\$([$&`']|\d\d?|<[^>]*>)/g,
            bt = /\$([$&`']|\d\d?)/g;
        for (var mt in (dt("replace", 2, function (e, t, i) {
            return [
                function (i, n) {
                    var o = r(this),
                        s = null == i ? void 0 : i[e];
                    return void 0 !== s ? s.call(i, o, n) : t.call(String(o), i, n);
                },
                function (e, o) {
                    var s = i(t, e, this, o);
                    if (s.done) return s.value;
                    var r = N(e),
                        c = String(this),
                        a = "function" == typeof o;
                    a || (o = String(o));
                    var l = r.global;
                    if (l) {
                        var d = r.unicode;
                        r.lastIndex = 0;
                    }
                    for (var h = []; ; ) {
                        var f = ct(r, c);
                        if (null === f) break;
                        if ((h.push(f), !l)) break;
                        "" === String(f[0]) && (r.lastIndex = rt(c, p(r.lastIndex), d));
                    }
                    for (var M, b = "", m = 0, g = 0; g < h.length; g++) {
                        f = h[g];
                        for (var A = String(f[0]), z = pt(ht(u(f.index), c.length), 0), y = [], v = 1; v < f.length; v++) y.push(void 0 === (M = f[v]) ? M : String(M));
                        var O = f.groups;
                        if (a) {
                            var L = [A].concat(y, z, c);
                            void 0 !== O && L.push(O);
                            var T = String(o.apply(void 0, L));
                        } else T = n(A, c, z, y, O, o);
                        z >= m && ((b += c.slice(m, z) + T), (m = z + A.length));
                    }
                    return b + c.slice(m);
                },
            ];
            function n(e, i, n, o, s, r) {
                var a = n + e.length,
                    l = o.length,
                    u = bt;
                return (
                    void 0 !== s && ((s = c(s)), (u = Mt)),
                    t.call(r, u, function (t, r) {
                        var c;
                        switch (r.charAt(0)) {
                            case "$":
                                return "$";
                            case "&":
                                return e;
                            case "`":
                                return i.slice(0, n);
                            case "'":
                                return i.slice(a);
                            case "<":
                                c = s[r.slice(1, -1)];
                                break;
                            default:
                                var u = +r;
                                if (0 === u) return t;
                                if (u > l) {
                                    var d = ft(u / 10);
                                    return 0 === d ? t : d <= l ? (void 0 === o[d - 1] ? r.charAt(1) : o[d - 1] + r.charAt(1)) : t;
                                }
                                c = o[u - 1];
                        }
                        return void 0 === c ? "" : c;
                    })
                );
            }
        }),
        {
            CSSRuleList: 0,
            CSSStyleDeclaration: 0,
            CSSValueList: 0,
            ClientRectList: 0,
            DOMRectList: 0,
            DOMStringList: 0,
            DOMTokenList: 1,
            DataTransferItemList: 0,
            FileList: 0,
            HTMLAllCollection: 0,
            HTMLCollection: 0,
            HTMLFormElement: 0,
            HTMLSelectElement: 0,
            MediaList: 0,
            MimeTypeArray: 0,
            NamedNodeMap: 0,
            NodeList: 1,
            PaintRequestList: 0,
            Plugin: 0,
            PluginArray: 0,
            SVGLengthList: 0,
            SVGNumberList: 0,
            SVGPathSegList: 0,
            SVGPointList: 0,
            SVGStringList: 0,
            SVGTransformList: 0,
            SourceBufferList: 0,
            StyleSheetList: 0,
            TextTrackCueList: 0,
            TextTrackList: 0,
            TouchList: 0,
        })) {
            var gt = y[mt],
                At = gt && gt.prototype;
            if (At && At.forEach !== _e)
                try {
                    C(At, "forEach", _e);
                } catch (e) {
                    At.forEach = _e;
                }
        }
        var zt = "Expected a function",
            yt = /^\s+|\s+$/g,
            vt = /^[-+]0x[0-9a-f]+$/i,
            Ot = /^0b[01]+$/i,
            Lt = /^0o[0-7]+$/i,
            Tt = parseInt,
            Nt = "object" == typeof M && M && M.Object === Object && M,
            qt = "object" == typeof self && self && self.Object === Object && self,
            wt = Nt || qt || Function("return this")(),
            Wt = Object.prototype.toString,
            St = Math.max,
            Ct = Math.min,
            kt = function () {
                return wt.Date.now();
            };
        function Bt(e) {
            var t = typeof e;
            return !!e && ("object" == t || "function" == t);
        }
        function Et(e) {
            if ("number" == typeof e) return e;
            if (
                (function (e) {
                    return (
                        "symbol" == typeof e ||
                        ((function (e) {
                            return !!e && "object" == typeof e;
                        })(e) &&
                            "[object Symbol]" == Wt.call(e))
                    );
                })(e)
            )
                return NaN;
            if (Bt(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = Bt(t) ? t + "" : t;
            }
            if ("string" != typeof e) return 0 === e ? e : +e;
            e = e.replace(yt, "");
            var i = Ot.test(e);
            return i || Lt.test(e) ? Tt(e.slice(2), i ? 2 : 8) : vt.test(e) ? NaN : +e;
        }
        var Xt = function (e, t, i) {
                var n = !0,
                    o = !0;
                if ("function" != typeof e) throw new TypeError(zt);
                return (
                    Bt(i) && ((n = "leading" in i ? !!i.leading : n), (o = "trailing" in i ? !!i.trailing : o)),
                    (function (e, t, i) {
                        var n,
                            o,
                            s,
                            r,
                            c,
                            a,
                            l = 0,
                            u = !1,
                            d = !1,
                            p = !0;
                        if ("function" != typeof e) throw new TypeError(zt);
                        function h(t) {
                            var i = n,
                                s = o;
                            return (n = o = void 0), (l = t), (r = e.apply(s, i));
                        }
                        function f(e) {
                            var i = e - a;
                            return void 0 === a || i >= t || i < 0 || (d && e - l >= s);
                        }
                        function M() {
                            var e = kt();
                            if (f(e)) return b(e);
                            c = setTimeout(
                                M,
                                (function (e) {
                                    var i = t - (e - a);
                                    return d ? Ct(i, s - (e - l)) : i;
                                })(e)
                            );
                        }
                        function b(e) {
                            return (c = void 0), p && n ? h(e) : ((n = o = void 0), r);
                        }
                        function m() {
                            var e = kt(),
                                i = f(e);
                            if (((n = arguments), (o = this), (a = e), i)) {
                                if (void 0 === c)
                                    return (function (e) {
                                        return (l = e), (c = setTimeout(M, t)), u ? h(e) : r;
                                    })(a);
                                if (d) return (c = setTimeout(M, t)), h(a);
                            }
                            return void 0 === c && (c = setTimeout(M, t)), r;
                        }
                        return (
                            (t = Et(t) || 0),
                            Bt(i) && ((u = !!i.leading), (s = (d = "maxWait" in i) ? St(Et(i.maxWait) || 0, t) : s), (p = "trailing" in i ? !!i.trailing : p)),
                            (m.cancel = function () {
                                void 0 !== c && clearTimeout(c), (l = 0), (n = a = o = c = void 0);
                            }),
                            (m.flush = function () {
                                return void 0 === c ? r : b(kt());
                            }),
                            m
                        );
                    })(e, t, { leading: n, maxWait: t, trailing: o })
                );
            },
            xt = /^\s+|\s+$/g,
            _t = /^[-+]0x[0-9a-f]+$/i,
            Dt = /^0b[01]+$/i,
            Rt = /^0o[0-7]+$/i,
            Pt = parseInt,
            It = "object" == typeof M && M && M.Object === Object && M,
            Ht = "object" == typeof self && self && self.Object === Object && self,
            jt = It || Ht || Function("return this")(),
            $t = Object.prototype.toString,
            Ft = Math.max,
            Ut = Math.min,
            Vt = function () {
                return jt.Date.now();
            };
        function Yt(e) {
            var t = typeof e;
            return !!e && ("object" == t || "function" == t);
        }
        function Gt(e) {
            if ("number" == typeof e) return e;
            if (
                (function (e) {
                    return (
                        "symbol" == typeof e ||
                        ((function (e) {
                            return !!e && "object" == typeof e;
                        })(e) &&
                            "[object Symbol]" == $t.call(e))
                    );
                })(e)
            )
                return NaN;
            if (Yt(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = Yt(t) ? t + "" : t;
            }
            if ("string" != typeof e) return 0 === e ? e : +e;
            e = e.replace(xt, "");
            var i = Dt.test(e);
            return i || Rt.test(e) ? Pt(e.slice(2), i ? 2 : 8) : _t.test(e) ? NaN : +e;
        }
        var Kt = function (e, t, i) {
                var n,
                    o,
                    s,
                    r,
                    c,
                    a,
                    l = 0,
                    u = !1,
                    d = !1,
                    p = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function h(t) {
                    var i = n,
                        s = o;
                    return (n = o = void 0), (l = t), (r = e.apply(s, i));
                }
                function f(e) {
                    var i = e - a;
                    return void 0 === a || i >= t || i < 0 || (d && e - l >= s);
                }
                function M() {
                    var e = Vt();
                    if (f(e)) return b(e);
                    c = setTimeout(
                        M,
                        (function (e) {
                            var i = t - (e - a);
                            return d ? Ut(i, s - (e - l)) : i;
                        })(e)
                    );
                }
                function b(e) {
                    return (c = void 0), p && n ? h(e) : ((n = o = void 0), r);
                }
                function m() {
                    var e = Vt(),
                        i = f(e);
                    if (((n = arguments), (o = this), (a = e), i)) {
                        if (void 0 === c)
                            return (function (e) {
                                return (l = e), (c = setTimeout(M, t)), u ? h(e) : r;
                            })(a);
                        if (d) return (c = setTimeout(M, t)), h(a);
                    }
                    return void 0 === c && (c = setTimeout(M, t)), r;
                }
                return (
                    (t = Gt(t) || 0),
                    Yt(i) && ((u = !!i.leading), (s = (d = "maxWait" in i) ? Ft(Gt(i.maxWait) || 0, t) : s), (p = "trailing" in i ? !!i.trailing : p)),
                    (m.cancel = function () {
                        void 0 !== c && clearTimeout(c), (l = 0), (n = a = o = c = void 0);
                    }),
                    (m.flush = function () {
                        return void 0 === c ? r : b(Vt());
                    }),
                    m
                );
            },
            Qt = "__lodash_hash_undefined__",
            Jt = /^\[object .+?Constructor\]$/,
            Zt = "object" == typeof M && M && M.Object === Object && M,
            ei = "object" == typeof self && self && self.Object === Object && self,
            ti = Zt || ei || Function("return this")(),
            ii = Array.prototype,
            ni = Function.prototype,
            oi = Object.prototype,
            si = ti["__core-js_shared__"],
            ri = (function () {
                var e = /[^.]+$/.exec((si && si.keys && si.keys.IE_PROTO) || "");
                return e ? "Symbol(src)_1." + e : "";
            })(),
            ci = ni.toString,
            ai = oi.hasOwnProperty,
            li = oi.toString,
            ui = RegExp(
                "^" +
                    ci
                        .call(ai)
                        .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
                        .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") +
                    "$"
            ),
            di = ii.splice,
            pi = Ai(ti, "Map"),
            hi = Ai(Object, "create");
        function fi(e) {
            var t = -1,
                i = e ? e.length : 0;
            for (this.clear(); ++t < i; ) {
                var n = e[t];
                this.set(n[0], n[1]);
            }
        }
        function Mi(e) {
            var t = -1,
                i = e ? e.length : 0;
            for (this.clear(); ++t < i; ) {
                var n = e[t];
                this.set(n[0], n[1]);
            }
        }
        function bi(e) {
            var t = -1,
                i = e ? e.length : 0;
            for (this.clear(); ++t < i; ) {
                var n = e[t];
                this.set(n[0], n[1]);
            }
        }
        function mi(e, t) {
            for (var i, n, o = e.length; o--; ) if ((i = e[o][0]) === (n = t) || (i != i && n != n)) return o;
            return -1;
        }
        function gi(e, t) {
            var i,
                n,
                o = e.__data__;
            return ("string" == (n = typeof (i = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== i : null === i) ? o["string" == typeof t ? "string" : "hash"] : o.map;
        }
        function Ai(e, t) {
            var i = (function (e, t) {
                return null == e ? void 0 : e[t];
            })(e, t);
            return (function (e) {
                return (
                    !(!yi(e) || ((t = e), ri && ri in t)) &&
                    ((function (e) {
                        var t = yi(e) ? li.call(e) : "";
                        return "[object Function]" == t || "[object GeneratorFunction]" == t;
                    })(e) ||
                    (function (e) {
                        var t = !1;
                        if (null != e && "function" != typeof e.toString)
                            try {
                                t = !!(e + "");
                            } catch (e) {}
                        return t;
                    })(e)
                        ? ui
                        : Jt
                    ).test(
                        (function (e) {
                            if (null != e) {
                                try {
                                    return ci.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        })(e)
                    )
                );
                var t;
            })(i)
                ? i
                : void 0;
        }
        function zi(e, t) {
            if ("function" != typeof e || (t && "function" != typeof t)) throw new TypeError("Expected a function");
            var i = function () {
                var n = arguments,
                    o = t ? t.apply(this, n) : n[0],
                    s = i.cache;
                if (s.has(o)) return s.get(o);
                var r = e.apply(this, n);
                return (i.cache = s.set(o, r)), r;
            };
            return (i.cache = new (zi.Cache || bi)()), i;
        }
        function yi(e) {
            var t = typeof e;
            return !!e && ("object" == t || "function" == t);
        }
        (fi.prototype.clear = function () {
            this.__data__ = hi ? hi(null) : {};
        }),
            (fi.prototype.delete = function (e) {
                return this.has(e) && delete this.__data__[e];
            }),
            (fi.prototype.get = function (e) {
                var t = this.__data__;
                if (hi) {
                    var i = t[e];
                    return i === Qt ? void 0 : i;
                }
                return ai.call(t, e) ? t[e] : void 0;
            }),
            (fi.prototype.has = function (e) {
                var t = this.__data__;
                return hi ? void 0 !== t[e] : ai.call(t, e);
            }),
            (fi.prototype.set = function (e, t) {
                return (this.__data__[e] = hi && void 0 === t ? Qt : t), this;
            }),
            (Mi.prototype.clear = function () {
                this.__data__ = [];
            }),
            (Mi.prototype.delete = function (e) {
                var t = this.__data__,
                    i = mi(t, e);
                return !(i < 0 || (i == t.length - 1 ? t.pop() : di.call(t, i, 1), 0));
            }),
            (Mi.prototype.get = function (e) {
                var t = this.__data__,
                    i = mi(t, e);
                return i < 0 ? void 0 : t[i][1];
            }),
            (Mi.prototype.has = function (e) {
                return mi(this.__data__, e) > -1;
            }),
            (Mi.prototype.set = function (e, t) {
                var i = this.__data__,
                    n = mi(i, e);
                return n < 0 ? i.push([e, t]) : (i[n][1] = t), this;
            }),
            (bi.prototype.clear = function () {
                this.__data__ = { hash: new fi(), map: new (pi || Mi)(), string: new fi() };
            }),
            (bi.prototype.delete = function (e) {
                return gi(this, e).delete(e);
            }),
            (bi.prototype.get = function (e) {
                return gi(this, e).get(e);
            }),
            (bi.prototype.has = function (e) {
                return gi(this, e).has(e);
            }),
            (bi.prototype.set = function (e, t) {
                return gi(this, e).set(e, t), this;
            }),
            (zi.Cache = bi);
        var vi = zi,
            Oi = (function () {
                if ("undefined" != typeof Map) return Map;
                function e(e, t) {
                    var i = -1;
                    return (
                        e.some(function (e, n) {
                            return e[0] === t && ((i = n), !0);
                        }),
                        i
                    );
                }
                return (function () {
                    function t() {
                        this.__entries__ = [];
                    }
                    return (
                        Object.defineProperty(t.prototype, "size", {
                            get: function () {
                                return this.__entries__.length;
                            },
                            enumerable: !0,
                            configurable: !0,
                        }),
                        (t.prototype.get = function (t) {
                            var i = e(this.__entries__, t),
                                n = this.__entries__[i];
                            return n && n[1];
                        }),
                        (t.prototype.set = function (t, i) {
                            var n = e(this.__entries__, t);
                            ~n ? (this.__entries__[n][1] = i) : this.__entries__.push([t, i]);
                        }),
                        (t.prototype.delete = function (t) {
                            var i = this.__entries__,
                                n = e(i, t);
                            ~n && i.splice(n, 1);
                        }),
                        (t.prototype.has = function (t) {
                            return !!~e(this.__entries__, t);
                        }),
                        (t.prototype.clear = function () {
                            this.__entries__.splice(0);
                        }),
                        (t.prototype.forEach = function (e, t) {
                            void 0 === t && (t = null);
                            for (var i = 0, n = this.__entries__; i < n.length; i++) {
                                var o = n[i];
                                e.call(t, o[1], o[0]);
                            }
                        }),
                        t
                    );
                })();
            })(),
            Li = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
            Ti = "undefined" != typeof global && global.Math === Math ? global : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
            Ni =
                "function" == typeof requestAnimationFrame
                    ? requestAnimationFrame.bind(Ti)
                    : function (e) {
                          return setTimeout(function () {
                              return e(Date.now());
                          }, 1e3 / 60);
                      },
            qi = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
            wi = "undefined" != typeof MutationObserver,
            Wi = (function () {
                function e() {
                    (this.connected_ = !1),
                        (this.mutationEventsAdded_ = !1),
                        (this.mutationsObserver_ = null),
                        (this.observers_ = []),
                        (this.onTransitionEnd_ = this.onTransitionEnd_.bind(this)),
                        (this.refresh = (function (e, t) {
                            var i = !1,
                                n = !1,
                                o = 0;
                            function s() {
                                i && ((i = !1), e()), n && c();
                            }
                            function r() {
                                Ni(s);
                            }
                            function c() {
                                var e = Date.now();
                                if (i) {
                                    if (e - o < 2) return;
                                    n = !0;
                                } else (i = !0), (n = !1), setTimeout(r, 20);
                                o = e;
                            }
                            return c;
                        })(this.refresh.bind(this)));
                }
                return (
                    (e.prototype.addObserver = function (e) {
                        ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
                    }),
                    (e.prototype.removeObserver = function (e) {
                        var t = this.observers_,
                            i = t.indexOf(e);
                        ~i && t.splice(i, 1), !t.length && this.connected_ && this.disconnect_();
                    }),
                    (e.prototype.refresh = function () {
                        this.updateObservers_() && this.refresh();
                    }),
                    (e.prototype.updateObservers_ = function () {
                        var e = this.observers_.filter(function (e) {
                            return e.gatherActive(), e.hasActive();
                        });
                        return (
                            e.forEach(function (e) {
                                return e.broadcastActive();
                            }),
                            e.length > 0
                        );
                    }),
                    (e.prototype.connect_ = function () {
                        Li &&
                            !this.connected_ &&
                            (document.addEventListener("transitionend", this.onTransitionEnd_),
                            window.addEventListener("resize", this.refresh),
                            wi
                                ? ((this.mutationsObserver_ = new MutationObserver(this.refresh)), this.mutationsObserver_.observe(document, { attributes: !0, childList: !0, characterData: !0, subtree: !0 }))
                                : (document.addEventListener("DOMSubtreeModified", this.refresh), (this.mutationEventsAdded_ = !0)),
                            (this.connected_ = !0));
                    }),
                    (e.prototype.disconnect_ = function () {
                        Li &&
                            this.connected_ &&
                            (document.removeEventListener("transitionend", this.onTransitionEnd_),
                            window.removeEventListener("resize", this.refresh),
                            this.mutationsObserver_ && this.mutationsObserver_.disconnect(),
                            this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh),
                            (this.mutationsObserver_ = null),
                            (this.mutationEventsAdded_ = !1),
                            (this.connected_ = !1));
                    }),
                    (e.prototype.onTransitionEnd_ = function (e) {
                        var t = e.propertyName,
                            i = void 0 === t ? "" : t;
                        qi.some(function (e) {
                            return !!~i.indexOf(e);
                        }) && this.refresh();
                    }),
                    (e.getInstance = function () {
                        return this.instance_ || (this.instance_ = new e()), this.instance_;
                    }),
                    (e.instance_ = null),
                    e
                );
            })(),
            Si = function (e, t) {
                for (var i = 0, n = Object.keys(t); i < n.length; i++) {
                    var o = n[i];
                    Object.defineProperty(e, o, { value: t[o], enumerable: !1, writable: !1, configurable: !0 });
                }
                return e;
            },
            Ci = function (e) {
                return (e && e.ownerDocument && e.ownerDocument.defaultView) || Ti;
            },
            ki = _i(0, 0, 0, 0);
        function Bi(e) {
            return parseFloat(e) || 0;
        }
        function Ei(e) {
            for (var t = [], i = 1; i < arguments.length; i++) t[i - 1] = arguments[i];
            return t.reduce(function (t, i) {
                return t + Bi(e["border-" + i + "-width"]);
            }, 0);
        }
        var Xi =
            "undefined" != typeof SVGGraphicsElement
                ? function (e) {
                      return e instanceof Ci(e).SVGGraphicsElement;
                  }
                : function (e) {
                      return e instanceof Ci(e).SVGElement && "function" == typeof e.getBBox;
                  };
        function xi(e) {
            return Li
                ? Xi(e)
                    ? (function (e) {
                          var t = e.getBBox();
                          return _i(0, 0, t.width, t.height);
                      })(e)
                    : (function (e) {
                          var t = e.clientWidth,
                              i = e.clientHeight;
                          if (!t && !i) return ki;
                          var n = Ci(e).getComputedStyle(e),
                              o = (function (e) {
                                  for (var t = {}, i = 0, n = ["top", "right", "bottom", "left"]; i < n.length; i++) {
                                      var o = n[i],
                                          s = e["padding-" + o];
                                      t[o] = Bi(s);
                                  }
                                  return t;
                              })(n),
                              s = o.left + o.right,
                              r = o.top + o.bottom,
                              c = Bi(n.width),
                              a = Bi(n.height);
                          if (
                              ("border-box" === n.boxSizing && (Math.round(c + s) !== t && (c -= Ei(n, "left", "right") + s), Math.round(a + r) !== i && (a -= Ei(n, "top", "bottom") + r)),
                              !(function (e) {
                                  return e === Ci(e).document.documentElement;
                              })(e))
                          ) {
                              var l = Math.round(c + s) - t,
                                  u = Math.round(a + r) - i;
                              1 !== Math.abs(l) && (c -= l), 1 !== Math.abs(u) && (a -= u);
                          }
                          return _i(o.left, o.top, c, a);
                      })(e)
                : ki;
        }
        function _i(e, t, i, n) {
            return { x: e, y: t, width: i, height: n };
        }
        var Di = (function () {
                function e(e) {
                    (this.broadcastWidth = 0), (this.broadcastHeight = 0), (this.contentRect_ = _i(0, 0, 0, 0)), (this.target = e);
                }
                return (
                    (e.prototype.isActive = function () {
                        var e = xi(this.target);
                        return (this.contentRect_ = e), e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
                    }),
                    (e.prototype.broadcastRect = function () {
                        var e = this.contentRect_;
                        return (this.broadcastWidth = e.width), (this.broadcastHeight = e.height), e;
                    }),
                    e
                );
            })(),
            Ri = function (e, t) {
                var i,
                    n,
                    o,
                    s,
                    r,
                    c,
                    a,
                    l =
                        ((n = (i = t).x),
                        (o = i.y),
                        (s = i.width),
                        (r = i.height),
                        (c = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object),
                        (a = Object.create(c.prototype)),
                        Si(a, { x: n, y: o, width: s, height: r, top: o, right: n + s, bottom: r + o, left: n }),
                        a);
                Si(this, { target: e, contentRect: l });
            },
            Pi = (function () {
                function e(e, t, i) {
                    if (((this.activeObservations_ = []), (this.observations_ = new Oi()), "function" != typeof e)) throw new TypeError("The callback provided as parameter 1 is not a function.");
                    (this.callback_ = e), (this.controller_ = t), (this.callbackCtx_ = i);
                }
                return (
                    (e.prototype.observe = function (e) {
                        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
                        if ("undefined" != typeof Element && Element instanceof Object) {
                            if (!(e instanceof Ci(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                            var t = this.observations_;
                            t.has(e) || (t.set(e, new Di(e)), this.controller_.addObserver(this), this.controller_.refresh());
                        }
                    }),
                    (e.prototype.unobserve = function (e) {
                        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
                        if ("undefined" != typeof Element && Element instanceof Object) {
                            if (!(e instanceof Ci(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                            var t = this.observations_;
                            t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
                        }
                    }),
                    (e.prototype.disconnect = function () {
                        this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
                    }),
                    (e.prototype.gatherActive = function () {
                        var e = this;
                        this.clearActive(),
                            this.observations_.forEach(function (t) {
                                t.isActive() && e.activeObservations_.push(t);
                            });
                    }),
                    (e.prototype.broadcastActive = function () {
                        if (this.hasActive()) {
                            var e = this.callbackCtx_,
                                t = this.activeObservations_.map(function (e) {
                                    return new Ri(e.target, e.broadcastRect());
                                });
                            this.callback_.call(e, t, e), this.clearActive();
                        }
                    }),
                    (e.prototype.clearActive = function () {
                        this.activeObservations_.splice(0);
                    }),
                    (e.prototype.hasActive = function () {
                        return this.activeObservations_.length > 0;
                    }),
                    e
                );
            })(),
            Ii = "undefined" != typeof WeakMap ? new WeakMap() : new Oi(),
            Hi = function e(t) {
                if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function.");
                if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
                var i = Wi.getInstance(),
                    n = new Pi(t, i, this);
                Ii.set(this, n);
            };
        ["observe", "unobserve", "disconnect"].forEach(function (e) {
            Hi.prototype[e] = function () {
                var t;
                return (t = Ii.get(this))[e].apply(t, arguments);
            };
        });
        var ji = void 0 !== Ti.ResizeObserver ? Ti.ResizeObserver : Hi,
            $i = !("undefined" == typeof window || !window.document || !window.document.createElement);
        function Fi() {
            if ("undefined" == typeof document) return 0;
            var e = document.body,
                t = document.createElement("div"),
                i = t.style;
            (i.position = "fixed"), (i.left = 0), (i.visibility = "hidden"), (i.overflowY = "scroll"), e.appendChild(t);
            var n = t.getBoundingClientRect().right;
            return e.removeChild(t), n;
        }
        var Ui = (function () {
            function e(t, i) {
                var n = this;
                (this.onScroll = function () {
                    n.scrollXTicking || (window.requestAnimationFrame(n.scrollX), (n.scrollXTicking = !0)), n.scrollYTicking || (window.requestAnimationFrame(n.scrollY), (n.scrollYTicking = !0));
                }),
                    (this.scrollX = function () {
                        n.axis.x.isOverflowing && (n.showScrollbar("x"), n.positionScrollbar("x")), (n.scrollXTicking = !1);
                    }),
                    (this.scrollY = function () {
                        n.axis.y.isOverflowing && (n.showScrollbar("y"), n.positionScrollbar("y")), (n.scrollYTicking = !1);
                    }),
                    (this.onMouseEnter = function () {
                        n.showScrollbar("x"), n.showScrollbar("y");
                    }),
                    (this.onMouseMove = function (e) {
                        (n.mouseX = e.clientX), (n.mouseY = e.clientY), (n.axis.x.isOverflowing || n.axis.x.forceVisible) && n.onMouseMoveForAxis("x"), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && n.onMouseMoveForAxis("y");
                    }),
                    (this.onMouseLeave = function () {
                        n.onMouseMove.cancel(),
                            (n.axis.x.isOverflowing || n.axis.x.forceVisible) && n.onMouseLeaveForAxis("x"),
                            (n.axis.y.isOverflowing || n.axis.y.forceVisible) && n.onMouseLeaveForAxis("y"),
                            (n.mouseX = -1),
                            (n.mouseY = -1);
                    }),
                    (this.onWindowResize = function () {
                        (n.scrollbarWidth = Fi()), n.hideNativeScrollbar();
                    }),
                    (this.hideScrollbars = function () {
                        (n.axis.x.track.rect = n.axis.x.track.el.getBoundingClientRect()),
                            (n.axis.y.track.rect = n.axis.y.track.el.getBoundingClientRect()),
                            n.isWithinBounds(n.axis.y.track.rect) || (n.axis.y.scrollbar.el.classList.remove(n.classNames.visible), (n.axis.y.isVisible = !1)),
                            n.isWithinBounds(n.axis.x.track.rect) || (n.axis.x.scrollbar.el.classList.remove(n.classNames.visible), (n.axis.x.isVisible = !1));
                    }),
                    (this.onPointerEvent = function (e) {
                        var t, i;
                        (n.axis.x.scrollbar.rect = n.axis.x.scrollbar.el.getBoundingClientRect()),
                            (n.axis.y.scrollbar.rect = n.axis.y.scrollbar.el.getBoundingClientRect()),
                            (n.axis.x.isOverflowing || n.axis.x.forceVisible) && (i = n.isWithinBounds(n.axis.x.scrollbar.rect)),
                            (n.axis.y.isOverflowing || n.axis.y.forceVisible) && (t = n.isWithinBounds(n.axis.y.scrollbar.rect)),
                            (t || i) && (e.preventDefault(), e.stopPropagation(), "mousedown" === e.type && (t && n.onDragStart(e, "y"), i && n.onDragStart(e, "x")));
                    }),
                    (this.drag = function (t) {
                        var i = n.axis[n.draggedAxis].track,
                            o = i.rect[n.axis[n.draggedAxis].sizeAttr],
                            s = n.axis[n.draggedAxis].scrollbar;
                        t.preventDefault(), t.stopPropagation();
                        var r =
                            ((("y" === n.draggedAxis ? t.pageY : t.pageX) - i.rect[n.axis[n.draggedAxis].offsetAttr] - n.axis[n.draggedAxis].dragOffset) / i.rect[n.axis[n.draggedAxis].sizeAttr]) *
                            n.contentWrapperEl[n.axis[n.draggedAxis].scrollSizeAttr];
                        "x" === n.draggedAxis && ((r = n.isRtl && e.getRtlHelpers().isRtlScrollbarInverted ? r - (o + s.size) : r), (r = n.isRtl && e.getRtlHelpers().isRtlScrollingInverted ? -r : r)),
                            (n.contentWrapperEl[n.axis[n.draggedAxis].scrollOffsetAttr] = r);
                    }),
                    (this.onEndDrag = function (e) {
                        e.preventDefault(),
                            e.stopPropagation(),
                            n.el.classList.remove(n.classNames.dragging),
                            document.removeEventListener("mousemove", n.drag, !0),
                            document.removeEventListener("mouseup", n.onEndDrag, !0),
                            (n.removePreventClickId = window.setTimeout(function () {
                                document.removeEventListener("click", n.preventClick, !0), document.removeEventListener("dblclick", n.preventClick, !0), (n.removePreventClickId = null);
                            }));
                    }),
                    (this.preventClick = function (e) {
                        e.preventDefault(), e.stopPropagation();
                    }),
                    (this.el = t),
                    this.flashTimeout,
                    this.contentEl,
                    this.contentWrapperEl,
                    this.offsetEl,
                    this.maskEl,
                    this.globalObserver,
                    this.mutationObserver,
                    this.resizeObserver,
                    this.scrollbarWidth,
                    (this.minScrollbarWidth = 20),
                    (this.options = Object.assign({}, e.defaultOptions, i)),
                    (this.classNames = Object.assign({}, e.defaultOptions.classNames, this.options.classNames)),
                    this.isRtl,
                    (this.axis = {
                        x: {
                            scrollOffsetAttr: "scrollLeft",
                            sizeAttr: "width",
                            scrollSizeAttr: "scrollWidth",
                            offsetAttr: "left",
                            overflowAttr: "overflowX",
                            dragOffset: 0,
                            isOverflowing: !0,
                            isVisible: !1,
                            forceVisible: !1,
                            track: {},
                            scrollbar: {},
                        },
                        y: {
                            scrollOffsetAttr: "scrollTop",
                            sizeAttr: "height",
                            scrollSizeAttr: "scrollHeight",
                            offsetAttr: "top",
                            overflowAttr: "overflowY",
                            dragOffset: 0,
                            isOverflowing: !0,
                            isVisible: !1,
                            forceVisible: !1,
                            track: {},
                            scrollbar: {},
                        },
                    }),
                    (this.removePreventClickId = null),
                    this.el.SimpleBar ||
                        ((this.recalculate = Xt(this.recalculate.bind(this), 64)),
                        (this.onMouseMove = Xt(this.onMouseMove.bind(this), 64)),
                        (this.hideScrollbars = Kt(this.hideScrollbars.bind(this), this.options.timeout)),
                        (this.onWindowResize = Kt(this.onWindowResize.bind(this), 64, { leading: !0 })),
                        (e.getRtlHelpers = vi(e.getRtlHelpers)),
                        this.init());
            }
            (e.getRtlHelpers = function () {
                var t = document.createElement("div");
                t.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
                var i = t.firstElementChild;
                document.body.appendChild(i);
                var n = i.firstElementChild;
                i.scrollLeft = 0;
                var o = e.getOffset(i),
                    s = e.getOffset(n);
                i.scrollLeft = 999;
                var r = e.getOffset(n);
                return { isRtlScrollingInverted: o.left !== s.left && s.left - r.left != 0, isRtlScrollbarInverted: o.left !== s.left };
            }),
                (e.initHtmlApi = function () {
                    (this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this)),
                        "undefined" != typeof MutationObserver &&
                            ((this.globalObserver = new MutationObserver(function (t) {
                                t.forEach(function (t) {
                                    Array.prototype.forEach.call(t.addedNodes, function (t) {
                                        1 === t.nodeType &&
                                            (t.hasAttribute("data-simplebar")
                                                ? !t.SimpleBar && new e(t, e.getElOptions(t))
                                                : Array.prototype.forEach.call(t.querySelectorAll("[data-simplebar]"), function (t) {
                                                      !t.SimpleBar && new e(t, e.getElOptions(t));
                                                  }));
                                    }),
                                        Array.prototype.forEach.call(t.removedNodes, function (e) {
                                            1 === e.nodeType &&
                                                (e.hasAttribute("data-simplebar")
                                                    ? e.SimpleBar && e.SimpleBar.unMount()
                                                    : Array.prototype.forEach.call(e.querySelectorAll("[data-simplebar]"), function (e) {
                                                          e.SimpleBar && e.SimpleBar.unMount();
                                                      }));
                                        });
                                });
                            })),
                            this.globalObserver.observe(document, { childList: !0, subtree: !0 })),
                        "complete" === document.readyState || ("loading" !== document.readyState && !document.documentElement.doScroll)
                            ? window.setTimeout(this.initDOMLoadedElements)
                            : (document.addEventListener("DOMContentLoaded", this.initDOMLoadedElements), window.addEventListener("load", this.initDOMLoadedElements));
                }),
                (e.getElOptions = function (e) {
                    return Array.prototype.reduce.call(
                        e.attributes,
                        function (e, t) {
                            var i = t.name.match(/data-simplebar-(.+)/);
                            if (i) {
                                var n = i[1].replace(/\W+(.)/g, function (e, t) {
                                    return t.toUpperCase();
                                });
                                switch (t.value) {
                                    case "true":
                                        e[n] = !0;
                                        break;
                                    case "false":
                                        e[n] = !1;
                                        break;
                                    case void 0:
                                        e[n] = !0;
                                        break;
                                    default:
                                        e[n] = t.value;
                                }
                            }
                            return e;
                        },
                        {}
                    );
                }),
                (e.removeObserver = function () {
                    this.globalObserver.disconnect();
                }),
                (e.initDOMLoadedElements = function () {
                    document.removeEventListener("DOMContentLoaded", this.initDOMLoadedElements),
                        window.removeEventListener("load", this.initDOMLoadedElements),
                        Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"), function (t) {
                            t.SimpleBar || new e(t, e.getElOptions(t));
                        });
                }),
                (e.getOffset = function (e) {
                    var t = e.getBoundingClientRect();
                    return { top: t.top + (window.pageYOffset || document.documentElement.scrollTop), left: t.left + (window.pageXOffset || document.documentElement.scrollLeft) };
                });
            var t = e.prototype;
            return (
                (t.init = function () {
                    (this.el.SimpleBar = this), $i && (this.initDOM(), (this.scrollbarWidth = Fi()), this.recalculate(), this.initListeners());
                }),
                (t.initDOM = function () {
                    var e = this;
                    if (
                        Array.prototype.filter.call(this.el.children, function (t) {
                            return t.classList.contains(e.classNames.wrapper);
                        }).length
                    )
                        (this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper)),
                            (this.contentWrapperEl = this.el.querySelector("." + this.classNames.contentWrapper)),
                            (this.offsetEl = this.el.querySelector("." + this.classNames.offset)),
                            (this.maskEl = this.el.querySelector("." + this.classNames.mask)),
                            (this.contentEl = this.el.querySelector("." + this.classNames.contentEl)),
                            (this.placeholderEl = this.el.querySelector("." + this.classNames.placeholder)),
                            (this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl)),
                            (this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl)),
                            (this.axis.x.track.el = this.el.querySelector("." + this.classNames.track + "." + this.classNames.horizontal)),
                            (this.axis.y.track.el = this.el.querySelector("." + this.classNames.track + "." + this.classNames.vertical));
                    else {
                        for (
                            this.wrapperEl = document.createElement("div"),
                                this.contentWrapperEl = document.createElement("div"),
                                this.offsetEl = document.createElement("div"),
                                this.maskEl = document.createElement("div"),
                                this.contentEl = document.createElement("div"),
                                this.placeholderEl = document.createElement("div"),
                                this.heightAutoObserverWrapperEl = document.createElement("div"),
                                this.heightAutoObserverEl = document.createElement("div"),
                                this.wrapperEl.classList.add(this.classNames.wrapper),
                                this.contentWrapperEl.classList.add(this.classNames.contentWrapper),
                                this.offsetEl.classList.add(this.classNames.offset),
                                this.maskEl.classList.add(this.classNames.mask),
                                this.contentEl.classList.add(this.classNames.contentEl),
                                this.placeholderEl.classList.add(this.classNames.placeholder),
                                this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl),
                                this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
                            this.el.firstChild;

                        )
                            this.contentEl.appendChild(this.el.firstChild);
                        this.contentWrapperEl.appendChild(this.contentEl),
                            this.offsetEl.appendChild(this.contentWrapperEl),
                            this.maskEl.appendChild(this.offsetEl),
                            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl),
                            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl),
                            this.wrapperEl.appendChild(this.maskEl),
                            this.wrapperEl.appendChild(this.placeholderEl),
                            this.el.appendChild(this.wrapperEl);
                    }
                    if (!this.axis.x.track.el || !this.axis.y.track.el) {
                        var t = document.createElement("div"),
                            i = document.createElement("div");
                        t.classList.add(this.classNames.track),
                            i.classList.add(this.classNames.scrollbar),
                            t.appendChild(i),
                            (this.axis.x.track.el = t.cloneNode(!0)),
                            this.axis.x.track.el.classList.add(this.classNames.horizontal),
                            (this.axis.y.track.el = t.cloneNode(!0)),
                            this.axis.y.track.el.classList.add(this.classNames.vertical),
                            this.el.appendChild(this.axis.x.track.el),
                            this.el.appendChild(this.axis.y.track.el);
                    }
                    (this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar)),
                        (this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar)),
                        this.options.autoHide || (this.axis.x.scrollbar.el.classList.add(this.classNames.visible), this.axis.y.scrollbar.el.classList.add(this.classNames.visible)),
                        this.el.setAttribute("data-simplebar", "init");
                }),
                (t.initListeners = function () {
                    var e = this;
                    this.options.autoHide && this.el.addEventListener("mouseenter", this.onMouseEnter),
                        ["mousedown", "click", "dblclick"].forEach(function (t) {
                            e.el.addEventListener(t, e.onPointerEvent, !0);
                        }),
                        ["touchstart", "touchend", "touchmove"].forEach(function (t) {
                            e.el.addEventListener(t, e.onPointerEvent, { capture: !0, passive: !0 });
                        }),
                        this.el.addEventListener("mousemove", this.onMouseMove),
                        this.el.addEventListener("mouseleave", this.onMouseLeave),
                        this.contentWrapperEl.addEventListener("scroll", this.onScroll),
                        window.addEventListener("resize", this.onWindowResize),
                        (this.resizeObserver = new ji(this.recalculate)),
                        this.resizeObserver.observe(this.el),
                        this.resizeObserver.observe(this.contentEl);
                }),
                (t.recalculate = function () {
                    var e = this.heightAutoObserverEl.offsetHeight <= 1,
                        t = this.heightAutoObserverEl.offsetWidth <= 1;
                    (this.elStyles = window.getComputedStyle(this.el)),
                        (this.isRtl = "rtl" === this.elStyles.direction),
                        (this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft),
                        (this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft),
                        (this.contentWrapperEl.style.height = e ? "auto" : "100%"),
                        (this.placeholderEl.style.width = t ? this.contentEl.offsetWidth + "px" : "auto"),
                        (this.placeholderEl.style.height = this.contentEl.scrollHeight + "px"),
                        (this.axis.x.isOverflowing = this.contentWrapperEl.scrollWidth > this.contentWrapperEl.offsetWidth),
                        (this.axis.y.isOverflowing = this.contentWrapperEl.scrollHeight > this.contentWrapperEl.offsetHeight),
                        (this.axis.x.isOverflowing = "hidden" !== this.elStyles.overflowX && this.axis.x.isOverflowing),
                        (this.axis.y.isOverflowing = "hidden" !== this.elStyles.overflowY && this.axis.y.isOverflowing),
                        (this.axis.x.forceVisible = "x" === this.options.forceVisible || !0 === this.options.forceVisible),
                        (this.axis.y.forceVisible = "y" === this.options.forceVisible || !0 === this.options.forceVisible),
                        this.hideNativeScrollbar(),
                        (this.axis.x.track.rect = this.axis.x.track.el.getBoundingClientRect()),
                        (this.axis.y.track.rect = this.axis.y.track.el.getBoundingClientRect()),
                        (this.axis.x.scrollbar.size = this.getScrollbarSize("x")),
                        (this.axis.y.scrollbar.size = this.getScrollbarSize("y")),
                        (this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px"),
                        (this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px"),
                        this.positionScrollbar("x"),
                        this.positionScrollbar("y"),
                        this.toggleTrackVisibility("x"),
                        this.toggleTrackVisibility("y");
                }),
                (t.getScrollbarSize = function (e) {
                    void 0 === e && (e = "y");
                    var t,
                        i = this.scrollbarWidth ? this.contentWrapperEl[this.axis[e].scrollSizeAttr] : this.contentWrapperEl[this.axis[e].scrollSizeAttr] - this.minScrollbarWidth,
                        n = this.axis[e].track.rect[this.axis[e].sizeAttr];
                    if (this.axis[e].isOverflowing) {
                        var o = n / i;
                        return (t = Math.max(~~(o * n), this.options.scrollbarMinSize)), this.options.scrollbarMaxSize && (t = Math.min(t, this.options.scrollbarMaxSize)), t;
                    }
                }),
                (t.positionScrollbar = function (t) {
                    void 0 === t && (t = "y");
                    var i = this.contentWrapperEl[this.axis[t].scrollSizeAttr],
                        n = this.axis[t].track.rect[this.axis[t].sizeAttr],
                        o = parseInt(this.elStyles[this.axis[t].sizeAttr], 10),
                        s = this.axis[t].scrollbar,
                        r = this.contentWrapperEl[this.axis[t].scrollOffsetAttr],
                        c = (r = "x" === t && this.isRtl && e.getRtlHelpers().isRtlScrollingInverted ? -r : r) / (i - o),
                        a = ~~((n - s.size) * c);
                    (a = "x" === t && this.isRtl && e.getRtlHelpers().isRtlScrollbarInverted ? a + (n - s.size) : a), (s.el.style.transform = "x" === t ? "translate3d(" + a + "px, 0, 0)" : "translate3d(0, " + a + "px, 0)");
                }),
                (t.toggleTrackVisibility = function (e) {
                    void 0 === e && (e = "y");
                    var t = this.axis[e].track.el,
                        i = this.axis[e].scrollbar.el;
                    this.axis[e].isOverflowing || this.axis[e].forceVisible
                        ? ((t.style.visibility = "visible"), (this.contentWrapperEl.style[this.axis[e].overflowAttr] = "scroll"))
                        : ((t.style.visibility = "hidden"), (this.contentWrapperEl.style[this.axis[e].overflowAttr] = "hidden")),
                        this.axis[e].isOverflowing ? (i.style.display = "block") : (i.style.display = "none");
                }),
                (t.hideNativeScrollbar = function () {
                    if (
                        ((this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + (this.scrollbarWidth || this.minScrollbarWidth) + "px" : 0),
                        (this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + (this.scrollbarWidth || this.minScrollbarWidth) + "px" : 0),
                        !this.scrollbarWidth)
                    ) {
                        var e = [this.isRtl ? "paddingLeft" : "paddingRight"];
                        (this.contentWrapperEl.style[e] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? this.minScrollbarWidth + "px" : 0),
                            (this.contentWrapperEl.style.paddingBottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? this.minScrollbarWidth + "px" : 0);
                    }
                }),
                (t.onMouseMoveForAxis = function (e) {
                    void 0 === e && (e = "y"),
                        (this.axis[e].track.rect = this.axis[e].track.el.getBoundingClientRect()),
                        (this.axis[e].scrollbar.rect = this.axis[e].scrollbar.el.getBoundingClientRect()),
                        this.isWithinBounds(this.axis[e].scrollbar.rect) ? this.axis[e].scrollbar.el.classList.add(this.classNames.hover) : this.axis[e].scrollbar.el.classList.remove(this.classNames.hover),
                        this.isWithinBounds(this.axis[e].track.rect) ? (this.showScrollbar(e), this.axis[e].track.el.classList.add(this.classNames.hover)) : this.axis[e].track.el.classList.remove(this.classNames.hover);
                }),
                (t.onMouseLeaveForAxis = function (e) {
                    void 0 === e && (e = "y"), this.axis[e].track.el.classList.remove(this.classNames.hover), this.axis[e].scrollbar.el.classList.remove(this.classNames.hover);
                }),
                (t.showScrollbar = function (e) {
                    void 0 === e && (e = "y");
                    var t = this.axis[e].scrollbar.el;
                    this.axis[e].isVisible || (t.classList.add(this.classNames.visible), (this.axis[e].isVisible = !0)), this.options.autoHide && this.hideScrollbars();
                }),
                (t.onDragStart = function (e, t) {
                    void 0 === t && (t = "y");
                    var i = this.axis[t].scrollbar.el,
                        n = "y" === t ? e.pageY : e.pageX;
                    (this.axis[t].dragOffset = n - i.getBoundingClientRect()[this.axis[t].offsetAttr]),
                        (this.draggedAxis = t),
                        this.el.classList.add(this.classNames.dragging),
                        document.addEventListener("mousemove", this.drag, !0),
                        document.addEventListener("mouseup", this.onEndDrag, !0),
                        null === this.removePreventClickId
                            ? (document.addEventListener("click", this.preventClick, !0), document.addEventListener("dblclick", this.preventClick, !0))
                            : (window.clearTimeout(this.removePreventClickId), (this.removePreventClickId = null));
                }),
                (t.getContentElement = function () {
                    return this.contentEl;
                }),
                (t.getScrollElement = function () {
                    return this.contentWrapperEl;
                }),
                (t.removeListeners = function () {
                    var e = this;
                    this.options.autoHide && this.el.removeEventListener("mouseenter", this.onMouseEnter),
                        ["mousedown", "click", "dblclick"].forEach(function (t) {
                            e.el.removeEventListener(t, e.onPointerEvent, !0);
                        }),
                        ["touchstart", "touchend", "touchmove"].forEach(function (t) {
                            e.el.removeEventListener(t, e.onPointerEvent, { capture: !0, passive: !0 });
                        }),
                        this.el.removeEventListener("mousemove", this.onMouseMove),
                        this.el.removeEventListener("mouseleave", this.onMouseLeave),
                        this.contentWrapperEl.removeEventListener("scroll", this.onScroll),
                        window.removeEventListener("resize", this.onWindowResize),
                        this.mutationObserver && this.mutationObserver.disconnect(),
                        this.resizeObserver.disconnect(),
                        this.recalculate.cancel(),
                        this.onMouseMove.cancel(),
                        this.hideScrollbars.cancel(),
                        this.onWindowResize.cancel();
                }),
                (t.unMount = function () {
                    this.removeListeners(), (this.el.SimpleBar = null);
                }),
                (t.isChildNode = function (e) {
                    return null !== e && (e === this.el || this.isChildNode(e.parentNode));
                }),
                (t.isWithinBounds = function (e) {
                    return this.mouseX >= e.left && this.mouseX <= e.left + e.width && this.mouseY >= e.top && this.mouseY <= e.top + e.height;
                }),
                e
            );
        })();
        return (
            (Ui.defaultOptions = {
                autoHide: !0,
                forceVisible: !1,
                classNames: {
                    contentEl: "simplebar-content",
                    contentWrapper: "simplebar-content-wrapper",
                    offset: "simplebar-offset",
                    mask: "simplebar-mask",
                    wrapper: "simplebar-wrapper",
                    placeholder: "simplebar-placeholder",
                    scrollbar: "simplebar-scrollbar",
                    track: "simplebar-track",
                    heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
                    heightAutoObserverEl: "simplebar-height-auto-observer",
                    visible: "simplebar-visible",
                    horizontal: "simplebar-horizontal",
                    vertical: "simplebar-vertical",
                    hover: "simplebar-hover",
                    dragging: "simplebar-dragging",
                },
                scrollbarMinSize: 25,
                scrollbarMaxSize: 0,
                timeout: 1e3,
            }),
            $i && Ui.initHtmlApi(),
            Ui
        );
    }),
    "object" == typeof navigator &&
        (function (e, t) {
            "object" == typeof exports && "undefined" != typeof module ? (module.exports = t()) : "function" == typeof define && define.amd ? define("Plyr", t) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Plyr = t());
        })(this, function () {
            "use strict";
            function e(e, t, i) {
                return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = i), e;
            }
            function t(e, t) {
                for (var i = 0; i < t.length; i++) {
                    var n = t[i];
                    (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            function i(e, t, i) {
                return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = i), e;
            }
            function n(e, t) {
                var i = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(e);
                    t &&
                        (n = n.filter(function (t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })),
                        i.push.apply(i, n);
                }
                return i;
            }
            function o(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var o = null != arguments[t] ? arguments[t] : {};
                    t % 2
                        ? n(Object(o), !0).forEach(function (t) {
                              i(e, t, o[t]);
                          })
                        : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o))
                        : n(Object(o)).forEach(function (t) {
                              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
                          });
                }
                return e;
            }
            var s = { addCSS: !0, thumbWidth: 15, watch: !0 };
            function r(e, t) {
                return function () {
                    return Array.from(document.querySelectorAll(t)).includes(this);
                }.call(e, t);
            }
            var c = function (e) {
                    return null != e ? e.constructor : null;
                },
                a = function (e, t) {
                    return !!(e && t && e instanceof t);
                },
                l = function (e) {
                    return c(e) === String;
                },
                u = function (e) {
                    return Array.isArray(e);
                },
                d = function (e) {
                    return a(e, NodeList);
                },
                p = l,
                h = u,
                f = d,
                M = function (e) {
                    return a(e, Element);
                },
                b = function (e) {
                    return a(e, Event);
                },
                m = function (e) {
                    return (
                        (function (e) {
                            return null == e;
                        })(e) ||
                        ((l(e) || u(e) || d(e)) && !e.length) ||
                        ((function (e) {
                            return c(e) === Object;
                        })(e) &&
                            !Object.keys(e).length)
                    );
                };
            var g = (function () {
                function e(t, i) {
                    (function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e),
                        M(t) ? (this.element = t) : p(t) && (this.element = document.querySelector(t)),
                        M(this.element) && m(this.element.rangeTouch) && ((this.config = o({}, s, {}, i)), this.init());
                }
                return (
                    (function (e, i, n) {
                        i && t(e.prototype, i), n && t(e, n);
                    })(
                        e,
                        [
                            {
                                key: "init",
                                value: function () {
                                    e.enabled &&
                                        (this.config.addCSS && ((this.element.style.userSelect = "none"), (this.element.style.webKitUserSelect = "none"), (this.element.style.touchAction = "manipulation")),
                                        this.listeners(!0),
                                        (this.element.rangeTouch = this));
                                },
                            },
                            {
                                key: "destroy",
                                value: function () {
                                    e.enabled &&
                                        (this.config.addCSS && ((this.element.style.userSelect = ""), (this.element.style.webKitUserSelect = ""), (this.element.style.touchAction = "")), this.listeners(!1), (this.element.rangeTouch = null));
                                },
                            },
                            {
                                key: "listeners",
                                value: function (e) {
                                    var t = this,
                                        i = e ? "addEventListener" : "removeEventListener";
                                    ["touchstart", "touchmove", "touchend"].forEach(function (e) {
                                        t.element[i](
                                            e,
                                            function (e) {
                                                return t.set(e);
                                            },
                                            !1
                                        );
                                    });
                                },
                            },
                            {
                                key: "get",
                                value: function (t) {
                                    if (!e.enabled || !b(t)) return null;
                                    var i,
                                        n = t.target,
                                        o = t.changedTouches[0],
                                        s = parseFloat(n.getAttribute("min")) || 0,
                                        r = parseFloat(n.getAttribute("max")) || 100,
                                        c = parseFloat(n.getAttribute("step")) || 1,
                                        a = n.getBoundingClientRect(),
                                        l = ((100 / a.width) * (this.config.thumbWidth / 2)) / 100;
                                    return (
                                        0 > (i = (100 / a.width) * (o.clientX - a.left)) ? (i = 0) : 100 < i && (i = 100),
                                        50 > i ? (i -= (100 - 2 * i) * l) : 50 < i && (i += 2 * (i - 50) * l),
                                        s +
                                            (function (e, t) {
                                                if (1 > t) {
                                                    var i = (function (e) {
                                                        var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                                                        return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
                                                    })(t);
                                                    return parseFloat(e.toFixed(i));
                                                }
                                                return Math.round(e / t) * t;
                                            })((i / 100) * (r - s), c)
                                    );
                                },
                            },
                            {
                                key: "set",
                                value: function (t) {
                                    e.enabled &&
                                        b(t) &&
                                        !t.target.disabled &&
                                        (t.preventDefault(),
                                        (t.target.value = this.get(t)),
                                        (function (e, t) {
                                            if (e && t) {
                                                var i = new Event(t, { bubbles: !0 });
                                                e.dispatchEvent(i);
                                            }
                                        })(t.target, "touchend" === t.type ? "change" : "input"));
                                },
                            },
                        ],
                        [
                            {
                                key: "setup",
                                value: function (t) {
                                    var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
                                        n = null;
                                    if ((m(t) || p(t) ? (n = Array.from(document.querySelectorAll(p(t) ? t : 'input[type="range"]'))) : M(t) ? (n = [t]) : f(t) ? (n = Array.from(t)) : h(t) && (n = t.filter(M)), m(n))) return null;
                                    var c = o({}, s, {}, i);
                                    if (p(t) && c.watch) {
                                        var a = new MutationObserver(function (i) {
                                            Array.from(i).forEach(function (i) {
                                                Array.from(i.addedNodes).forEach(function (i) {
                                                    M(i) && r(i, t) && new e(i, c);
                                                });
                                            });
                                        });
                                        a.observe(document.body, { childList: !0, subtree: !0 });
                                    }
                                    return n.map(function (t) {
                                        return new e(t, i);
                                    });
                                },
                            },
                            {
                                key: "enabled",
                                get: function () {
                                    return "ontouchstart" in document.documentElement;
                                },
                            },
                        ]
                    ),
                    e
                );
            })();
            const A = (e) => (null != e ? e.constructor : null),
                z = (e, t) => Boolean(e && t && e instanceof t),
                y = (e) => null == e,
                v = (e) => A(e) === Object,
                O = (e) => A(e) === String,
                L = (e) => A(e) === Function,
                T = (e) => Array.isArray(e),
                N = (e) => z(e, NodeList),
                q = (e) => y(e) || ((O(e) || T(e) || N(e)) && !e.length) || (v(e) && !Object.keys(e).length);
            var w = y,
                W = v,
                S = (e) => A(e) === Number && !Number.isNaN(e),
                C = O,
                k = (e) => A(e) === Boolean,
                B = L,
                E = T,
                X = N,
                x = (e) => null !== e && "object" == typeof e && 1 === e.nodeType && "object" == typeof e.style && "object" == typeof e.ownerDocument,
                _ = (e) => z(e, Event),
                D = (e) => z(e, KeyboardEvent),
                R = (e) => z(e, TextTrack) || (!y(e) && O(e.kind)),
                P = (e) => {
                    if (z(e, window.URL)) return !0;
                    if (!O(e)) return !1;
                    let t = e;
                    (e.startsWith("http://") && e.startsWith("https://")) || (t = `http://${e}`);
                    try {
                        return !q(new URL(t).hostname);
                    } catch (e) {
                        return !1;
                    }
                },
                I = q;
            const H = (() => {
                const e = document.createElement("span"),
                    t = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" },
                    i = Object.keys(t).find((t) => void 0 !== e.style[t]);
                return !!C(i) && t[i];
            })();
            function j(e, t) {
                setTimeout(() => {
                    try {
                        (e.hidden = !0), e.offsetHeight, (e.hidden = !1);
                    } catch (e) {}
                }, t);
            }
            const $ = {
                isIE: Boolean(window.document.documentMode),
                isEdge: window.navigator.userAgent.includes("Edge"),
                isWebkit: "WebkitAppearance" in document.documentElement.style && !/Edge/.test(navigator.userAgent),
                isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
                isIos: ("MacIntel" === navigator.platform && navigator.maxTouchPoints > 1) || /(iPad|iPhone|iPod)/gi.test(navigator.platform),
            };
            function F(e, t) {
                return t.split(".").reduce((e, t) => e && e[t], e);
            }
            function U(e = {}, ...t) {
                if (!t.length) return e;
                const i = t.shift();
                return W(i)
                    ? (Object.keys(i).forEach((t) => {
                          W(i[t]) ? (Object.keys(e).includes(t) || Object.assign(e, { [t]: {} }), U(e[t], i[t])) : Object.assign(e, { [t]: i[t] });
                      }),
                      U(e, ...t))
                    : e;
            }
            function V(e, t) {
                const i = e.length ? e : [e];
                Array.from(i)
                    .reverse()
                    .forEach((e, i) => {
                        const n = i > 0 ? t.cloneNode(!0) : t,
                            o = e.parentNode,
                            s = e.nextSibling;
                        n.appendChild(e), s ? o.insertBefore(n, s) : o.appendChild(n);
                    });
            }
            function Y(e, t) {
                x(e) &&
                    !I(t) &&
                    Object.entries(t)
                        .filter(([, e]) => !w(e))
                        .forEach(([t, i]) => e.setAttribute(t, i));
            }
            function G(e, t, i) {
                const n = document.createElement(e);
                return W(t) && Y(n, t), C(i) && (n.innerText = i), n;
            }
            function K(e, t, i, n) {
                x(t) && t.appendChild(G(e, i, n));
            }
            function Q(e) {
                X(e) || E(e) ? Array.from(e).forEach(Q) : x(e) && x(e.parentNode) && e.parentNode.removeChild(e);
            }
            function J(e) {
                if (!x(e)) return;
                let { length: t } = e.childNodes;
                for (; t > 0; ) e.removeChild(e.lastChild), (t -= 1);
            }
            function Z(e, t) {
                return x(t) && x(t.parentNode) && x(e) ? (t.parentNode.replaceChild(e, t), e) : null;
            }
            function ee(e, t) {
                if (!C(e) || I(e)) return {};
                const i = {},
                    n = U({}, t);
                return (
                    e.split(",").forEach((e) => {
                        const t = e.trim(),
                            o = t.replace(".", ""),
                            s = t.replace(/[[\]]/g, "").split("="),
                            [r] = s,
                            c = s.length > 1 ? s[1].replace(/["']/g, "") : "";
                        switch (t.charAt(0)) {
                            case ".":
                                C(n.class) ? (i.class = `${n.class} ${o}`) : (i.class = o);
                                break;
                            case "#":
                                i.id = t.replace("#", "");
                                break;
                            case "[":
                                i[r] = c;
                        }
                    }),
                    U(n, i)
                );
            }
            function te(e, t) {
                if (!x(e)) return;
                let i = t;
                k(i) || (i = !e.hidden), (e.hidden = i);
            }
            function ie(e, t, i) {
                if (X(e)) return Array.from(e).map((e) => ie(e, t, i));
                if (x(e)) {
                    let n = "toggle";
                    return void 0 !== i && (n = i ? "add" : "remove"), e.classList[n](t), e.classList.contains(t);
                }
                return !1;
            }
            function ne(e, t) {
                return x(e) && e.classList.contains(t);
            }
            function oe(e, t) {
                const { prototype: i } = Element;
                return (
                    i.matches ||
                    i.webkitMatchesSelector ||
                    i.mozMatchesSelector ||
                    i.msMatchesSelector ||
                    function () {
                        return Array.from(document.querySelectorAll(t)).includes(this);
                    }
                ).call(e, t);
            }
            function se(e) {
                return this.elements.container.querySelectorAll(e);
            }
            function re(e) {
                return this.elements.container.querySelector(e);
            }
            function ce(e = null, t = !1) {
                x(e) && (e.focus({ preventScroll: !0 }), t && ie(e, this.config.classNames.tabFocus));
            }
            const ae = { "audio/ogg": "vorbis", "audio/wav": "1", "video/webm": "vp8, vorbis", "video/mp4": "avc1.42E01E, mp4a.40.2", "video/ogg": "theora" },
                le = {
                    audio: "canPlayType" in document.createElement("audio"),
                    video: "canPlayType" in document.createElement("video"),
                    check(e, t, i) {
                        const n = $.isIPhone && i && le.playsinline,
                            o = le[e] || "html5" !== t;
                        return { api: o, ui: o && le.rangeInput && ("video" !== e || !$.isIPhone || n) };
                    },
                    pip: !($.isIPhone || (!B(G("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || G("video").disablePictureInPicture))),
                    airplay: B(window.WebKitPlaybackTargetAvailabilityEvent),
                    playsinline: "playsInline" in document.createElement("video"),
                    mime(e) {
                        if (I(e)) return !1;
                        const [t] = e.split("/");
                        let i = e;
                        if (!this.isHTML5 || t !== this.type) return !1;
                        Object.keys(ae).includes(i) && (i += `; codecs="${ae[e]}"`);
                        try {
                            return Boolean(i && this.media.canPlayType(i).replace(/no/, ""));
                        } catch (e) {
                            return !1;
                        }
                    },
                    textTracks: "textTracks" in document.createElement("video"),
                    rangeInput: (() => {
                        const e = document.createElement("input");
                        return (e.type = "range"), "range" === e.type;
                    })(),
                    touch: "ontouchstart" in document.documentElement,
                    transitions: !1 !== H,
                    reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches,
                },
                ue = (() => {
                    let e = !1;
                    try {
                        const t = Object.defineProperty({}, "passive", { get: () => ((e = !0), null) });
                        window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
                    } catch (e) {}
                    return e;
                })();
            function de(e, t, i, n = !1, o = !0, s = !1) {
                if (!e || !("addEventListener" in e) || I(t) || !B(i)) return;
                const r = t.split(" ");
                let c = s;
                ue && (c = { passive: o, capture: s }),
                    r.forEach((t) => {
                        this && this.eventListeners && n && this.eventListeners.push({ element: e, type: t, callback: i, options: c }), e[n ? "addEventListener" : "removeEventListener"](t, i, c);
                    });
            }
            function pe(e, t = "", i, n = !0, o = !1) {
                de.call(this, e, t, i, !0, n, o);
            }
            function he(e, t = "", i, n = !0, o = !1) {
                de.call(this, e, t, i, !1, n, o);
            }
            function fe(e, t = "", i, n = !0, o = !1) {
                const s = (...r) => {
                    he(e, t, s, n, o), i.apply(this, r);
                };
                de.call(this, e, t, s, !0, n, o);
            }
            function Me(e, t = "", i = !1, n = {}) {
                if (!x(e) || I(t)) return;
                const o = new CustomEvent(t, { bubbles: i, detail: { ...n, plyr: this } });
                e.dispatchEvent(o);
            }
            function be() {
                this &&
                    this.eventListeners &&
                    (this.eventListeners.forEach((e) => {
                        const { element: t, type: i, callback: n, options: o } = e;
                        t.removeEventListener(i, n, o);
                    }),
                    (this.eventListeners = []));
            }
            function me() {
                return new Promise((e) => (this.ready ? setTimeout(e, 0) : pe.call(this, this.elements.container, "ready", e))).then(() => {});
            }
            function ge(e) {
                ((e) => z(e, Promise) && L(e.then))(e) && e.then(null, () => {});
            }
            function Ae(e) {
                return E(e) ? e.filter((t, i) => e.indexOf(t) === i) : e;
            }
            function ze(e, t) {
                return E(e) && e.length ? e.reduce((e, i) => (Math.abs(i - t) < Math.abs(e - t) ? i : e)) : null;
            }
            function ye(e) {
                return !(!window || !window.CSS) && window.CSS.supports(e);
            }
            const ve = [
                [1, 1],
                [4, 3],
                [3, 4],
                [5, 4],
                [4, 5],
                [3, 2],
                [2, 3],
                [16, 10],
                [10, 16],
                [16, 9],
                [9, 16],
                [21, 9],
                [9, 21],
                [32, 9],
                [9, 32],
            ].reduce((e, [t, i]) => ({ ...e, [t / i]: [t, i] }), {});
            function Oe(e) {
                return !!(E(e) || (C(e) && e.includes(":"))) && (E(e) ? e : e.split(":")).map(Number).every(S);
            }
            function Le(e) {
                if (!E(e) || !e.every(S)) return null;
                const [t, i] = e,
                    n = (e, t) => (0 === t ? e : n(t, e % t)),
                    o = n(t, i);
                return [t / o, i / o];
            }
            function Te(e) {
                const t = (e) => (Oe(e) ? e.split(":").map(Number) : null);
                let i = t(e);
                if ((null === i && (i = t(this.config.ratio)), null === i && !I(this.embed) && E(this.embed.ratio) && ({ ratio: i } = this.embed), null === i && this.isHTML5)) {
                    const { videoWidth: e, videoHeight: t } = this.media;
                    i = [e, t];
                }
                return Le(i);
            }
            function Ne(e) {
                if (!this.isVideo) return {};
                const { wrapper: t } = this.elements,
                    i = Te.call(this, e);
                if (!E(i)) return {};
                const [n, o] = Le(i),
                    s = (100 / n) * o;
                if ((ye(`aspect-ratio: ${n}/${o}`) ? (t.style.aspectRatio = `${n}/${o}`) : (t.style.paddingBottom = `${s}%`), this.isVimeo && !this.config.vimeo.premium && this.supported.ui)) {
                    const e = (100 / this.media.offsetWidth) * parseInt(window.getComputedStyle(this.media).paddingBottom, 10),
                        i = (e - s) / (e / 50);
                    this.fullscreen.active ? (t.style.paddingBottom = null) : (this.media.style.transform = `translateY(-${i}%)`);
                } else this.isHTML5 && t.classList.add(this.config.classNames.videoFixedRatio);
                return { padding: s, ratio: i };
            }
            function qe(e, t, i = 0.05) {
                const n = e / t,
                    o = ze(Object.keys(ve), n);
                return Math.abs(o - n) <= i ? ve[o] : [e, t];
            }
            const we = {
                getSources() {
                    return this.isHTML5
                        ? Array.from(this.media.querySelectorAll("source")).filter((e) => {
                              const t = e.getAttribute("type");
                              return !!I(t) || le.mime.call(this, t);
                          })
                        : [];
                },
                getQualityOptions() {
                    return this.config.quality.forced
                        ? this.config.quality.options
                        : we.getSources
                              .call(this)
                              .map((e) => Number(e.getAttribute("size")))
                              .filter(Boolean);
                },
                setup() {
                    if (!this.isHTML5) return;
                    const e = this;
                    (e.options.speed = e.config.speed.options),
                        I(this.config.ratio) || Ne.call(e),
                        Object.defineProperty(e.media, "quality", {
                            get() {
                                const t = we.getSources.call(e).find((t) => t.getAttribute("src") === e.source);
                                return t && Number(t.getAttribute("size"));
                            },
                            set(t) {
                                if (e.quality !== t) {
                                    if (e.config.quality.forced && B(e.config.quality.onChange)) e.config.quality.onChange(t);
                                    else {
                                        const i = we.getSources.call(e).find((e) => Number(e.getAttribute("size")) === t);
                                        if (!i) return;
                                        const { currentTime: n, paused: o, preload: s, readyState: r, playbackRate: c } = e.media;
                                        (e.media.src = i.getAttribute("src")),
                                            ("none" !== s || r) &&
                                                (e.once("loadedmetadata", () => {
                                                    (e.speed = c), (e.currentTime = n), o || ge(e.play());
                                                }),
                                                e.media.load());
                                    }
                                    Me.call(e, e.media, "qualitychange", !1, { quality: t });
                                }
                            },
                        });
                },
                cancelRequests() {
                    this.isHTML5 && (Q(we.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
                },
            };
            function We(e, ...t) {
                return I(e) ? e : e.toString().replace(/{(\d+)}/g, (e, i) => t[i].toString());
            }
            const Se = (e = "", t = "", i = "") => e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i.toString()),
                Ce = (e = "") => e.toString().replace(/\w\S*/g, (e) => e.charAt(0).toUpperCase() + e.substr(1).toLowerCase());
            function ke(e) {
                const t = document.createElement("div");
                return t.appendChild(e), t.innerHTML;
            }
            const Be = { pip: "PIP", airplay: "AirPlay", html5: "HTML5", vimeo: "Vimeo", youtube: "YouTube" },
                Ee = {
                    get(e = "", t = {}) {
                        if (I(e) || I(t)) return "";
                        let i = F(t.i18n, e);
                        if (I(i)) return Object.keys(Be).includes(e) ? Be[e] : "";
                        const n = { "{seektime}": t.seekTime, "{title}": t.title };
                        return (
                            Object.entries(n).forEach(([e, t]) => {
                                i = Se(i, e, t);
                            }),
                            i
                        );
                    },
                };
            class Xe {
                constructor(t) {
                    e(this, "get", (e) => {
                        if (!Xe.supported || !this.enabled) return null;
                        const t = window.localStorage.getItem(this.key);
                        if (I(t)) return null;
                        const i = JSON.parse(t);
                        return C(e) && e.length ? i[e] : i;
                    }),
                        e(this, "set", (e) => {
                            if (!Xe.supported || !this.enabled) return;
                            if (!W(e)) return;
                            let t = this.get();
                            I(t) && (t = {}), U(t, e);
                            try {
                                window.localStorage.setItem(this.key, JSON.stringify(t));
                            } catch (e) {}
                        }),
                        (this.enabled = t.config.storage.enabled),
                        (this.key = t.config.storage.key);
                }
                static get supported() {
                    try {
                        if (!("localStorage" in window)) return !1;
                        const e = "___test";
                        return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
            }
            function xe(e, t = "text") {
                return new Promise((i, n) => {
                    try {
                        const n = new XMLHttpRequest();
                        if (!("withCredentials" in n)) return;
                        n.addEventListener("load", () => {
                            if ("text" === t)
                                try {
                                    i(JSON.parse(n.responseText));
                                } catch (e) {
                                    i(n.responseText);
                                }
                            else i(n.response);
                        }),
                            n.addEventListener("error", () => {
                                throw new Error(n.status);
                            }),
                            n.open("GET", e, !0),
                            (n.responseType = t),
                            n.send();
                    } catch (e) {
                        n(e);
                    }
                });
            }
            function _e(e, t) {
                if (!C(e)) return;
                const i = C(t);
                let n = !1;
                const o = () => null !== document.getElementById(t),
                    s = (e, t) => {
                        (e.innerHTML = t), (i && o()) || document.body.insertAdjacentElement("afterbegin", e);
                    };
                if (!i || !o()) {
                    const o = Xe.supported,
                        r = document.createElement("div");
                    if ((r.setAttribute("hidden", ""), i && r.setAttribute("id", t), o)) {
                        const e = window.localStorage.getItem(`cache-${t}`);
                        if (((n = null !== e), n)) {
                            const t = JSON.parse(e);
                            s(r, t.content);
                        }
                    }
                    xe(e)
                        .then((e) => {
                            if (!I(e)) {
                                if (o)
                                    try {
                                        window.localStorage.setItem(`cache-${t}`, JSON.stringify({ content: e }));
                                    } catch (e) {}
                                s(r, e);
                            }
                        })
                        .catch(() => {});
                }
            }
            const De = (e) => Math.trunc((e / 60 / 60) % 60, 10);
            function Re(e = 0, t = !1, i = !1) {
                if (!S(e)) return Re(void 0, t, i);
                const n = (e) => `0${e}`.slice(-2);
                let o = De(e);
                const s = ((r = e), Math.trunc((r / 60) % 60, 10));
                var r;
                const c = ((e) => Math.trunc(e % 60, 10))(e);
                return (o = t || o > 0 ? `${o}:` : ""), `${i && e > 0 ? "-" : ""}${o}${n(s)}:${n(c)}`;
            }
            const Pe = {
                getIconUrl() {
                    const e = new URL(this.config.iconUrl, window.location),
                        t = window.location.host ? window.location.host : window.top.location.host,
                        i = e.host !== t || ($.isIE && !window.svg4everybody);
                    return { url: this.config.iconUrl, cors: i };
                },
                findElements() {
                    try {
                        return (
                            (this.elements.controls = re.call(this, this.config.selectors.controls.wrapper)),
                            (this.elements.buttons = {
                                play: se.call(this, this.config.selectors.buttons.play),
                                pause: re.call(this, this.config.selectors.buttons.pause),
                                restart: re.call(this, this.config.selectors.buttons.restart),
                                rewind: re.call(this, this.config.selectors.buttons.rewind),
                                fastForward: re.call(this, this.config.selectors.buttons.fastForward),
                                mute: re.call(this, this.config.selectors.buttons.mute),
                                pip: re.call(this, this.config.selectors.buttons.pip),
                                airplay: re.call(this, this.config.selectors.buttons.airplay),
                                settings: re.call(this, this.config.selectors.buttons.settings),
                                captions: re.call(this, this.config.selectors.buttons.captions),
                                fullscreen: re.call(this, this.config.selectors.buttons.fullscreen),
                            }),
                            (this.elements.progress = re.call(this, this.config.selectors.progress)),
                            (this.elements.inputs = { seek: re.call(this, this.config.selectors.inputs.seek), volume: re.call(this, this.config.selectors.inputs.volume) }),
                            (this.elements.display = {
                                buffer: re.call(this, this.config.selectors.display.buffer),
                                currentTime: re.call(this, this.config.selectors.display.currentTime),
                                duration: re.call(this, this.config.selectors.display.duration),
                            }),
                            x(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)),
                            !0
                        );
                    } catch (e) {
                        return this.debug.warn("It looks like there is a problem with your custom controls HTML", e), this.toggleNativeControls(!0), !1;
                    }
                },
                createIcon(e, t) {
                    const i = "http://www.w3.org/2000/svg",
                        n = Pe.getIconUrl.call(this),
                        o = `${n.cors ? "" : n.url}#${this.config.iconPrefix}`,
                        s = document.createElementNS(i, "svg");
                    Y(s, U(t, { "aria-hidden": "true", focusable: "false" }));
                    const r = document.createElementNS(i, "use"),
                        c = `${o}-${e}`;
                    return "href" in r && r.setAttributeNS("http://www.w3.org/1999/xlink", "href", c), r.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", c), s.appendChild(r), s;
                },
                createLabel(e, t = {}) {
                    const i = Ee.get(e, this.config);
                    return G("span", { ...t, class: [t.class, this.config.classNames.hidden].filter(Boolean).join(" ") }, i);
                },
                createBadge(e) {
                    if (I(e)) return null;
                    const t = G("span", { class: this.config.classNames.menu.value });
                    return t.appendChild(G("span", { class: this.config.classNames.menu.badge }, e)), t;
                },
                createButton(e, t) {
                    const i = U({}, t);
                    let n = (function (e = "") {
                        let t = e.toString();
                        return (
                            (t = (function (e = "") {
                                let t = e.toString();
                                return (t = Se(t, "-", " ")), (t = Se(t, "_", " ")), (t = Ce(t)), Se(t, " ", "");
                            })(t)),
                            t.charAt(0).toLowerCase() + t.slice(1)
                        );
                    })(e);
                    const o = { element: "button", toggle: !1, label: null, icon: null, labelPressed: null, iconPressed: null };
                    switch (
                        (["element", "icon", "label"].forEach((e) => {
                            Object.keys(i).includes(e) && ((o[e] = i[e]), delete i[e]);
                        }),
                        "button" !== o.element || Object.keys(i).includes("type") || (i.type = "button"),
                        Object.keys(i).includes("class") ? i.class.split(" ").some((e) => e === this.config.classNames.control) || U(i, { class: `${i.class} ${this.config.classNames.control}` }) : (i.class = this.config.classNames.control),
                        e)
                    ) {
                        case "play":
                            (o.toggle = !0), (o.label = "play"), (o.labelPressed = "pause"), (o.icon = "play"), (o.iconPressed = "pause");
                            break;
                        case "mute":
                            (o.toggle = !0), (o.label = "mute"), (o.labelPressed = "unmute"), (o.icon = "volume"), (o.iconPressed = "muted");
                            break;
                        case "captions":
                            (o.toggle = !0), (o.label = "enableCaptions"), (o.labelPressed = "disableCaptions"), (o.icon = "captions-off"), (o.iconPressed = "captions-on");
                            break;
                        case "fullscreen":
                            (o.toggle = !0), (o.label = "enterFullscreen"), (o.labelPressed = "exitFullscreen"), (o.icon = "enter-fullscreen"), (o.iconPressed = "exit-fullscreen");
                            break;
                        case "play-large":
                            (i.class += ` ${this.config.classNames.control}--overlaid`), (n = "play"), (o.label = "play"), (o.icon = "play");
                            break;
                        default:
                            I(o.label) && (o.label = n), I(o.icon) && (o.icon = e);
                    }
                    const s = G(o.element);
                    return (
                        o.toggle
                            ? (s.appendChild(Pe.createIcon.call(this, o.iconPressed, { class: "icon--pressed" })),
                              s.appendChild(Pe.createIcon.call(this, o.icon, { class: "icon--not-pressed" })),
                              s.appendChild(Pe.createLabel.call(this, o.labelPressed, { class: "label--pressed" })),
                              s.appendChild(Pe.createLabel.call(this, o.label, { class: "label--not-pressed" })))
                            : (s.appendChild(Pe.createIcon.call(this, o.icon)), s.appendChild(Pe.createLabel.call(this, o.label))),
                        U(i, ee(this.config.selectors.buttons[n], i)),
                        Y(s, i),
                        "play" === n ? (E(this.elements.buttons[n]) || (this.elements.buttons[n] = []), this.elements.buttons[n].push(s)) : (this.elements.buttons[n] = s),
                        s
                    );
                },
                createRange(e, t) {
                    const i = G(
                        "input",
                        U(
                            ee(this.config.selectors.inputs[e]),
                            { type: "range", min: 0, max: 100, step: 0.01, value: 0, autocomplete: "off", role: "slider", "aria-label": Ee.get(e, this.config), "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": 0 },
                            t
                        )
                    );
                    return (this.elements.inputs[e] = i), Pe.updateRangeFill.call(this, i), g.setup(i), i;
                },
                createProgress(e, t) {
                    const i = G("progress", U(ee(this.config.selectors.display[e]), { min: 0, max: 100, value: 0, role: "progressbar", "aria-hidden": !0 }, t));
                    if ("volume" !== e) {
                        i.appendChild(G("span", null, "0"));
                        const t = { played: "played", buffer: "buffered" }[e],
                            n = t ? Ee.get(t, this.config) : "";
                        i.innerText = `% ${n.toLowerCase()}`;
                    }
                    return (this.elements.display[e] = i), i;
                },
                createTime(e, t) {
                    const i = ee(this.config.selectors.display[e], t),
                        n = G("div", U(i, { class: `${i.class ? i.class : ""} ${this.config.classNames.display.time} `.trim(), "aria-label": Ee.get(e, this.config) }), "00:00");
                    return (this.elements.display[e] = n), n;
                },
                bindMenuItemShortcuts(e, t) {
                    pe.call(
                        this,
                        e,
                        "keydown keyup",
                        (i) => {
                            if (![32, 38, 39, 40].includes(i.which)) return;
                            if ((i.preventDefault(), i.stopPropagation(), "keydown" === i.type)) return;
                            const n = oe(e, '[role="menuitemradio"]');
                            if (!n && [32, 39].includes(i.which)) Pe.showMenuPanel.call(this, t, !0);
                            else {
                                let t;
                                32 !== i.which &&
                                    (40 === i.which || (n && 39 === i.which) ? ((t = e.nextElementSibling), x(t) || (t = e.parentNode.firstElementChild)) : ((t = e.previousElementSibling), x(t) || (t = e.parentNode.lastElementChild)),
                                    ce.call(this, t, !0));
                            }
                        },
                        !1
                    ),
                        pe.call(this, e, "keyup", (e) => {
                            13 === e.which && Pe.focusFirstMenuItem.call(this, null, !0);
                        });
                },
                createMenuItem({ value: e, list: t, type: i, title: n, badge: o = null, checked: s = !1 }) {
                    const r = ee(this.config.selectors.inputs[i]),
                        c = G("button", U(r, { type: "button", role: "menuitemradio", class: `${this.config.classNames.control} ${r.class ? r.class : ""}`.trim(), "aria-checked": s, value: e })),
                        a = G("span");
                    (a.innerHTML = n),
                        x(o) && a.appendChild(o),
                        c.appendChild(a),
                        Object.defineProperty(c, "checked", {
                            enumerable: !0,
                            get: () => "true" === c.getAttribute("aria-checked"),
                            set(e) {
                                e &&
                                    Array.from(c.parentNode.children)
                                        .filter((e) => oe(e, '[role="menuitemradio"]'))
                                        .forEach((e) => e.setAttribute("aria-checked", "false")),
                                    c.setAttribute("aria-checked", e ? "true" : "false");
                            },
                        }),
                        this.listeners.bind(
                            c,
                            "click keyup",
                            (t) => {
                                if (!D(t) || 32 === t.which) {
                                    switch ((t.preventDefault(), t.stopPropagation(), (c.checked = !0), i)) {
                                        case "language":
                                            this.currentTrack = Number(e);
                                            break;
                                        case "quality":
                                            this.quality = e;
                                            break;
                                        case "speed":
                                            this.speed = parseFloat(e);
                                    }
                                    Pe.showMenuPanel.call(this, "home", D(t));
                                }
                            },
                            i,
                            !1
                        ),
                        Pe.bindMenuItemShortcuts.call(this, c, i),
                        t.appendChild(c);
                },
                formatTime(e = 0, t = !1) {
                    return S(e) ? Re(e, De(this.duration) > 0, t) : e;
                },
                updateTimeDisplay(e = null, t = 0, i = !1) {
                    x(e) && S(t) && (e.innerText = Pe.formatTime(t, i));
                },
                updateVolume() {
                    this.supported.ui &&
                        (x(this.elements.inputs.volume) && Pe.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume),
                        x(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume));
                },
                setRange(e, t = 0) {
                    x(e) && ((e.value = t), Pe.updateRangeFill.call(this, e));
                },
                updateProgress(e) {
                    if (!this.supported.ui || !_(e)) return;
                    let t = 0;
                    const i = (e, t) => {
                        const i = S(t) ? t : 0,
                            n = x(e) ? e : this.elements.display.buffer;
                        if (x(n)) {
                            n.value = i;
                            const e = n.getElementsByTagName("span")[0];
                            x(e) && (e.childNodes[0].nodeValue = i);
                        }
                    };
                    if (e)
                        switch (e.type) {
                            case "timeupdate":
                            case "seeking":
                            case "seeked":
                                (n = this.currentTime),
                                    (o = this.duration),
                                    (t = 0 === n || 0 === o || Number.isNaN(n) || Number.isNaN(o) ? 0 : ((n / o) * 100).toFixed(2)),
                                    "timeupdate" === e.type && Pe.setRange.call(this, this.elements.inputs.seek, t);
                                break;
                            case "playing":
                            case "progress":
                                i(this.elements.display.buffer, 100 * this.buffered);
                        }
                    var n, o;
                },
                updateRangeFill(e) {
                    const t = _(e) ? e.target : e;
                    if (x(t) && "range" === t.getAttribute("type")) {
                        if (oe(t, this.config.selectors.inputs.seek)) {
                            t.setAttribute("aria-valuenow", this.currentTime);
                            const e = Pe.formatTime(this.currentTime),
                                i = Pe.formatTime(this.duration),
                                n = Ee.get("seekLabel", this.config);
                            t.setAttribute("aria-valuetext", n.replace("{currentTime}", e).replace("{duration}", i));
                        } else if (oe(t, this.config.selectors.inputs.volume)) {
                            const e = 100 * t.value;
                            t.setAttribute("aria-valuenow", e), t.setAttribute("aria-valuetext", `${e.toFixed(1)}%`);
                        } else t.setAttribute("aria-valuenow", t.value);
                        $.isWebkit && t.style.setProperty("--value", (t.value / t.max) * 100 + "%");
                    }
                },
                updateSeekTooltip(e) {
                    if (!this.config.tooltips.seek || !x(this.elements.inputs.seek) || !x(this.elements.display.seekTooltip) || 0 === this.duration) return;
                    const t = `${this.config.classNames.tooltip}--visible`,
                        i = (e) => ie(this.elements.display.seekTooltip, t, e);
                    if (this.touch) return void i(!1);
                    let n = 0;
                    const o = this.elements.progress.getBoundingClientRect();
                    if (_(e)) n = (100 / o.width) * (e.pageX - o.left);
                    else {
                        if (!ne(this.elements.display.seekTooltip, t)) return;
                        n = parseFloat(this.elements.display.seekTooltip.style.left, 10);
                    }
                    n < 0 ? (n = 0) : n > 100 && (n = 100),
                        Pe.updateTimeDisplay.call(this, this.elements.display.seekTooltip, (this.duration / 100) * n),
                        (this.elements.display.seekTooltip.style.left = `${n}%`),
                        _(e) && ["mouseenter", "mouseleave"].includes(e.type) && i("mouseenter" === e.type);
                },
                timeUpdate(e) {
                    const t = !x(this.elements.display.duration) && this.config.invertTime;
                    Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, t ? this.duration - this.currentTime : this.currentTime, t), (e && "timeupdate" === e.type && this.media.seeking) || Pe.updateProgress.call(this, e);
                },
                durationUpdate() {
                    if (!this.supported.ui || (!this.config.invertTime && this.currentTime)) return;
                    if (this.duration >= 2 ** 32) return te(this.elements.display.currentTime, !0), void te(this.elements.progress, !0);
                    x(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
                    const e = x(this.elements.display.duration);
                    !e && this.config.displayDuration && this.paused && Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration),
                        e && Pe.updateTimeDisplay.call(this, this.elements.display.duration, this.duration),
                        Pe.updateSeekTooltip.call(this);
                },
                toggleMenuButton(e, t) {
                    te(this.elements.settings.buttons[e], !t);
                },
                updateSetting(e, t, i) {
                    const n = this.elements.settings.panels[e];
                    let o = null,
                        s = t;
                    if ("captions" === e) o = this.currentTrack;
                    else {
                        if (((o = I(i) ? this[e] : i), I(o) && (o = this.config[e].default), !I(this.options[e]) && !this.options[e].includes(o))) return void this.debug.warn(`Unsupported value of '${o}' for ${e}`);
                        if (!this.config[e].options.includes(o)) return void this.debug.warn(`Disabled value of '${o}' for ${e}`);
                    }
                    if ((x(s) || (s = n && n.querySelector('[role="menu"]')), !x(s))) return;
                    this.elements.settings.buttons[e].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = Pe.getLabel.call(this, e, o);
                    const r = s && s.querySelector(`[value="${o}"]`);
                    x(r) && (r.checked = !0);
                },
                getLabel(e, t) {
                    switch (e) {
                        case "speed":
                            return 1 === t ? Ee.get("normal", this.config) : `${t}&times;`;
                        case "quality":
                            if (S(t)) {
                                const e = Ee.get(`qualityLabel.${t}`, this.config);
                                return e.length ? e : `${t}p`;
                            }
                            return Ce(t);
                        case "captions":
                            return je.getLabel.call(this);
                        default:
                            return null;
                    }
                },
                setQualityMenu(e) {
                    if (!x(this.elements.settings.panels.quality)) return;
                    const t = "quality",
                        i = this.elements.settings.panels.quality.querySelector('[role="menu"]');
                    E(e) && (this.options.quality = Ae(e).filter((e) => this.config.quality.options.includes(e)));
                    const n = !I(this.options.quality) && this.options.quality.length > 1;
                    if ((Pe.toggleMenuButton.call(this, t, n), J(i), Pe.checkMenu.call(this), !n)) return;
                    const o = (e) => {
                        const t = Ee.get(`qualityBadge.${e}`, this.config);
                        return t.length ? Pe.createBadge.call(this, t) : null;
                    };
                    this.options.quality
                        .sort((e, t) => {
                            const i = this.config.quality.options;
                            return i.indexOf(e) > i.indexOf(t) ? 1 : -1;
                        })
                        .forEach((e) => {
                            Pe.createMenuItem.call(this, { value: e, list: i, type: t, title: Pe.getLabel.call(this, "quality", e), badge: o(e) });
                        }),
                        Pe.updateSetting.call(this, t, i);
                },
                setCaptionsMenu() {
                    if (!x(this.elements.settings.panels.captions)) return;
                    const e = "captions",
                        t = this.elements.settings.panels.captions.querySelector('[role="menu"]'),
                        i = je.getTracks.call(this),
                        n = Boolean(i.length);
                    if ((Pe.toggleMenuButton.call(this, e, n), J(t), Pe.checkMenu.call(this), !n)) return;
                    const o = i.map((e, i) => ({
                        value: i,
                        checked: this.captions.toggled && this.currentTrack === i,
                        title: je.getLabel.call(this, e),
                        badge: e.language && Pe.createBadge.call(this, e.language.toUpperCase()),
                        list: t,
                        type: "language",
                    }));
                    o.unshift({ value: -1, checked: !this.captions.toggled, title: Ee.get("disabled", this.config), list: t, type: "language" }), o.forEach(Pe.createMenuItem.bind(this)), Pe.updateSetting.call(this, e, t);
                },
                setSpeedMenu() {
                    if (!x(this.elements.settings.panels.speed)) return;
                    const e = "speed",
                        t = this.elements.settings.panels.speed.querySelector('[role="menu"]');
                    this.options.speed = this.options.speed.filter((e) => e >= this.minimumSpeed && e <= this.maximumSpeed);
                    const i = !I(this.options.speed) && this.options.speed.length > 1;
                    Pe.toggleMenuButton.call(this, e, i),
                        J(t),
                        Pe.checkMenu.call(this),
                        i &&
                            (this.options.speed.forEach((i) => {
                                Pe.createMenuItem.call(this, { value: i, list: t, type: e, title: Pe.getLabel.call(this, "speed", i) });
                            }),
                            Pe.updateSetting.call(this, e, t));
                },
                checkMenu() {
                    const { buttons: e } = this.elements.settings,
                        t = !I(e) && Object.values(e).some((e) => !e.hidden);
                    te(this.elements.settings.menu, !t);
                },
                focusFirstMenuItem(e, t = !1) {
                    if (this.elements.settings.popup.hidden) return;
                    let i = e;
                    x(i) || (i = Object.values(this.elements.settings.panels).find((e) => !e.hidden));
                    const n = i.querySelector('[role^="menuitem"]');
                    ce.call(this, n, t);
                },
                toggleMenu(e) {
                    const { popup: t } = this.elements.settings,
                        i = this.elements.buttons.settings;
                    if (!x(t) || !x(i)) return;
                    const { hidden: n } = t;
                    let o = n;
                    if (k(e)) o = e;
                    else if (D(e) && 27 === e.which) o = !1;
                    else if (_(e)) {
                        const n = B(e.composedPath) ? e.composedPath()[0] : e.target,
                            s = t.contains(n);
                        if (s || (!s && e.target !== i && o)) return;
                    }
                    i.setAttribute("aria-expanded", o), te(t, !o), ie(this.elements.container, this.config.classNames.menu.open, o), o && D(e) ? Pe.focusFirstMenuItem.call(this, null, !0) : o || n || ce.call(this, i, D(e));
                },
                getMenuSize(e) {
                    const t = e.cloneNode(!0);
                    (t.style.position = "absolute"), (t.style.opacity = 0), t.removeAttribute("hidden"), e.parentNode.appendChild(t);
                    const i = t.scrollWidth,
                        n = t.scrollHeight;
                    return Q(t), { width: i, height: n };
                },
                showMenuPanel(e = "", t = !1) {
                    const i = this.elements.container.querySelector(`#plyr-settings-${this.id}-${e}`);
                    if (!x(i)) return;
                    const n = i.parentNode,
                        o = Array.from(n.children).find((e) => !e.hidden);
                    if (le.transitions && !le.reducedMotion) {
                        (n.style.width = `${o.scrollWidth}px`), (n.style.height = `${o.scrollHeight}px`);
                        const e = Pe.getMenuSize.call(this, i),
                            t = (e) => {
                                e.target === n && ["width", "height"].includes(e.propertyName) && ((n.style.width = ""), (n.style.height = ""), he.call(this, n, H, t));
                            };
                        pe.call(this, n, H, t), (n.style.width = `${e.width}px`), (n.style.height = `${e.height}px`);
                    }
                    te(o, !0), te(i, !1), Pe.focusFirstMenuItem.call(this, i, t);
                },
                setDownloadUrl() {
                    const e = this.elements.buttons.download;
                    x(e) && e.setAttribute("href", this.download);
                },
                create(e) {
                    const { bindMenuItemShortcuts: t, createButton: i, createProgress: n, createRange: o, createTime: s, setQualityMenu: r, setSpeedMenu: c, showMenuPanel: a } = Pe;
                    (this.elements.controls = null), E(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i.call(this, "play-large"));
                    const l = G("div", ee(this.config.selectors.controls.wrapper));
                    this.elements.controls = l;
                    const u = { class: "plyr__controls__item" };
                    return (
                        Ae(E(this.config.controls) ? this.config.controls : []).forEach((r) => {
                            if (
                                ("restart" === r && l.appendChild(i.call(this, "restart", u)),
                                "rewind" === r && l.appendChild(i.call(this, "rewind", u)),
                                "play" === r && l.appendChild(i.call(this, "play", u)),
                                "fast-forward" === r && l.appendChild(i.call(this, "fast-forward", u)),
                                "progress" === r)
                            ) {
                                const t = G("div", { class: `${u.class} plyr__progress__container` }),
                                    i = G("div", ee(this.config.selectors.progress));
                                if ((i.appendChild(o.call(this, "seek", { id: `plyr-seek-${e.id}` })), i.appendChild(n.call(this, "buffer")), this.config.tooltips.seek)) {
                                    const e = G("span", { class: this.config.classNames.tooltip }, "00:00");
                                    i.appendChild(e), (this.elements.display.seekTooltip = e);
                                }
                                (this.elements.progress = i), t.appendChild(this.elements.progress), l.appendChild(t);
                            }
                            if (("current-time" === r && l.appendChild(s.call(this, "currentTime", u)), "duration" === r && l.appendChild(s.call(this, "duration", u)), "mute" === r || "volume" === r)) {
                                let { volume: t } = this.elements;
                                if (
                                    ((x(t) && l.contains(t)) || ((t = G("div", U({}, u, { class: `${u.class} plyr__volume`.trim() }))), (this.elements.volume = t), l.appendChild(t)),
                                    "mute" === r && t.appendChild(i.call(this, "mute")),
                                    "volume" === r && !$.isIos)
                                ) {
                                    const i = { max: 1, step: 0.05, value: this.config.volume };
                                    t.appendChild(o.call(this, "volume", U(i, { id: `plyr-volume-${e.id}` })));
                                }
                            }
                            if (("captions" === r && l.appendChild(i.call(this, "captions", u)), "settings" === r && !I(this.config.settings))) {
                                const n = G("div", U({}, u, { class: `${u.class} plyr__menu`.trim(), hidden: "" }));
                                n.appendChild(i.call(this, "settings", { "aria-haspopup": !0, "aria-controls": `plyr-settings-${e.id}`, "aria-expanded": !1 }));
                                const o = G("div", { class: "plyr__menu__container", id: `plyr-settings-${e.id}`, hidden: "" }),
                                    s = G("div"),
                                    r = G("div", { id: `plyr-settings-${e.id}-home` }),
                                    c = G("div", { role: "menu" });
                                r.appendChild(c),
                                    s.appendChild(r),
                                    (this.elements.settings.panels.home = r),
                                    this.config.settings.forEach((i) => {
                                        const n = G(
                                            "button",
                                            U(ee(this.config.selectors.buttons.settings), {
                                                type: "button",
                                                class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                                                role: "menuitem",
                                                "aria-haspopup": !0,
                                                hidden: "",
                                            })
                                        );
                                        t.call(this, n, i),
                                            pe.call(this, n, "click", () => {
                                                a.call(this, i, !1);
                                            });
                                        const o = G("span", null, Ee.get(i, this.config)),
                                            r = G("span", { class: this.config.classNames.menu.value });
                                        (r.innerHTML = e[i]), o.appendChild(r), n.appendChild(o), c.appendChild(n);
                                        const l = G("div", { id: `plyr-settings-${e.id}-${i}`, hidden: "" }),
                                            u = G("button", { type: "button", class: `${this.config.classNames.control} ${this.config.classNames.control}--back` });
                                        u.appendChild(G("span", { "aria-hidden": !0 }, Ee.get(i, this.config))),
                                            u.appendChild(G("span", { class: this.config.classNames.hidden }, Ee.get("menuBack", this.config))),
                                            pe.call(
                                                this,
                                                l,
                                                "keydown",
                                                (e) => {
                                                    37 === e.which && (e.preventDefault(), e.stopPropagation(), a.call(this, "home", !0));
                                                },
                                                !1
                                            ),
                                            pe.call(this, u, "click", () => {
                                                a.call(this, "home", !1);
                                            }),
                                            l.appendChild(u),
                                            l.appendChild(G("div", { role: "menu" })),
                                            s.appendChild(l),
                                            (this.elements.settings.buttons[i] = n),
                                            (this.elements.settings.panels[i] = l);
                                    }),
                                    o.appendChild(s),
                                    n.appendChild(o),
                                    l.appendChild(n),
                                    (this.elements.settings.popup = o),
                                    (this.elements.settings.menu = n);
                            }
                            if (("pip" === r && le.pip && l.appendChild(i.call(this, "pip", u)), "airplay" === r && le.airplay && l.appendChild(i.call(this, "airplay", u)), "download" === r)) {
                                const e = U({}, u, { element: "a", href: this.download, target: "_blank" });
                                this.isHTML5 && (e.download = "");
                                const { download: t } = this.config.urls;
                                !P(t) && this.isEmbed && U(e, { icon: `logo-${this.provider}`, label: this.provider }), l.appendChild(i.call(this, "download", e));
                            }
                            "fullscreen" === r && l.appendChild(i.call(this, "fullscreen", u));
                        }),
                        this.isHTML5 && r.call(this, we.getQualityOptions.call(this)),
                        c.call(this),
                        l
                    );
                },
                inject() {
                    if (this.config.loadSprite) {
                        const e = Pe.getIconUrl.call(this);
                        e.cors && _e(e.url, "sprite-plyr");
                    }
                    this.id = Math.floor(1e4 * Math.random());
                    let e = null;
                    this.elements.controls = null;
                    const t = { id: this.id, seektime: this.config.seekTime, title: this.config.title };
                    let i,
                        n = !0;
                    if (
                        (B(this.config.controls) && (this.config.controls = this.config.controls.call(this, t)),
                        this.config.controls || (this.config.controls = []),
                        x(this.config.controls) || C(this.config.controls)
                            ? (e = this.config.controls)
                            : ((e = Pe.create.call(this, { id: this.id, seektime: this.config.seekTime, speed: this.speed, quality: this.quality, captions: je.getLabel.call(this) })), (n = !1)),
                        n &&
                            C(this.config.controls) &&
                            (e = ((e) => {
                                let i = e;
                                return (
                                    Object.entries(t).forEach(([e, t]) => {
                                        i = Se(i, `{${e}}`, t);
                                    }),
                                    i
                                );
                            })(e)),
                        C(this.config.selectors.controls.container) && (i = document.querySelector(this.config.selectors.controls.container)),
                        x(i) || (i = this.elements.container),
                        i[x(e) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", e),
                        x(this.elements.controls) || Pe.findElements.call(this),
                        !I(this.elements.buttons))
                    ) {
                        const e = (e) => {
                            const t = this.config.classNames.controlPressed;
                            Object.defineProperty(e, "pressed", {
                                enumerable: !0,
                                get: () => ne(e, t),
                                set(i = !1) {
                                    ie(e, t, i);
                                },
                            });
                        };
                        Object.values(this.elements.buttons)
                            .filter(Boolean)
                            .forEach((t) => {
                                E(t) || X(t) ? Array.from(t).filter(Boolean).forEach(e) : e(t);
                            });
                    }
                    if (($.isEdge && j(i), this.config.tooltips.controls)) {
                        const { classNames: e, selectors: t } = this.config,
                            i = `${t.controls.wrapper} ${t.labels} .${e.hidden}`,
                            n = se.call(this, i);
                        Array.from(n).forEach((e) => {
                            ie(e, this.config.classNames.hidden, !1), ie(e, this.config.classNames.tooltip, !0);
                        });
                    }
                },
            };
            function Ie(e, t = !0) {
                let i = e;
                if (t) {
                    const e = document.createElement("a");
                    (e.href = i), (i = e.href);
                }
                try {
                    return new URL(i);
                } catch (e) {
                    return null;
                }
            }
            function He(e) {
                const t = new URLSearchParams();
                return (
                    W(e) &&
                        Object.entries(e).forEach(([e, i]) => {
                            t.set(e, i);
                        }),
                    t
                );
            }
            const je = {
                    setup() {
                        if (!this.supported.ui) return;
                        if (!this.isVideo || this.isYouTube || (this.isHTML5 && !le.textTracks))
                            return void (E(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this));
                        var e, t;
                        if (
                            (x(this.elements.captions) ||
                                ((this.elements.captions = G("div", ee(this.config.selectors.captions))), (e = this.elements.captions), (t = this.elements.wrapper), x(e) && x(t) && t.parentNode.insertBefore(e, t.nextSibling)),
                            $.isIE && window.URL)
                        ) {
                            const e = this.media.querySelectorAll("track");
                            Array.from(e).forEach((e) => {
                                const t = e.getAttribute("src"),
                                    i = Ie(t);
                                null !== i &&
                                    i.hostname !== window.location.href.hostname &&
                                    ["http:", "https:"].includes(i.protocol) &&
                                    xe(t, "blob")
                                        .then((t) => {
                                            e.setAttribute("src", window.URL.createObjectURL(t));
                                        })
                                        .catch(() => {
                                            Q(e);
                                        });
                            });
                        }
                        const i = Ae((navigator.languages || [navigator.language || navigator.userLanguage || "en"]).map((e) => e.split("-")[0]));
                        let n = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
                        "auto" === n && ([n] = i);
                        let o = this.storage.get("captions");
                        if ((k(o) || ({ active: o } = this.config.captions), Object.assign(this.captions, { toggled: !1, active: o, language: n, languages: i }), this.isHTML5)) {
                            const e = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                            pe.call(this, this.media.textTracks, e, je.update.bind(this));
                        }
                        setTimeout(je.update.bind(this), 0);
                    },
                    update() {
                        const e = je.getTracks.call(this, !0),
                            { active: t, language: i, meta: n, currentTrackNode: o } = this.captions,
                            s = Boolean(e.find((e) => e.language === i));
                        this.isHTML5 &&
                            this.isVideo &&
                            e
                                .filter((e) => !n.get(e))
                                .forEach((e) => {
                                    this.debug.log("Track added", e), n.set(e, { default: "showing" === e.mode }), "showing" === e.mode && (e.mode = "hidden"), pe.call(this, e, "cuechange", () => je.updateCues.call(this));
                                }),
                            ((s && this.language !== i) || !e.includes(o)) && (je.setLanguage.call(this, i), je.toggle.call(this, t && s)),
                            this.elements && ie(this.elements.container, this.config.classNames.captions.enabled, !I(e)),
                            E(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this);
                    },
                    toggle(e, t = !0) {
                        if (!this.supported.ui) return;
                        const { toggled: i } = this.captions,
                            n = this.config.classNames.captions.active,
                            o = w(e) ? !i : e;
                        if (o !== i) {
                            if ((t || ((this.captions.active = o), this.storage.set({ captions: o })), !this.language && o && !t)) {
                                const e = je.getTracks.call(this),
                                    t = je.findTrack.call(this, [this.captions.language, ...this.captions.languages], !0);
                                return (this.captions.language = t.language), void je.set.call(this, e.indexOf(t));
                            }
                            this.elements.buttons.captions && (this.elements.buttons.captions.pressed = o),
                                ie(this.elements.container, n, o),
                                (this.captions.toggled = o),
                                Pe.updateSetting.call(this, "captions"),
                                Me.call(this, this.media, o ? "captionsenabled" : "captionsdisabled");
                        }
                        setTimeout(() => {
                            o && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
                        });
                    },
                    set(e, t = !0) {
                        const i = je.getTracks.call(this);
                        if (-1 !== e)
                            if (S(e))
                                if (e in i) {
                                    if (this.captions.currentTrack !== e) {
                                        this.captions.currentTrack = e;
                                        const n = i[e],
                                            { language: o } = n || {};
                                        (this.captions.currentTrackNode = n),
                                            Pe.updateSetting.call(this, "captions"),
                                            t || ((this.captions.language = o), this.storage.set({ language: o })),
                                            this.isVimeo && this.embed.enableTextTrack(o),
                                            Me.call(this, this.media, "languagechange");
                                    }
                                    je.toggle.call(this, !0, t), this.isHTML5 && this.isVideo && je.updateCues.call(this);
                                } else this.debug.warn("Track not found", e);
                            else this.debug.warn("Invalid caption argument", e);
                        else je.toggle.call(this, !1, t);
                    },
                    setLanguage(e, t = !0) {
                        if (!C(e)) return void this.debug.warn("Invalid language argument", e);
                        const i = e.toLowerCase();
                        this.captions.language = i;
                        const n = je.getTracks.call(this),
                            o = je.findTrack.call(this, [i]);
                        je.set.call(this, n.indexOf(o), t);
                    },
                    getTracks(e = !1) {
                        return Array.from((this.media || {}).textTracks || [])
                            .filter((t) => !this.isHTML5 || e || this.captions.meta.has(t))
                            .filter((e) => ["captions", "subtitles"].includes(e.kind));
                    },
                    findTrack(e, t = !1) {
                        const i = je.getTracks.call(this),
                            n = (e) => Number((this.captions.meta.get(e) || {}).default),
                            o = Array.from(i).sort((e, t) => n(t) - n(e));
                        let s;
                        return e.every((e) => ((s = o.find((t) => t.language === e)), !s)), s || (t ? o[0] : void 0);
                    },
                    getCurrentTrack() {
                        return je.getTracks.call(this)[this.currentTrack];
                    },
                    getLabel(e) {
                        let t = e;
                        return (
                            !R(t) && le.textTracks && this.captions.toggled && (t = je.getCurrentTrack.call(this)),
                            R(t) ? (I(t.label) ? (I(t.language) ? Ee.get("enabled", this.config) : e.language.toUpperCase()) : t.label) : Ee.get("disabled", this.config)
                        );
                    },
                    updateCues(e) {
                        if (!this.supported.ui) return;
                        if (!x(this.elements.captions)) return void this.debug.warn("No captions element to render to");
                        if (!w(e) && !Array.isArray(e)) return void this.debug.warn("updateCues: Invalid input", e);
                        let t = e;
                        if (!t) {
                            const e = je.getCurrentTrack.call(this);
                            t = Array.from((e || {}).activeCues || [])
                                .map((e) => e.getCueAsHTML())
                                .map(ke);
                        }
                        const i = t.map((e) => e.trim()).join("\n");
                        if (i !== this.elements.captions.innerHTML) {
                            J(this.elements.captions);
                            const e = G("span", ee(this.config.selectors.caption));
                            (e.innerHTML = i), this.elements.captions.appendChild(e), Me.call(this, this.media, "cuechange");
                        }
                    },
                },
                $e = {
                    enabled: !0,
                    title: "",
                    debug: !1,
                    autoplay: !1,
                    autopause: !0,
                    playsinline: !0,
                    seekTime: 10,
                    volume: 1,
                    muted: !1,
                    duration: null,
                    displayDuration: !0,
                    invertTime: !0,
                    toggleInvert: !0,
                    ratio: null,
                    clickToPlay: !0,
                    hideControls: !0,
                    resetOnEnd: !1,
                    disableContextMenu: !0,
                    loadSprite: !0,
                    iconPrefix: "plyr",
                    iconUrl: "https://cdn.plyr.io/3.6.12/plyr.svg",
                    blankVideo: "https://cdn.plyr.io/static/blank.mp4",
                    quality: { default: 576, options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240], forced: !1, onChange: null },
                    loop: { active: !1 },
                    speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 4] },
                    keyboard: { focused: !0, global: !1 },
                    tooltips: { controls: !1, seek: !0 },
                    captions: { active: !1, language: "auto", update: !1 },
                    fullscreen: { enabled: !0, fallback: !0, iosNative: !1 },
                    storage: { enabled: !0, key: "plyr" },
                    controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen"],
                    settings: ["captions", "quality", "speed"],
                    i18n: {
                        restart: "Restart",
                        rewind: "Rewind {seektime}s",
                        play: "Play",
                        pause: "Pause",
                        fastForward: "Forward {seektime}s",
                        seek: "Seek",
                        seekLabel: "{currentTime} of {duration}",
                        played: "Played",
                        buffered: "Buffered",
                        currentTime: "Current time",
                        duration: "Duration",
                        volume: "Volume",
                        mute: "Mute",
                        unmute: "Unmute",
                        enableCaptions: "Enable captions",
                        disableCaptions: "Disable captions",
                        download: "Download",
                        enterFullscreen: "Enter fullscreen",
                        exitFullscreen: "Exit fullscreen",
                        frameTitle: "Player for {title}",
                        captions: "Captions",
                        settings: "Settings",
                        pip: "PIP",
                        menuBack: "Go back to previous menu",
                        speed: "Speed",
                        normal: "Normal",
                        quality: "Quality",
                        loop: "Loop",
                        start: "Start",
                        end: "End",
                        all: "All",
                        reset: "Reset",
                        disabled: "Disabled",
                        enabled: "Enabled",
                        advertisement: "Ad",
                        qualityBadge: { 2160: "4K", 1440: "HD", 1080: "HD", 720: "HD", 576: "SD", 480: "SD" },
                    },
                    urls: {
                        download: null,
                        vimeo: { sdk: "https://player.vimeo.com/api/player.js", iframe: "https://player.vimeo.com/video/{0}?{1}", api: "https://vimeo.com/api/oembed.json?url={0}" },
                        youtube: { sdk: "https://www.youtube.com/iframe_api", api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}" },
                        googleIMA: { sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js" },
                    },
                    listeners: {
                        seek: null,
                        play: null,
                        pause: null,
                        restart: null,
                        rewind: null,
                        fastForward: null,
                        mute: null,
                        volume: null,
                        captions: null,
                        download: null,
                        fullscreen: null,
                        pip: null,
                        airplay: null,
                        speed: null,
                        quality: null,
                        loop: null,
                        language: null,
                    },
                    events: [
                        "ended",
                        "progress",
                        "stalled",
                        "playing",
                        "waiting",
                        "canplay",
                        "canplaythrough",
                        "loadstart",
                        "loadeddata",
                        "loadedmetadata",
                        "timeupdate",
                        "volumechange",
                        "play",
                        "pause",
                        "error",
                        "seeking",
                        "seeked",
                        "emptied",
                        "ratechange",
                        "cuechange",
                        "download",
                        "enterfullscreen",
                        "exitfullscreen",
                        "captionsenabled",
                        "captionsdisabled",
                        "languagechange",
                        "controlshidden",
                        "controlsshown",
                        "ready",
                        "statechange",
                        "qualitychange",
                        "adsloaded",
                        "adscontentpause",
                        "adscontentresume",
                        "adstarted",
                        "adsmidpoint",
                        "adscomplete",
                        "adsallcomplete",
                        "adsimpression",
                        "adsclick",
                    ],
                    selectors: {
                        editable: "input, textarea, select, [contenteditable]",
                        container: ".plyr",
                        controls: { container: null, wrapper: ".plyr__controls" },
                        labels: "[data-plyr]",
                        buttons: {
                            play: '[data-plyr="play"]',
                            pause: '[data-plyr="pause"]',
                            restart: '[data-plyr="restart"]',
                            rewind: '[data-plyr="rewind"]',
                            fastForward: '[data-plyr="fast-forward"]',
                            mute: '[data-plyr="mute"]',
                            captions: '[data-plyr="captions"]',
                            download: '[data-plyr="download"]',
                            fullscreen: '[data-plyr="fullscreen"]',
                            pip: '[data-plyr="pip"]',
                            airplay: '[data-plyr="airplay"]',
                            settings: '[data-plyr="settings"]',
                            loop: '[data-plyr="loop"]',
                        },
                        inputs: { seek: '[data-plyr="seek"]', volume: '[data-plyr="volume"]', speed: '[data-plyr="speed"]', language: '[data-plyr="language"]', quality: '[data-plyr="quality"]' },
                        display: { currentTime: ".plyr__time--current", duration: ".plyr__time--duration", buffer: ".plyr__progress__buffer", loop: ".plyr__progress__loop", volume: ".plyr__volume--display" },
                        progress: ".plyr__progress",
                        captions: ".plyr__captions",
                        caption: ".plyr__caption",
                    },
                    classNames: {
                        type: "plyr--{0}",
                        provider: "plyr--{0}",
                        video: "plyr__video-wrapper",
                        embed: "plyr__video-embed",
                        videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
                        embedContainer: "plyr__video-embed__container",
                        poster: "plyr__poster",
                        posterEnabled: "plyr__poster-enabled",
                        ads: "plyr__ads",
                        control: "plyr__control",
                        controlPressed: "plyr__control--pressed",
                        playing: "plyr--playing",
                        paused: "plyr--paused",
                        stopped: "plyr--stopped",
                        loading: "plyr--loading",
                        hover: "plyr--hover",
                        tooltip: "plyr__tooltip",
                        cues: "plyr__cues",
                        hidden: "plyr__sr-only",
                        hideControls: "plyr--hide-controls",
                        isIos: "plyr--is-ios",
                        isTouch: "plyr--is-touch",
                        uiSupported: "plyr--full-ui",
                        noTransition: "plyr--no-transition",
                        display: { time: "plyr__time" },
                        menu: { value: "plyr__menu__value", badge: "plyr__badge", open: "plyr--menu-open" },
                        captions: { enabled: "plyr--captions-enabled", active: "plyr--captions-active" },
                        fullscreen: { enabled: "plyr--fullscreen-enabled", fallback: "plyr--fullscreen-fallback" },
                        pip: { supported: "plyr--pip-supported", active: "plyr--pip-active" },
                        airplay: { supported: "plyr--airplay-supported", active: "plyr--airplay-active" },
                        tabFocus: "plyr__tab-focus",
                        previewThumbnails: {
                            thumbContainer: "plyr__preview-thumb",
                            thumbContainerShown: "plyr__preview-thumb--is-shown",
                            imageContainer: "plyr__preview-thumb__image-container",
                            timeContainer: "plyr__preview-thumb__time-container",
                            scrubbingContainer: "plyr__preview-scrubbing",
                            scrubbingContainerShown: "plyr__preview-scrubbing--is-shown",
                        },
                    },
                    attributes: { embed: { provider: "data-plyr-provider", id: "data-plyr-embed-id", hash: "data-plyr-embed-hash" } },
                    ads: { enabled: !1, publisherId: "", tagUrl: "" },
                    previewThumbnails: { enabled: !1, src: "" },
                    vimeo: { byline: !1, portrait: !1, title: !1, speed: !0, transparent: !1, customControls: !0, referrerPolicy: null, premium: !1 },
                    youtube: { rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, customControls: !0, noCookie: !1 },
                },
                Fe = "picture-in-picture",
                Ue = { html5: "html5", youtube: "youtube", vimeo: "vimeo" },
                Ve = "video",
                Ye = () => {};
            class Ge {
                constructor(e = !1) {
                    (this.enabled = window.console && e), this.enabled && this.log("Debugging enabled");
                }
                get log() {
                    return this.enabled ? Function.prototype.bind.call(console.log, console) : Ye;
                }
                get warn() {
                    return this.enabled ? Function.prototype.bind.call(console.warn, console) : Ye;
                }
                get error() {
                    return this.enabled ? Function.prototype.bind.call(console.error, console) : Ye;
                }
            }
            class Ke {
                constructor(t) {
                    e(this, "onChange", () => {
                        if (!this.enabled) return;
                        const e = this.player.elements.buttons.fullscreen;
                        x(e) && (e.pressed = this.active);
                        const t = this.target === this.player.media ? this.target : this.player.elements.container;
                        Me.call(this.player, t, this.active ? "enterfullscreen" : "exitfullscreen", !0);
                    }),
                        e(this, "toggleFallback", (e = !1) => {
                            if (
                                (e ? (this.scrollPosition = { x: window.scrollX || 0, y: window.scrollY || 0 }) : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y),
                                (document.body.style.overflow = e ? "hidden" : ""),
                                ie(this.target, this.player.config.classNames.fullscreen.fallback, e),
                                $.isIos)
                            ) {
                                let t = document.head.querySelector('meta[name="viewport"]');
                                const i = "viewport-fit=cover";
                                t || ((t = document.createElement("meta")), t.setAttribute("name", "viewport"));
                                const n = C(t.content) && t.content.includes(i);
                                e
                                    ? ((this.cleanupViewport = !n), n || (t.content += `,${i}`))
                                    : this.cleanupViewport &&
                                      (t.content = t.content
                                          .split(",")
                                          .filter((e) => e.trim() !== i)
                                          .join(","));
                            }
                            this.onChange();
                        }),
                        e(this, "trapFocus", (e) => {
                            if ($.isIos || !this.active || "Tab" !== e.key || 9 !== e.keyCode) return;
                            const t = document.activeElement,
                                i = se.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"),
                                [n] = i,
                                o = i[i.length - 1];
                            t !== o || e.shiftKey ? t === n && e.shiftKey && (o.focus(), e.preventDefault()) : (n.focus(), e.preventDefault());
                        }),
                        e(this, "update", () => {
                            if (this.enabled) {
                                let e;
                                (e = this.forceFallback ? "Fallback (forced)" : Ke.native ? "Native" : "Fallback"), this.player.debug.log(`${e} fullscreen enabled`);
                            } else this.player.debug.log("Fullscreen not supported and fallback disabled");
                            ie(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.enabled);
                        }),
                        e(this, "enter", () => {
                            this.enabled &&
                                ($.isIos && this.player.config.fullscreen.iosNative
                                    ? this.player.isVimeo
                                        ? this.player.embed.requestFullscreen()
                                        : this.target.webkitEnterFullscreen()
                                    : !Ke.native || this.forceFallback
                                    ? this.toggleFallback(!0)
                                    : this.prefix
                                    ? I(this.prefix) || this.target[`${this.prefix}Request${this.property}`]()
                                    : this.target.requestFullscreen({ navigationUI: "hide" }));
                        }),
                        e(this, "exit", () => {
                            if (this.enabled)
                                if ($.isIos && this.player.config.fullscreen.iosNative) this.target.webkitExitFullscreen(), ge(this.player.play());
                                else if (!Ke.native || this.forceFallback) this.toggleFallback(!1);
                                else if (this.prefix) {
                                    if (!I(this.prefix)) {
                                        const e = "moz" === this.prefix ? "Cancel" : "Exit";
                                        document[`${this.prefix}${e}${this.property}`]();
                                    }
                                } else (document.cancelFullScreen || document.exitFullscreen).call(document);
                        }),
                        e(this, "toggle", () => {
                            this.active ? this.exit() : this.enter();
                        }),
                        (this.player = t),
                        (this.prefix = Ke.prefix),
                        (this.property = Ke.property),
                        (this.scrollPosition = { x: 0, y: 0 }),
                        (this.forceFallback = "force" === t.config.fullscreen.fallback),
                        (this.player.elements.fullscreen =
                            t.config.fullscreen.container &&
                            (function (e, t) {
                                const { prototype: i } = Element;
                                return (
                                    i.closest ||
                                    function () {
                                        let e = this;
                                        do {
                                            if (oe.matches(e, t)) return e;
                                            e = e.parentElement || e.parentNode;
                                        } while (null !== e && 1 === e.nodeType);
                                        return null;
                                    }
                                ).call(e, t);
                            })(this.player.elements.container, t.config.fullscreen.container)),
                        pe.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, () => {
                            this.onChange();
                        }),
                        pe.call(this.player, this.player.elements.container, "dblclick", (e) => {
                            (x(this.player.elements.controls) && this.player.elements.controls.contains(e.target)) || this.player.listeners.proxy(e, this.toggle, "fullscreen");
                        }),
                        pe.call(this, this.player.elements.container, "keydown", (e) => this.trapFocus(e)),
                        this.update();
                }
                static get native() {
                    return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
                }
                get usingNative() {
                    return Ke.native && !this.forceFallback;
                }
                static get prefix() {
                    if (B(document.exitFullscreen)) return "";
                    let e = "";
                    return ["webkit", "moz", "ms"].some((t) => !((!B(document[`${t}ExitFullscreen`]) && !B(document[`${t}CancelFullScreen`])) || ((e = t), 0))), e;
                }
                static get property() {
                    return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
                }
                get enabled() {
                    return (Ke.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo;
                }
                get active() {
                    if (!this.enabled) return !1;
                    if (!Ke.native || this.forceFallback) return ne(this.target, this.player.config.classNames.fullscreen.fallback);
                    const e = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
                    return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
                }
                get target() {
                    return $.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen || this.player.elements.container;
                }
            }
            function Qe(e, t = 1) {
                return new Promise((i, n) => {
                    const o = new Image(),
                        s = () => {
                            delete o.onload, delete o.onerror, (o.naturalWidth >= t ? i : n)(o);
                        };
                    Object.assign(o, { onload: s, onerror: s, src: e });
                });
            }
            const Je = {
                addStyleHook() {
                    ie(this.elements.container, this.config.selectors.container.replace(".", ""), !0), ie(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
                },
                toggleNativeControls(e = !1) {
                    e && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
                },
                build() {
                    if ((this.listeners.media(), !this.supported.ui)) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void Je.toggleNativeControls.call(this, !0);
                    x(this.elements.controls) || (Pe.inject.call(this), this.listeners.controls()),
                        Je.toggleNativeControls.call(this),
                        this.isHTML5 && je.setup.call(this),
                        (this.volume = null),
                        (this.muted = null),
                        (this.loop = null),
                        (this.quality = null),
                        (this.speed = null),
                        Pe.updateVolume.call(this),
                        Pe.timeUpdate.call(this),
                        Pe.durationUpdate.call(this),
                        Je.checkPlaying.call(this),
                        ie(this.elements.container, this.config.classNames.pip.supported, le.pip && this.isHTML5 && this.isVideo),
                        ie(this.elements.container, this.config.classNames.airplay.supported, le.airplay && this.isHTML5),
                        ie(this.elements.container, this.config.classNames.isIos, $.isIos),
                        ie(this.elements.container, this.config.classNames.isTouch, this.touch),
                        (this.ready = !0),
                        setTimeout(() => {
                            Me.call(this, this.media, "ready");
                        }, 0),
                        Je.setTitle.call(this),
                        this.poster && Je.setPoster.call(this, this.poster, !1).catch(() => {}),
                        this.config.duration && Pe.durationUpdate.call(this);
                },
                setTitle() {
                    let e = Ee.get("play", this.config);
                    if (
                        (C(this.config.title) && !I(this.config.title) && (e += `, ${this.config.title}`),
                        Array.from(this.elements.buttons.play || []).forEach((t) => {
                            t.setAttribute("aria-label", e);
                        }),
                        this.isEmbed)
                    ) {
                        const e = re.call(this, "iframe");
                        if (!x(e)) return;
                        const t = I(this.config.title) ? "video" : this.config.title,
                            i = Ee.get("frameTitle", this.config);
                        e.setAttribute("title", i.replace("{title}", t));
                    }
                },
                togglePoster(e) {
                    ie(this.elements.container, this.config.classNames.posterEnabled, e);
                },
                setPoster(e, t = !0) {
                    return t && this.poster
                        ? Promise.reject(new Error("Poster already set"))
                        : (this.media.setAttribute("data-poster", e),
                          this.elements.poster.removeAttribute("hidden"),
                          me
                              .call(this)
                              .then(() => Qe(e))
                              .catch((t) => {
                                  throw (e === this.poster && Je.togglePoster.call(this, !1), t);
                              })
                              .then(() => {
                                  if (e !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
                              })
                              .then(() => (Object.assign(this.elements.poster.style, { backgroundImage: `url('${e}')`, backgroundSize: "" }), Je.togglePoster.call(this, !0), e)));
                },
                checkPlaying(e) {
                    ie(this.elements.container, this.config.classNames.playing, this.playing),
                        ie(this.elements.container, this.config.classNames.paused, this.paused),
                        ie(this.elements.container, this.config.classNames.stopped, this.stopped),
                        Array.from(this.elements.buttons.play || []).forEach((e) => {
                            Object.assign(e, { pressed: this.playing }), e.setAttribute("aria-label", Ee.get(this.playing ? "pause" : "play", this.config));
                        }),
                        (_(e) && "timeupdate" === e.type) || Je.toggleControls.call(this);
                },
                checkLoading(e) {
                    (this.loading = ["stalled", "waiting"].includes(e.type)),
                        clearTimeout(this.timers.loading),
                        (this.timers.loading = setTimeout(
                            () => {
                                ie(this.elements.container, this.config.classNames.loading, this.loading), Je.toggleControls.call(this);
                            },
                            this.loading ? 250 : 0
                        ));
                },
                toggleControls(e) {
                    const { controls: t } = this.elements;
                    if (t && this.config.hideControls) {
                        const i = this.touch && this.lastSeekTime + 2e3 > Date.now();
                        this.toggleControls(Boolean(e || this.loading || this.paused || t.pressed || t.hover || i));
                    }
                },
                migrateStyles() {
                    Object.values({ ...this.media.style })
                        .filter((e) => !I(e) && C(e) && e.startsWith("--plyr"))
                        .forEach((e) => {
                            this.elements.container.style.setProperty(e, this.media.style.getPropertyValue(e)), this.media.style.removeProperty(e);
                        }),
                        I(this.media.style) && this.media.removeAttribute("style");
                },
            };
            class Ze {
                constructor(t) {
                    e(this, "firstTouch", () => {
                        const { player: e } = this,
                            { elements: t } = e;
                        (e.touch = !0), ie(t.container, e.config.classNames.isTouch, !0);
                    }),
                        e(this, "setTabFocus", (e) => {
                            const { player: t } = this,
                                { elements: i } = t;
                            if ((clearTimeout(this.focusTimer), "keydown" === e.type && 9 !== e.which)) return;
                            "keydown" === e.type && (this.lastKeyDown = e.timeStamp);
                            const n = e.timeStamp - this.lastKeyDown <= 20;
                            ("focus" !== e.type || n) &&
                                ((() => {
                                    const e = t.config.classNames.tabFocus;
                                    ie(se.call(t, `.${e}`), e, !1);
                                })(),
                                "focusout" !== e.type &&
                                    (this.focusTimer = setTimeout(() => {
                                        const e = document.activeElement;
                                        i.container.contains(e) && ie(document.activeElement, t.config.classNames.tabFocus, !0);
                                    }, 10)));
                        }),
                        e(this, "global", (e = !0) => {
                            const { player: t } = this;
                            t.config.keyboard.global && de.call(t, window, "keydown keyup", this.handleKey, e, !1),
                                de.call(t, document.body, "click", this.toggleMenu, e),
                                fe.call(t, document.body, "touchstart", this.firstTouch),
                                de.call(t, document.body, "keydown focus blur focusout", this.setTabFocus, e, !1, !0);
                        }),
                        e(this, "container", () => {
                            const { player: e } = this,
                                { config: t, elements: i, timers: n } = e;
                            !t.keyboard.global && t.keyboard.focused && pe.call(e, i.container, "keydown keyup", this.handleKey, !1),
                                pe.call(e, i.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (t) => {
                                    const { controls: o } = i;
                                    o && "enterfullscreen" === t.type && ((o.pressed = !1), (o.hover = !1));
                                    let s = 0;
                                    ["touchstart", "touchmove", "mousemove"].includes(t.type) && (Je.toggleControls.call(e, !0), (s = e.touch ? 3e3 : 2e3)),
                                        clearTimeout(n.controls),
                                        (n.controls = setTimeout(() => Je.toggleControls.call(e, !1), s));
                                });
                            const o = () => {
                                    if (!e.isVimeo || e.config.vimeo.premium) return;
                                    const t = i.wrapper,
                                        { active: n } = e.fullscreen,
                                        [o, s] = Te.call(e),
                                        r = ye(`aspect-ratio: ${o} / ${s}`);
                                    if (!n) return void (r ? ((t.style.width = null), (t.style.height = null)) : ((t.style.maxWidth = null), (t.style.margin = null)));
                                    const [c, a] = [Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0), Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)],
                                        l = c / a > o / s;
                                    r ? ((t.style.width = l ? "auto" : "100%"), (t.style.height = l ? "100%" : "auto")) : ((t.style.maxWidth = l ? (a / s) * o + "px" : null), (t.style.margin = l ? "0 auto" : null));
                                },
                                s = () => {
                                    clearTimeout(n.resized), (n.resized = setTimeout(o, 50));
                                };
                            pe.call(e, i.container, "enterfullscreen exitfullscreen", (t) => {
                                const { target: n } = e.fullscreen;
                                n === i.container && ((!e.isEmbed && I(e.config.ratio)) || (o(), ("enterfullscreen" === t.type ? pe : he).call(e, window, "resize", s)));
                            });
                        }),
                        e(this, "media", () => {
                            const { player: e } = this,
                                { elements: t } = e;
                            if (
                                (pe.call(e, e.media, "timeupdate seeking seeked", (t) => Pe.timeUpdate.call(e, t)),
                                pe.call(e, e.media, "durationchange loadeddata loadedmetadata", (t) => Pe.durationUpdate.call(e, t)),
                                pe.call(e, e.media, "ended", () => {
                                    e.isHTML5 && e.isVideo && e.config.resetOnEnd && (e.restart(), e.pause());
                                }),
                                pe.call(e, e.media, "progress playing seeking seeked", (t) => Pe.updateProgress.call(e, t)),
                                pe.call(e, e.media, "volumechange", (t) => Pe.updateVolume.call(e, t)),
                                pe.call(e, e.media, "playing play pause ended emptied timeupdate", (t) => Je.checkPlaying.call(e, t)),
                                pe.call(e, e.media, "waiting canplay seeked playing", (t) => Je.checkLoading.call(e, t)),
                                e.supported.ui && e.config.clickToPlay && !e.isAudio)
                            ) {
                                const i = re.call(e, `.${e.config.classNames.video}`);
                                if (!x(i)) return;
                                pe.call(e, t.container, "click", (n) => {
                                    ([t.container, i].includes(n.target) || i.contains(n.target)) &&
                                        ((e.touch && e.config.hideControls) ||
                                            (e.ended
                                                ? (this.proxy(n, e.restart, "restart"),
                                                  this.proxy(
                                                      n,
                                                      () => {
                                                          ge(e.play());
                                                      },
                                                      "play"
                                                  ))
                                                : this.proxy(
                                                      n,
                                                      () => {
                                                          ge(e.togglePlay());
                                                      },
                                                      "play"
                                                  )));
                                });
                            }
                            e.supported.ui &&
                                e.config.disableContextMenu &&
                                pe.call(
                                    e,
                                    t.wrapper,
                                    "contextmenu",
                                    (e) => {
                                        e.preventDefault();
                                    },
                                    !1
                                ),
                                pe.call(e, e.media, "volumechange", () => {
                                    e.storage.set({ volume: e.volume, muted: e.muted });
                                }),
                                pe.call(e, e.media, "ratechange", () => {
                                    Pe.updateSetting.call(e, "speed"), e.storage.set({ speed: e.speed });
                                }),
                                pe.call(e, e.media, "qualitychange", (t) => {
                                    Pe.updateSetting.call(e, "quality", null, t.detail.quality);
                                }),
                                pe.call(e, e.media, "ready qualitychange", () => {
                                    Pe.setDownloadUrl.call(e);
                                });
                            const i = e.config.events.concat(["keyup", "keydown"]).join(" ");
                            pe.call(e, e.media, i, (i) => {
                                let { detail: n = {} } = i;
                                "error" === i.type && (n = e.media.error), Me.call(e, t.container, i.type, !0, n);
                            });
                        }),
                        e(this, "proxy", (e, t, i) => {
                            const { player: n } = this,
                                o = n.config.listeners[i];
                            let s = !0;
                            B(o) && (s = o.call(n, e)), !1 !== s && B(t) && t.call(n, e);
                        }),
                        e(this, "bind", (e, t, i, n, o = !0) => {
                            const { player: s } = this,
                                r = s.config.listeners[n],
                                c = B(r);
                            pe.call(s, e, t, (e) => this.proxy(e, i, n), o && !c);
                        }),
                        e(this, "controls", () => {
                            const { player: e } = this,
                                { elements: t } = e,
                                i = $.isIE ? "change" : "input";
                            if (
                                (t.buttons.play &&
                                    Array.from(t.buttons.play).forEach((t) => {
                                        this.bind(
                                            t,
                                            "click",
                                            () => {
                                                ge(e.togglePlay());
                                            },
                                            "play"
                                        );
                                    }),
                                this.bind(t.buttons.restart, "click", e.restart, "restart"),
                                this.bind(
                                    t.buttons.rewind,
                                    "click",
                                    () => {
                                        (e.lastSeekTime = Date.now()), e.rewind();
                                    },
                                    "rewind"
                                ),
                                this.bind(
                                    t.buttons.fastForward,
                                    "click",
                                    () => {
                                        (e.lastSeekTime = Date.now()), e.forward();
                                    },
                                    "fastForward"
                                ),
                                this.bind(
                                    t.buttons.mute,
                                    "click",
                                    () => {
                                        e.muted = !e.muted;
                                    },
                                    "mute"
                                ),
                                this.bind(t.buttons.captions, "click", () => e.toggleCaptions()),
                                this.bind(
                                    t.buttons.download,
                                    "click",
                                    () => {
                                        Me.call(e, e.media, "download");
                                    },
                                    "download"
                                ),
                                this.bind(
                                    t.buttons.fullscreen,
                                    "click",
                                    () => {
                                        e.fullscreen.toggle();
                                    },
                                    "fullscreen"
                                ),
                                this.bind(
                                    t.buttons.pip,
                                    "click",
                                    () => {
                                        e.pip = "toggle";
                                    },
                                    "pip"
                                ),
                                this.bind(t.buttons.airplay, "click", e.airplay, "airplay"),
                                this.bind(
                                    t.buttons.settings,
                                    "click",
                                    (t) => {
                                        t.stopPropagation(), t.preventDefault(), Pe.toggleMenu.call(e, t);
                                    },
                                    null,
                                    !1
                                ),
                                this.bind(
                                    t.buttons.settings,
                                    "keyup",
                                    (t) => {
                                        const i = t.which;
                                        [13, 32].includes(i) && (13 !== i ? (t.preventDefault(), t.stopPropagation(), Pe.toggleMenu.call(e, t)) : Pe.focusFirstMenuItem.call(e, null, !0));
                                    },
                                    null,
                                    !1
                                ),
                                this.bind(t.settings.menu, "keydown", (t) => {
                                    27 === t.which && Pe.toggleMenu.call(e, t);
                                }),
                                this.bind(t.inputs.seek, "mousedown mousemove", (e) => {
                                    const i = t.progress.getBoundingClientRect(),
                                        n = (100 / i.width) * (e.pageX - i.left);
                                    e.currentTarget.setAttribute("seek-value", n);
                                }),
                                this.bind(t.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (t) => {
                                    const i = t.currentTarget,
                                        n = t.keyCode ? t.keyCode : t.which,
                                        o = "play-on-seeked";
                                    if (D(t) && 39 !== n && 37 !== n) return;
                                    e.lastSeekTime = Date.now();
                                    const s = i.hasAttribute(o),
                                        r = ["mouseup", "touchend", "keyup"].includes(t.type);
                                    s && r ? (i.removeAttribute(o), ge(e.play())) : !r && e.playing && (i.setAttribute(o, ""), e.pause());
                                }),
                                $.isIos)
                            ) {
                                const t = se.call(e, 'input[type="range"]');
                                Array.from(t).forEach((e) => this.bind(e, i, (e) => j(e.target)));
                            }
                            this.bind(
                                t.inputs.seek,
                                i,
                                (t) => {
                                    const i = t.currentTarget;
                                    let n = i.getAttribute("seek-value");
                                    I(n) && (n = i.value), i.removeAttribute("seek-value"), (e.currentTime = (n / i.max) * e.duration);
                                },
                                "seek"
                            ),
                                this.bind(t.progress, "mouseenter mouseleave mousemove", (t) => Pe.updateSeekTooltip.call(e, t)),
                                this.bind(t.progress, "mousemove touchmove", (t) => {
                                    const { previewThumbnails: i } = e;
                                    i && i.loaded && i.startMove(t);
                                }),
                                this.bind(t.progress, "mouseleave touchend click", () => {
                                    const { previewThumbnails: t } = e;
                                    t && t.loaded && t.endMove(!1, !0);
                                }),
                                this.bind(t.progress, "mousedown touchstart", (t) => {
                                    const { previewThumbnails: i } = e;
                                    i && i.loaded && i.startScrubbing(t);
                                }),
                                this.bind(t.progress, "mouseup touchend", (t) => {
                                    const { previewThumbnails: i } = e;
                                    i && i.loaded && i.endScrubbing(t);
                                }),
                                $.isWebkit &&
                                    Array.from(se.call(e, 'input[type="range"]')).forEach((t) => {
                                        this.bind(t, "input", (t) => Pe.updateRangeFill.call(e, t.target));
                                    }),
                                e.config.toggleInvert &&
                                    !x(t.display.duration) &&
                                    this.bind(t.display.currentTime, "click", () => {
                                        0 !== e.currentTime && ((e.config.invertTime = !e.config.invertTime), Pe.timeUpdate.call(e));
                                    }),
                                this.bind(
                                    t.inputs.volume,
                                    i,
                                    (t) => {
                                        e.volume = t.target.value;
                                    },
                                    "volume"
                                ),
                                this.bind(t.controls, "mouseenter mouseleave", (i) => {
                                    t.controls.hover = !e.touch && "mouseenter" === i.type;
                                }),
                                t.fullscreen &&
                                    Array.from(t.fullscreen.children)
                                        .filter((e) => !e.contains(t.container))
                                        .forEach((i) => {
                                            this.bind(i, "mouseenter mouseleave", (i) => {
                                                t.controls && (t.controls.hover = !e.touch && "mouseenter" === i.type);
                                            });
                                        }),
                                this.bind(t.controls, "mousedown mouseup touchstart touchend touchcancel", (e) => {
                                    t.controls.pressed = ["mousedown", "touchstart"].includes(e.type);
                                }),
                                this.bind(t.controls, "focusin", () => {
                                    const { config: i, timers: n } = e;
                                    ie(t.controls, i.classNames.noTransition, !0),
                                        Je.toggleControls.call(e, !0),
                                        setTimeout(() => {
                                            ie(t.controls, i.classNames.noTransition, !1);
                                        }, 0);
                                    const o = this.touch ? 3e3 : 4e3;
                                    clearTimeout(n.controls), (n.controls = setTimeout(() => Je.toggleControls.call(e, !1), o));
                                }),
                                this.bind(
                                    t.inputs.volume,
                                    "wheel",
                                    (t) => {
                                        const i = t.webkitDirectionInvertedFromDevice,
                                            [n, o] = [t.deltaX, -t.deltaY].map((e) => (i ? -e : e)),
                                            s = Math.sign(Math.abs(n) > Math.abs(o) ? n : o);
                                        e.increaseVolume(s / 50);
                                        const { volume: r } = e.media;
                                        ((1 === s && r < 1) || (-1 === s && r > 0)) && t.preventDefault();
                                    },
                                    "volume",
                                    !1
                                );
                        }),
                        (this.player = t),
                        (this.lastKey = null),
                        (this.focusTimer = null),
                        (this.lastKeyDown = null),
                        (this.handleKey = this.handleKey.bind(this)),
                        (this.toggleMenu = this.toggleMenu.bind(this)),
                        (this.setTabFocus = this.setTabFocus.bind(this)),
                        (this.firstTouch = this.firstTouch.bind(this));
                }
                handleKey(e) {
                    const { player: t } = this,
                        { elements: i } = t,
                        n = e.keyCode ? e.keyCode : e.which,
                        o = "keydown" === e.type,
                        s = o && n === this.lastKey;
                    if (!(e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) && S(n))
                        if (o) {
                            const o = document.activeElement;
                            if (x(o)) {
                                const { editable: n } = t.config.selectors,
                                    { seek: s } = i.inputs;
                                if (o !== s && oe(o, n)) return;
                                if (32 === e.which && oe(o, 'button, [role^="menuitem"]')) return;
                            }
                            switch (([32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 56, 57, 67, 70, 73, 75, 76, 77, 79].includes(n) && (e.preventDefault(), e.stopPropagation()), n)) {
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                    s || (t.currentTime = (t.duration / 10) * (n - 48));
                                    break;
                                case 32:
                                case 75:
                                    s || ge(t.togglePlay());
                                    break;
                                case 38:
                                    t.increaseVolume(0.1);
                                    break;
                                case 40:
                                    t.decreaseVolume(0.1);
                                    break;
                                case 77:
                                    s || (t.muted = !t.muted);
                                    break;
                                case 39:
                                    t.forward();
                                    break;
                                case 37:
                                    t.rewind();
                                    break;
                                case 70:
                                    t.fullscreen.toggle();
                                    break;
                                case 67:
                                    s || t.toggleCaptions();
                                    break;
                                case 76:
                                    t.loop = !t.loop;
                            }
                            27 === n && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(), (this.lastKey = n);
                        } else this.lastKey = null;
                }
                toggleMenu(e) {
                    Pe.toggleMenu.call(this.player, e);
                }
            }
            "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
            var et = (function (e, t) {
                return (
                    (function (e, t) {
                        e.exports = (function () {
                            var e = function () {},
                                t = {},
                                i = {},
                                n = {};
                            function o(e, t) {
                                e = e.push ? e : [e];
                                var o,
                                    s,
                                    r,
                                    c = [],
                                    a = e.length,
                                    l = a;
                                for (
                                    o = function (e, i) {
                                        i.length && c.push(e), --l || t(c);
                                    };
                                    a--;

                                )
                                    (s = e[a]), (r = i[s]) ? o(s, r) : (n[s] = n[s] || []).push(o);
                            }
                            function s(e, t) {
                                if (e) {
                                    var o = n[e];
                                    if (((i[e] = t), o)) for (; o.length; ) o[0](e, t), o.splice(0, 1);
                                }
                            }
                            function r(t, i) {
                                t.call && (t = { success: t }), i.length ? (t.error || e)(i) : (t.success || e)(t);
                            }
                            function c(t, i, n, o) {
                                var s,
                                    r,
                                    a = document,
                                    l = n.async,
                                    u = (n.numRetries || 0) + 1,
                                    d = n.before || e,
                                    p = t.replace(/[\?|#].*$/, ""),
                                    h = t.replace(/^(css|img)!/, "");
                                (o = o || 0),
                                    /(^css!|\.css$)/.test(p)
                                        ? (((r = a.createElement("link")).rel = "stylesheet"), (r.href = h), (s = "hideFocus" in r) && r.relList && ((s = 0), (r.rel = "preload"), (r.as = "style")))
                                        : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(p)
                                        ? ((r = a.createElement("img")).src = h)
                                        : (((r = a.createElement("script")).src = t), (r.async = void 0 === l || l)),
                                    (r.onload = r.onerror = r.onbeforeload = function (e) {
                                        var a = e.type[0];
                                        if (s)
                                            try {
                                                r.sheet.cssText.length || (a = "e");
                                            } catch (e) {
                                                18 != e.code && (a = "e");
                                            }
                                        if ("e" == a) {
                                            if ((o += 1) < u) return c(t, i, n, o);
                                        } else if ("preload" == r.rel && "style" == r.as) return (r.rel = "stylesheet");
                                        i(t, a, e.defaultPrevented);
                                    }),
                                    !1 !== d(t, r) && a.head.appendChild(r);
                            }
                            function a(e, t, i) {
                                var n,
                                    o,
                                    s = (e = e.push ? e : [e]).length,
                                    r = s,
                                    a = [];
                                for (
                                    n = function (e, i, n) {
                                        if (("e" == i && a.push(e), "b" == i)) {
                                            if (!n) return;
                                            a.push(e);
                                        }
                                        --s || t(a);
                                    },
                                        o = 0;
                                    o < r;
                                    o++
                                )
                                    c(e[o], n, i);
                            }
                            function l(e, i, n) {
                                var o, c;
                                if ((i && i.trim && (o = i), (c = (o ? n : i) || {}), o)) {
                                    if (o in t) throw "LoadJS";
                                    t[o] = !0;
                                }
                                function l(t, i) {
                                    a(
                                        e,
                                        function (e) {
                                            r(c, e), t && r({ success: t, error: i }, e), s(o, e);
                                        },
                                        c
                                    );
                                }
                                if (c.returnPromise) return new Promise(l);
                                l();
                            }
                            return (
                                (l.ready = function (e, t) {
                                    return (
                                        o(e, function (e) {
                                            r(t, e);
                                        }),
                                        l
                                    );
                                }),
                                (l.done = function (e) {
                                    s(e, []);
                                }),
                                (l.reset = function () {
                                    (t = {}), (i = {}), (n = {});
                                }),
                                (l.isDefined = function (e) {
                                    return e in t;
                                }),
                                l
                            );
                        })();
                    })((t = { exports: {} })),
                    t.exports
                );
            })();
            function tt(e) {
                return new Promise((t, i) => {
                    et(e, { success: t, error: i });
                });
            }
            function it(e) {
                e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && ((this.media.paused = !e), Me.call(this, this.media, e ? "play" : "pause"));
            }
            const nt = {
                setup() {
                    const e = this;
                    ie(e.elements.wrapper, e.config.classNames.embed, !0),
                        (e.options.speed = e.config.speed.options),
                        Ne.call(e),
                        W(window.Vimeo)
                            ? nt.ready.call(e)
                            : tt(e.config.urls.vimeo.sdk)
                                  .then(() => {
                                      nt.ready.call(e);
                                  })
                                  .catch((t) => {
                                      e.debug.warn("Vimeo SDK (player.js) failed to load", t);
                                  });
                },
                ready() {
                    const e = this,
                        t = e.config.vimeo,
                        { premium: i, referrerPolicy: n, ...o } = t;
                    let s = e.media.getAttribute("src"),
                        r = "";
                    I(s)
                        ? ((s = e.media.getAttribute(e.config.attributes.embed.id)), (r = e.media.getAttribute(e.config.attributes.embed.hash)))
                        : (r = (function (e) {
                              const t = e.match(/^.*(?:vimeo.com\/|video\/)(?:\d+)(?:\?.*&*h=|\/)+(?<hash>[\d,a-f]+)/);
                              return t ? t.groups.hash : null;
                          })(s));
                    const c = r ? { h: r } : {};
                    i && Object.assign(o, { controls: !1, sidedock: !1 });
                    const a = He({ loop: e.config.loop.active, autoplay: e.autoplay, muted: e.muted, gesture: "media", playsinline: !this.config.fullscreen.iosNative, ...c, ...o }),
                        l = I((u = s)) ? null : S(Number(u)) ? u : u.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : u;
                    var u;
                    const d = G("iframe"),
                        p = We(e.config.urls.vimeo.iframe, l, a);
                    if (
                        (d.setAttribute("src", p),
                        d.setAttribute("allowfullscreen", ""),
                        d.setAttribute("allow", ["autoplay", "fullscreen", "picture-in-picture", "encrypted-media", "accelerometer", "gyroscope"].join("; ")),
                        I(n) || d.setAttribute("referrerPolicy", n),
                        i || !t.customControls)
                    )
                        d.setAttribute("data-poster", e.poster), (e.media = Z(d, e.media));
                    else {
                        const t = G("div", { class: e.config.classNames.embedContainer, "data-poster": e.poster });
                        t.appendChild(d), (e.media = Z(t, e.media));
                    }
                    t.customControls ||
                        xe(We(e.config.urls.vimeo.api, p)).then((t) => {
                            !I(t) && t.thumbnail_url && Je.setPoster.call(e, t.thumbnail_url).catch(() => {});
                        }),
                        (e.embed = new window.Vimeo.Player(d, { autopause: e.config.autopause, muted: e.muted })),
                        (e.media.paused = !0),
                        (e.media.currentTime = 0),
                        e.supported.ui && e.embed.disableTextTrack(),
                        (e.media.play = () => (it.call(e, !0), e.embed.play())),
                        (e.media.pause = () => (it.call(e, !1), e.embed.pause())),
                        (e.media.stop = () => {
                            e.pause(), (e.currentTime = 0);
                        });
                    let { currentTime: h } = e.media;
                    Object.defineProperty(e.media, "currentTime", {
                        get: () => h,
                        set(t) {
                            const { embed: i, media: n, paused: o, volume: s } = e,
                                r = o && !i.hasPlayed;
                            (n.seeking = !0),
                                Me.call(e, n, "seeking"),
                                Promise.resolve(r && i.setVolume(0))
                                    .then(() => i.setCurrentTime(t))
                                    .then(() => r && i.pause())
                                    .then(() => r && i.setVolume(s))
                                    .catch(() => {});
                        },
                    });
                    let f = e.config.speed.selected;
                    Object.defineProperty(e.media, "playbackRate", {
                        get: () => f,
                        set(t) {
                            e.embed
                                .setPlaybackRate(t)
                                .then(() => {
                                    (f = t), Me.call(e, e.media, "ratechange");
                                })
                                .catch(() => {
                                    e.options.speed = [1];
                                });
                        },
                    });
                    let { volume: M } = e.config;
                    Object.defineProperty(e.media, "volume", {
                        get: () => M,
                        set(t) {
                            e.embed.setVolume(t).then(() => {
                                (M = t), Me.call(e, e.media, "volumechange");
                            });
                        },
                    });
                    let { muted: b } = e.config;
                    Object.defineProperty(e.media, "muted", {
                        get: () => b,
                        set(t) {
                            const i = !!k(t) && t;
                            e.embed.setVolume(i ? 0 : e.config.volume).then(() => {
                                (b = i), Me.call(e, e.media, "volumechange");
                            });
                        },
                    });
                    let m,
                        { loop: g } = e.config;
                    Object.defineProperty(e.media, "loop", {
                        get: () => g,
                        set(t) {
                            const i = k(t) ? t : e.config.loop.active;
                            e.embed.setLoop(i).then(() => {
                                g = i;
                            });
                        },
                    }),
                        e.embed
                            .getVideoUrl()
                            .then((t) => {
                                (m = t), Pe.setDownloadUrl.call(e);
                            })
                            .catch((e) => {
                                this.debug.warn(e);
                            }),
                        Object.defineProperty(e.media, "currentSrc", { get: () => m }),
                        Object.defineProperty(e.media, "ended", { get: () => e.currentTime === e.duration }),
                        Promise.all([e.embed.getVideoWidth(), e.embed.getVideoHeight()]).then((t) => {
                            const [i, n] = t;
                            (e.embed.ratio = qe(i, n)), Ne.call(this);
                        }),
                        e.embed.setAutopause(e.config.autopause).then((t) => {
                            e.config.autopause = t;
                        }),
                        e.embed.getVideoTitle().then((t) => {
                            (e.config.title = t), Je.setTitle.call(this);
                        }),
                        e.embed.getCurrentTime().then((t) => {
                            (h = t), Me.call(e, e.media, "timeupdate");
                        }),
                        e.embed.getDuration().then((t) => {
                            (e.media.duration = t), Me.call(e, e.media, "durationchange");
                        }),
                        e.embed.getTextTracks().then((t) => {
                            (e.media.textTracks = t), je.setup.call(e);
                        }),
                        e.embed.on("cuechange", ({ cues: t = [] }) => {
                            const i = t.map((e) =>
                                (function (e) {
                                    const t = document.createDocumentFragment(),
                                        i = document.createElement("div");
                                    return t.appendChild(i), (i.innerHTML = e), t.firstChild.innerText;
                                })(e.text)
                            );
                            je.updateCues.call(e, i);
                        }),
                        e.embed.on("loaded", () => {
                            e.embed.getPaused().then((t) => {
                                it.call(e, !t), t || Me.call(e, e.media, "playing");
                            }),
                                x(e.embed.element) && e.supported.ui && e.embed.element.setAttribute("tabindex", -1);
                        }),
                        e.embed.on("bufferstart", () => {
                            Me.call(e, e.media, "waiting");
                        }),
                        e.embed.on("bufferend", () => {
                            Me.call(e, e.media, "playing");
                        }),
                        e.embed.on("play", () => {
                            it.call(e, !0), Me.call(e, e.media, "playing");
                        }),
                        e.embed.on("pause", () => {
                            it.call(e, !1);
                        }),
                        e.embed.on("timeupdate", (t) => {
                            (e.media.seeking = !1), (h = t.seconds), Me.call(e, e.media, "timeupdate");
                        }),
                        e.embed.on("progress", (t) => {
                            (e.media.buffered = t.percent),
                                Me.call(e, e.media, "progress"),
                                1 === parseInt(t.percent, 10) && Me.call(e, e.media, "canplaythrough"),
                                e.embed.getDuration().then((t) => {
                                    t !== e.media.duration && ((e.media.duration = t), Me.call(e, e.media, "durationchange"));
                                });
                        }),
                        e.embed.on("seeked", () => {
                            (e.media.seeking = !1), Me.call(e, e.media, "seeked");
                        }),
                        e.embed.on("ended", () => {
                            (e.media.paused = !0), Me.call(e, e.media, "ended");
                        }),
                        e.embed.on("error", (t) => {
                            (e.media.error = t), Me.call(e, e.media, "error");
                        }),
                        t.customControls && setTimeout(() => Je.build.call(e), 0);
                },
            };
            function ot(e) {
                e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && ((this.media.paused = !e), Me.call(this, this.media, e ? "play" : "pause"));
            }
            function st(e) {
                return e.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0;
            }
            const rt = {
                    setup() {
                        if ((ie(this.elements.wrapper, this.config.classNames.embed, !0), W(window.YT) && B(window.YT.Player))) rt.ready.call(this);
                        else {
                            const e = window.onYouTubeIframeAPIReady;
                            (window.onYouTubeIframeAPIReady = () => {
                                B(e) && e(), rt.ready.call(this);
                            }),
                                tt(this.config.urls.youtube.sdk).catch((e) => {
                                    this.debug.warn("YouTube API failed to load", e);
                                });
                        }
                    },
                    getTitle(e) {
                        xe(We(this.config.urls.youtube.api, e))
                            .then((e) => {
                                if (W(e)) {
                                    const { title: t, height: i, width: n } = e;
                                    (this.config.title = t), Je.setTitle.call(this), (this.embed.ratio = qe(n, i));
                                }
                                Ne.call(this);
                            })
                            .catch(() => {
                                Ne.call(this);
                            });
                    },
                    ready() {
                        const e = this,
                            t = e.config.youtube,
                            i = e.media && e.media.getAttribute("id");
                        if (!I(i) && i.startsWith("youtube-")) return;
                        let n = e.media.getAttribute("src");
                        I(n) && (n = e.media.getAttribute(this.config.attributes.embed.id));
                        const o = I((s = n)) ? null : s.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : s;
                        var s;
                        const r = G("div", { id: `${e.provider}-${Math.floor(1e4 * Math.random())}`, "data-poster": t.customControls ? e.poster : void 0 });
                        if (((e.media = Z(r, e.media)), t.customControls)) {
                            const t = (e) => `https://i.ytimg.com/vi/${o}/${e}default.jpg`;
                            Qe(t("maxres"), 121)
                                .catch(() => Qe(t("sd"), 121))
                                .catch(() => Qe(t("hq")))
                                .then((t) => Je.setPoster.call(e, t.src))
                                .then((t) => {
                                    t.includes("maxres") || (e.elements.poster.style.backgroundSize = "cover");
                                })
                                .catch(() => {});
                        }
                        e.embed = new window.YT.Player(e.media, {
                            videoId: o,
                            host: st(t),
                            playerVars: U(
                                {},
                                {
                                    autoplay: e.config.autoplay ? 1 : 0,
                                    hl: e.config.hl,
                                    controls: e.supported.ui && t.customControls ? 0 : 1,
                                    disablekb: 1,
                                    playsinline: e.config.fullscreen.iosNative ? 0 : 1,
                                    cc_load_policy: e.captions.active ? 1 : 0,
                                    cc_lang_pref: e.config.captions.language,
                                    widget_referrer: window ? window.location.href : null,
                                },
                                t
                            ),
                            events: {
                                onError(t) {
                                    if (!e.media.error) {
                                        const i = t.data,
                                            n =
                                                {
                                                    2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                                    5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                                    100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                                    101: "The owner of the requested video does not allow it to be played in embedded players.",
                                                    150: "The owner of the requested video does not allow it to be played in embedded players.",
                                                }[i] || "An unknown error occured";
                                        (e.media.error = { code: i, message: n }), Me.call(e, e.media, "error");
                                    }
                                },
                                onPlaybackRateChange(t) {
                                    const i = t.target;
                                    (e.media.playbackRate = i.getPlaybackRate()), Me.call(e, e.media, "ratechange");
                                },
                                onReady(i) {
                                    if (B(e.media.play)) return;
                                    const n = i.target;
                                    rt.getTitle.call(e, o),
                                        (e.media.play = () => {
                                            ot.call(e, !0), n.playVideo();
                                        }),
                                        (e.media.pause = () => {
                                            ot.call(e, !1), n.pauseVideo();
                                        }),
                                        (e.media.stop = () => {
                                            n.stopVideo();
                                        }),
                                        (e.media.duration = n.getDuration()),
                                        (e.media.paused = !0),
                                        (e.media.currentTime = 0),
                                        Object.defineProperty(e.media, "currentTime", {
                                            get: () => Number(n.getCurrentTime()),
                                            set(t) {
                                                e.paused && !e.embed.hasPlayed && e.embed.mute(), (e.media.seeking = !0), Me.call(e, e.media, "seeking"), n.seekTo(t);
                                            },
                                        }),
                                        Object.defineProperty(e.media, "playbackRate", {
                                            get: () => n.getPlaybackRate(),
                                            set(e) {
                                                n.setPlaybackRate(e);
                                            },
                                        });
                                    let { volume: s } = e.config;
                                    Object.defineProperty(e.media, "volume", {
                                        get: () => s,
                                        set(t) {
                                            (s = t), n.setVolume(100 * s), Me.call(e, e.media, "volumechange");
                                        },
                                    });
                                    let { muted: r } = e.config;
                                    Object.defineProperty(e.media, "muted", {
                                        get: () => r,
                                        set(t) {
                                            const i = k(t) ? t : r;
                                            (r = i), n[i ? "mute" : "unMute"](), n.setVolume(100 * s), Me.call(e, e.media, "volumechange");
                                        },
                                    }),
                                        Object.defineProperty(e.media, "currentSrc", { get: () => n.getVideoUrl() }),
                                        Object.defineProperty(e.media, "ended", { get: () => e.currentTime === e.duration });
                                    const c = n.getAvailablePlaybackRates();
                                    (e.options.speed = c.filter((t) => e.config.speed.options.includes(t))),
                                        e.supported.ui && t.customControls && e.media.setAttribute("tabindex", -1),
                                        Me.call(e, e.media, "timeupdate"),
                                        Me.call(e, e.media, "durationchange"),
                                        clearInterval(e.timers.buffering),
                                        (e.timers.buffering = setInterval(() => {
                                            (e.media.buffered = n.getVideoLoadedFraction()),
                                                (null === e.media.lastBuffered || e.media.lastBuffered < e.media.buffered) && Me.call(e, e.media, "progress"),
                                                (e.media.lastBuffered = e.media.buffered),
                                                1 === e.media.buffered && (clearInterval(e.timers.buffering), Me.call(e, e.media, "canplaythrough"));
                                        }, 200)),
                                        t.customControls && setTimeout(() => Je.build.call(e), 50);
                                },
                                onStateChange(i) {
                                    const n = i.target;
                                    switch ((clearInterval(e.timers.playing), e.media.seeking && [1, 2].includes(i.data) && ((e.media.seeking = !1), Me.call(e, e.media, "seeked")), i.data)) {
                                        case -1:
                                            Me.call(e, e.media, "timeupdate"), (e.media.buffered = n.getVideoLoadedFraction()), Me.call(e, e.media, "progress");
                                            break;
                                        case 0:
                                            ot.call(e, !1), e.media.loop ? (n.stopVideo(), n.playVideo()) : Me.call(e, e.media, "ended");
                                            break;
                                        case 1:
                                            t.customControls && !e.config.autoplay && e.media.paused && !e.embed.hasPlayed
                                                ? e.media.pause()
                                                : (ot.call(e, !0),
                                                  Me.call(e, e.media, "playing"),
                                                  (e.timers.playing = setInterval(() => {
                                                      Me.call(e, e.media, "timeupdate");
                                                  }, 50)),
                                                  e.media.duration !== n.getDuration() && ((e.media.duration = n.getDuration()), Me.call(e, e.media, "durationchange")));
                                            break;
                                        case 2:
                                            e.muted || e.embed.unMute(), ot.call(e, !1);
                                            break;
                                        case 3:
                                            Me.call(e, e.media, "waiting");
                                    }
                                    Me.call(e, e.elements.container, "statechange", !1, { code: i.data });
                                },
                            },
                        });
                    },
                },
                ct = {
                    setup() {
                        this.media
                            ? (ie(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0),
                              ie(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0),
                              this.isEmbed && ie(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0),
                              this.isVideo &&
                                  ((this.elements.wrapper = G("div", { class: this.config.classNames.video })),
                                  V(this.media, this.elements.wrapper),
                                  (this.elements.poster = G("div", { class: this.config.classNames.poster })),
                                  this.elements.wrapper.appendChild(this.elements.poster)),
                              this.isHTML5 ? we.setup.call(this) : this.isYouTube ? rt.setup.call(this) : this.isVimeo && nt.setup.call(this))
                            : this.debug.warn("No media element found!");
                    },
                };
            class at {
                constructor(t) {
                    e(this, "load", () => {
                        this.enabled &&
                            (W(window.google) && W(window.google.ima)
                                ? this.ready()
                                : tt(this.player.config.urls.googleIMA.sdk)
                                      .then(() => {
                                          this.ready();
                                      })
                                      .catch(() => {
                                          this.trigger("error", new Error("Google IMA SDK failed to load"));
                                      }));
                    }),
                        e(this, "ready", () => {
                            var e;
                            this.enabled || ((e = this).manager && e.manager.destroy(), e.elements.displayContainer && e.elements.displayContainer.destroy(), e.elements.container.remove()),
                                this.startSafetyTimer(12e3, "ready()"),
                                this.managerPromise.then(() => {
                                    this.clearSafetyTimer("onAdsManagerLoaded()");
                                }),
                                this.listeners(),
                                this.setupIMA();
                        }),
                        e(this, "setupIMA", () => {
                            (this.elements.container = G("div", { class: this.player.config.classNames.ads })),
                                this.player.elements.container.appendChild(this.elements.container),
                                google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED),
                                google.ima.settings.setLocale(this.player.config.ads.language),
                                google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline),
                                (this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media)),
                                (this.loader = new google.ima.AdsLoader(this.elements.displayContainer)),
                                this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (e) => this.onAdsManagerLoaded(e), !1),
                                this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e) => this.onAdError(e), !1),
                                this.requestAds();
                        }),
                        e(this, "requestAds", () => {
                            const { container: e } = this.player.elements;
                            try {
                                const t = new google.ima.AdsRequest();
                                (t.adTagUrl = this.tagUrl),
                                    (t.linearAdSlotWidth = e.offsetWidth),
                                    (t.linearAdSlotHeight = e.offsetHeight),
                                    (t.nonLinearAdSlotWidth = e.offsetWidth),
                                    (t.nonLinearAdSlotHeight = e.offsetHeight),
                                    (t.forceNonLinearFullSlot = !1),
                                    t.setAdWillPlayMuted(!this.player.muted),
                                    this.loader.requestAds(t);
                            } catch (e) {
                                this.onAdError(e);
                            }
                        }),
                        e(this, "pollCountdown", (e = !1) => {
                            if (!e) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
                            this.countdownTimer = setInterval(() => {
                                const e = Re(Math.max(this.manager.getRemainingTime(), 0)),
                                    t = `${Ee.get("advertisement", this.player.config)} - ${e}`;
                                this.elements.container.setAttribute("data-badge-text", t);
                            }, 100);
                        }),
                        e(this, "onAdsManagerLoaded", (e) => {
                            if (!this.enabled) return;
                            const t = new google.ima.AdsRenderingSettings();
                            (t.restoreCustomPlaybackStateOnAdBreakComplete = !0),
                                (t.enablePreloading = !0),
                                (this.manager = e.getAdsManager(this.player, t)),
                                (this.cuePoints = this.manager.getCuePoints()),
                                this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e) => this.onAdError(e)),
                                Object.keys(google.ima.AdEvent.Type).forEach((e) => {
                                    this.manager.addEventListener(google.ima.AdEvent.Type[e], (e) => this.onAdEvent(e));
                                }),
                                this.trigger("loaded");
                        }),
                        e(this, "addCuePoints", () => {
                            I(this.cuePoints) ||
                                this.cuePoints.forEach((e) => {
                                    if (0 !== e && -1 !== e && e < this.player.duration) {
                                        const t = this.player.elements.progress;
                                        if (x(t)) {
                                            const i = (100 / this.player.duration) * e,
                                                n = G("span", { class: this.player.config.classNames.cues });
                                            (n.style.left = `${i.toString()}%`), t.appendChild(n);
                                        }
                                    }
                                });
                        }),
                        e(this, "onAdEvent", (e) => {
                            const { container: t } = this.player.elements,
                                i = e.getAd(),
                                n = e.getAdData();
                            switch (
                                (((e) => {
                                    Me.call(this.player, this.player.media, `ads${e.replace(/_/g, "").toLowerCase()}`);
                                })(e.type),
                                e.type)
                            ) {
                                case google.ima.AdEvent.Type.LOADED:
                                    this.trigger("loaded"), this.pollCountdown(!0), i.isLinear() || ((i.width = t.offsetWidth), (i.height = t.offsetHeight));
                                    break;
                                case google.ima.AdEvent.Type.STARTED:
                                    this.manager.setVolume(this.player.volume);
                                    break;
                                case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                                    this.player.ended ? this.loadAds() : this.loader.contentComplete();
                                    break;
                                case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                                    this.pauseContent();
                                    break;
                                case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                                    this.pollCountdown(), this.resumeContent();
                                    break;
                                case google.ima.AdEvent.Type.LOG:
                                    n.adError && this.player.debug.warn(`Non-fatal ad error: ${n.adError.getMessage()}`);
                            }
                        }),
                        e(this, "onAdError", (e) => {
                            this.cancel(), this.player.debug.warn("Ads error", e);
                        }),
                        e(this, "listeners", () => {
                            const { container: e } = this.player.elements;
                            let t;
                            this.player.on("canplay", () => {
                                this.addCuePoints();
                            }),
                                this.player.on("ended", () => {
                                    this.loader.contentComplete();
                                }),
                                this.player.on("timeupdate", () => {
                                    t = this.player.currentTime;
                                }),
                                this.player.on("seeked", () => {
                                    const e = this.player.currentTime;
                                    I(this.cuePoints) ||
                                        this.cuePoints.forEach((i, n) => {
                                            t < i && i < e && (this.manager.discardAdBreak(), this.cuePoints.splice(n, 1));
                                        });
                                }),
                                window.addEventListener("resize", () => {
                                    this.manager && this.manager.resize(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL);
                                });
                        }),
                        e(this, "play", () => {
                            const { container: e } = this.player.elements;
                            this.managerPromise || this.resumeContent(),
                                this.managerPromise
                                    .then(() => {
                                        this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
                                        try {
                                            this.initialized || (this.manager.init(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), (this.initialized = !0);
                                        } catch (e) {
                                            this.onAdError(e);
                                        }
                                    })
                                    .catch(() => {});
                        }),
                        e(this, "resumeContent", () => {
                            (this.elements.container.style.zIndex = ""), (this.playing = !1), ge(this.player.media.play());
                        }),
                        e(this, "pauseContent", () => {
                            (this.elements.container.style.zIndex = 3), (this.playing = !0), this.player.media.pause();
                        }),
                        e(this, "cancel", () => {
                            this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
                        }),
                        e(this, "loadAds", () => {
                            this.managerPromise
                                .then(() => {
                                    this.manager && this.manager.destroy(),
                                        (this.managerPromise = new Promise((e) => {
                                            this.on("loaded", e), this.player.debug.log(this.manager);
                                        })),
                                        (this.initialized = !1),
                                        this.requestAds();
                                })
                                .catch(() => {});
                        }),
                        e(this, "trigger", (e, ...t) => {
                            const i = this.events[e];
                            E(i) &&
                                i.forEach((e) => {
                                    B(e) && e.apply(this, t);
                                });
                        }),
                        e(this, "on", (e, t) => (E(this.events[e]) || (this.events[e] = []), this.events[e].push(t), this)),
                        e(this, "startSafetyTimer", (e, t) => {
                            this.player.debug.log(`Safety timer invoked from: ${t}`),
                                (this.safetyTimer = setTimeout(() => {
                                    this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
                                }, e));
                        }),
                        e(this, "clearSafetyTimer", (e) => {
                            w(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${e}`), clearTimeout(this.safetyTimer), (this.safetyTimer = null));
                        }),
                        (this.player = t),
                        (this.config = t.config.ads),
                        (this.playing = !1),
                        (this.initialized = !1),
                        (this.elements = { container: null, displayContainer: null }),
                        (this.manager = null),
                        (this.loader = null),
                        (this.cuePoints = null),
                        (this.events = {}),
                        (this.safetyTimer = null),
                        (this.countdownTimer = null),
                        (this.managerPromise = new Promise((e, t) => {
                            this.on("loaded", e), this.on("error", t);
                        })),
                        this.load();
                }
                get enabled() {
                    const { config: e } = this;
                    return this.player.isHTML5 && this.player.isVideo && e.enabled && (!I(e.publisherId) || P(e.tagUrl));
                }
                get tagUrl() {
                    const { config: e } = this;
                    return P(e.tagUrl)
                        ? e.tagUrl
                        : `https://go.aniview.com/api/adserver6/vast/?${He({
                              AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                              AV_CHANNELID: "5a0458dc28a06145e4519d21",
                              AV_URL: window.location.hostname,
                              cb: Date.now(),
                              AV_WIDTH: 640,
                              AV_HEIGHT: 480,
                              AV_CDIM2: e.publisherId,
                          })}`;
                }
            }
            const lt = (e) => {
                    const t = [];
                    return (
                        e.split(/\r\n\r\n|\n\n|\r\r/).forEach((e) => {
                            const i = {};
                            e.split(/\r\n|\n|\r/).forEach((e) => {
                                if (S(i.startTime)) {
                                    if (!I(e.trim()) && I(i.text)) {
                                        const t = e.trim().split("#xywh=");
                                        ([i.text] = t), t[1] && ([i.x, i.y, i.w, i.h] = t[1].split(","));
                                    }
                                } else {
                                    const t = e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                                    t &&
                                        ((i.startTime = 60 * Number(t[1] || 0) * 60 + 60 * Number(t[2]) + Number(t[3]) + Number(`0.${t[4]}`)),
                                        (i.endTime = 60 * Number(t[6] || 0) * 60 + 60 * Number(t[7]) + Number(t[8]) + Number(`0.${t[9]}`)));
                                }
                            }),
                                i.text && t.push(i);
                        }),
                        t
                    );
                },
                ut = (e, t) => {
                    const i = {};
                    return e > t.width / t.height ? ((i.width = t.width), (i.height = (1 / e) * t.width)) : ((i.height = t.height), (i.width = e * t.height)), i;
                };
            class dt {
                constructor(t) {
                    e(this, "load", () => {
                        this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled),
                            this.enabled &&
                                this.getThumbnails().then(() => {
                                    this.enabled && (this.render(), this.determineContainerAutoSizing(), (this.loaded = !0));
                                });
                    }),
                        e(
                            this,
                            "getThumbnails",
                            () =>
                                new Promise((e) => {
                                    const { src: t } = this.player.config.previewThumbnails;
                                    if (I(t)) throw new Error("Missing previewThumbnails.src config attribute");
                                    const i = () => {
                                        this.thumbnails.sort((e, t) => e.height - t.height), this.player.debug.log("Preview thumbnails", this.thumbnails), e();
                                    };
                                    if (B(t))
                                        t((e) => {
                                            (this.thumbnails = e), i();
                                        });
                                    else {
                                        const e = (C(t) ? [t] : t).map((e) => this.getThumbnail(e));
                                        Promise.all(e).then(i);
                                    }
                                })
                        ),
                        e(
                            this,
                            "getThumbnail",
                            (e) =>
                                new Promise((t) => {
                                    xe(e).then((i) => {
                                        const n = { frames: lt(i), height: null, urlPrefix: "" };
                                        n.frames[0].text.startsWith("/") || n.frames[0].text.startsWith("http://") || n.frames[0].text.startsWith("https://") || (n.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                                        const o = new Image();
                                        (o.onload = () => {
                                            (n.height = o.naturalHeight), (n.width = o.naturalWidth), this.thumbnails.push(n), t();
                                        }),
                                            (o.src = n.urlPrefix + n.frames[0].text);
                                    });
                                })
                        ),
                        e(this, "startMove", (e) => {
                            if (this.loaded && _(e) && ["touchmove", "mousemove"].includes(e.type) && this.player.media.duration) {
                                if ("touchmove" === e.type) this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                                else {
                                    const t = this.player.elements.progress.getBoundingClientRect(),
                                        i = (100 / t.width) * (e.pageX - t.left);
                                    (this.seekTime = this.player.media.duration * (i / 100)),
                                        this.seekTime < 0 && (this.seekTime = 0),
                                        this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1),
                                        (this.mousePosX = e.pageX),
                                        (this.elements.thumb.time.innerText = Re(this.seekTime));
                                }
                                this.showImageAtCurrentTime();
                            }
                        }),
                        e(this, "endMove", () => {
                            this.toggleThumbContainer(!1, !0);
                        }),
                        e(this, "startScrubbing", (e) => {
                            (w(e.button) || !1 === e.button || 0 === e.button) && ((this.mouseDown = !0), this.player.media.duration && (this.toggleScrubbingContainer(!0), this.toggleThumbContainer(!1, !0), this.showImageAtCurrentTime()));
                        }),
                        e(this, "endScrubbing", () => {
                            (this.mouseDown = !1),
                                Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime)
                                    ? this.toggleScrubbingContainer(!1)
                                    : fe.call(this.player, this.player.media, "timeupdate", () => {
                                          this.mouseDown || this.toggleScrubbingContainer(!1);
                                      });
                        }),
                        e(this, "listeners", () => {
                            this.player.on("play", () => {
                                this.toggleThumbContainer(!1, !0);
                            }),
                                this.player.on("seeked", () => {
                                    this.toggleThumbContainer(!1);
                                }),
                                this.player.on("timeupdate", () => {
                                    this.lastTime = this.player.media.currentTime;
                                });
                        }),
                        e(this, "render", () => {
                            (this.elements.thumb.container = G("div", { class: this.player.config.classNames.previewThumbnails.thumbContainer })),
                                (this.elements.thumb.imageContainer = G("div", { class: this.player.config.classNames.previewThumbnails.imageContainer })),
                                this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                            const e = G("div", { class: this.player.config.classNames.previewThumbnails.timeContainer });
                            (this.elements.thumb.time = G("span", {}, "00:00")),
                                e.appendChild(this.elements.thumb.time),
                                this.elements.thumb.container.appendChild(e),
                                x(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container),
                                (this.elements.scrubbing.container = G("div", { class: this.player.config.classNames.previewThumbnails.scrubbingContainer })),
                                this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
                        }),
                        e(this, "destroy", () => {
                            this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
                        }),
                        e(this, "showImageAtCurrentTime", () => {
                            this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
                            const e = this.thumbnails[0].frames.findIndex((e) => this.seekTime >= e.startTime && this.seekTime <= e.endTime),
                                t = e >= 0;
                            let i = 0;
                            this.mouseDown || this.toggleThumbContainer(t),
                                t &&
                                    (this.thumbnails.forEach((t, n) => {
                                        this.loadedImages.includes(t.frames[e].text) && (i = n);
                                    }),
                                    e !== this.showingThumb && ((this.showingThumb = e), this.loadImage(i)));
                        }),
                        e(this, "loadImage", (e = 0) => {
                            const t = this.showingThumb,
                                i = this.thumbnails[e],
                                { urlPrefix: n } = i,
                                o = i.frames[t],
                                s = i.frames[t].text,
                                r = n + s;
                            if (this.currentImageElement && this.currentImageElement.dataset.filename === s)
                                this.showImage(this.currentImageElement, o, e, t, s, !1), (this.currentImageElement.dataset.index = t), this.removeOldImages(this.currentImageElement);
                            else {
                                this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
                                const i = new Image();
                                (i.src = r),
                                    (i.dataset.index = t),
                                    (i.dataset.filename = s),
                                    (this.showingThumbFilename = s),
                                    this.player.debug.log(`Loading image: ${r}`),
                                    (i.onload = () => this.showImage(i, o, e, t, s, !0)),
                                    (this.loadingImage = i),
                                    this.removeOldImages(i);
                            }
                        }),
                        e(this, "showImage", (e, t, i, n, o, s = !0) => {
                            this.player.debug.log(`Showing thumb: ${o}. num: ${n}. qual: ${i}. newimg: ${s}`),
                                this.setImageSizeAndOffset(e, t),
                                s && (this.currentImageContainer.appendChild(e), (this.currentImageElement = e), this.loadedImages.includes(o) || this.loadedImages.push(o)),
                                this.preloadNearby(n, !0).then(this.preloadNearby(n, !1)).then(this.getHigherQuality(i, e, t, o));
                        }),
                        e(this, "removeOldImages", (e) => {
                            Array.from(this.currentImageContainer.children).forEach((t) => {
                                if ("img" !== t.tagName.toLowerCase()) return;
                                const i = this.usingSprites ? 500 : 1e3;
                                if (t.dataset.index !== e.dataset.index && !t.dataset.deleting) {
                                    t.dataset.deleting = !0;
                                    const { currentImageContainer: e } = this;
                                    setTimeout(() => {
                                        e.removeChild(t), this.player.debug.log(`Removing thumb: ${t.dataset.filename}`);
                                    }, i);
                                }
                            });
                        }),
                        e(
                            this,
                            "preloadNearby",
                            (e, t = !0) =>
                                new Promise((i) => {
                                    setTimeout(() => {
                                        const n = this.thumbnails[0].frames[e].text;
                                        if (this.showingThumbFilename === n) {
                                            let o;
                                            o = t ? this.thumbnails[0].frames.slice(e) : this.thumbnails[0].frames.slice(0, e).reverse();
                                            let s = !1;
                                            o.forEach((e) => {
                                                const t = e.text;
                                                if (t !== n && !this.loadedImages.includes(t)) {
                                                    (s = !0), this.player.debug.log(`Preloading thumb filename: ${t}`);
                                                    const { urlPrefix: e } = this.thumbnails[0],
                                                        n = e + t,
                                                        o = new Image();
                                                    (o.src = n),
                                                        (o.onload = () => {
                                                            this.player.debug.log(`Preloaded thumb filename: ${t}`), this.loadedImages.includes(t) || this.loadedImages.push(t), i();
                                                        });
                                                }
                                            }),
                                                s || i();
                                        }
                                    }, 300);
                                })
                        ),
                        e(this, "getHigherQuality", (e, t, i, n) => {
                            if (e < this.thumbnails.length - 1) {
                                let o = t.naturalHeight;
                                this.usingSprites && (o = i.h),
                                    o < this.thumbContainerHeight &&
                                        setTimeout(() => {
                                            this.showingThumbFilename === n && (this.player.debug.log(`Showing higher quality thumb for: ${n}`), this.loadImage(e + 1));
                                        }, 300);
                            }
                        }),
                        e(this, "toggleThumbContainer", (e = !1, t = !1) => {
                            const i = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                            this.elements.thumb.container.classList.toggle(i, e), !e && t && ((this.showingThumb = null), (this.showingThumbFilename = null));
                        }),
                        e(this, "toggleScrubbingContainer", (e = !1) => {
                            const t = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                            this.elements.scrubbing.container.classList.toggle(t, e), e || ((this.showingThumb = null), (this.showingThumbFilename = null));
                        }),
                        e(this, "determineContainerAutoSizing", () => {
                            (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = !0);
                        }),
                        e(this, "setThumbContainerSizeAndPos", () => {
                            if (this.sizeSpecifiedInCSS) {
                                if (this.elements.thumb.imageContainer.clientHeight > 20 && this.elements.thumb.imageContainer.clientWidth < 20) {
                                    const e = Math.floor(this.elements.thumb.imageContainer.clientHeight * this.thumbAspectRatio);
                                    this.elements.thumb.imageContainer.style.width = `${e}px`;
                                } else if (this.elements.thumb.imageContainer.clientHeight < 20 && this.elements.thumb.imageContainer.clientWidth > 20) {
                                    const e = Math.floor(this.elements.thumb.imageContainer.clientWidth / this.thumbAspectRatio);
                                    this.elements.thumb.imageContainer.style.height = `${e}px`;
                                }
                            } else {
                                const e = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                                (this.elements.thumb.imageContainer.style.height = `${this.thumbContainerHeight}px`), (this.elements.thumb.imageContainer.style.width = `${e}px`);
                            }
                            this.setThumbContainerPos();
                        }),
                        e(this, "setThumbContainerPos", () => {
                            const e = this.player.elements.progress.getBoundingClientRect(),
                                t = this.player.elements.container.getBoundingClientRect(),
                                { container: i } = this.elements.thumb,
                                n = t.left - e.left + 10,
                                o = t.right - e.left - i.clientWidth - 10;
                            let s = this.mousePosX - e.left - i.clientWidth / 2;
                            s < n && (s = n), s > o && (s = o), (i.style.left = `${s}px`);
                        }),
                        e(this, "setScrubbingContainerSize", () => {
                            const { width: e, height: t } = ut(this.thumbAspectRatio, { width: this.player.media.clientWidth, height: this.player.media.clientHeight });
                            (this.elements.scrubbing.container.style.width = `${e}px`), (this.elements.scrubbing.container.style.height = `${t}px`);
                        }),
                        e(this, "setImageSizeAndOffset", (e, t) => {
                            if (!this.usingSprites) return;
                            const i = this.thumbContainerHeight / t.h;
                            (e.style.height = e.naturalHeight * i + "px"), (e.style.width = e.naturalWidth * i + "px"), (e.style.left = `-${t.x * i}px`), (e.style.top = `-${t.y * i}px`);
                        }),
                        (this.player = t),
                        (this.thumbnails = []),
                        (this.loaded = !1),
                        (this.lastMouseMoveTime = Date.now()),
                        (this.mouseDown = !1),
                        (this.loadedImages = []),
                        (this.elements = { thumb: {}, scrubbing: {} }),
                        this.load();
                }
                get enabled() {
                    return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
                }
                get currentImageContainer() {
                    return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
                }
                get usingSprites() {
                    return Object.keys(this.thumbnails[0].frames[0]).includes("w");
                }
                get thumbAspectRatio() {
                    return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
                }
                get thumbContainerHeight() {
                    if (this.mouseDown) {
                        const { height: e } = ut(this.thumbAspectRatio, { width: this.player.media.clientWidth, height: this.player.media.clientHeight });
                        return e;
                    }
                    return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
                }
                get currentImageElement() {
                    return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
                }
                set currentImageElement(e) {
                    this.mouseDown ? (this.currentScrubbingImageElement = e) : (this.currentThumbnailImageElement = e);
                }
            }
            const pt = {
                insertElements(e, t) {
                    C(t)
                        ? K(e, this.media, { src: t })
                        : E(t) &&
                          t.forEach((t) => {
                              K(e, this.media, t);
                          });
                },
                change(e) {
                    F(e, "sources.length")
                        ? (we.cancelRequests.call(this),
                          this.destroy.call(
                              this,
                              () => {
                                  (this.options.quality = []), Q(this.media), (this.media = null), x(this.elements.container) && this.elements.container.removeAttribute("class");
                                  const { sources: t, type: i } = e,
                                      [{ provider: n = Ue.html5, src: o }] = t,
                                      s = "html5" === n ? i : "div",
                                      r = "html5" === n ? {} : { src: o };
                                  Object.assign(this, { provider: n, type: i, supported: le.check(i, n, this.config.playsinline), media: G(s, r) }),
                                      this.elements.container.appendChild(this.media),
                                      k(e.autoplay) && (this.config.autoplay = e.autoplay),
                                      this.isHTML5 &&
                                          (this.config.crossorigin && this.media.setAttribute("crossorigin", ""),
                                          this.config.autoplay && this.media.setAttribute("autoplay", ""),
                                          I(e.poster) || (this.poster = e.poster),
                                          this.config.loop.active && this.media.setAttribute("loop", ""),
                                          this.config.muted && this.media.setAttribute("muted", ""),
                                          this.config.playsinline && this.media.setAttribute("playsinline", "")),
                                      Je.addStyleHook.call(this),
                                      this.isHTML5 && pt.insertElements.call(this, "source", t),
                                      (this.config.title = e.title),
                                      ct.setup.call(this),
                                      this.isHTML5 && Object.keys(e).includes("tracks") && pt.insertElements.call(this, "track", e.tracks),
                                      (this.isHTML5 || (this.isEmbed && !this.supported.ui)) && Je.build.call(this),
                                      this.isHTML5 && this.media.load(),
                                      I(e.previewThumbnails) ||
                                          (Object.assign(this.config.previewThumbnails, e.previewThumbnails),
                                          this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), (this.previewThumbnails = null)),
                                          this.config.previewThumbnails.enabled && (this.previewThumbnails = new dt(this))),
                                      this.fullscreen.update();
                              },
                              !0
                          ))
                        : this.debug.warn("Invalid source format");
                },
            };
            class ht {
                constructor(t, i) {
                    if (
                        (e(this, "play", () => (B(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(() => this.ads.play()).catch(() => ge(this.media.play())), this.media.play()) : null)),
                        e(this, "pause", () => (this.playing && B(this.media.pause) ? this.media.pause() : null)),
                        e(this, "togglePlay", (e) => ((k(e) ? e : !this.playing) ? this.play() : this.pause())),
                        e(this, "stop", () => {
                            this.isHTML5 ? (this.pause(), this.restart()) : B(this.media.stop) && this.media.stop();
                        }),
                        e(this, "restart", () => {
                            this.currentTime = 0;
                        }),
                        e(this, "rewind", (e) => {
                            this.currentTime -= S(e) ? e : this.config.seekTime;
                        }),
                        e(this, "forward", (e) => {
                            this.currentTime += S(e) ? e : this.config.seekTime;
                        }),
                        e(this, "increaseVolume", (e) => {
                            const t = this.media.muted ? 0 : this.volume;
                            this.volume = t + (S(e) ? e : 0);
                        }),
                        e(this, "decreaseVolume", (e) => {
                            this.increaseVolume(-e);
                        }),
                        e(this, "airplay", () => {
                            le.airplay && this.media.webkitShowPlaybackTargetPicker();
                        }),
                        e(this, "toggleControls", (e) => {
                            if (this.supported.ui && !this.isAudio) {
                                const t = ne(this.elements.container, this.config.classNames.hideControls),
                                    i = void 0 === e ? void 0 : !e,
                                    n = ie(this.elements.container, this.config.classNames.hideControls, i);
                                if ((n && E(this.config.controls) && this.config.controls.includes("settings") && !I(this.config.settings) && Pe.toggleMenu.call(this, !1), n !== t)) {
                                    const e = n ? "controlshidden" : "controlsshown";
                                    Me.call(this, this.media, e);
                                }
                                return !n;
                            }
                            return !1;
                        }),
                        e(this, "on", (e, t) => {
                            pe.call(this, this.elements.container, e, t);
                        }),
                        e(this, "once", (e, t) => {
                            fe.call(this, this.elements.container, e, t);
                        }),
                        e(this, "off", (e, t) => {
                            he(this.elements.container, e, t);
                        }),
                        e(this, "destroy", (e, t = !1) => {
                            if (!this.ready) return;
                            const i = () => {
                                (document.body.style.overflow = ""),
                                    (this.embed = null),
                                    t
                                        ? (Object.keys(this.elements).length &&
                                              (Q(this.elements.buttons.play),
                                              Q(this.elements.captions),
                                              Q(this.elements.controls),
                                              Q(this.elements.wrapper),
                                              (this.elements.buttons.play = null),
                                              (this.elements.captions = null),
                                              (this.elements.controls = null),
                                              (this.elements.wrapper = null)),
                                          B(e) && e())
                                        : (be.call(this),
                                          we.cancelRequests.call(this),
                                          Z(this.elements.original, this.elements.container),
                                          Me.call(this, this.elements.original, "destroyed", !0),
                                          B(e) && e.call(this.elements.original),
                                          (this.ready = !1),
                                          setTimeout(() => {
                                              (this.elements = null), (this.media = null);
                                          }, 200));
                            };
                            this.stop(),
                                clearTimeout(this.timers.loading),
                                clearTimeout(this.timers.controls),
                                clearTimeout(this.timers.resized),
                                this.isHTML5
                                    ? (Je.toggleNativeControls.call(this, !0), i())
                                    : this.isYouTube
                                    ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), null !== this.embed && B(this.embed.destroy) && this.embed.destroy(), i())
                                    : this.isVimeo && (null !== this.embed && this.embed.unload().then(i), setTimeout(i, 200));
                        }),
                        e(this, "supports", (e) => le.mime.call(this, e)),
                        (this.timers = {}),
                        (this.ready = !1),
                        (this.loading = !1),
                        (this.failed = !1),
                        (this.touch = le.touch),
                        (this.media = t),
                        C(this.media) && (this.media = document.querySelectorAll(this.media)),
                        ((window.jQuery && this.media instanceof jQuery) || X(this.media) || E(this.media)) && (this.media = this.media[0]),
                        (this.config = U(
                            {},
                            $e,
                            ht.defaults,
                            i || {},
                            (() => {
                                try {
                                    return JSON.parse(this.media.getAttribute("data-plyr-config"));
                                } catch (e) {
                                    return {};
                                }
                            })()
                        )),
                        (this.elements = { container: null, fullscreen: null, captions: null, buttons: {}, display: {}, progress: {}, inputs: {}, settings: { popup: null, menu: null, panels: {}, buttons: {} } }),
                        (this.captions = { active: null, currentTrack: -1, meta: new WeakMap() }),
                        (this.fullscreen = { active: !1 }),
                        (this.options = { speed: [], quality: [] }),
                        (this.debug = new Ge(this.config.debug)),
                        this.debug.log("Config", this.config),
                        this.debug.log("Support", le),
                        w(this.media) || !x(this.media))
                    )
                        return void this.debug.error("Setup failed: no suitable element passed");
                    if (this.media.plyr) return void this.debug.warn("Target already setup");
                    if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
                    if (!le.check().api) return void this.debug.error("Setup failed: no support");
                    const n = this.media.cloneNode(!0);
                    (n.autoplay = !1), (this.elements.original = n);
                    const o = this.media.tagName.toLowerCase();
                    let s = null,
                        r = null;
                    switch (o) {
                        case "div":
                            if (((s = this.media.querySelector("iframe")), x(s))) {
                                if (
                                    ((r = Ie(s.getAttribute("src"))),
                                    (this.provider = (function (e) {
                                        return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e) ? Ue.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e) ? Ue.vimeo : null;
                                    })(r.toString())),
                                    (this.elements.container = this.media),
                                    (this.media = s),
                                    (this.elements.container.className = ""),
                                    r.search.length)
                                ) {
                                    const e = ["1", "true"];
                                    e.includes(r.searchParams.get("autoplay")) && (this.config.autoplay = !0),
                                        e.includes(r.searchParams.get("loop")) && (this.config.loop.active = !0),
                                        this.isYouTube ? ((this.config.playsinline = e.includes(r.searchParams.get("playsinline"))), (this.config.youtube.hl = r.searchParams.get("hl"))) : (this.config.playsinline = !0);
                                }
                            } else (this.provider = this.media.getAttribute(this.config.attributes.embed.provider)), this.media.removeAttribute(this.config.attributes.embed.provider);
                            if (I(this.provider) || !Object.values(Ue).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
                            this.type = Ve;
                            break;
                        case "video":
                        case "audio":
                            (this.type = o),
                                (this.provider = Ue.html5),
                                this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0),
                                this.media.hasAttribute("autoplay") && (this.config.autoplay = !0),
                                (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0),
                                this.media.hasAttribute("muted") && (this.config.muted = !0),
                                this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                            break;
                        default:
                            return void this.debug.error("Setup failed: unsupported type");
                    }
                    (this.supported = le.check(this.type, this.provider, this.config.playsinline)),
                        this.supported.api
                            ? ((this.eventListeners = []),
                              (this.listeners = new Ze(this)),
                              (this.storage = new Xe(this)),
                              (this.media.plyr = this),
                              x(this.elements.container) || ((this.elements.container = G("div", { tabindex: 0 })), V(this.media, this.elements.container)),
                              Je.migrateStyles.call(this),
                              Je.addStyleHook.call(this),
                              ct.setup.call(this),
                              this.config.debug &&
                                  pe.call(this, this.elements.container, this.config.events.join(" "), (e) => {
                                      this.debug.log(`event: ${e.type}`);
                                  }),
                              (this.fullscreen = new Ke(this)),
                              (this.isHTML5 || (this.isEmbed && !this.supported.ui)) && Je.build.call(this),
                              this.listeners.container(),
                              this.listeners.global(),
                              this.config.ads.enabled && (this.ads = new at(this)),
                              this.isHTML5 && this.config.autoplay && this.once("canplay", () => ge(this.play())),
                              (this.lastSeekTime = 0),
                              this.config.previewThumbnails.enabled && (this.previewThumbnails = new dt(this)))
                            : this.debug.error("Setup failed: no support");
                }
                get isHTML5() {
                    return this.provider === Ue.html5;
                }
                get isEmbed() {
                    return this.isYouTube || this.isVimeo;
                }
                get isYouTube() {
                    return this.provider === Ue.youtube;
                }
                get isVimeo() {
                    return this.provider === Ue.vimeo;
                }
                get isVideo() {
                    return this.type === Ve;
                }
                get isAudio() {
                    return "audio" === this.type;
                }
                get playing() {
                    return Boolean(this.ready && !this.paused && !this.ended);
                }
                get paused() {
                    return Boolean(this.media.paused);
                }
                get stopped() {
                    return Boolean(this.paused && 0 === this.currentTime);
                }
                get ended() {
                    return Boolean(this.media.ended);
                }
                set currentTime(e) {
                    if (!this.duration) return;
                    const t = S(e) && e > 0;
                    (this.media.currentTime = t ? Math.min(e, this.duration) : 0), this.debug.log(`Seeking to ${this.currentTime} seconds`);
                }
                get currentTime() {
                    return Number(this.media.currentTime);
                }
                get buffered() {
                    const { buffered: e } = this.media;
                    return S(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
                }
                get seeking() {
                    return Boolean(this.media.seeking);
                }
                get duration() {
                    const e = parseFloat(this.config.duration),
                        t = (this.media || {}).duration,
                        i = S(t) && t !== 1 / 0 ? t : 0;
                    return e || i;
                }
                set volume(e) {
                    let t = e;
                    C(t) && (t = Number(t)),
                        S(t) || (t = this.storage.get("volume")),
                        S(t) || ({ volume: t } = this.config),
                        t > 1 && (t = 1),
                        t < 0 && (t = 0),
                        (this.config.volume = t),
                        (this.media.volume = t),
                        !I(e) && this.muted && t > 0 && (this.muted = !1);
                }
                get volume() {
                    return Number(this.media.volume);
                }
                set muted(e) {
                    let t = e;
                    k(t) || (t = this.storage.get("muted")), k(t) || (t = this.config.muted), (this.config.muted = t), (this.media.muted = t);
                }
                get muted() {
                    return Boolean(this.media.muted);
                }
                get hasAudio() {
                    return !this.isHTML5 || !!this.isAudio || Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
                }
                set speed(e) {
                    let t = null;
                    S(e) && (t = e), S(t) || (t = this.storage.get("speed")), S(t) || (t = this.config.speed.selected);
                    const { minimumSpeed: i, maximumSpeed: n } = this;
                    (t = (function (e = 0, t = 0, i = 255) {
                        return Math.min(Math.max(e, t), i);
                    })(t, i, n)),
                        (this.config.speed.selected = t),
                        setTimeout(() => {
                            this.media && (this.media.playbackRate = t);
                        }, 0);
                }
                get speed() {
                    return Number(this.media.playbackRate);
                }
                get minimumSpeed() {
                    return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? 0.5 : 0.0625;
                }
                get maximumSpeed() {
                    return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
                }
                set quality(e) {
                    const t = this.config.quality,
                        i = this.options.quality;
                    if (!i.length) return;
                    let n = [!I(e) && Number(e), this.storage.get("quality"), t.selected, t.default].find(S),
                        o = !0;
                    if (!i.includes(n)) {
                        const e = ze(i, n);
                        this.debug.warn(`Unsupported quality option: ${n}, using ${e} instead`), (n = e), (o = !1);
                    }
                    (t.selected = n), (this.media.quality = n), o && this.storage.set({ quality: n });
                }
                get quality() {
                    return this.media.quality;
                }
                set loop(e) {
                    const t = k(e) ? e : this.config.loop.active;
                    (this.config.loop.active = t), (this.media.loop = t);
                }
                get loop() {
                    return Boolean(this.media.loop);
                }
                set source(e) {
                    pt.change.call(this, e);
                }
                get source() {
                    return this.media.currentSrc;
                }
                get download() {
                    const { download: e } = this.config.urls;
                    return P(e) ? e : this.source;
                }
                set download(e) {
                    P(e) && ((this.config.urls.download = e), Pe.setDownloadUrl.call(this));
                }
                set poster(e) {
                    this.isVideo ? Je.setPoster.call(this, e, !1).catch(() => {}) : this.debug.warn("Poster can only be set for video");
                }
                get poster() {
                    return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
                }
                get ratio() {
                    if (!this.isVideo) return null;
                    const e = Le(Te.call(this));
                    return E(e) ? e.join(":") : e;
                }
                set ratio(e) {
                    this.isVideo ? (C(e) && Oe(e) ? ((this.config.ratio = Le(e)), Ne.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e})`)) : this.debug.warn("Aspect ratio can only be set for video");
                }
                set autoplay(e) {
                    const t = k(e) ? e : this.config.autoplay;
                    this.config.autoplay = t;
                }
                get autoplay() {
                    return Boolean(this.config.autoplay);
                }
                toggleCaptions(e) {
                    je.toggle.call(this, e, !1);
                }
                set currentTrack(e) {
                    je.set.call(this, e, !1), je.setup();
                }
                get currentTrack() {
                    const { toggled: e, currentTrack: t } = this.captions;
                    return e ? t : -1;
                }
                set language(e) {
                    je.setLanguage.call(this, e, !1);
                }
                get language() {
                    return (je.getCurrentTrack.call(this) || {}).language;
                }
                set pip(e) {
                    if (!le.pip) return;
                    const t = k(e) ? e : !this.pip;
                    B(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? Fe : "inline"),
                        B(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture());
                }
                get pip() {
                    return le.pip ? (I(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === Fe) : null;
                }
                setPreviewThumbnails(e) {
                    this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), (this.previewThumbnails = null)),
                        Object.assign(this.config.previewThumbnails, e),
                        this.config.previewThumbnails.enabled && (this.previewThumbnails = new dt(this));
                }
                static supported(e, t, i) {
                    return le.check(e, t, i);
                }
                static loadSprite(e, t) {
                    return _e(e, t);
                }
                static setup(e, t = {}) {
                    let i = null;
                    return C(e) ? (i = Array.from(document.querySelectorAll(e))) : X(e) ? (i = Array.from(e)) : E(e) && (i = e.filter(x)), I(i) ? null : i.map((e) => new ht(e, t));
                }
            }
            var ft;
            return (ht.defaults = ((ft = $e), JSON.parse(JSON.stringify(ft)))), ht;
        }),
    (function (e, t) {
        "object" == typeof exports && "undefined" != typeof module ? (module.exports = t()) : "function" == typeof define && define.amd ? define(t) : (e.moment = t());
    })(this, function () {
        "use strict";
        var e, t;
        function i() {
            return e.apply(null, arguments);
        }
        function n(e) {
            return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
        }
        function o(e) {
            return null != e && "[object Object]" === Object.prototype.toString.call(e);
        }
        function s(e) {
            return void 0 === e;
        }
        function r(e) {
            return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
        }
        function c(e) {
            return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
        }
        function a(e, t) {
            var i,
                n = [];
            for (i = 0; i < e.length; ++i) n.push(t(e[i], i));
            return n;
        }
        function l(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }
        function u(e, t) {
            for (var i in t) l(t, i) && (e[i] = t[i]);
            return l(t, "toString") && (e.toString = t.toString), l(t, "valueOf") && (e.valueOf = t.valueOf), e;
        }
        function d(e, t, i, n) {
            return bt(e, t, i, n, !0).utc();
        }
        function p(e) {
            return (
                null == e._pf &&
                    (e._pf = {
                        empty: !1,
                        unusedTokens: [],
                        unusedInput: [],
                        overflow: -2,
                        charsLeftOver: 0,
                        nullInput: !1,
                        invalidMonth: null,
                        invalidFormat: !1,
                        userInvalidated: !1,
                        iso: !1,
                        parsedDateParts: [],
                        meridiem: null,
                        rfc2822: !1,
                        weekdayMismatch: !1,
                    }),
                e._pf
            );
        }
        function h(e) {
            if (null == e._isValid) {
                var i = p(e),
                    n = t.call(i.parsedDateParts, function (e) {
                        return null != e;
                    }),
                    o = !isNaN(e._d.getTime()) && i.overflow < 0 && !i.empty && !i.invalidMonth && !i.invalidWeekday && !i.weekdayMismatch && !i.nullInput && !i.invalidFormat && !i.userInvalidated && (!i.meridiem || (i.meridiem && n));
                if ((e._strict && (o = o && 0 === i.charsLeftOver && 0 === i.unusedTokens.length && void 0 === i.bigHour), null != Object.isFrozen && Object.isFrozen(e))) return o;
                e._isValid = o;
            }
            return e._isValid;
        }
        function f(e) {
            var t = d(NaN);
            return null != e ? u(p(t), e) : (p(t).userInvalidated = !0), t;
        }
        t = Array.prototype.some
            ? Array.prototype.some
            : function (e) {
                  for (var t = Object(this), i = t.length >>> 0, n = 0; n < i; n++) if (n in t && e.call(this, t[n], n, t)) return !0;
                  return !1;
              };
        var M = (i.momentProperties = []);
        function b(e, t) {
            var i, n, o;
            if (
                (s(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject),
                s(t._i) || (e._i = t._i),
                s(t._f) || (e._f = t._f),
                s(t._l) || (e._l = t._l),
                s(t._strict) || (e._strict = t._strict),
                s(t._tzm) || (e._tzm = t._tzm),
                s(t._isUTC) || (e._isUTC = t._isUTC),
                s(t._offset) || (e._offset = t._offset),
                s(t._pf) || (e._pf = p(t)),
                s(t._locale) || (e._locale = t._locale),
                0 < M.length)
            )
                for (i = 0; i < M.length; i++) s((o = t[(n = M[i])])) || (e[n] = o);
            return e;
        }
        var m = !1;
        function g(e) {
            b(this, e), (this._d = new Date(null != e._d ? e._d.getTime() : NaN)), this.isValid() || (this._d = new Date(NaN)), !1 === m && ((m = !0), i.updateOffset(this), (m = !1));
        }
        function A(e) {
            return e instanceof g || (null != e && null != e._isAMomentObject);
        }
        function z(e) {
            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
        }
        function y(e) {
            var t = +e,
                i = 0;
            return 0 !== t && isFinite(t) && (i = z(t)), i;
        }
        function v(e, t, i) {
            var n,
                o = Math.min(e.length, t.length),
                s = Math.abs(e.length - t.length),
                r = 0;
            for (n = 0; n < o; n++) ((i && e[n] !== t[n]) || (!i && y(e[n]) !== y(t[n]))) && r++;
            return r + s;
        }
        function O(e) {
            !1 === i.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
        }
        function L(e, t) {
            var n = !0;
            return u(function () {
                if ((null != i.deprecationHandler && i.deprecationHandler(null, e), n)) {
                    for (var o, s = [], r = 0; r < arguments.length; r++) {
                        if (((o = ""), "object" == typeof arguments[r])) {
                            for (var c in ((o += "\n[" + r + "] "), arguments[0])) o += c + ": " + arguments[0][c] + ", ";
                            o = o.slice(0, -2);
                        } else o = arguments[r];
                        s.push(o);
                    }
                    O(e + "\nArguments: " + Array.prototype.slice.call(s).join("") + "\n" + new Error().stack), (n = !1);
                }
                return t.apply(this, arguments);
            }, t);
        }
        var T,
            N = {};
        function q(e, t) {
            null != i.deprecationHandler && i.deprecationHandler(e, t), N[e] || (O(t), (N[e] = !0));
        }
        function w(e) {
            return e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
        }
        function W(e, t) {
            var i,
                n = u({}, e);
            for (i in t) l(t, i) && (o(e[i]) && o(t[i]) ? ((n[i] = {}), u(n[i], e[i]), u(n[i], t[i])) : null != t[i] ? (n[i] = t[i]) : delete n[i]);
            for (i in e) l(e, i) && !l(t, i) && o(e[i]) && (n[i] = u({}, n[i]));
            return n;
        }
        function S(e) {
            null != e && this.set(e);
        }
        (i.suppressDeprecationWarnings = !1),
            (i.deprecationHandler = null),
            (T = Object.keys
                ? Object.keys
                : function (e) {
                      var t,
                          i = [];
                      for (t in e) l(e, t) && i.push(t);
                      return i;
                  });
        var C = {};
        function k(e, t) {
            var i = e.toLowerCase();
            C[i] = C[i + "s"] = C[t] = e;
        }
        function B(e) {
            return "string" == typeof e ? C[e] || C[e.toLowerCase()] : void 0;
        }
        function E(e) {
            var t,
                i,
                n = {};
            for (i in e) l(e, i) && (t = B(i)) && (n[t] = e[i]);
            return n;
        }
        var X = {};
        function x(e, t) {
            X[e] = t;
        }
        function _(e, t, i) {
            var n = "" + Math.abs(e),
                o = t - n.length;
            return (0 <= e ? (i ? "+" : "") : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + n;
        }
        var D = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
            R = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
            P = {},
            I = {};
        function H(e, t, i, n) {
            var o = n;
            "string" == typeof n &&
                (o = function () {
                    return this[n]();
                }),
                e && (I[e] = o),
                t &&
                    (I[t[0]] = function () {
                        return _(o.apply(this, arguments), t[1], t[2]);
                    }),
                i &&
                    (I[i] = function () {
                        return this.localeData().ordinal(o.apply(this, arguments), e);
                    });
        }
        function j(e, t) {
            return e.isValid()
                ? ((t = $(t, e.localeData())),
                  (P[t] =
                      P[t] ||
                      (function (e) {
                          var t,
                              i,
                              n,
                              o = e.match(D);
                          for (t = 0, i = o.length; t < i; t++) I[o[t]] ? (o[t] = I[o[t]]) : (o[t] = (n = o[t]).match(/\[[\s\S]/) ? n.replace(/^\[|\]$/g, "") : n.replace(/\\/g, ""));
                          return function (t) {
                              var n,
                                  s = "";
                              for (n = 0; n < i; n++) s += w(o[n]) ? o[n].call(t, e) : o[n];
                              return s;
                          };
                      })(t)),
                  P[t](e))
                : e.localeData().invalidDate();
        }
        function $(e, t) {
            var i = 5;
            function n(e) {
                return t.longDateFormat(e) || e;
            }
            for (R.lastIndex = 0; 0 <= i && R.test(e); ) (e = e.replace(R, n)), (R.lastIndex = 0), (i -= 1);
            return e;
        }
        var F = /\d/,
            U = /\d\d/,
            V = /\d{3}/,
            Y = /\d{4}/,
            G = /[+-]?\d{6}/,
            K = /\d\d?/,
            Q = /\d\d\d\d?/,
            J = /\d\d\d\d\d\d?/,
            Z = /\d{1,3}/,
            ee = /\d{1,4}/,
            te = /[+-]?\d{1,6}/,
            ie = /\d+/,
            ne = /[+-]?\d+/,
            oe = /Z|[+-]\d\d:?\d\d/gi,
            se = /Z|[+-]\d\d(?::?\d\d)?/gi,
            re = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
            ce = {};
        function ae(e, t, i) {
            ce[e] = w(t)
                ? t
                : function (e, n) {
                      return e && i ? i : t;
                  };
        }
        function le(e, t) {
            return l(ce, e)
                ? ce[e](t._strict, t._locale)
                : new RegExp(
                      ue(
                          e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, i, n, o) {
                              return t || i || n || o;
                          })
                      )
                  );
        }
        function ue(e) {
            return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
        }
        var de = {};
        function pe(e, t) {
            var i,
                n = t;
            for (
                "string" == typeof e && (e = [e]),
                    r(t) &&
                        (n = function (e, i) {
                            i[t] = y(e);
                        }),
                    i = 0;
                i < e.length;
                i++
            )
                de[e[i]] = n;
        }
        function he(e, t) {
            pe(e, function (e, i, n, o) {
                (n._w = n._w || {}), t(e, n._w, n, o);
            });
        }
        function fe(e) {
            return Me(e) ? 366 : 365;
        }
        function Me(e) {
            return (e % 4 == 0 && e % 100 != 0) || e % 400 == 0;
        }
        H("Y", 0, 0, function () {
            var e = this.year();
            return e <= 9999 ? "" + e : "+" + e;
        }),
            H(0, ["YY", 2], 0, function () {
                return this.year() % 100;
            }),
            H(0, ["YYYY", 4], 0, "year"),
            H(0, ["YYYYY", 5], 0, "year"),
            H(0, ["YYYYYY", 6, !0], 0, "year"),
            k("year", "y"),
            x("year", 1),
            ae("Y", ne),
            ae("YY", K, U),
            ae("YYYY", ee, Y),
            ae("YYYYY", te, G),
            ae("YYYYYY", te, G),
            pe(["YYYYY", "YYYYYY"], 0),
            pe("YYYY", function (e, t) {
                t[0] = 2 === e.length ? i.parseTwoDigitYear(e) : y(e);
            }),
            pe("YY", function (e, t) {
                t[0] = i.parseTwoDigitYear(e);
            }),
            pe("Y", function (e, t) {
                t[0] = parseInt(e, 10);
            }),
            (i.parseTwoDigitYear = function (e) {
                return y(e) + (68 < y(e) ? 1900 : 2e3);
            });
        var be,
            me = ge("FullYear", !0);
        function ge(e, t) {
            return function (n) {
                return null != n ? (ze(this, e, n), i.updateOffset(this, t), this) : Ae(this, e);
            };
        }
        function Ae(e, t) {
            return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
        }
        function ze(e, t, i) {
            e.isValid() && !isNaN(i) && ("FullYear" === t && Me(e.year()) && 1 === e.month() && 29 === e.date() ? e._d["set" + (e._isUTC ? "UTC" : "") + t](i, e.month(), ye(i, e.month())) : e._d["set" + (e._isUTC ? "UTC" : "") + t](i));
        }
        function ye(e, t) {
            if (isNaN(e) || isNaN(t)) return NaN;
            var i = ((t % 12) + 12) % 12;
            return (e += (t - i) / 12), 1 === i ? (Me(e) ? 29 : 28) : 31 - ((i % 7) % 2);
        }
        (be = Array.prototype.indexOf
            ? Array.prototype.indexOf
            : function (e) {
                  var t;
                  for (t = 0; t < this.length; ++t) if (this[t] === e) return t;
                  return -1;
              }),
            H("M", ["MM", 2], "Mo", function () {
                return this.month() + 1;
            }),
            H("MMM", 0, 0, function (e) {
                return this.localeData().monthsShort(this, e);
            }),
            H("MMMM", 0, 0, function (e) {
                return this.localeData().months(this, e);
            }),
            k("month", "M"),
            x("month", 8),
            ae("M", K),
            ae("MM", K, U),
            ae("MMM", function (e, t) {
                return t.monthsShortRegex(e);
            }),
            ae("MMMM", function (e, t) {
                return t.monthsRegex(e);
            }),
            pe(["M", "MM"], function (e, t) {
                t[1] = y(e) - 1;
            }),
            pe(["MMM", "MMMM"], function (e, t, i, n) {
                var o = i._locale.monthsParse(e, n, i._strict);
                null != o ? (t[1] = o) : (p(i).invalidMonth = e);
            });
        var ve = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
            Oe = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            Le = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");
        function Te(e, t) {
            var i;
            if (!e.isValid()) return e;
            if ("string" == typeof t)
                if (/^\d+$/.test(t)) t = y(t);
                else if (!r((t = e.localeData().monthsParse(t)))) return e;
            return (i = Math.min(e.date(), ye(e.year(), t))), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, i), e;
        }
        function Ne(e) {
            return null != e ? (Te(this, e), i.updateOffset(this, !0), this) : Ae(this, "Month");
        }
        var qe = re,
            we = re;
        function We() {
            function e(e, t) {
                return t.length - e.length;
            }
            var t,
                i,
                n = [],
                o = [],
                s = [];
            for (t = 0; t < 12; t++) (i = d([2e3, t])), n.push(this.monthsShort(i, "")), o.push(this.months(i, "")), s.push(this.months(i, "")), s.push(this.monthsShort(i, ""));
            for (n.sort(e), o.sort(e), s.sort(e), t = 0; t < 12; t++) (n[t] = ue(n[t])), (o[t] = ue(o[t]));
            for (t = 0; t < 24; t++) s[t] = ue(s[t]);
            (this._monthsRegex = new RegExp("^(" + s.join("|") + ")", "i")),
                (this._monthsShortRegex = this._monthsRegex),
                (this._monthsStrictRegex = new RegExp("^(" + o.join("|") + ")", "i")),
                (this._monthsShortStrictRegex = new RegExp("^(" + n.join("|") + ")", "i"));
        }
        function Se(e) {
            var t = new Date(Date.UTC.apply(null, arguments));
            return e < 100 && 0 <= e && isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e), t;
        }
        function Ce(e, t, i) {
            var n = 7 + t - i;
            return (-(7 + Se(e, 0, n).getUTCDay() - t) % 7) + n - 1;
        }
        function ke(e, t, i, n, o) {
            var s,
                r,
                c = 1 + 7 * (t - 1) + ((7 + i - n) % 7) + Ce(e, n, o);
            return c <= 0 ? (r = fe((s = e - 1)) + c) : c > fe(e) ? ((s = e + 1), (r = c - fe(e))) : ((s = e), (r = c)), { year: s, dayOfYear: r };
        }
        function Be(e, t, i) {
            var n,
                o,
                s = Ce(e.year(), t, i),
                r = Math.floor((e.dayOfYear() - s - 1) / 7) + 1;
            return r < 1 ? (n = r + Ee((o = e.year() - 1), t, i)) : r > Ee(e.year(), t, i) ? ((n = r - Ee(e.year(), t, i)), (o = e.year() + 1)) : ((o = e.year()), (n = r)), { week: n, year: o };
        }
        function Ee(e, t, i) {
            var n = Ce(e, t, i),
                o = Ce(e + 1, t, i);
            return (fe(e) - n + o) / 7;
        }
        H("w", ["ww", 2], "wo", "week"),
            H("W", ["WW", 2], "Wo", "isoWeek"),
            k("week", "w"),
            k("isoWeek", "W"),
            x("week", 5),
            x("isoWeek", 5),
            ae("w", K),
            ae("ww", K, U),
            ae("W", K),
            ae("WW", K, U),
            he(["w", "ww", "W", "WW"], function (e, t, i, n) {
                t[n.substr(0, 1)] = y(e);
            }),
            H("d", 0, "do", "day"),
            H("dd", 0, 0, function (e) {
                return this.localeData().weekdaysMin(this, e);
            }),
            H("ddd", 0, 0, function (e) {
                return this.localeData().weekdaysShort(this, e);
            }),
            H("dddd", 0, 0, function (e) {
                return this.localeData().weekdays(this, e);
            }),
            H("e", 0, 0, "weekday"),
            H("E", 0, 0, "isoWeekday"),
            k("day", "d"),
            k("weekday", "e"),
            k("isoWeekday", "E"),
            x("day", 11),
            x("weekday", 11),
            x("isoWeekday", 11),
            ae("d", K),
            ae("e", K),
            ae("E", K),
            ae("dd", function (e, t) {
                return t.weekdaysMinRegex(e);
            }),
            ae("ddd", function (e, t) {
                return t.weekdaysShortRegex(e);
            }),
            ae("dddd", function (e, t) {
                return t.weekdaysRegex(e);
            }),
            he(["dd", "ddd", "dddd"], function (e, t, i, n) {
                var o = i._locale.weekdaysParse(e, n, i._strict);
                null != o ? (t.d = o) : (p(i).invalidWeekday = e);
            }),
            he(["d", "e", "E"], function (e, t, i, n) {
                t[n] = y(e);
            });
        var Xe = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            xe = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            _e = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            De = re,
            Re = re,
            Pe = re;
        function Ie() {
            function e(e, t) {
                return t.length - e.length;
            }
            var t,
                i,
                n,
                o,
                s,
                r = [],
                c = [],
                a = [],
                l = [];
            for (t = 0; t < 7; t++) (i = d([2e3, 1]).day(t)), (n = this.weekdaysMin(i, "")), (o = this.weekdaysShort(i, "")), (s = this.weekdays(i, "")), r.push(n), c.push(o), a.push(s), l.push(n), l.push(o), l.push(s);
            for (r.sort(e), c.sort(e), a.sort(e), l.sort(e), t = 0; t < 7; t++) (c[t] = ue(c[t])), (a[t] = ue(a[t])), (l[t] = ue(l[t]));
            (this._weekdaysRegex = new RegExp("^(" + l.join("|") + ")", "i")),
                (this._weekdaysShortRegex = this._weekdaysRegex),
                (this._weekdaysMinRegex = this._weekdaysRegex),
                (this._weekdaysStrictRegex = new RegExp("^(" + a.join("|") + ")", "i")),
                (this._weekdaysShortStrictRegex = new RegExp("^(" + c.join("|") + ")", "i")),
                (this._weekdaysMinStrictRegex = new RegExp("^(" + r.join("|") + ")", "i"));
        }
        function He() {
            return this.hours() % 12 || 12;
        }
        function je(e, t) {
            H(e, 0, 0, function () {
                return this.localeData().meridiem(this.hours(), this.minutes(), t);
            });
        }
        function $e(e, t) {
            return t._meridiemParse;
        }
        H("H", ["HH", 2], 0, "hour"),
            H("h", ["hh", 2], 0, He),
            H("k", ["kk", 2], 0, function () {
                return this.hours() || 24;
            }),
            H("hmm", 0, 0, function () {
                return "" + He.apply(this) + _(this.minutes(), 2);
            }),
            H("hmmss", 0, 0, function () {
                return "" + He.apply(this) + _(this.minutes(), 2) + _(this.seconds(), 2);
            }),
            H("Hmm", 0, 0, function () {
                return "" + this.hours() + _(this.minutes(), 2);
            }),
            H("Hmmss", 0, 0, function () {
                return "" + this.hours() + _(this.minutes(), 2) + _(this.seconds(), 2);
            }),
            je("a", !0),
            je("A", !1),
            k("hour", "h"),
            x("hour", 13),
            ae("a", $e),
            ae("A", $e),
            ae("H", K),
            ae("h", K),
            ae("k", K),
            ae("HH", K, U),
            ae("hh", K, U),
            ae("kk", K, U),
            ae("hmm", Q),
            ae("hmmss", J),
            ae("Hmm", Q),
            ae("Hmmss", J),
            pe(["H", "HH"], 3),
            pe(["k", "kk"], function (e, t, i) {
                var n = y(e);
                t[3] = 24 === n ? 0 : n;
            }),
            pe(["a", "A"], function (e, t, i) {
                (i._isPm = i._locale.isPM(e)), (i._meridiem = e);
            }),
            pe(["h", "hh"], function (e, t, i) {
                (t[3] = y(e)), (p(i).bigHour = !0);
            }),
            pe("hmm", function (e, t, i) {
                var n = e.length - 2;
                (t[3] = y(e.substr(0, n))), (t[4] = y(e.substr(n))), (p(i).bigHour = !0);
            }),
            pe("hmmss", function (e, t, i) {
                var n = e.length - 4,
                    o = e.length - 2;
                (t[3] = y(e.substr(0, n))), (t[4] = y(e.substr(n, 2))), (t[5] = y(e.substr(o))), (p(i).bigHour = !0);
            }),
            pe("Hmm", function (e, t, i) {
                var n = e.length - 2;
                (t[3] = y(e.substr(0, n))), (t[4] = y(e.substr(n)));
            }),
            pe("Hmmss", function (e, t, i) {
                var n = e.length - 4,
                    o = e.length - 2;
                (t[3] = y(e.substr(0, n))), (t[4] = y(e.substr(n, 2))), (t[5] = y(e.substr(o)));
            });
        var Fe,
            Ue = ge("Hours", !0),
            Ve = {
                calendar: { sameDay: "[Today at] LT", nextDay: "[Tomorrow at] LT", nextWeek: "dddd [at] LT", lastDay: "[Yesterday at] LT", lastWeek: "[Last] dddd [at] LT", sameElse: "L" },
                longDateFormat: { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" },
                invalidDate: "Invalid date",
                ordinal: "%d",
                dayOfMonthOrdinalParse: /\d{1,2}/,
                relativeTime: {
                    future: "in %s",
                    past: "%s ago",
                    s: "a few seconds",
                    ss: "%d seconds",
                    m: "a minute",
                    mm: "%d minutes",
                    h: "an hour",
                    hh: "%d hours",
                    d: "a day",
                    dd: "%d days",
                    M: "a month",
                    MM: "%d months",
                    y: "a year",
                    yy: "%d years",
                },
                months: Oe,
                monthsShort: Le,
                week: { dow: 0, doy: 6 },
                weekdays: Xe,
                weekdaysMin: _e,
                weekdaysShort: xe,
                meridiemParse: /[ap]\.?m?\.?/i,
            },
            Ye = {},
            Ge = {};
        function Ke(e) {
            return e ? e.toLowerCase().replace("_", "-") : e;
        }
        function Qe(e) {
            var t = null;
            if (!Ye[e] && "undefined" != typeof module && module && module.exports)
                try {
                    (t = Fe._abbr), require("./locale/" + e), Je(t);
                } catch (e) {}
            return Ye[e];
        }
        function Je(e, t) {
            var i;
            return e && ((i = s(t) ? et(e) : Ze(e, t)) ? (Fe = i) : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), Fe._abbr;
        }
        function Ze(e, t) {
            if (null !== t) {
                var i,
                    n = Ve;
                if (((t.abbr = e), null != Ye[e]))
                    q(
                        "defineLocaleOverride",
                        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
                    ),
                        (n = Ye[e]._config);
                else if (null != t.parentLocale)
                    if (null != Ye[t.parentLocale]) n = Ye[t.parentLocale]._config;
                    else {
                        if (null == (i = Qe(t.parentLocale))) return Ge[t.parentLocale] || (Ge[t.parentLocale] = []), Ge[t.parentLocale].push({ name: e, config: t }), null;
                        n = i._config;
                    }
                return (
                    (Ye[e] = new S(W(n, t))),
                    Ge[e] &&
                        Ge[e].forEach(function (e) {
                            Ze(e.name, e.config);
                        }),
                    Je(e),
                    Ye[e]
                );
            }
            return delete Ye[e], null;
        }
        function et(e) {
            var t;
            if ((e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)) return Fe;
            if (!n(e)) {
                if ((t = Qe(e))) return t;
                e = [e];
            }
            return (function (e) {
                for (var t, i, n, o, s = 0; s < e.length; ) {
                    for (t = (o = Ke(e[s]).split("-")).length, i = (i = Ke(e[s + 1])) ? i.split("-") : null; 0 < t; ) {
                        if ((n = Qe(o.slice(0, t).join("-")))) return n;
                        if (i && i.length >= t && v(o, i, !0) >= t - 1) break;
                        t--;
                    }
                    s++;
                }
                return Fe;
            })(e);
        }
        function tt(e) {
            var t,
                i = e._a;
            return (
                i &&
                    -2 === p(e).overflow &&
                    ((t =
                        i[1] < 0 || 11 < i[1]
                            ? 1
                            : i[2] < 1 || i[2] > ye(i[0], i[1])
                            ? 2
                            : i[3] < 0 || 24 < i[3] || (24 === i[3] && (0 !== i[4] || 0 !== i[5] || 0 !== i[6]))
                            ? 3
                            : i[4] < 0 || 59 < i[4]
                            ? 4
                            : i[5] < 0 || 59 < i[5]
                            ? 5
                            : i[6] < 0 || 999 < i[6]
                            ? 6
                            : -1),
                    p(e)._overflowDayOfYear && (t < 0 || 2 < t) && (t = 2),
                    p(e)._overflowWeeks && -1 === t && (t = 7),
                    p(e)._overflowWeekday && -1 === t && (t = 8),
                    (p(e).overflow = t)),
                e
            );
        }
        function it(e, t, i) {
            return null != e ? e : null != t ? t : i;
        }
        function nt(e) {
            var t,
                n,
                o,
                s,
                r,
                c = [];
            if (!e._d) {
                var a, l;
                for (
                    a = e,
                        l = new Date(i.now()),
                        o = a._useUTC ? [l.getUTCFullYear(), l.getUTCMonth(), l.getUTCDate()] : [l.getFullYear(), l.getMonth(), l.getDate()],
                        e._w &&
                            null == e._a[2] &&
                            null == e._a[1] &&
                            (function (e) {
                                var t, i, n, o, s, r, c, a;
                                if (null != (t = e._w).GG || null != t.W || null != t.E) (s = 1), (r = 4), (i = it(t.GG, e._a[0], Be(mt(), 1, 4).year)), (n = it(t.W, 1)), ((o = it(t.E, 1)) < 1 || 7 < o) && (a = !0);
                                else {
                                    (s = e._locale._week.dow), (r = e._locale._week.doy);
                                    var l = Be(mt(), s, r);
                                    (i = it(t.gg, e._a[0], l.year)), (n = it(t.w, l.week)), null != t.d ? ((o = t.d) < 0 || 6 < o) && (a = !0) : null != t.e ? ((o = t.e + s), (t.e < 0 || 6 < t.e) && (a = !0)) : (o = s);
                                }
                                n < 1 || n > Ee(i, s, r) ? (p(e)._overflowWeeks = !0) : null != a ? (p(e)._overflowWeekday = !0) : ((c = ke(i, n, o, s, r)), (e._a[0] = c.year), (e._dayOfYear = c.dayOfYear));
                            })(e),
                        null != e._dayOfYear &&
                            ((r = it(e._a[0], o[0])), (e._dayOfYear > fe(r) || 0 === e._dayOfYear) && (p(e)._overflowDayOfYear = !0), (n = Se(r, 0, e._dayOfYear)), (e._a[1] = n.getUTCMonth()), (e._a[2] = n.getUTCDate())),
                        t = 0;
                    t < 3 && null == e._a[t];
                    ++t
                )
                    e._a[t] = c[t] = o[t];
                for (; t < 7; t++) e._a[t] = c[t] = null == e._a[t] ? (2 === t ? 1 : 0) : e._a[t];
                24 === e._a[3] && 0 === e._a[4] && 0 === e._a[5] && 0 === e._a[6] && ((e._nextDay = !0), (e._a[3] = 0)),
                    (e._d = (e._useUTC
                        ? Se
                        : function (e, t, i, n, o, s, r) {
                              var c = new Date(e, t, i, n, o, s, r);
                              return e < 100 && 0 <= e && isFinite(c.getFullYear()) && c.setFullYear(e), c;
                          }
                    ).apply(null, c)),
                    (s = e._useUTC ? e._d.getUTCDay() : e._d.getDay()),
                    null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
                    e._nextDay && (e._a[3] = 24),
                    e._w && void 0 !== e._w.d && e._w.d !== s && (p(e).weekdayMismatch = !0);
            }
        }
        var ot = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            st = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            rt = /Z|[+-]\d\d(?::?\d\d)?/,
            ct = [
                ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
                ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
                ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
                ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
                ["YYYY-DDD", /\d{4}-\d{3}/],
                ["YYYY-MM", /\d{4}-\d\d/, !1],
                ["YYYYYYMMDD", /[+-]\d{10}/],
                ["YYYYMMDD", /\d{8}/],
                ["GGGG[W]WWE", /\d{4}W\d{3}/],
                ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
                ["YYYYDDD", /\d{7}/],
            ],
            at = [
                ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
                ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
                ["HH:mm:ss", /\d\d:\d\d:\d\d/],
                ["HH:mm", /\d\d:\d\d/],
                ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
                ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
                ["HHmmss", /\d\d\d\d\d\d/],
                ["HHmm", /\d\d\d\d/],
                ["HH", /\d\d/],
            ],
            lt = /^\/?Date\((\-?\d+)/i;
        function ut(e) {
            var t,
                i,
                n,
                o,
                s,
                r,
                c = e._i,
                a = ot.exec(c) || st.exec(c);
            if (a) {
                for (p(e).iso = !0, t = 0, i = ct.length; t < i; t++)
                    if (ct[t][1].exec(a[1])) {
                        (o = ct[t][0]), (n = !1 !== ct[t][2]);
                        break;
                    }
                if (null == o) return void (e._isValid = !1);
                if (a[3]) {
                    for (t = 0, i = at.length; t < i; t++)
                        if (at[t][1].exec(a[3])) {
                            s = (a[2] || " ") + at[t][0];
                            break;
                        }
                    if (null == s) return void (e._isValid = !1);
                }
                if (!n && null != s) return void (e._isValid = !1);
                if (a[4]) {
                    if (!rt.exec(a[4])) return void (e._isValid = !1);
                    r = "Z";
                }
                (e._f = o + (s || "") + (r || "")), ft(e);
            } else e._isValid = !1;
        }
        var dt = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
        var pt = { UT: 0, GMT: 0, EDT: -240, EST: -300, CDT: -300, CST: -360, MDT: -360, MST: -420, PDT: -420, PST: -480 };
        function ht(e) {
            var t,
                i,
                n,
                o = dt.exec(
                    e._i
                        .replace(/\([^)]*\)|[\n\t]/g, " ")
                        .replace(/(\s\s+)/g, " ")
                        .replace(/^\s\s*/, "")
                        .replace(/\s\s*$/, "")
                );
            if (o) {
                var s = (function (e, t, i, n, o, s) {
                    var r = [
                        (function (e) {
                            var t = parseInt(e, 10);
                            return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
                        })(e),
                        Le.indexOf(t),
                        parseInt(i, 10),
                        parseInt(n, 10),
                        parseInt(o, 10),
                    ];
                    return s && r.push(parseInt(s, 10)), r;
                })(o[4], o[3], o[2], o[5], o[6], o[7]);
                if (((i = s), (n = e), (t = o[1]) && xe.indexOf(t) !== new Date(i[0], i[1], i[2]).getDay() && ((p(n).weekdayMismatch = !0), !(n._isValid = !1)))) return;
                (e._a = s),
                    (e._tzm = (function (e, t, i) {
                        if (e) return pt[e];
                        if (t) return 0;
                        var n = parseInt(i, 10),
                            o = n % 100;
                        return ((n - o) / 100) * 60 + o;
                    })(o[8], o[9], o[10])),
                    (e._d = Se.apply(null, e._a)),
                    e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
                    (p(e).rfc2822 = !0);
            } else e._isValid = !1;
        }
        function ft(e) {
            if (e._f !== i.ISO_8601)
                if (e._f !== i.RFC_2822) {
                    (e._a = []), (p(e).empty = !0);
                    var t,
                        n,
                        o,
                        s,
                        r,
                        c,
                        a,
                        u,
                        d = "" + e._i,
                        h = d.length,
                        f = 0;
                    for (o = $(e._f, e._locale).match(D) || [], t = 0; t < o.length; t++)
                        (s = o[t]),
                            (n = (d.match(le(s, e)) || [])[0]) && (0 < (r = d.substr(0, d.indexOf(n))).length && p(e).unusedInput.push(r), (d = d.slice(d.indexOf(n) + n.length)), (f += n.length)),
                            I[s] ? (n ? (p(e).empty = !1) : p(e).unusedTokens.push(s), (c = s), (u = e), null != (a = n) && l(de, c) && de[c](a, u._a, u, c)) : e._strict && !n && p(e).unusedTokens.push(s);
                    (p(e).charsLeftOver = h - f),
                        0 < d.length && p(e).unusedInput.push(d),
                        e._a[3] <= 12 && !0 === p(e).bigHour && 0 < e._a[3] && (p(e).bigHour = void 0),
                        (p(e).parsedDateParts = e._a.slice(0)),
                        (p(e).meridiem = e._meridiem),
                        (e._a[3] = (function (e, t, i) {
                            var n;
                            return null == i ? t : null != e.meridiemHour ? e.meridiemHour(t, i) : (null != e.isPM && ((n = e.isPM(i)) && t < 12 && (t += 12), n || 12 !== t || (t = 0)), t);
                        })(e._locale, e._a[3], e._meridiem)),
                        nt(e),
                        tt(e);
                } else ht(e);
            else ut(e);
        }
        function Mt(e) {
            var t,
                l,
                d,
                M,
                m = e._i,
                z = e._f;
            return (
                (e._locale = e._locale || et(e._l)),
                null === m || (void 0 === z && "" === m)
                    ? f({ nullInput: !0 })
                    : ("string" == typeof m && (e._i = m = e._locale.preparse(m)),
                      A(m)
                          ? new g(tt(m))
                          : (c(m)
                                ? (e._d = m)
                                : n(z)
                                ? (function (e) {
                                      var t, i, n, o, s;
                                      if (0 === e._f.length) return (p(e).invalidFormat = !0), (e._d = new Date(NaN));
                                      for (o = 0; o < e._f.length; o++)
                                          (s = 0),
                                              (t = b({}, e)),
                                              null != e._useUTC && (t._useUTC = e._useUTC),
                                              (t._f = e._f[o]),
                                              ft(t),
                                              h(t) && ((s += p(t).charsLeftOver), (s += 10 * p(t).unusedTokens.length), (p(t).score = s), (null == n || s < n) && ((n = s), (i = t)));
                                      u(e, i || t);
                                  })(e)
                                : z
                                ? ft(e)
                                : s((l = (t = e)._i))
                                ? (t._d = new Date(i.now()))
                                : c(l)
                                ? (t._d = new Date(l.valueOf()))
                                : "string" == typeof l
                                ? ((d = t), null === (M = lt.exec(d._i)) ? (ut(d), !1 === d._isValid && (delete d._isValid, ht(d), !1 === d._isValid && (delete d._isValid, i.createFromInputFallback(d)))) : (d._d = new Date(+M[1])))
                                : n(l)
                                ? ((t._a = a(l.slice(0), function (e) {
                                      return parseInt(e, 10);
                                  })),
                                  nt(t))
                                : o(l)
                                ? (function (e) {
                                      if (!e._d) {
                                          var t = E(e._i);
                                          (e._a = a([t.year, t.month, t.day || t.date, t.hour, t.minute, t.second, t.millisecond], function (e) {
                                              return e && parseInt(e, 10);
                                          })),
                                              nt(e);
                                      }
                                  })(t)
                                : r(l)
                                ? (t._d = new Date(l))
                                : i.createFromInputFallback(t),
                            h(e) || (e._d = null),
                            e))
            );
        }
        function bt(e, t, i, s, r) {
            var c,
                a = {};
            return (
                (!0 !== i && !1 !== i) || ((s = i), (i = void 0)),
                ((o(e) &&
                    (function (e) {
                        if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
                        var t;
                        for (t in e) if (e.hasOwnProperty(t)) return !1;
                        return !0;
                    })(e)) ||
                    (n(e) && 0 === e.length)) &&
                    (e = void 0),
                (a._isAMomentObject = !0),
                (a._useUTC = a._isUTC = r),
                (a._l = i),
                (a._i = e),
                (a._f = t),
                (a._strict = s),
                (c = new g(tt(Mt(a))))._nextDay && (c.add(1, "d"), (c._nextDay = void 0)),
                c
            );
        }
        function mt(e, t, i, n) {
            return bt(e, t, i, n, !1);
        }
        (i.createFromInputFallback = L(
            "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
            function (e) {
                e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
            }
        )),
            (i.ISO_8601 = function () {}),
            (i.RFC_2822 = function () {});
        var gt = L("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
                var e = mt.apply(null, arguments);
                return this.isValid() && e.isValid() ? (e < this ? this : e) : f();
            }),
            At = L("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
                var e = mt.apply(null, arguments);
                return this.isValid() && e.isValid() ? (this < e ? this : e) : f();
            });
        function zt(e, t) {
            var i, o;
            if ((1 === t.length && n(t[0]) && (t = t[0]), !t.length)) return mt();
            for (i = t[0], o = 1; o < t.length; ++o) (t[o].isValid() && !t[o][e](i)) || (i = t[o]);
            return i;
        }
        var yt = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];
        function vt(e) {
            var t = E(e),
                i = t.year || 0,
                n = t.quarter || 0,
                o = t.month || 0,
                s = t.week || 0,
                r = t.day || 0,
                c = t.hour || 0,
                a = t.minute || 0,
                l = t.second || 0,
                u = t.millisecond || 0;
            (this._isValid = (function (e) {
                for (var t in e) if (-1 === be.call(yt, t) || (null != e[t] && isNaN(e[t]))) return !1;
                for (var i = !1, n = 0; n < yt.length; ++n)
                    if (e[yt[n]]) {
                        if (i) return !1;
                        parseFloat(e[yt[n]]) !== y(e[yt[n]]) && (i = !0);
                    }
                return !0;
            })(t)),
                (this._milliseconds = +u + 1e3 * l + 6e4 * a + 1e3 * c * 60 * 60),
                (this._days = +r + 7 * s),
                (this._months = +o + 3 * n + 12 * i),
                (this._data = {}),
                (this._locale = et()),
                this._bubble();
        }
        function Ot(e) {
            return e instanceof vt;
        }
        function Lt(e) {
            return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
        }
        function Tt(e, t) {
            H(e, 0, 0, function () {
                var e = this.utcOffset(),
                    i = "+";
                return e < 0 && ((e = -e), (i = "-")), i + _(~~(e / 60), 2) + t + _(~~e % 60, 2);
            });
        }
        Tt("Z", ":"),
            Tt("ZZ", ""),
            ae("Z", se),
            ae("ZZ", se),
            pe(["Z", "ZZ"], function (e, t, i) {
                (i._useUTC = !0), (i._tzm = qt(se, e));
            });
        var Nt = /([\+\-]|\d\d)/gi;
        function qt(e, t) {
            var i = (t || "").match(e);
            if (null === i) return null;
            var n = ((i[i.length - 1] || []) + "").match(Nt) || ["-", 0, 0],
                o = 60 * n[1] + y(n[2]);
            return 0 === o ? 0 : "+" === n[0] ? o : -o;
        }
        function wt(e, t) {
            var n, o;
            return t._isUTC ? ((n = t.clone()), (o = (A(e) || c(e) ? e.valueOf() : mt(e).valueOf()) - n.valueOf()), n._d.setTime(n._d.valueOf() + o), i.updateOffset(n, !1), n) : mt(e).local();
        }
        function Wt(e) {
            return 15 * -Math.round(e._d.getTimezoneOffset() / 15);
        }
        function St() {
            return !!this.isValid() && this._isUTC && 0 === this._offset;
        }
        i.updateOffset = function () {};
        var Ct = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,
            kt = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
        function Bt(e, t) {
            var i,
                n,
                o,
                s = e,
                c = null;
            return (
                Ot(e)
                    ? (s = { ms: e._milliseconds, d: e._days, M: e._months })
                    : r(e)
                    ? ((s = {}), t ? (s[t] = e) : (s.milliseconds = e))
                    : (c = Ct.exec(e))
                    ? ((i = "-" === c[1] ? -1 : 1), (s = { y: 0, d: y(c[2]) * i, h: y(c[3]) * i, m: y(c[4]) * i, s: y(c[5]) * i, ms: y(Lt(1e3 * c[6])) * i }))
                    : (c = kt.exec(e))
                    ? ((i = "-" === c[1] ? -1 : (c[1], 1)), (s = { y: Et(c[2], i), M: Et(c[3], i), w: Et(c[4], i), d: Et(c[5], i), h: Et(c[6], i), m: Et(c[7], i), s: Et(c[8], i) }))
                    : null == s
                    ? (s = {})
                    : "object" == typeof s &&
                      ("from" in s || "to" in s) &&
                      ((o = (function (e, t) {
                          var i;
                          return e.isValid() && t.isValid() ? ((t = wt(t, e)), e.isBefore(t) ? (i = Xt(e, t)) : (((i = Xt(t, e)).milliseconds = -i.milliseconds), (i.months = -i.months)), i) : { milliseconds: 0, months: 0 };
                      })(mt(s.from), mt(s.to))),
                      ((s = {}).ms = o.milliseconds),
                      (s.M = o.months)),
                (n = new vt(s)),
                Ot(e) && l(e, "_locale") && (n._locale = e._locale),
                n
            );
        }
        function Et(e, t) {
            var i = e && parseFloat(e.replace(",", "."));
            return (isNaN(i) ? 0 : i) * t;
        }
        function Xt(e, t) {
            var i = { milliseconds: 0, months: 0 };
            return (i.months = t.month() - e.month() + 12 * (t.year() - e.year())), e.clone().add(i.months, "M").isAfter(t) && --i.months, (i.milliseconds = +t - +e.clone().add(i.months, "M")), i;
        }
        function xt(e, t) {
            return function (i, n) {
                var o;
                return (
                    null === n ||
                        isNaN(+n) ||
                        (q(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), (o = i), (i = n), (n = o)),
                    _t(this, Bt((i = "string" == typeof i ? +i : i), n), e),
                    this
                );
            };
        }
        function _t(e, t, n, o) {
            var s = t._milliseconds,
                r = Lt(t._days),
                c = Lt(t._months);
            e.isValid() && ((o = null == o || o), c && Te(e, Ae(e, "Month") + c * n), r && ze(e, "Date", Ae(e, "Date") + r * n), s && e._d.setTime(e._d.valueOf() + s * n), o && i.updateOffset(e, r || c));
        }
        (Bt.fn = vt.prototype),
            (Bt.invalid = function () {
                return Bt(NaN);
            });
        var Dt = xt(1, "add"),
            Rt = xt(-1, "subtract");
        function Pt(e, t) {
            var i = 12 * (t.year() - e.year()) + (t.month() - e.month()),
                n = e.clone().add(i, "months");
            return -(i + (t - n < 0 ? (t - n) / (n - e.clone().add(i - 1, "months")) : (t - n) / (e.clone().add(i + 1, "months") - n))) || 0;
        }
        function It(e) {
            var t;
            return void 0 === e ? this._locale._abbr : (null != (t = et(e)) && (this._locale = t), this);
        }
        (i.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ"), (i.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]");
        var Ht = L("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (e) {
            return void 0 === e ? this.localeData() : this.locale(e);
        });
        function jt() {
            return this._locale;
        }
        function $t(e, t) {
            H(0, [e, e.length], 0, t);
        }
        function Ft(e, t, i, n, o) {
            var s;
            return null == e
                ? Be(this, n, o).year
                : ((s = Ee(e, n, o)) < t && (t = s),
                  function (e, t, i, n, o) {
                      var s = ke(e, t, i, n, o),
                          r = Se(s.year, 0, s.dayOfYear);
                      return this.year(r.getUTCFullYear()), this.month(r.getUTCMonth()), this.date(r.getUTCDate()), this;
                  }.call(this, e, t, i, n, o));
        }
        H(0, ["gg", 2], 0, function () {
            return this.weekYear() % 100;
        }),
            H(0, ["GG", 2], 0, function () {
                return this.isoWeekYear() % 100;
            }),
            $t("gggg", "weekYear"),
            $t("ggggg", "weekYear"),
            $t("GGGG", "isoWeekYear"),
            $t("GGGGG", "isoWeekYear"),
            k("weekYear", "gg"),
            k("isoWeekYear", "GG"),
            x("weekYear", 1),
            x("isoWeekYear", 1),
            ae("G", ne),
            ae("g", ne),
            ae("GG", K, U),
            ae("gg", K, U),
            ae("GGGG", ee, Y),
            ae("gggg", ee, Y),
            ae("GGGGG", te, G),
            ae("ggggg", te, G),
            he(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, i, n) {
                t[n.substr(0, 2)] = y(e);
            }),
            he(["gg", "GG"], function (e, t, n, o) {
                t[o] = i.parseTwoDigitYear(e);
            }),
            H("Q", 0, "Qo", "quarter"),
            k("quarter", "Q"),
            x("quarter", 7),
            ae("Q", F),
            pe("Q", function (e, t) {
                t[1] = 3 * (y(e) - 1);
            }),
            H("D", ["DD", 2], "Do", "date"),
            k("date", "D"),
            x("date", 9),
            ae("D", K),
            ae("DD", K, U),
            ae("Do", function (e, t) {
                return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
            }),
            pe(["D", "DD"], 2),
            pe("Do", function (e, t) {
                t[2] = y(e.match(K)[0]);
            });
        var Ut = ge("Date", !0);
        H("DDD", ["DDDD", 3], "DDDo", "dayOfYear"),
            k("dayOfYear", "DDD"),
            x("dayOfYear", 4),
            ae("DDD", Z),
            ae("DDDD", V),
            pe(["DDD", "DDDD"], function (e, t, i) {
                i._dayOfYear = y(e);
            }),
            H("m", ["mm", 2], 0, "minute"),
            k("minute", "m"),
            x("minute", 14),
            ae("m", K),
            ae("mm", K, U),
            pe(["m", "mm"], 4);
        var Vt = ge("Minutes", !1);
        H("s", ["ss", 2], 0, "second"), k("second", "s"), x("second", 15), ae("s", K), ae("ss", K, U), pe(["s", "ss"], 5);
        var Yt,
            Gt = ge("Seconds", !1);
        for (
            H("S", 0, 0, function () {
                return ~~(this.millisecond() / 100);
            }),
                H(0, ["SS", 2], 0, function () {
                    return ~~(this.millisecond() / 10);
                }),
                H(0, ["SSS", 3], 0, "millisecond"),
                H(0, ["SSSS", 4], 0, function () {
                    return 10 * this.millisecond();
                }),
                H(0, ["SSSSS", 5], 0, function () {
                    return 100 * this.millisecond();
                }),
                H(0, ["SSSSSS", 6], 0, function () {
                    return 1e3 * this.millisecond();
                }),
                H(0, ["SSSSSSS", 7], 0, function () {
                    return 1e4 * this.millisecond();
                }),
                H(0, ["SSSSSSSS", 8], 0, function () {
                    return 1e5 * this.millisecond();
                }),
                H(0, ["SSSSSSSSS", 9], 0, function () {
                    return 1e6 * this.millisecond();
                }),
                k("millisecond", "ms"),
                x("millisecond", 16),
                ae("S", Z, F),
                ae("SS", Z, U),
                ae("SSS", Z, V),
                Yt = "SSSS";
            Yt.length <= 9;
            Yt += "S"
        )
            ae(Yt, ie);
        function Kt(e, t) {
            t[6] = y(1e3 * ("0." + e));
        }
        for (Yt = "S"; Yt.length <= 9; Yt += "S") pe(Yt, Kt);
        var Qt = ge("Milliseconds", !1);
        H("z", 0, 0, "zoneAbbr"), H("zz", 0, 0, "zoneName");
        var Jt = g.prototype;
        function Zt(e) {
            return e;
        }
        (Jt.add = Dt),
            (Jt.calendar = function (e, t) {
                var n = e || mt(),
                    o = wt(n, this).startOf("day"),
                    s = i.calendarFormat(this, o) || "sameElse",
                    r = t && (w(t[s]) ? t[s].call(this, n) : t[s]);
                return this.format(r || this.localeData().calendar(s, this, mt(n)));
            }),
            (Jt.clone = function () {
                return new g(this);
            }),
            (Jt.diff = function (e, t, i) {
                var n, o, s;
                if (!this.isValid()) return NaN;
                if (!(n = wt(e, this)).isValid()) return NaN;
                switch (((o = 6e4 * (n.utcOffset() - this.utcOffset())), (t = B(t)))) {
                    case "year":
                        s = Pt(this, n) / 12;
                        break;
                    case "month":
                        s = Pt(this, n);
                        break;
                    case "quarter":
                        s = Pt(this, n) / 3;
                        break;
                    case "second":
                        s = (this - n) / 1e3;
                        break;
                    case "minute":
                        s = (this - n) / 6e4;
                        break;
                    case "hour":
                        s = (this - n) / 36e5;
                        break;
                    case "day":
                        s = (this - n - o) / 864e5;
                        break;
                    case "week":
                        s = (this - n - o) / 6048e5;
                        break;
                    default:
                        s = this - n;
                }
                return i ? s : z(s);
            }),
            (Jt.endOf = function (e) {
                return void 0 === (e = B(e)) || "millisecond" === e
                    ? this
                    : ("date" === e && (e = "day"),
                      this.startOf(e)
                          .add(1, "isoWeek" === e ? "week" : e)
                          .subtract(1, "ms"));
            }),
            (Jt.format = function (e) {
                e || (e = this.isUtc() ? i.defaultFormatUtc : i.defaultFormat);
                var t = j(this, e);
                return this.localeData().postformat(t);
            }),
            (Jt.from = function (e, t) {
                return this.isValid() && ((A(e) && e.isValid()) || mt(e).isValid()) ? Bt({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
            }),
            (Jt.fromNow = function (e) {
                return this.from(mt(), e);
            }),
            (Jt.to = function (e, t) {
                return this.isValid() && ((A(e) && e.isValid()) || mt(e).isValid()) ? Bt({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
            }),
            (Jt.toNow = function (e) {
                return this.to(mt(), e);
            }),
            (Jt.get = function (e) {
                return w(this[(e = B(e))]) ? this[e]() : this;
            }),
            (Jt.invalidAt = function () {
                return p(this).overflow;
            }),
            (Jt.isAfter = function (e, t) {
                var i = A(e) ? e : mt(e);
                return !(!this.isValid() || !i.isValid()) && ("millisecond" === (t = B(s(t) ? "millisecond" : t)) ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(t).valueOf());
            }),
            (Jt.isBefore = function (e, t) {
                var i = A(e) ? e : mt(e);
                return !(!this.isValid() || !i.isValid()) && ("millisecond" === (t = B(s(t) ? "millisecond" : t)) ? this.valueOf() < i.valueOf() : this.clone().endOf(t).valueOf() < i.valueOf());
            }),
            (Jt.isBetween = function (e, t, i, n) {
                return ("(" === (n = n || "()")[0] ? this.isAfter(e, i) : !this.isBefore(e, i)) && (")" === n[1] ? this.isBefore(t, i) : !this.isAfter(t, i));
            }),
            (Jt.isSame = function (e, t) {
                var i,
                    n = A(e) ? e : mt(e);
                return (
                    !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = B(t || "millisecond")) ? this.valueOf() === n.valueOf() : ((i = n.valueOf()), this.clone().startOf(t).valueOf() <= i && i <= this.clone().endOf(t).valueOf()))
                );
            }),
            (Jt.isSameOrAfter = function (e, t) {
                return this.isSame(e, t) || this.isAfter(e, t);
            }),
            (Jt.isSameOrBefore = function (e, t) {
                return this.isSame(e, t) || this.isBefore(e, t);
            }),
            (Jt.isValid = function () {
                return h(this);
            }),
            (Jt.lang = Ht),
            (Jt.locale = It),
            (Jt.localeData = jt),
            (Jt.max = At),
            (Jt.min = gt),
            (Jt.parsingFlags = function () {
                return u({}, p(this));
            }),
            (Jt.set = function (e, t) {
                if ("object" == typeof e)
                    for (
                        var i = (function (e) {
                                var t = [];
                                for (var i in e) t.push({ unit: i, priority: X[i] });
                                return (
                                    t.sort(function (e, t) {
                                        return e.priority - t.priority;
                                    }),
                                    t
                                );
                            })((e = E(e))),
                            n = 0;
                        n < i.length;
                        n++
                    )
                        this[i[n].unit](e[i[n].unit]);
                else if (w(this[(e = B(e))])) return this[e](t);
                return this;
            }),
            (Jt.startOf = function (e) {
                switch ((e = B(e))) {
                    case "year":
                        this.month(0);
                    case "quarter":
                    case "month":
                        this.date(1);
                    case "week":
                    case "isoWeek":
                    case "day":
                    case "date":
                        this.hours(0);
                    case "hour":
                        this.minutes(0);
                    case "minute":
                        this.seconds(0);
                    case "second":
                        this.milliseconds(0);
                }
                return "week" === e && this.weekday(0), "isoWeek" === e && this.isoWeekday(1), "quarter" === e && this.month(3 * Math.floor(this.month() / 3)), this;
            }),
            (Jt.subtract = Rt),
            (Jt.toArray = function () {
                var e = this;
                return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
            }),
            (Jt.toObject = function () {
                var e = this;
                return { years: e.year(), months: e.month(), date: e.date(), hours: e.hours(), minutes: e.minutes(), seconds: e.seconds(), milliseconds: e.milliseconds() };
            }),
            (Jt.toDate = function () {
                return new Date(this.valueOf());
            }),
            (Jt.toISOString = function (e) {
                if (!this.isValid()) return null;
                var t = !0 !== e,
                    i = t ? this.clone().utc() : this;
                return i.year() < 0 || 9999 < i.year()
                    ? j(i, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ")
                    : w(Date.prototype.toISOString)
                    ? t
                        ? this.toDate().toISOString()
                        : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", j(i, "Z"))
                    : j(i, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
            }),
            (Jt.inspect = function () {
                if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
                var e = "moment",
                    t = "";
                this.isLocal() || ((e = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone"), (t = "Z"));
                var i = "[" + e + '("]',
                    n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY",
                    o = t + '[")]';
                return this.format(i + n + "-MM-DD[T]HH:mm:ss.SSS" + o);
            }),
            (Jt.toJSON = function () {
                return this.isValid() ? this.toISOString() : null;
            }),
            (Jt.toString = function () {
                return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
            }),
            (Jt.unix = function () {
                return Math.floor(this.valueOf() / 1e3);
            }),
            (Jt.valueOf = function () {
                return this._d.valueOf() - 6e4 * (this._offset || 0);
            }),
            (Jt.creationData = function () {
                return { input: this._i, format: this._f, locale: this._locale, isUTC: this._isUTC, strict: this._strict };
            }),
            (Jt.year = me),
            (Jt.isLeapYear = function () {
                return Me(this.year());
            }),
            (Jt.weekYear = function (e) {
                return Ft.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
            }),
            (Jt.isoWeekYear = function (e) {
                return Ft.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
            }),
            (Jt.quarter = Jt.quarters = function (e) {
                return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + (this.month() % 3));
            }),
            (Jt.month = Ne),
            (Jt.daysInMonth = function () {
                return ye(this.year(), this.month());
            }),
            (Jt.week = Jt.weeks = function (e) {
                var t = this.localeData().week(this);
                return null == e ? t : this.add(7 * (e - t), "d");
            }),
            (Jt.isoWeek = Jt.isoWeeks = function (e) {
                var t = Be(this, 1, 4).week;
                return null == e ? t : this.add(7 * (e - t), "d");
            }),
            (Jt.weeksInYear = function () {
                var e = this.localeData()._week;
                return Ee(this.year(), e.dow, e.doy);
            }),
            (Jt.isoWeeksInYear = function () {
                return Ee(this.year(), 1, 4);
            }),
            (Jt.date = Ut),
            (Jt.day = Jt.days = function (e) {
                if (!this.isValid()) return null != e ? this : NaN;
                var t,
                    i,
                    n = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                return null != e ? ((t = e), (i = this.localeData()), (e = "string" != typeof t ? t : isNaN(t) ? ("number" == typeof (t = i.weekdaysParse(t)) ? t : null) : parseInt(t, 10)), this.add(e - n, "d")) : n;
            }),
            (Jt.weekday = function (e) {
                if (!this.isValid()) return null != e ? this : NaN;
                var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
                return null == e ? t : this.add(e - t, "d");
            }),
            (Jt.isoWeekday = function (e) {
                if (!this.isValid()) return null != e ? this : NaN;
                if (null != e) {
                    var t = ((i = e), (n = this.localeData()), "string" == typeof i ? n.weekdaysParse(i) % 7 || 7 : isNaN(i) ? null : i);
                    return this.day(this.day() % 7 ? t : t - 7);
                }
                return this.day() || 7;
                var i, n;
            }),
            (Jt.dayOfYear = function (e) {
                var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
                return null == e ? t : this.add(e - t, "d");
            }),
            (Jt.hour = Jt.hours = Ue),
            (Jt.minute = Jt.minutes = Vt),
            (Jt.second = Jt.seconds = Gt),
            (Jt.millisecond = Jt.milliseconds = Qt),
            (Jt.utcOffset = function (e, t, n) {
                var o,
                    s = this._offset || 0;
                if (!this.isValid()) return null != e ? this : NaN;
                if (null != e) {
                    if ("string" == typeof e) {
                        if (null === (e = qt(se, e))) return this;
                    } else Math.abs(e) < 16 && !n && (e *= 60);
                    return (
                        !this._isUTC && t && (o = Wt(this)),
                        (this._offset = e),
                        (this._isUTC = !0),
                        null != o && this.add(o, "m"),
                        s !== e && (!t || this._changeInProgress ? _t(this, Bt(e - s, "m"), 1, !1) : this._changeInProgress || ((this._changeInProgress = !0), i.updateOffset(this, !0), (this._changeInProgress = null))),
                        this
                    );
                }
                return this._isUTC ? s : Wt(this);
            }),
            (Jt.utc = function (e) {
                return this.utcOffset(0, e);
            }),
            (Jt.local = function (e) {
                return this._isUTC && (this.utcOffset(0, e), (this._isUTC = !1), e && this.subtract(Wt(this), "m")), this;
            }),
            (Jt.parseZone = function () {
                if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
                else if ("string" == typeof this._i) {
                    var e = qt(oe, this._i);
                    null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
                }
                return this;
            }),
            (Jt.hasAlignedHourOffset = function (e) {
                return !!this.isValid() && ((e = e ? mt(e).utcOffset() : 0), (this.utcOffset() - e) % 60 == 0);
            }),
            (Jt.isDST = function () {
                return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
            }),
            (Jt.isLocal = function () {
                return !!this.isValid() && !this._isUTC;
            }),
            (Jt.isUtcOffset = function () {
                return !!this.isValid() && this._isUTC;
            }),
            (Jt.isUtc = St),
            (Jt.isUTC = St),
            (Jt.zoneAbbr = function () {
                return this._isUTC ? "UTC" : "";
            }),
            (Jt.zoneName = function () {
                return this._isUTC ? "Coordinated Universal Time" : "";
            }),
            (Jt.dates = L("dates accessor is deprecated. Use date instead.", Ut)),
            (Jt.months = L("months accessor is deprecated. Use month instead", Ne)),
            (Jt.years = L("years accessor is deprecated. Use year instead", me)),
            (Jt.zone = L("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (e, t) {
                return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
            })),
            (Jt.isDSTShifted = L("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
                if (!s(this._isDSTShifted)) return this._isDSTShifted;
                var e = {};
                if ((b(e, this), (e = Mt(e))._a)) {
                    var t = e._isUTC ? d(e._a) : mt(e._a);
                    this._isDSTShifted = this.isValid() && 0 < v(e._a, t.toArray());
                } else this._isDSTShifted = !1;
                return this._isDSTShifted;
            }));
        var ei = S.prototype;
        function ti(e, t, i, n) {
            var o = et(),
                s = d().set(n, t);
            return o[i](s, e);
        }
        function ii(e, t, i) {
            if ((r(e) && ((t = e), (e = void 0)), (e = e || ""), null != t)) return ti(e, t, i, "month");
            var n,
                o = [];
            for (n = 0; n < 12; n++) o[n] = ti(e, n, i, "month");
            return o;
        }
        function ni(e, t, i, n) {
            "boolean" == typeof e ? r(t) && ((i = t), (t = void 0)) : ((t = e), (e = !1), r((i = t)) && ((i = t), (t = void 0))), (t = t || "");
            var o,
                s = et(),
                c = e ? s._week.dow : 0;
            if (null != i) return ti(t, (i + c) % 7, n, "day");
            var a = [];
            for (o = 0; o < 7; o++) a[o] = ti(t, (o + c) % 7, n, "day");
            return a;
        }
        (ei.calendar = function (e, t, i) {
            var n = this._calendar[e] || this._calendar.sameElse;
            return w(n) ? n.call(t, i) : n;
        }),
            (ei.longDateFormat = function (e) {
                var t = this._longDateFormat[e],
                    i = this._longDateFormat[e.toUpperCase()];
                return t || !i
                    ? t
                    : ((this._longDateFormat[e] = i.replace(/MMMM|MM|DD|dddd/g, function (e) {
                          return e.slice(1);
                      })),
                      this._longDateFormat[e]);
            }),
            (ei.invalidDate = function () {
                return this._invalidDate;
            }),
            (ei.ordinal = function (e) {
                return this._ordinal.replace("%d", e);
            }),
            (ei.preparse = Zt),
            (ei.postformat = Zt),
            (ei.relativeTime = function (e, t, i, n) {
                var o = this._relativeTime[i];
                return w(o) ? o(e, t, i, n) : o.replace(/%d/i, e);
            }),
            (ei.pastFuture = function (e, t) {
                var i = this._relativeTime[0 < e ? "future" : "past"];
                return w(i) ? i(t) : i.replace(/%s/i, t);
            }),
            (ei.set = function (e) {
                var t, i;
                for (i in e) w((t = e[i])) ? (this[i] = t) : (this["_" + i] = t);
                (this._config = e), (this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source));
            }),
            (ei.months = function (e, t) {
                return e ? (n(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || ve).test(t) ? "format" : "standalone"][e.month()]) : n(this._months) ? this._months : this._months.standalone;
            }),
            (ei.monthsShort = function (e, t) {
                return e ? (n(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[ve.test(t) ? "format" : "standalone"][e.month()]) : n(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
            }),
            (ei.monthsParse = function (e, t, i) {
                var n, o, s;
                if (this._monthsParseExact)
                    return function (e, t, i) {
                        var n,
                            o,
                            s,
                            r = e.toLocaleLowerCase();
                        if (!this._monthsParse)
                            for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
                                (s = d([2e3, n])), (this._shortMonthsParse[n] = this.monthsShort(s, "").toLocaleLowerCase()), (this._longMonthsParse[n] = this.months(s, "").toLocaleLowerCase());
                        return i
                            ? "MMM" === t
                                ? -1 !== (o = be.call(this._shortMonthsParse, r))
                                    ? o
                                    : null
                                : -1 !== (o = be.call(this._longMonthsParse, r))
                                ? o
                                : null
                            : "MMM" === t
                            ? -1 !== (o = be.call(this._shortMonthsParse, r)) || -1 !== (o = be.call(this._longMonthsParse, r))
                                ? o
                                : null
                            : -1 !== (o = be.call(this._longMonthsParse, r)) || -1 !== (o = be.call(this._shortMonthsParse, r))
                            ? o
                            : null;
                    }.call(this, e, t, i);
                for (this._monthsParse || ((this._monthsParse = []), (this._longMonthsParse = []), (this._shortMonthsParse = [])), n = 0; n < 12; n++) {
                    if (
                        ((o = d([2e3, n])),
                        i &&
                            !this._longMonthsParse[n] &&
                            ((this._longMonthsParse[n] = new RegExp("^" + this.months(o, "").replace(".", "") + "$", "i")), (this._shortMonthsParse[n] = new RegExp("^" + this.monthsShort(o, "").replace(".", "") + "$", "i"))),
                        i || this._monthsParse[n] || ((s = "^" + this.months(o, "") + "|^" + this.monthsShort(o, "")), (this._monthsParse[n] = new RegExp(s.replace(".", ""), "i"))),
                        i && "MMMM" === t && this._longMonthsParse[n].test(e))
                    )
                        return n;
                    if (i && "MMM" === t && this._shortMonthsParse[n].test(e)) return n;
                    if (!i && this._monthsParse[n].test(e)) return n;
                }
            }),
            (ei.monthsRegex = function (e) {
                return this._monthsParseExact
                    ? (l(this, "_monthsRegex") || We.call(this), e ? this._monthsStrictRegex : this._monthsRegex)
                    : (l(this, "_monthsRegex") || (this._monthsRegex = we), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
            }),
            (ei.monthsShortRegex = function (e) {
                return this._monthsParseExact
                    ? (l(this, "_monthsRegex") || We.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex)
                    : (l(this, "_monthsShortRegex") || (this._monthsShortRegex = qe), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
            }),
            (ei.week = function (e) {
                return Be(e, this._week.dow, this._week.doy).week;
            }),
            (ei.firstDayOfYear = function () {
                return this._week.doy;
            }),
            (ei.firstDayOfWeek = function () {
                return this._week.dow;
            }),
            (ei.weekdays = function (e, t) {
                return e ? (n(this._weekdays) ? this._weekdays[e.day()] : this._weekdays[this._weekdays.isFormat.test(t) ? "format" : "standalone"][e.day()]) : n(this._weekdays) ? this._weekdays : this._weekdays.standalone;
            }),
            (ei.weekdaysMin = function (e) {
                return e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
            }),
            (ei.weekdaysShort = function (e) {
                return e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
            }),
            (ei.weekdaysParse = function (e, t, i) {
                var n, o, s;
                if (this._weekdaysParseExact)
                    return function (e, t, i) {
                        var n,
                            o,
                            s,
                            r = e.toLocaleLowerCase();
                        if (!this._weekdaysParse)
                            for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
                                (s = d([2e3, 1]).day(n)),
                                    (this._minWeekdaysParse[n] = this.weekdaysMin(s, "").toLocaleLowerCase()),
                                    (this._shortWeekdaysParse[n] = this.weekdaysShort(s, "").toLocaleLowerCase()),
                                    (this._weekdaysParse[n] = this.weekdays(s, "").toLocaleLowerCase());
                        return i
                            ? "dddd" === t
                                ? -1 !== (o = be.call(this._weekdaysParse, r))
                                    ? o
                                    : null
                                : "ddd" === t
                                ? -1 !== (o = be.call(this._shortWeekdaysParse, r))
                                    ? o
                                    : null
                                : -1 !== (o = be.call(this._minWeekdaysParse, r))
                                ? o
                                : null
                            : "dddd" === t
                            ? -1 !== (o = be.call(this._weekdaysParse, r)) || -1 !== (o = be.call(this._shortWeekdaysParse, r)) || -1 !== (o = be.call(this._minWeekdaysParse, r))
                                ? o
                                : null
                            : "ddd" === t
                            ? -1 !== (o = be.call(this._shortWeekdaysParse, r)) || -1 !== (o = be.call(this._weekdaysParse, r)) || -1 !== (o = be.call(this._minWeekdaysParse, r))
                                ? o
                                : null
                            : -1 !== (o = be.call(this._minWeekdaysParse, r)) || -1 !== (o = be.call(this._weekdaysParse, r)) || -1 !== (o = be.call(this._shortWeekdaysParse, r))
                            ? o
                            : null;
                    }.call(this, e, t, i);
                for (this._weekdaysParse || ((this._weekdaysParse = []), (this._minWeekdaysParse = []), (this._shortWeekdaysParse = []), (this._fullWeekdaysParse = [])), n = 0; n < 7; n++) {
                    if (
                        ((o = d([2e3, 1]).day(n)),
                        i &&
                            !this._fullWeekdaysParse[n] &&
                            ((this._fullWeekdaysParse[n] = new RegExp("^" + this.weekdays(o, "").replace(".", "\\.?") + "$", "i")),
                            (this._shortWeekdaysParse[n] = new RegExp("^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$", "i")),
                            (this._minWeekdaysParse[n] = new RegExp("^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$", "i"))),
                        this._weekdaysParse[n] || ((s = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, "")), (this._weekdaysParse[n] = new RegExp(s.replace(".", ""), "i"))),
                        i && "dddd" === t && this._fullWeekdaysParse[n].test(e))
                    )
                        return n;
                    if (i && "ddd" === t && this._shortWeekdaysParse[n].test(e)) return n;
                    if (i && "dd" === t && this._minWeekdaysParse[n].test(e)) return n;
                    if (!i && this._weekdaysParse[n].test(e)) return n;
                }
            }),
            (ei.weekdaysRegex = function (e) {
                return this._weekdaysParseExact
                    ? (l(this, "_weekdaysRegex") || Ie.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex)
                    : (l(this, "_weekdaysRegex") || (this._weekdaysRegex = De), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
            }),
            (ei.weekdaysShortRegex = function (e) {
                return this._weekdaysParseExact
                    ? (l(this, "_weekdaysRegex") || Ie.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
                    : (l(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Re), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
            }),
            (ei.weekdaysMinRegex = function (e) {
                return this._weekdaysParseExact
                    ? (l(this, "_weekdaysRegex") || Ie.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
                    : (l(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Pe), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
            }),
            (ei.isPM = function (e) {
                return "p" === (e + "").toLowerCase().charAt(0);
            }),
            (ei.meridiem = function (e, t, i) {
                return 11 < e ? (i ? "pm" : "PM") : i ? "am" : "AM";
            }),
            Je("en", {
                dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                ordinal: function (e) {
                    var t = e % 10;
                    return e + (1 === y((e % 100) / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
                },
            }),
            (i.lang = L("moment.lang is deprecated. Use moment.locale instead.", Je)),
            (i.langData = L("moment.langData is deprecated. Use moment.localeData instead.", et));
        var oi = Math.abs;
        function si(e, t, i, n) {
            var o = Bt(t, i);
            return (e._milliseconds += n * o._milliseconds), (e._days += n * o._days), (e._months += n * o._months), e._bubble();
        }
        function ri(e) {
            return e < 0 ? Math.floor(e) : Math.ceil(e);
        }
        function ci(e) {
            return (4800 * e) / 146097;
        }
        function ai(e) {
            return (146097 * e) / 4800;
        }
        function li(e) {
            return function () {
                return this.as(e);
            };
        }
        var ui = li("ms"),
            di = li("s"),
            pi = li("m"),
            hi = li("h"),
            fi = li("d"),
            Mi = li("w"),
            bi = li("M"),
            mi = li("y");
        function gi(e) {
            return function () {
                return this.isValid() ? this._data[e] : NaN;
            };
        }
        var Ai = gi("milliseconds"),
            zi = gi("seconds"),
            yi = gi("minutes"),
            vi = gi("hours"),
            Oi = gi("days"),
            Li = gi("months"),
            Ti = gi("years"),
            Ni = Math.round,
            qi = { ss: 44, s: 45, m: 45, h: 22, d: 26, M: 11 },
            wi = Math.abs;
        function Wi(e) {
            return (0 < e) - (e < 0) || +e;
        }
        function Si() {
            if (!this.isValid()) return this.localeData().invalidDate();
            var e,
                t,
                i = wi(this._milliseconds) / 1e3,
                n = wi(this._days),
                o = wi(this._months);
            (t = z((e = z(i / 60)) / 60)), (i %= 60), (e %= 60);
            var s = z(o / 12),
                r = (o %= 12),
                c = n,
                a = t,
                l = e,
                u = i ? i.toFixed(3).replace(/\.?0+$/, "") : "",
                d = this.asSeconds();
            if (!d) return "P0D";
            var p = d < 0 ? "-" : "",
                h = Wi(this._months) !== Wi(d) ? "-" : "",
                f = Wi(this._days) !== Wi(d) ? "-" : "",
                M = Wi(this._milliseconds) !== Wi(d) ? "-" : "";
            return p + "P" + (s ? h + s + "Y" : "") + (r ? h + r + "M" : "") + (c ? f + c + "D" : "") + (a || l || u ? "T" : "") + (a ? M + a + "H" : "") + (l ? M + l + "M" : "") + (u ? M + u + "S" : "");
        }
        var Ci = vt.prototype;
        return (
            (Ci.isValid = function () {
                return this._isValid;
            }),
            (Ci.abs = function () {
                var e = this._data;
                return (
                    (this._milliseconds = oi(this._milliseconds)),
                    (this._days = oi(this._days)),
                    (this._months = oi(this._months)),
                    (e.milliseconds = oi(e.milliseconds)),
                    (e.seconds = oi(e.seconds)),
                    (e.minutes = oi(e.minutes)),
                    (e.hours = oi(e.hours)),
                    (e.months = oi(e.months)),
                    (e.years = oi(e.years)),
                    this
                );
            }),
            (Ci.add = function (e, t) {
                return si(this, e, t, 1);
            }),
            (Ci.subtract = function (e, t) {
                return si(this, e, t, -1);
            }),
            (Ci.as = function (e) {
                if (!this.isValid()) return NaN;
                var t,
                    i,
                    n = this._milliseconds;
                if ("month" === (e = B(e)) || "year" === e) return (t = this._days + n / 864e5), (i = this._months + ci(t)), "month" === e ? i : i / 12;
                switch (((t = this._days + Math.round(ai(this._months))), e)) {
                    case "week":
                        return t / 7 + n / 6048e5;
                    case "day":
                        return t + n / 864e5;
                    case "hour":
                        return 24 * t + n / 36e5;
                    case "minute":
                        return 1440 * t + n / 6e4;
                    case "second":
                        return 86400 * t + n / 1e3;
                    case "millisecond":
                        return Math.floor(864e5 * t) + n;
                    default:
                        throw new Error("Unknown unit " + e);
                }
            }),
            (Ci.asMilliseconds = ui),
            (Ci.asSeconds = di),
            (Ci.asMinutes = pi),
            (Ci.asHours = hi),
            (Ci.asDays = fi),
            (Ci.asWeeks = Mi),
            (Ci.asMonths = bi),
            (Ci.asYears = mi),
            (Ci.valueOf = function () {
                return this.isValid() ? this._milliseconds + 864e5 * this._days + (this._months % 12) * 2592e6 + 31536e6 * y(this._months / 12) : NaN;
            }),
            (Ci._bubble = function () {
                var e,
                    t,
                    i,
                    n,
                    o,
                    s = this._milliseconds,
                    r = this._days,
                    c = this._months,
                    a = this._data;
                return (
                    (0 <= s && 0 <= r && 0 <= c) || (s <= 0 && r <= 0 && c <= 0) || ((s += 864e5 * ri(ai(c) + r)), (c = r = 0)),
                    (a.milliseconds = s % 1e3),
                    (e = z(s / 1e3)),
                    (a.seconds = e % 60),
                    (t = z(e / 60)),
                    (a.minutes = t % 60),
                    (i = z(t / 60)),
                    (a.hours = i % 24),
                    (c += o = z(ci((r += z(i / 24))))),
                    (r -= ri(ai(o))),
                    (n = z(c / 12)),
                    (c %= 12),
                    (a.days = r),
                    (a.months = c),
                    (a.years = n),
                    this
                );
            }),
            (Ci.clone = function () {
                return Bt(this);
            }),
            (Ci.get = function (e) {
                return (e = B(e)), this.isValid() ? this[e + "s"]() : NaN;
            }),
            (Ci.milliseconds = Ai),
            (Ci.seconds = zi),
            (Ci.minutes = yi),
            (Ci.hours = vi),
            (Ci.days = Oi),
            (Ci.weeks = function () {
                return z(this.days() / 7);
            }),
            (Ci.months = Li),
            (Ci.years = Ti),
            (Ci.humanize = function (e) {
                if (!this.isValid()) return this.localeData().invalidDate();
                var t,
                    i,
                    n,
                    o,
                    s,
                    r,
                    c,
                    a,
                    l,
                    u,
                    d = this.localeData(),
                    p =
                        ((t = !e),
                        (i = d),
                        (n = Bt(this).abs()),
                        (o = Ni(n.as("s"))),
                        (s = Ni(n.as("m"))),
                        (r = Ni(n.as("h"))),
                        (c = Ni(n.as("d"))),
                        (a = Ni(n.as("M"))),
                        (l = Ni(n.as("y"))),
                        ((u = (o <= qi.ss && ["s", o]) ||
                            (o < qi.s && ["ss", o]) ||
                            (s <= 1 && ["m"]) ||
                            (s < qi.m && ["mm", s]) ||
                            (r <= 1 && ["h"]) ||
                            (r < qi.h && ["hh", r]) ||
                            (c <= 1 && ["d"]) ||
                            (c < qi.d && ["dd", c]) ||
                            (a <= 1 && ["M"]) ||
                            (a < qi.M && ["MM", a]) ||
                            (l <= 1 && ["y"]) || ["yy", l])[2] = t),
                        (u[3] = 0 < +this),
                        (u[4] = i),
                        function (e, t, i, n, o) {
                            return o.relativeTime(t || 1, !!i, e, n);
                        }.apply(null, u));
                return e && (p = d.pastFuture(+this, p)), d.postformat(p);
            }),
            (Ci.toISOString = Si),
            (Ci.toString = Si),
            (Ci.toJSON = Si),
            (Ci.locale = It),
            (Ci.localeData = jt),
            (Ci.toIsoString = L("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", Si)),
            (Ci.lang = Ht),
            H("X", 0, 0, "unix"),
            H("x", 0, 0, "valueOf"),
            ae("x", ne),
            ae("X", /[+-]?\d+(\.\d{1,3})?/),
            pe("X", function (e, t, i) {
                i._d = new Date(1e3 * parseFloat(e, 10));
            }),
            pe("x", function (e, t, i) {
                i._d = new Date(y(e));
            }),
            (i.version = "2.22.2"),
            (e = mt),
            (i.fn = Jt),
            (i.min = function () {
                return zt("isBefore", [].slice.call(arguments, 0));
            }),
            (i.max = function () {
                return zt("isAfter", [].slice.call(arguments, 0));
            }),
            (i.now = function () {
                return Date.now ? Date.now() : +new Date();
            }),
            (i.utc = d),
            (i.unix = function (e) {
                return mt(1e3 * e);
            }),
            (i.months = function (e, t) {
                return ii(e, t, "months");
            }),
            (i.isDate = c),
            (i.locale = Je),
            (i.invalid = f),
            (i.duration = Bt),
            (i.isMoment = A),
            (i.weekdays = function (e, t, i) {
                return ni(e, t, i, "weekdays");
            }),
            (i.parseZone = function () {
                return mt.apply(null, arguments).parseZone();
            }),
            (i.localeData = et),
            (i.isDuration = Ot),
            (i.monthsShort = function (e, t) {
                return ii(e, t, "monthsShort");
            }),
            (i.weekdaysMin = function (e, t, i) {
                return ni(e, t, i, "weekdaysMin");
            }),
            (i.defineLocale = Ze),
            (i.updateLocale = function (e, t) {
                if (null != t) {
                    var i,
                        n,
                        o = Ve;
                    null != (n = Qe(e)) && (o = n._config), ((i = new S((t = W(o, t)))).parentLocale = Ye[e]), (Ye[e] = i), Je(e);
                } else null != Ye[e] && (null != Ye[e].parentLocale ? (Ye[e] = Ye[e].parentLocale) : null != Ye[e] && delete Ye[e]);
                return Ye[e];
            }),
            (i.locales = function () {
                return T(Ye);
            }),
            (i.weekdaysShort = function (e, t, i) {
                return ni(e, t, i, "weekdaysShort");
            }),
            (i.normalizeUnits = B),
            (i.relativeTimeRounding = function (e) {
                return void 0 === e ? Ni : "function" == typeof e && ((Ni = e), !0);
            }),
            (i.relativeTimeThreshold = function (e, t) {
                return void 0 !== qi[e] && (void 0 === t ? qi[e] : ((qi[e] = t), "s" === e && (qi.ss = t - 1), !0));
            }),
            (i.calendarFormat = function (e, t) {
                var i = e.diff(t, "days", !0);
                return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse";
            }),
            (i.prototype = Jt),
            (i.HTML5_FMT = {
                DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
                DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
                DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
                DATE: "YYYY-MM-DD",
                TIME: "HH:mm",
                TIME_SECONDS: "HH:mm:ss",
                TIME_MS: "HH:mm:ss.SSS",
                WEEK: "YYYY-[W]WW",
                MONTH: "YYYY-MM",
            }),
            i
        );
    }),
    (function (e, t) {
        "use strict";
        "object" == typeof module && module.exports ? (module.exports = t(require("moment"))) : "function" == typeof define && define.amd ? define(["moment"], t) : t(e.moment);
    })(this, function (e) {
        "use strict";
        var t,
            i = {},
            n = {},
            o = {},
            s = {};
        (e && "string" == typeof e.version) || N("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
        var r = e.version.split("."),
            c = +r[0],
            a = +r[1];
        function l(e) {
            return 96 < e ? e - 87 : 64 < e ? e - 29 : e - 48;
        }
        function u(e) {
            var t = 0,
                i = e.split("."),
                n = i[0],
                o = i[1] || "",
                s = 1,
                r = 0,
                c = 1;
            for (45 === e.charCodeAt(0) && (c = -(t = 1)); t < n.length; t++) r = 60 * r + l(n.charCodeAt(t));
            for (t = 0; t < o.length; t++) (s /= 60), (r += l(o.charCodeAt(t)) * s);
            return r * c;
        }
        function d(e) {
            for (var t = 0; t < e.length; t++) e[t] = u(e[t]);
        }
        function p(e, t) {
            var i,
                n = [];
            for (i = 0; i < t.length; i++) n[i] = e[t[i]];
            return n;
        }
        function h(e) {
            var t = e.split("|"),
                i = t[2].split(" "),
                n = t[3].split(""),
                o = t[4].split(" ");
            return (
                d(i),
                d(n),
                d(o),
                (function (e, t) {
                    for (var i = 0; i < t; i++) e[i] = Math.round((e[i - 1] || 0) + 6e4 * e[i]);
                    e[t - 1] = 1 / 0;
                })(o, n.length),
                { name: t[0], abbrs: p(t[1].split(" "), n), offsets: p(i, n), untils: o, population: 0 | t[5] }
            );
        }
        function f(e) {
            e && this._set(h(e));
        }
        function M(e) {
            var t = e.toTimeString(),
                i = t.match(/\([a-z ]+\)/i);
            "GMT" === (i = i && i[0] ? ((i = i[0].match(/[A-Z]/g)) ? i.join("") : void 0) : (i = t.match(/[A-Z]{3,5}/g)) ? i[0] : void 0) && (i = void 0), (this.at = +e), (this.abbr = i), (this.offset = e.getTimezoneOffset());
        }
        function b(e) {
            (this.zone = e), (this.offsetScore = 0), (this.abbrScore = 0);
        }
        function m(e, t) {
            for (var i, n; (n = 6e4 * (((t.at - e.at) / 12e4) | 0)); ) (i = new M(new Date(e.at + n))).offset === e.offset ? (e = i) : (t = i);
            return e;
        }
        function g(e, t) {
            return e.offsetScore !== t.offsetScore ? e.offsetScore - t.offsetScore : e.abbrScore !== t.abbrScore ? e.abbrScore - t.abbrScore : t.zone.population - e.zone.population;
        }
        function A(e, t) {
            var i, n;
            for (d(t), i = 0; i < t.length; i++) (n = t[i]), (s[n] = s[n] || {}), (s[n][e] = !0);
        }
        function z(e) {
            return (e || "").toLowerCase().replace(/\//g, "_");
        }
        function y(e) {
            var t, n, s, r;
            for ("string" == typeof e && (e = [e]), t = 0; t < e.length; t++) (r = z((n = (s = e[t].split("|"))[0]))), (i[r] = e[t]), (o[r] = n), A(r, s[2].split(" "));
        }
        function v(e, t) {
            e = z(e);
            var s,
                r = i[e];
            return r instanceof f ? r : "string" == typeof r ? ((r = new f(r)), (i[e] = r)) : n[e] && t !== v && (s = v(n[e], v)) ? ((r = i[e] = new f())._set(s), (r.name = o[e]), r) : null;
        }
        function O(e) {
            var t, i, s, r;
            for ("string" == typeof e && (e = [e]), t = 0; t < e.length; t++) (s = z((i = e[t].split("|"))[0])), (r = z(i[1])), (n[s] = r), (o[s] = i[0]), (n[r] = s), (o[r] = i[1]);
        }
        function L(e) {
            y(e.zones), O(e.links), (q.dataVersion = e.version);
        }
        function T(e) {
            var t = "X" === e._f || "x" === e._f;
            return !(!e._a || void 0 !== e._tzm || t);
        }
        function N(e) {
            "undefined" != typeof console && "function" == typeof console.error && console.error(e);
        }
        function q(t) {
            var i = Array.prototype.slice.call(arguments, 0, -1),
                n = arguments[arguments.length - 1],
                o = v(n),
                s = e.utc.apply(null, i);
            return o && !e.isMoment(t) && T(s) && s.add(o.parse(s), "minutes"), s.tz(n), s;
        }
        (c < 2 || (2 === c && a < 6)) && N("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + e.version + ". See momentjs.com"),
            (f.prototype = {
                _set: function (e) {
                    (this.name = e.name), (this.abbrs = e.abbrs), (this.untils = e.untils), (this.offsets = e.offsets), (this.population = e.population);
                },
                _index: function (e) {
                    var t,
                        i = +e,
                        n = this.untils;
                    for (t = 0; t < n.length; t++) if (i < n[t]) return t;
                },
                parse: function (e) {
                    var t,
                        i,
                        n,
                        o,
                        s = +e,
                        r = this.offsets,
                        c = this.untils,
                        a = c.length - 1;
                    for (o = 0; o < a; o++) if (((t = r[o]), (i = r[o + 1]), (n = r[o ? o - 1 : o]), t < i && q.moveAmbiguousForward ? (t = i) : n < t && q.moveInvalidForward && (t = n), s < c[o] - 6e4 * t)) return r[o];
                    return r[a];
                },
                abbr: function (e) {
                    return this.abbrs[this._index(e)];
                },
                offset: function (e) {
                    return N("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(e)];
                },
                utcOffset: function (e) {
                    return this.offsets[this._index(e)];
                },
            }),
            (b.prototype.scoreOffsetAt = function (e) {
                (this.offsetScore += Math.abs(this.zone.utcOffset(e.at) - e.offset)), this.zone.abbr(e.at).replace(/[^A-Z]/g, "") !== e.abbr && this.abbrScore++;
            }),
            (q.version = "0.5.21"),
            (q.dataVersion = ""),
            (q._zones = i),
            (q._links = n),
            (q._names = o),
            (q.add = y),
            (q.link = O),
            (q.load = L),
            (q.zone = v),
            (q.zoneExists = function e(t) {
                return e.didShowError || ((e.didShowError = !0), N("moment.tz.zoneExists('" + t + "') has been deprecated in favor of !moment.tz.zone('" + t + "')")), !!v(t);
            }),
            (q.guess = function (e) {
                return (
                    (t && !e) ||
                        (t = (function () {
                            try {
                                var e = Intl.DateTimeFormat().resolvedOptions().timeZone;
                                if (e && 3 < e.length) {
                                    var t = o[z(e)];
                                    if (t) return t;
                                    N("Moment Timezone found " + e + " from the Intl api, but did not have that data loaded.");
                                }
                            } catch (e) {}
                            var i,
                                n,
                                r,
                                c = (function () {
                                    var e,
                                        t,
                                        i,
                                        n = new Date().getFullYear() - 2,
                                        o = new M(new Date(n, 0, 1)),
                                        s = [o];
                                    for (i = 1; i < 48; i++) (t = new M(new Date(n, i, 1))).offset !== o.offset && ((e = m(o, t)), s.push(e), s.push(new M(new Date(e.at + 6e4)))), (o = t);
                                    for (i = 0; i < 4; i++) s.push(new M(new Date(n + i, 0, 1))), s.push(new M(new Date(n + i, 6, 1)));
                                    return s;
                                })(),
                                a = c.length,
                                l = (function (e) {
                                    var t,
                                        i,
                                        n,
                                        r = e.length,
                                        c = {},
                                        a = [];
                                    for (t = 0; t < r; t++) for (i in (n = s[e[t].offset] || {})) n.hasOwnProperty(i) && (c[i] = !0);
                                    for (t in c) c.hasOwnProperty(t) && a.push(o[t]);
                                    return a;
                                })(c),
                                u = [];
                            for (n = 0; n < l.length; n++) {
                                for (i = new b(v(l[n]), a), r = 0; r < a; r++) i.scoreOffsetAt(c[r]);
                                u.push(i);
                            }
                            return u.sort(g), 0 < u.length ? u[0].zone.name : void 0;
                        })()),
                    t
                );
            }),
            (q.names = function () {
                var e,
                    t = [];
                for (e in o) o.hasOwnProperty(e) && (i[e] || i[n[e]]) && o[e] && t.push(o[e]);
                return t.sort();
            }),
            (q.Zone = f),
            (q.unpack = h),
            (q.unpackBase60 = u),
            (q.needsOffset = T),
            (q.moveInvalidForward = !0),
            (q.moveAmbiguousForward = !1);
        var w,
            W = e.fn;
        function S(e) {
            return function () {
                return this._z ? this._z.abbr(this) : e.call(this);
            };
        }
        (e.tz = q),
            (e.defaultZone = null),
            (e.updateOffset = function (t, i) {
                var n,
                    o = e.defaultZone;
                void 0 === t._z && (o && T(t) && !t._isUTC && ((t._d = e.utc(t._a)._d), t.utc().add(o.parse(t), "minutes")), (t._z = o)),
                    t._z && ((n = t._z.utcOffset(t)), Math.abs(n) < 16 && (n /= 60), void 0 !== t.utcOffset ? t.utcOffset(-n, i) : t.zone(n, i));
            }),
            (W.tz = function (t, i) {
                if (t) {
                    if ("string" != typeof t) throw new Error("Time zone name must be a string, got " + t + " [" + typeof t + "]");
                    return (this._z = v(t)), this._z ? e.updateOffset(this, i) : N("Moment Timezone has no data for " + t + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this;
                }
                if (this._z) return this._z.name;
            }),
            (W.zoneName = S(W.zoneName)),
            (W.zoneAbbr = S(W.zoneAbbr)),
            (W.utc =
                ((w = W.utc),
                function () {
                    return (this._z = null), w.apply(this, arguments);
                })),
            (e.tz.setDefault = function (t) {
                return (c < 2 || (2 === c && a < 9)) && N("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + e.version + "."), (e.defaultZone = t ? v(t) : null), e;
            });
        var C = e.momentProperties;
        return (
            "[object Array]" === Object.prototype.toString.call(C) ? (C.push("_z"), C.push("_a")) : C && (C._z = null),
            L({
                version: "2018e",
                zones: [
                    "Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
                    "Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
                    "Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
                    "Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
                    "Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
                    "Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
                    "Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
                    "Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
                    "Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
                    "Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
                    "Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
                    "Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
                    "Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0",
                    "Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
                    "Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
                    "Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
                    "Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|012|-2le00 4i6N0",
                    "Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
                    "Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
                    "Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
                    "America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
                    "America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
                    "America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
                    "America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
                    "America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
                    "America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
                    "America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
                    "America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0",
                    "America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
                    "America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0",
                    "America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
                    "America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0",
                    "America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0",
                    "America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
                    "America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0",
                    "America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0",
                    "America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
                    "America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
                    "America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
                    "America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
                    "America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
                    "America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
                    "America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
                    "America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
                    "America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
                    "America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
                    "America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
                    "America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
                    "America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
                    "America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|77e4",
                    "America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
                    "America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
                    "America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
                    "America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
                    "America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
                    "America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
                    "America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
                    "America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
                    "America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|54e4",
                    "America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
                    "America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
                    "America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
                    "America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
                    "America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
                    "America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
                    "America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
                    "America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
                    "America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
                    "America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
                    "America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
                    "America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
                    "America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
                    "America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
                    "America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
                    "America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
                    "America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
                    "America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
                    "America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
                    "America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
                    "America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
                    "America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
                    "America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
                    "America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
                    "America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
                    "America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
                    "America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
                    "America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
                    "America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
                    "America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
                    "America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
                    "America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
                    "America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
                    "America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
                    "America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
                    "America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
                    "America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
                    "America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
                    "America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
                    "America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
                    "America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
                    "America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
                    "America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
                    "America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
                    "America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
                    "America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
                    "America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
                    "America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
                    "America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
                    "America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
                    "America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
                    "America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
                    "America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
                    "America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
                    "America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
                    "America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
                    "America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0",
                    "America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
                    "America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
                    "America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
                    "America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
                    "America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
                    "America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
                    "America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
                    "America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
                    "America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|20e6",
                    "America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
                    "America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
                    "America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
                    "America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
                    "America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
                    "America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
                    "America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
                    "America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
                    "America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
                    "America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
                    "America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
                    "America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
                    "Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10",
                    "Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
                    "Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
                    "Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
                    "Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
                    "Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
                    "Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
                    "Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
                    "Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
                    "Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
                    "Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
                    "Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
                    "Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
                    "Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
                    "Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
                    "Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
                    "Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
                    "Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
                    "Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
                    "Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
                    "Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
                    "Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
                    "Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
                    "Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
                    "Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
                    "Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
                    "Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
                    "Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
                    "Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
                    "Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
                    "Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
                    "Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
                    "Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
                    "Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
                    "Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
                    "Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
                    "Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
                    "Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
                    "Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
                    "Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|18e5",
                    "Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|25e4",
                    "Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
                    "Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
                    "Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
                    "Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
                    "Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
                    "Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
                    "Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
                    "Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
                    "Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
                    "Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
                    "Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
                    "Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
                    "Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
                    "Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
                    "Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
                    "Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
                    "Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
                    "Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le80 1XO3u 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4",
                    "Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
                    "Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
                    "Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
                    "Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
                    "Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
                    "Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
                    "Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
                    "Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
                    "Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
                    "Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BAu|29e5",
                    "Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
                    "Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
                    "Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
                    "Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
                    "Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
                    "Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
                    "Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
                    "Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
                    "Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
                    "Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
                    "Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
                    "Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6",
                    "Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
                    "Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
                    "Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
                    "Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
                    "Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
                    "Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
                    "Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
                    "Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
                    "Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
                    "Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
                    "Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
                    "Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
                    "Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
                    "Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
                    "Atlantic/South_Georgia|-02|20|0||30",
                    "Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
                    "Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
                    "Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
                    "Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
                    "Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
                    "Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
                    "Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
                    "Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
                    "Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
                    "Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
                    "Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
                    "Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
                    "Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
                    "CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
                    "Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
                    "CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
                    "Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
                    "EST|EST|50|0|",
                    "EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "Etc/GMT-0|GMT|0|0|",
                    "Etc/GMT-1|+01|-10|0|",
                    "Pacific/Port_Moresby|+10|-a0|0||25e4",
                    "Pacific/Pohnpei|+11|-b0|0||34e3",
                    "Pacific/Tarawa|+12|-c0|0||29e3",
                    "Etc/GMT-13|+13|-d0|0|",
                    "Etc/GMT-14|+14|-e0|0|",
                    "Etc/GMT-2|+02|-20|0|",
                    "Etc/GMT-3|+03|-30|0|",
                    "Etc/GMT-4|+04|-40|0|",
                    "Etc/GMT-5|+05|-50|0|",
                    "Etc/GMT-6|+06|-60|0|",
                    "Indian/Christmas|+07|-70|0||21e2",
                    "Etc/GMT-8|+08|-80|0|",
                    "Pacific/Palau|+09|-90|0||21e3",
                    "Etc/GMT+1|-01|10|0|",
                    "Etc/GMT+10|-10|a0|0|",
                    "Etc/GMT+11|-11|b0|0|",
                    "Etc/GMT+12|-12|c0|0|",
                    "Etc/GMT+3|-03|30|0|",
                    "Etc/GMT+4|-04|40|0|",
                    "Etc/GMT+5|-05|50|0|",
                    "Etc/GMT+6|-06|60|0|",
                    "Etc/GMT+7|-07|70|0|",
                    "Etc/GMT+8|-08|80|0|",
                    "Etc/GMT+9|-09|90|0|",
                    "Etc/UCT|UCT|0|0|",
                    "Etc/UTC|UTC|0|0|",
                    "Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
                    "Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
                    "Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
                    "Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
                    "Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
                    "Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
                    "Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
                    "Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
                    "Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
                    "Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
                    "Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
                    "Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
                    "Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
                    "Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
                    "Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
                    "Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
                    "Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
                    "Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
                    "Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
                    "Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
                    "Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
                    "Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
                    "Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
                    "Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
                    "Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
                    "Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
                    "Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
                    "Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
                    "Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
                    "Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
                    "Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
                    "Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
                    "Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
                    "Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
                    "Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
                    "Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
                    "Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
                    "Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
                    "Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
                    "Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
                    "Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
                    "Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
                    "Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
                    "HST|HST|a0|0|",
                    "Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
                    "Indian/Cocos|+0630|-6u|0||596",
                    "Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
                    "Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
                    "Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
                    "Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
                    "Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
                    "Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3",
                    "MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
                    "MST|MST|70|0|",
                    "MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
                    "Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
                    "Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
                    "Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
                    "Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1",
                    "Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
                    "Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4",
                    "Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
                    "Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
                    "Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
                    "Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
                    "Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
                    "Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
                    "Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2",
                    "Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3",
                    "Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
                    "Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
                    "Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
                    "Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
                    "Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
                    "Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
                    "Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
                    "Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
                    "Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
                    "Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
                    "PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
                    "WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
                ],
                links: [
                    "Africa/Abidjan|Africa/Bamako",
                    "Africa/Abidjan|Africa/Banjul",
                    "Africa/Abidjan|Africa/Conakry",
                    "Africa/Abidjan|Africa/Dakar",
                    "Africa/Abidjan|Africa/Freetown",
                    "Africa/Abidjan|Africa/Lome",
                    "Africa/Abidjan|Africa/Nouakchott",
                    "Africa/Abidjan|Africa/Ouagadougou",
                    "Africa/Abidjan|Africa/Timbuktu",
                    "Africa/Abidjan|Atlantic/St_Helena",
                    "Africa/Cairo|Egypt",
                    "Africa/Johannesburg|Africa/Maseru",
                    "Africa/Johannesburg|Africa/Mbabane",
                    "Africa/Lagos|Africa/Bangui",
                    "Africa/Lagos|Africa/Brazzaville",
                    "Africa/Lagos|Africa/Douala",
                    "Africa/Lagos|Africa/Kinshasa",
                    "Africa/Lagos|Africa/Libreville",
                    "Africa/Lagos|Africa/Luanda",
                    "Africa/Lagos|Africa/Malabo",
                    "Africa/Lagos|Africa/Niamey",
                    "Africa/Lagos|Africa/Porto-Novo",
                    "Africa/Maputo|Africa/Blantyre",
                    "Africa/Maputo|Africa/Bujumbura",
                    "Africa/Maputo|Africa/Gaborone",
                    "Africa/Maputo|Africa/Harare",
                    "Africa/Maputo|Africa/Kigali",
                    "Africa/Maputo|Africa/Lubumbashi",
                    "Africa/Maputo|Africa/Lusaka",
                    "Africa/Nairobi|Africa/Addis_Ababa",
                    "Africa/Nairobi|Africa/Asmara",
                    "Africa/Nairobi|Africa/Asmera",
                    "Africa/Nairobi|Africa/Dar_es_Salaam",
                    "Africa/Nairobi|Africa/Djibouti",
                    "Africa/Nairobi|Africa/Kampala",
                    "Africa/Nairobi|Africa/Mogadishu",
                    "Africa/Nairobi|Indian/Antananarivo",
                    "Africa/Nairobi|Indian/Comoro",
                    "Africa/Nairobi|Indian/Mayotte",
                    "Africa/Tripoli|Libya",
                    "America/Adak|America/Atka",
                    "America/Adak|US/Aleutian",
                    "America/Anchorage|US/Alaska",
                    "America/Argentina/Buenos_Aires|America/Buenos_Aires",
                    "America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
                    "America/Argentina/Catamarca|America/Catamarca",
                    "America/Argentina/Cordoba|America/Cordoba",
                    "America/Argentina/Cordoba|America/Rosario",
                    "America/Argentina/Jujuy|America/Jujuy",
                    "America/Argentina/Mendoza|America/Mendoza",
                    "America/Atikokan|America/Coral_Harbour",
                    "America/Chicago|US/Central",
                    "America/Curacao|America/Aruba",
                    "America/Curacao|America/Kralendijk",
                    "America/Curacao|America/Lower_Princes",
                    "America/Denver|America/Shiprock",
                    "America/Denver|Navajo",
                    "America/Denver|US/Mountain",
                    "America/Detroit|US/Michigan",
                    "America/Edmonton|Canada/Mountain",
                    "America/Fort_Wayne|America/Indiana/Indianapolis",
                    "America/Fort_Wayne|America/Indianapolis",
                    "America/Fort_Wayne|US/East-Indiana",
                    "America/Halifax|Canada/Atlantic",
                    "America/Havana|Cuba",
                    "America/Indiana/Knox|America/Knox_IN",
                    "America/Indiana/Knox|US/Indiana-Starke",
                    "America/Jamaica|Jamaica",
                    "America/Kentucky/Louisville|America/Louisville",
                    "America/Los_Angeles|US/Pacific",
                    "America/Los_Angeles|US/Pacific-New",
                    "America/Manaus|Brazil/West",
                    "America/Mazatlan|Mexico/BajaSur",
                    "America/Mexico_City|Mexico/General",
                    "America/New_York|US/Eastern",
                    "America/Noronha|Brazil/DeNoronha",
                    "America/Panama|America/Cayman",
                    "America/Phoenix|US/Arizona",
                    "America/Port_of_Spain|America/Anguilla",
                    "America/Port_of_Spain|America/Antigua",
                    "America/Port_of_Spain|America/Dominica",
                    "America/Port_of_Spain|America/Grenada",
                    "America/Port_of_Spain|America/Guadeloupe",
                    "America/Port_of_Spain|America/Marigot",
                    "America/Port_of_Spain|America/Montserrat",
                    "America/Port_of_Spain|America/St_Barthelemy",
                    "America/Port_of_Spain|America/St_Kitts",
                    "America/Port_of_Spain|America/St_Lucia",
                    "America/Port_of_Spain|America/St_Thomas",
                    "America/Port_of_Spain|America/St_Vincent",
                    "America/Port_of_Spain|America/Tortola",
                    "America/Port_of_Spain|America/Virgin",
                    "America/Regina|Canada/Saskatchewan",
                    "America/Rio_Branco|America/Porto_Acre",
                    "America/Rio_Branco|Brazil/Acre",
                    "America/Santiago|Chile/Continental",
                    "America/Sao_Paulo|Brazil/East",
                    "America/St_Johns|Canada/Newfoundland",
                    "America/Tijuana|America/Ensenada",
                    "America/Tijuana|America/Santa_Isabel",
                    "America/Tijuana|Mexico/BajaNorte",
                    "America/Toronto|America/Montreal",
                    "America/Toronto|Canada/Eastern",
                    "America/Vancouver|Canada/Pacific",
                    "America/Whitehorse|Canada/Yukon",
                    "America/Winnipeg|Canada/Central",
                    "Asia/Ashgabat|Asia/Ashkhabad",
                    "Asia/Bangkok|Asia/Phnom_Penh",
                    "Asia/Bangkok|Asia/Vientiane",
                    "Asia/Dhaka|Asia/Dacca",
                    "Asia/Dubai|Asia/Muscat",
                    "Asia/Ho_Chi_Minh|Asia/Saigon",
                    "Asia/Hong_Kong|Hongkong",
                    "Asia/Jerusalem|Asia/Tel_Aviv",
                    "Asia/Jerusalem|Israel",
                    "Asia/Kathmandu|Asia/Katmandu",
                    "Asia/Kolkata|Asia/Calcutta",
                    "Asia/Kuala_Lumpur|Asia/Singapore",
                    "Asia/Kuala_Lumpur|Singapore",
                    "Asia/Macau|Asia/Macao",
                    "Asia/Makassar|Asia/Ujung_Pandang",
                    "Asia/Nicosia|Europe/Nicosia",
                    "Asia/Qatar|Asia/Bahrain",
                    "Asia/Rangoon|Asia/Yangon",
                    "Asia/Riyadh|Asia/Aden",
                    "Asia/Riyadh|Asia/Kuwait",
                    "Asia/Seoul|ROK",
                    "Asia/Shanghai|Asia/Chongqing",
                    "Asia/Shanghai|Asia/Chungking",
                    "Asia/Shanghai|Asia/Harbin",
                    "Asia/Shanghai|PRC",
                    "Asia/Taipei|ROC",
                    "Asia/Tehran|Iran",
                    "Asia/Thimphu|Asia/Thimbu",
                    "Asia/Tokyo|Japan",
                    "Asia/Ulaanbaatar|Asia/Ulan_Bator",
                    "Asia/Urumqi|Asia/Kashgar",
                    "Atlantic/Faroe|Atlantic/Faeroe",
                    "Atlantic/Reykjavik|Iceland",
                    "Atlantic/South_Georgia|Etc/GMT+2",
                    "Australia/Adelaide|Australia/South",
                    "Australia/Brisbane|Australia/Queensland",
                    "Australia/Broken_Hill|Australia/Yancowinna",
                    "Australia/Darwin|Australia/North",
                    "Australia/Hobart|Australia/Tasmania",
                    "Australia/Lord_Howe|Australia/LHI",
                    "Australia/Melbourne|Australia/Victoria",
                    "Australia/Perth|Australia/West",
                    "Australia/Sydney|Australia/ACT",
                    "Australia/Sydney|Australia/Canberra",
                    "Australia/Sydney|Australia/NSW",
                    "Etc/GMT-0|Etc/GMT",
                    "Etc/GMT-0|Etc/GMT+0",
                    "Etc/GMT-0|Etc/GMT0",
                    "Etc/GMT-0|Etc/Greenwich",
                    "Etc/GMT-0|GMT",
                    "Etc/GMT-0|GMT+0",
                    "Etc/GMT-0|GMT-0",
                    "Etc/GMT-0|GMT0",
                    "Etc/GMT-0|Greenwich",
                    "Etc/UCT|UCT",
                    "Etc/UTC|Etc/Universal",
                    "Etc/UTC|Etc/Zulu",
                    "Etc/UTC|UTC",
                    "Etc/UTC|Universal",
                    "Etc/UTC|Zulu",
                    "Europe/Belgrade|Europe/Ljubljana",
                    "Europe/Belgrade|Europe/Podgorica",
                    "Europe/Belgrade|Europe/Sarajevo",
                    "Europe/Belgrade|Europe/Skopje",
                    "Europe/Belgrade|Europe/Zagreb",
                    "Europe/Chisinau|Europe/Tiraspol",
                    "Europe/Dublin|Eire",
                    "Europe/Helsinki|Europe/Mariehamn",
                    "Europe/Istanbul|Asia/Istanbul",
                    "Europe/Istanbul|Turkey",
                    "Europe/Lisbon|Portugal",
                    "Europe/London|Europe/Belfast",
                    "Europe/London|Europe/Guernsey",
                    "Europe/London|Europe/Isle_of_Man",
                    "Europe/London|Europe/Jersey",
                    "Europe/London|GB",
                    "Europe/London|GB-Eire",
                    "Europe/Moscow|W-SU",
                    "Europe/Oslo|Arctic/Longyearbyen",
                    "Europe/Oslo|Atlantic/Jan_Mayen",
                    "Europe/Prague|Europe/Bratislava",
                    "Europe/Rome|Europe/San_Marino",
                    "Europe/Rome|Europe/Vatican",
                    "Europe/Warsaw|Poland",
                    "Europe/Zurich|Europe/Busingen",
                    "Europe/Zurich|Europe/Vaduz",
                    "Indian/Christmas|Etc/GMT-7",
                    "Pacific/Auckland|Antarctica/McMurdo",
                    "Pacific/Auckland|Antarctica/South_Pole",
                    "Pacific/Auckland|NZ",
                    "Pacific/Chatham|NZ-CHAT",
                    "Pacific/Easter|Chile/EasterIsland",
                    "Pacific/Guam|Pacific/Saipan",
                    "Pacific/Honolulu|Pacific/Johnston",
                    "Pacific/Honolulu|US/Hawaii",
                    "Pacific/Kwajalein|Kwajalein",
                    "Pacific/Pago_Pago|Pacific/Midway",
                    "Pacific/Pago_Pago|Pacific/Samoa",
                    "Pacific/Pago_Pago|US/Samoa",
                    "Pacific/Palau|Etc/GMT-9",
                    "Pacific/Pohnpei|Etc/GMT-11",
                    "Pacific/Pohnpei|Pacific/Ponape",
                    "Pacific/Port_Moresby|Etc/GMT-10",
                    "Pacific/Port_Moresby|Pacific/Chuuk",
                    "Pacific/Port_Moresby|Pacific/Truk",
                    "Pacific/Port_Moresby|Pacific/Yap",
                    "Pacific/Tarawa|Etc/GMT-12",
                    "Pacific/Tarawa|Pacific/Funafuti",
                    "Pacific/Tarawa|Pacific/Wake",
                    "Pacific/Tarawa|Pacific/Wallis",
                ],
            }),
            e
        );
    }),
    (function (e) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], e) : e(jQuery);
    })(function (e) {
        "use strict";
        function t(e) {
            var t = e.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
            return new RegExp(t);
        }
        function i(e) {
            return function (i) {
                var o = i.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
                if (o)
                    for (var s = 0, r = o.length; s < r; ++s) {
                        var a = o[s].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
                            l = t(a[0]),
                            u = a[1] || "",
                            d = a[3] || "",
                            p = null;
                        (a = a[2]), c.hasOwnProperty(a) && ((p = c[a]), (p = Number(e[p]))), null !== p && ("!" === u && (p = n(d, p)), "" === u && p < 10 && (p = "0" + p.toString()), (i = i.replace(l, p.toString())));
                    }
                return i.replace(/%%/, "%");
            };
        }
        function n(e, t) {
            var i = "s",
                n = "";
            return e && (1 === (e = e.replace(/(:|;|\s)/gi, "").split(/\,/)).length ? (i = e[0]) : ((n = e[0]), (i = e[1]))), Math.abs(t) > 1 ? i : n;
        }
        var o = [],
            s = [],
            r = { precision: 100, elapse: !1, defer: !1 };
        s.push(/^[0-9]*$/.source), s.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), s.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), (s = new RegExp(s.join("|")));
        var c = { Y: "years", m: "months", n: "daysToMonth", d: "daysToWeek", w: "weeks", W: "weeksToMonth", H: "hours", M: "minutes", S: "seconds", D: "totalDays", I: "totalHours", N: "totalMinutes", T: "totalSeconds" },
            a = function (t, i, n) {
                (this.el = t),
                    (this.$el = e(t)),
                    (this.interval = null),
                    (this.offset = {}),
                    (this.options = e.extend({}, r)),
                    (this.instanceNumber = o.length),
                    o.push(this),
                    this.$el.data("countdown-instance", this.instanceNumber),
                    n && ("function" == typeof n ? (this.$el.on("update.countdown", n), this.$el.on("stoped.countdown", n), this.$el.on("finish.countdown", n)) : (this.options = e.extend({}, r, n))),
                    this.setFinalDate(i),
                    !1 === this.options.defer && this.start();
            };
        e.extend(a.prototype, {
            start: function () {
                null !== this.interval && clearInterval(this.interval);
                var e = this;
                this.update(),
                    (this.interval = setInterval(function () {
                        e.update.call(e);
                    }, this.options.precision));
            },
            stop: function () {
                clearInterval(this.interval), (this.interval = null), this.dispatchEvent("stoped");
            },
            toggle: function () {
                this.interval ? this.stop() : this.start();
            },
            pause: function () {
                this.stop();
            },
            resume: function () {
                this.start();
            },
            remove: function () {
                this.stop.call(this), (o[this.instanceNumber] = null), delete this.$el.data().countdownInstance;
            },
            setFinalDate: function (e) {
                this.finalDate = (function (e) {
                    if (e instanceof Date) return e;
                    if (String(e).match(s)) return String(e).match(/^[0-9]*$/) && (e = Number(e)), String(e).match(/\-/) && (e = String(e).replace(/\-/g, "/")), new Date(e);
                    throw new Error("Couldn't cast `" + e + "` to a date object.");
                })(e);
            },
            update: function () {
                if (0 !== this.$el.closest("html").length) {
                    var t,
                        i = void 0 !== e._data(this.el, "events"),
                        n = new Date();
                    (t = this.finalDate.getTime() - n.getTime()),
                        (t = Math.ceil(t / 1e3)),
                        (t = !this.options.elapse && t < 0 ? 0 : Math.abs(t)),
                        this.totalSecsLeft !== t &&
                            i &&
                            ((this.totalSecsLeft = t),
                            (this.elapsed = n >= this.finalDate),
                            (this.offset = {
                                seconds: this.totalSecsLeft % 60,
                                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                                daysToMonth: Math.floor((this.totalSecsLeft / 60 / 60 / 24) % 30.4368),
                                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                                weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                                years: Math.abs(this.finalDate.getFullYear() - n.getFullYear()),
                                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                                totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                                totalMinutes: Math.floor(this.totalSecsLeft / 60),
                                totalSeconds: this.totalSecsLeft,
                            }),
                            this.options.elapse || 0 !== this.totalSecsLeft ? this.dispatchEvent("update") : (this.stop(), this.dispatchEvent("finish")));
                } else this.remove();
            },
            dispatchEvent: function (t) {
                var n = e.Event(t + ".countdown");
                (n.finalDate = this.finalDate), (n.elapsed = this.elapsed), (n.offset = e.extend({}, this.offset)), (n.strftime = i(this.offset)), this.$el.trigger(n);
            },
        }),
            (e.fn.countdown = function () {
                var t = Array.prototype.slice.call(arguments, 0);
                return this.each(function () {
                    var i = e(this).data("countdown-instance");
                    if (void 0 !== i) {
                        var n = o[i],
                            s = t[0];
                        a.prototype.hasOwnProperty(s)
                            ? n[s].apply(n, t.slice(1))
                            : null === String(s).match(/^[$A-Z_][0-9A-Z_$]*$/i)
                            ? (n.setFinalDate.call(n, s), n.start())
                            : e.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, s));
                    } else new a(this, t[0], t[1]);
                });
            });
    });
